// src/components/AgentActions/AgentActions.tsx
import { arrowDownToBracket } from "@simplybusiness/icons";
import {
  Icon,
  Link,
  Button
} from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { forwardRef } from "react";

// src/components/AgentActions/handleDownload.ts
var handleDownload = (downloadQuoteUrl) => {
  fetch(downloadQuoteUrl).then((response) => {
    if (!response.ok) {
      throw new Error("Error fetching the file");
    }
    return response.blob();
  }).then((blob) => {
    const url = window.URL.createObjectURL(blob);
    const link2 = document.createElement("a");
    link2.href = url;
    link2.download = "downloaded-file.pdf";
    document.body.appendChild(link2);
    link2.click();
    document.body.removeChild(link2);
    window.URL.revokeObjectURL(url);
  }).catch((error) => {
    console.error(error);
  });
};

// src/components/AgentActions/AgentActions.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var AgentActions = forwardRef(
  (props, ref) => {
    const {
      elementType: Element = "div",
      newQuoteUrl,
      downloadQuoteUrl,
      componentName,
      ...otherProps
    } = props;
    const classes = classNames(
      "mobius",
      "mobius-agent-actions",
      otherProps.className
    );
    const { variant } = otherProps;
    return /* @__PURE__ */ jsxs(
      Element,
      {
        ref,
        ...otherProps,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        children: [
          /* @__PURE__ */ jsx(Link, { href: newQuoteUrl, className: "mobius-agent-actions__link", children: "Start New Quote" }),
          /* @__PURE__ */ jsxs(
            Button,
            {
              size: "sm",
              className: "mobius-agent-actions__button",
              onClick: () => handleDownload(downloadQuoteUrl),
              children: [
                /* @__PURE__ */ jsx(Icon, { icon: arrowDownToBracket }),
                "Download Quote Proposal"
              ]
            }
          )
        ]
      }
    );
  }
);
AgentActions.displayName = "AgentActions";

// src/components/AgentInformation/AgentInformation.tsx
import {
  Text
} from "@simplybusiness/mobius";
import classNames2 from "classnames/dedupe";
import { forwardRef as forwardRef2 } from "react";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var AgentInformation = forwardRef2(
  (props, ref) => {
    const {
      elementType: Element = "div",
      componentName,
      ...otherProps
    } = props;
    const classes = classNames2(
      "mobius",
      "mobius-agent-information",
      otherProps.className
    );
    const { variant } = otherProps;
    return /* @__PURE__ */ jsxs2(
      Element,
      {
        ref,
        ...otherProps,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        children: [
          /* @__PURE__ */ jsx2(Text, { children: "You should receive an email with this information in about 5 minutes. It includes a link to return to the quote." }),
          /* @__PURE__ */ jsx2(Text, { children: /* @__PURE__ */ jsx2("strong", { children: "Please note that this email will not go to your client" }) }),
          /* @__PURE__ */ jsx2(Text, { children: /* @__PURE__ */ jsx2("strong", { children: "If you share the quote email with your client and they would like to purchase, you will need to complete the binding process on behalf of your client by clicking the \u201CSelect\u201C button above and entering the client\u2018s credit card information." }) })
        ]
      }
    );
  }
);
AgentInformation.displayName = "AgentInformation";

// src/components/AgentReferral/AgentReferral.tsx
import classNames4 from "classnames/dedupe";
import { forwardRef as forwardRef4 } from "react";

// src/components/AgentReferral/AgentReferralReasons.tsx
import { Text as Text2 } from "@simplybusiness/mobius";

// src/components/AgentReferral/InfoCard/InfoCard.tsx
import { circleInfo } from "@simplybusiness/icons";
import { Flex, Icon as Icon2 } from "@simplybusiness/mobius";
import classNames3 from "classnames/dedupe";
import { forwardRef as forwardRef3 } from "react";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var InfoCard = forwardRef3((props, ref) => {
  const { header: header2, children, className, ...otherProps } = props;
  const classes = classNames3("mobius", "mobius-info-card", className, {
    "--has-header": header2
  });
  const headerClasses = "mobius-info-card__header";
  const iconClasses = "mobius-info-card__icon";
  const contentClasses = "mobius-info-card__content";
  return /* @__PURE__ */ jsxs3(
    Flex,
    {
      flexGrow: 1,
      ref,
      role: "note",
      className: classes,
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx3("span", { className: iconClasses, children: /* @__PURE__ */ jsx3(Icon2, { icon: circleInfo, size: "sm" }) }),
        /* @__PURE__ */ jsxs3("div", { children: [
          header2 && /* @__PURE__ */ jsx3("p", { className: headerClasses, children: header2 }),
          /* @__PURE__ */ jsx3("div", { className: contentClasses, children })
        ] })
      ]
    }
  );
});
InfoCard.displayName = "InfoCard";

// src/components/AgentReferral/AgentReferralReasons.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var AgentReferralReasons = (props) => {
  const { firstName, referralReasons } = props;
  return /* @__PURE__ */ jsxs4("div", { className: "mobius-agent-referral__reasons", children: [
    /* @__PURE__ */ jsxs4(Text2, { variant: "h3", children: [
      "Sorry! Here are some key factors why we couldn't get any quotes for",
      " ",
      firstName
    ] }),
    referralReasons.map(({ title, description }) => /* @__PURE__ */ jsx4(InfoCard, { header: title, children: description }, title))
  ] });
};

// src/components/AgentReferral/AgentReferralText.tsx
import { Text as Text3 } from "@simplybusiness/mobius";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var AgentReferralText = (props) => {
  const { firstName, referenceNumber, phoneNumber } = props;
  return /* @__PURE__ */ jsxs5("div", { className: "mobius-agent-referral__text", children: [
    /* @__PURE__ */ jsxs5(Text3, { variant: "h2", children: [
      "Thanks, ",
      firstName
    ] }),
    /* @__PURE__ */ jsx5(Text3, { variant: "body", children: "We're sorry, but we can't offer a quote based on the answers you provided." }),
    /* @__PURE__ */ jsxs5(Text3, { variant: "body", children: [
      "We'd be happy to explain further. Feel free to talk with one of our agents at ",
      /* @__PURE__ */ jsx5("strong", { children: phoneNumber }),
      ". Please keep this reference number ",
      /* @__PURE__ */ jsx5("strong", { children: referenceNumber }),
      " handy when you call."
    ] }),
    /* @__PURE__ */ jsx5(Text3, { variant: "h3", children: "Did you know?" }),
    /* @__PURE__ */ jsx5(Text3, { variant: "body", children: "Among the trades agents quote the most with us include painting and wall covering, handyperson, and carpentry, each covering up to $1 million per occurrence." })
  ] });
};

// src/components/AgentReferral/AgentReferral.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var AgentReferral = forwardRef4(
  (props, ref) => {
    const { className, componentName, ...otherProps } = props;
    const { variant } = otherProps;
    const classes = classNames4("mobius", "mobius-agent-referral", className);
    return /* @__PURE__ */ jsx6(
      "div",
      {
        ref,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        children: variant === "referral-reasons" ? /* @__PURE__ */ jsx6(
          AgentReferralReasons,
          {
            ...otherProps
          }
        ) : /* @__PURE__ */ jsx6(AgentReferralText, { ...otherProps })
      }
    );
  }
);
AgentReferral.displayName = "AgentReferral";

// src/components/AgentResources/AgentResources.tsx
import { arrowDownToLine, link } from "@simplybusiness/icons";
import { Icon as Icon3, Link as Link2, LinkButton, Text as Text4 } from "@simplybusiness/mobius";

// src/components/shared/Underline/Underline.tsx
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var Underline = (props) => {
  const { className } = props;
  return /* @__PURE__ */ jsx7(
    "span",
    {
      "aria-hidden": "true",
      style: { display: "block", width: 137, height: 10 },
      children: /* @__PURE__ */ jsxs6(
        "svg",
        {
          className,
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 137 10",
          children: [
            /* @__PURE__ */ jsx7("title", { children: "Underline icon" }),
            /* @__PURE__ */ jsx7(
              "path",
              {
                d: "M0 7.133c-.01-.758 1.643-1.961 2.66-1.987 1.018-.027 2.98.076 5.89.048 2.906-.024 20.056-.519 25.942-.774 5.885-.255 40.171-1.85 48.603-2.167 8.426-.32 30.733-1.147 35.092-1.26 4.359-.113 13.008-.337 13.734-.458.726-.121 2.385-.97 3.703-.246s1.86 2.83.859 3.965c-1.002 1.135-2.52 1.53-3.689 1.256s-2.769-.434-4.583-.486c-1.82-.055-40.255 1.244-44.18 1.448-3.925.2-34.801 1.36-39.454 1.579-4.647.219-11.474.648-21.5 1.16-10.022.513-16.636.735-18.528.784-1.892.05-3.13-.27-3.796-1.113C.087 8.039.01 7.839 0 7.132Z",
                fill: "currentColor"
              }
            )
          ]
        }
      )
    }
  );
};

// src/components/AgentResources/AgentResources.tsx
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var AgentResources = (props) => {
  const {
    appetiteGuideUrl,
    workingWithUsUrl,
    newQuoteUrl,
    componentName,
    ...otherProps
  } = props;
  const { variant } = otherProps;
  return /* @__PURE__ */ jsxs7(
    "div",
    {
      className: "mobius-agent-resources",
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      children: [
        /* @__PURE__ */ jsxs7(Text4, { variant: "h3", className: "mobius-agent-resources__title", children: [
          "Agent Resources",
          /* @__PURE__ */ jsx8(Underline, { className: "mobius-agent-resources__title-underline" })
        ] }),
        /* @__PURE__ */ jsxs7("ul", { className: "mobius-agent-resources__list", children: [
          /* @__PURE__ */ jsxs7("li", { className: "mobius-agent-resources__list-item", children: [
            /* @__PURE__ */ jsx8(Icon3, { icon: arrowDownToLine, size: "md" }),
            /* @__PURE__ */ jsx8(Link2, { href: appetiteGuideUrl, target: "_blank", children: "Download Appetite Guide" })
          ] }),
          workingWithUsUrl && /* @__PURE__ */ jsxs7("li", { className: "mobius-agent-resources__list-item", children: [
            /* @__PURE__ */ jsx8(Icon3, { icon: link, size: "md" }),
            /* @__PURE__ */ jsx8(Link2, { href: workingWithUsUrl, target: "_blank", children: "Working with Simply Business" })
          ] })
        ] }),
        newQuoteUrl && /* @__PURE__ */ jsx8(LinkButton, { href: newQuoteUrl, children: "Start New Quote" })
      ]
    }
  );
};

// src/components/CoverageSummary/CoverageSummary.tsx
import classNames11 from "classnames/dedupe";
import { forwardRef as forwardRef5 } from "react";

// src/components/CoverageSummary/PaymentSummary/PaymentSummary.tsx
import { Flex as Flex2, SegmentGroup, Segment } from "@simplybusiness/mobius";
import classNames5 from "classnames/dedupe";
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var PaymentSummary = (props) => {
  const { total, toPayToday, instalments } = props;
  const classes = classNames5("mobius", "mobius-payment-summary");
  return /* @__PURE__ */ jsxs8(SegmentGroup, { className: classes, children: [
    /* @__PURE__ */ jsx9(Segment, { className: "mobius-payment-summary__to-pay-today", children: /* @__PURE__ */ jsxs8(Flex2, { justifyContent: "space-between", children: [
      /* @__PURE__ */ jsx9("span", { children: /* @__PURE__ */ jsx9("strong", { children: "To pay today" }) }),
      /* @__PURE__ */ jsx9("span", { children: /* @__PURE__ */ jsx9("strong", { children: toPayToday }) })
    ] }) }),
    instalments.map(({ count, amount }) => /* @__PURE__ */ jsx9(Segment, { className: "mobius-payment-summary__instalments", children: /* @__PURE__ */ jsxs8(Flex2, { justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxs8("span", { children: [
        count,
        " monthly payments of"
      ] }),
      /* @__PURE__ */ jsx9("span", { children: amount })
    ] }) }, amount)),
    /* @__PURE__ */ jsx9(Segment, { className: "mobius-payment-summary__total", children: /* @__PURE__ */ jsxs8(Flex2, { justifyContent: "space-between", children: [
      /* @__PURE__ */ jsx9("span", { children: "Total (inc. tax + fees)" }),
      /* @__PURE__ */ jsx9("span", { children: /* @__PURE__ */ jsx9("strong", { children: total }) })
    ] }) })
  ] });
};

// src/components/CoverageSummary/QuoteSummary/QuoteSummary.tsx
import classNames10 from "classnames/dedupe";

// src/components/shared/ProductInfo/ProductInfo.tsx
import { Flex as Flex3, Text as Text5 } from "@simplybusiness/mobius";

// src/components/QuoteCards/QuoteCard/Logo/Logo.tsx
import classNames6 from "classnames";
import { jsx as jsx10 } from "react/jsx-runtime";
var Logo = ({ logoPath, className, alt }) => {
  const origin = "http://localhost:3000";
  const logoUrl = logoPath?.startsWith("http") ? logoPath : `${origin}${logoPath}`;
  const classes = classNames6("mobius-quote-details__logo", className);
  const altText = alt ?? "Provider logo";
  if (!logoPath) {
    return null;
  }
  return /* @__PURE__ */ jsx10("img", { src: logoUrl, alt: altText, className: classes });
};

// src/components/shared/ProductInfo/ProductInfo.tsx
import { jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var ProductInfo = (props) => {
  const { logo, productTitle, premium, policyStartDate, children } = props;
  return /* @__PURE__ */ jsx11(Flex3, { flexDirection: "column", children: /* @__PURE__ */ jsxs9("div", { className: "mobius-payment-info__multi-product", children: [
    /* @__PURE__ */ jsx11(Logo, { logoPath: logo, className: "mobius-payment-info__logo" }),
    /* @__PURE__ */ jsxs9(
      Flex3,
      {
        alignItems: "baseline",
        gap: "xs",
        justifyContent: "space-between",
        className: "mobius-payment-info__multi-product-text",
        flexGrow: 1,
        children: [
          /* @__PURE__ */ jsx11("strong", { children: productTitle }),
          /* @__PURE__ */ jsx11("strong", { children: premium })
        ]
      }
    ),
    /* @__PURE__ */ jsxs9(Text5, { className: "mobius-payment-info__start-date", children: [
      "Policy starting ",
      policyStartDate
    ] }),
    children
  ] }) });
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/Coverage.tsx
import {
  Accordion,
  Box,
  Modal as Modal2,
  Text as Text7,
  useBreakpoint as useBreakpoint3
} from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext3 } from "@simplybusiness/services";
import classNames8 from "classnames/dedupe";
import { useCallback as useCallback2, useState as useState2 } from "react";

// src/constants/breakpoints.ts
var customBreakpoints = [
  { size: "xs", value: 320 },
  { size: "sm", value: 480 },
  { size: "md", value: 600 },
  { size: "lg", value: 850 },
  { size: "xl", value: 1024 }
];

// src/components/QuoteCards/QuoteCard/CoverLimit/CoverLimit.tsx
import { Flex as Flex6 } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import { useAtom } from "jotai";
import { useCallback } from "react";

// src/store.ts
import { atom } from "jotai";

// src/constants/addresses.ts
var LINK_ADDRESS_QUESTION_NAME = "Same correspondence address pre quote";
var LINKED_ADDRESS_QUESTION_NAME = "UK correspondence address lookup";
var QUESTIONS_WITH_TOGGLE = [
  "uk_postcode",
  "customer[uk_postcode]"
];

// src/constants/errors.ts
var ERRORS = {
  REQUIRED: "Please provide an answer for this question",
  INVALID_EMAIL: "Please enter a valid email address",
  INVALID_POSTCODE: "Enter a UK postcode, or contact us for help",
  INVALID_TEL: "Enter a UK phone number or contact us for help"
};

// src/constants/constants.ts
var ANNUAL = "annual";
var YEARLY = "yearly";
var MONTHLY = "monthly";
var AIRBRAKE_PROJECT_ID = 90865;
var AIRBRAKE_PROJECT_KEY = "8f2c6b9818d527c9e959af92547e1f03";
var LOCALE_EN_GB = "en-GB";
var LOCALE_EN_US = "en-US";
var DEFAULT_LOCALE = LOCALE_EN_GB;
var PREPOP_ENDPOINT_URL = "?step_action=prepopulate";
var creditRatingAgencyDescriptions = {
  ambest: {
    label: "A.M. Best",
    description: "The world\u2019s largest credit rating agency specializing in the insurance industry. A.M. Best assesses the creditworthiness of and/or reports on insurance companies."
  },
  demotech: {
    label: "Demotech Rating",
    description: "Demotech is a financial analysis firm specializing in evaluating the financial stability of regional and specialty insurers."
  },
  // This is needed for the empty (UK) case
  "": {
    label: "",
    description: ""
  }
};

// src/store.ts
var sliderStateAtom = atom(false);
var paymentToggleAtom = atom(ANNUAL);
var experimentsAtom = atom(/* @__PURE__ */ new Map());
var localeAtom = atom("en-GB");
var tokensAtom = atom({
  authenticityToken: "",
  journeyToken: ""
});
var quoteComparisonPageAtom = atom(
  []
);
var environmentAtom = atom({ site: "", journeyId: "" });
var questionnaireFormUrlAtom = atom("");
var personalisedCoverPageAtom = atom([]);
var qcpLayoutToggleAtom = atom("list");
var redirectAtom = atom(void 0);

// src/components/QuoteCards/QuoteCard/InfoModal/index.tsx
import { useBreakpoint } from "@simplybusiness/mobius";

// src/components/QuoteCards/QuoteCard/InfoModal/CardModal.tsx
import { circleQuestion } from "@simplybusiness/icons";
import { Button as Button2, Flex as Flex4, Icon as Icon4, Modal } from "@simplybusiness/mobius";
import { useState } from "react";
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var CardModal = ({
  toggleText,
  title,
  body,
  onOpen,
  toggleIcon = true
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    if (onOpen) {
      onOpen();
    }
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  return /* @__PURE__ */ jsxs10(Flex4, { gap: "xxs", children: [
    /* @__PURE__ */ jsx12(
      Button2,
      {
        variant: "ghost",
        className: "mobius-quote-card__modal-trigger",
        onClick: handleOpen,
        children: /* @__PURE__ */ jsxs10(Flex4, { children: [
          /* @__PURE__ */ jsx12("span", { className: "mobius-quote-card__explainer-title", children: toggleText }),
          toggleIcon && /* @__PURE__ */ jsx12(
            Icon4,
            {
              icon: circleQuestion,
              size: "sm",
              className: "mobius-quote-card__explainer-icon"
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsxs10(
      Modal,
      {
        isOpen: open,
        onClose: handleClose,
        className: "mobius-quote-card__modal-container",
        animation: "fade",
        children: [
          /* @__PURE__ */ jsx12(Modal.Header, { children: title }),
          /* @__PURE__ */ jsx12(Modal.Content, { children: body })
        ]
      }
    )
  ] });
};

// src/components/QuoteCards/QuoteCard/InfoModal/CardPopover.tsx
import { circleQuestion as circleQuestion2 } from "@simplybusiness/icons";
import { Button as Button3, Flex as Flex5, Icon as Icon5, Popover } from "@simplybusiness/mobius";
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var CardPopover = ({
  toggleText,
  body,
  onOpen,
  toggleIcon = true,
  isCoreCover = false
}) => /* @__PURE__ */ jsx13(Flex5, { gap: "xxs", children: /* @__PURE__ */ jsx13(
  Popover,
  {
    className: "mobius-quote-card__info-popover",
    trigger: /* @__PURE__ */ jsx13(Button3, { variant: "ghost", className: "mobius-quote-card__modal-trigger", children: /* @__PURE__ */ jsxs11(Flex5, { children: [
      /* @__PURE__ */ jsx13(
        "span",
        {
          className: isCoreCover ? "" : "mobius-quote-card__explainer-title",
          children: toggleText
        }
      ),
      " ",
      toggleIcon && /* @__PURE__ */ jsx13(
        Icon5,
        {
          icon: circleQuestion2,
          size: "sm",
          className: "mobius-quote-card__explainer-icon"
        }
      )
    ] }) }),
    onOpen,
    children: body
  }
) });

// src/components/QuoteCards/QuoteCard/InfoModal/index.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var InfoModal = ({ title, ...props }) => {
  const { up } = useBreakpoint(customBreakpoints);
  if (up("md")) {
    return /* @__PURE__ */ jsx14(CardPopover, { ...props });
  }
  return /* @__PURE__ */ jsx14(CardModal, { title, ...props });
};

// src/components/QuoteCards/QuoteCard/CoverLimit/CoverLimit.tsx
import { Fragment, jsx as jsx15, jsxs as jsxs12 } from "react/jsx-runtime";
var CoverLimit = ({
  product,
  title,
  amount,
  explainer,
  withModal,
  isCoreCover
}) => {
  const { snowplow } = useSnowplowContext();
  const [sliderIsOpen] = useAtom(sliderStateAtom);
  const handleOpen = useCallback(() => {
    const category = `${sliderIsOpen ? "quote_details_slider" : "qcp"}_coverage_selection`;
    snowplow?.trigger("coverageModalOpened", { category, product, title });
  }, [sliderIsOpen, snowplow, product, title]);
  const modalTitle = /* @__PURE__ */ jsxs12(Fragment, { children: [
    title,
    /* @__PURE__ */ jsx15("br", {}),
    amount
  ] });
  return /* @__PURE__ */ jsxs12(
    Flex6,
    {
      justifyContent: "space-between",
      gap: "xs",
      className: isCoreCover ? "" : "mobius-quote-card__cover",
      flexGrow: 1,
      children: [
        explainer && withModal ? /* @__PURE__ */ jsx15(
          InfoModal,
          {
            toggleText: title,
            title: modalTitle,
            body: explainer,
            onOpen: handleOpen,
            isCoreCover
          }
        ) : title,
        /* @__PURE__ */ jsx15("strong", { className: isCoreCover ? "" : "mobius-quote-card__cover-amount", children: amount })
      ]
    }
  );
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/CoverageItems.tsx
import classNames7 from "classnames/dedupe";
import { tick, cross } from "@simplybusiness/icons";
import { Flex as Flex7, Icon as Icon6, Text as Text6 } from "@simplybusiness/mobius";

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/ViewExcess.tsx
import { Link as Link3, useBreakpoint as useBreakpoint2 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext2 } from "@simplybusiness/services";

// src/utils/componentLookup.ts
var getPropsByName = (props) => {
  const { name, components } = props;
  const componentEntry = components?.find(
    (component) => component?.metadata.name === name
  );
  if (!componentEntry) {
    return null;
  }
  const featureProps = {
    ...componentEntry?.props || {},
    ...{ componentName: componentEntry?.metadata.name },
    ...{ variant: componentEntry?.metadata.variant }
  };
  return componentEntry?.actions ? { ...featureProps, actions: componentEntry?.actions } : featureProps;
};

// src/utils/isObject.tsx
function isObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value) && Object.getPrototypeOf(value) === Object.prototype;
}

// src/utils/mapToArray.tsx
function mapToArray(object) {
  return Object.entries(object).map(([name, answer]) => ({ name, answer }));
}

// src/utils/transformDates.ts
var formatDateByLocale = (date, locale = "en-GB") => {
  const [year, month, day] = date.split("-");
  if (locale === "en-US") {
    return `${month}/${day}/${year}`;
  }
  return `${day}/${month}/${year}`;
};
var toISODate = (date) => {
  const [day, month, year] = date.split("/");
  return `${year}-${month}-${day}`;
};

// src/utils/transformAnswers.tsx
var createQuestionMetadataMap = (sections) => {
  const questionMap2 = /* @__PURE__ */ new Map();
  return sections.reduce((map, section) => {
    section.questions.forEach(
      ({ name, id, display }) => map.set(name, { id, type: display?.type })
    );
    return map;
  }, questionMap2);
};
var removeHiddenAnswers = (answers, sections, visibility) => {
  const answersToExclude = new Set(
    sections.flatMap((section) => section.questions).filter(
      (q) => q.includeAnswer === false || typeof q.includeAnswer === "undefined" && !visibility[q.name]
    ).map((q) => q.name)
  );
  return Object.fromEntries(
    Object.entries(answers).filter(([key]) => !answersToExclude.has(key))
  );
};
var transformAnswerValue = (value, type, locale) => {
  if (type === "date" && typeof value === "string") {
    return formatDateByLocale(value, locale);
  }
  return value;
};
var transformAddressLookupAnswers = (answers, sections) => {
  const { addressQuestions, fieldMappings } = sections.reduce(
    (acc, section) => {
      section.questions.filter((q) => q.display?.type === "address_lookup").forEach((question) => {
        acc.addressQuestions.add(question.name);
        const mappedFields = question.display.config?.mappedFields;
        if (mappedFields && Array.isArray(mappedFields)) {
          mappedFields.forEach((field) => {
            const fullKey = `${question.id}[${field.id}]`;
            if (field.associatedQuestionId) {
              acc.fieldMappings[field.associatedQuestionId] = fullKey;
            }
          });
        }
      });
      return acc;
    },
    { addressQuestions: /* @__PURE__ */ new Set(), fieldMappings: {} }
  );
  const transformed = Object.entries(answers).reduce(
    (acc, [key, value]) => {
      if (addressQuestions.has(key)) {
        return acc;
      }
      acc[key] = value;
      if (fieldMappings[key]) {
        acc[fieldMappings[key]] = value;
      }
      return acc;
    },
    {}
  );
  return transformed;
};
var transformAnswers = (answers, sections, visibility = {}, locale) => {
  const withTransformedAddressLookupAnswers = transformAddressLookupAnswers(
    answers,
    sections
  );
  const questionMetadata = createQuestionMetadataMap(sections);
  const filteredAnswers = removeHiddenAnswers(
    withTransformedAddressLookupAnswers,
    sections,
    visibility
  );
  return Object.entries(filteredAnswers).reduce(
    (acc, [key, value]) => {
      const newKey = questionMetadata.get(key)?.id || key;
      acc[newKey] = transformAnswerValue(
        value,
        questionMetadata.get(key)?.type,
        locale
      );
      return acc;
    },
    {}
  );
};

// src/utils/text.ts
var titleCase = (text3) => {
  const transformed = text3.toLowerCase().split(" ");
  for (let i = 0; i < transformed.length; i++) {
    transformed[i] = transformed[i].charAt(0).toUpperCase() + transformed[i].slice(1);
  }
  return transformed.join(" ");
};
var snakeCase = (text3 = "") => text3.toLowerCase().replace(/ /g, "_");
var camelToTitleCase = (text3) => {
  const withSpaces = text3.replace(/([A-Z])/g, " $1").toLowerCase();
  const titleCased = titleCase(withSpaces);
  return titleCased;
};
var camelToSnakeCase = (text3) => text3.charAt(0).toLowerCase() + text3.slice(1).replace(
  /(\[.*?\])|[A-Z]/g,
  (match, group) => group ? match : `_${match.toLowerCase()}`
);
var snakeCaseKeys = (object) => Object.entries(object || {}).reduce(
  (acc, [key, value]) => {
    const newKey = camelToSnakeCase(key);
    if (Array.isArray(value) && value.every(isObject)) {
      return {
        ...acc,
        [newKey]: value.map((v) => snakeCaseKeys(v))
      };
    }
    if (isObject(value)) {
      return {
        ...acc,
        [newKey]: snakeCaseKeys(value)
      };
    }
    return {
      ...acc,
      [newKey]: value
    };
  },
  {}
);
var isNumeric = (str = "") => {
  return !isNaN(Number(str)) && !isNaN(parseFloat(str));
};
var isCurrency = (string = "") => {
  const number = string.replace(/£/g, "");
  return isNumeric(number);
};
var containsHtmlMarkup = (text3) => {
  const validElements = [
    "strong",
    "b",
    "p",
    "ul",
    "li",
    "ol",
    "i",
    "em",
    "table",
    "tr",
    "td",
    "br",
    // regex will handle the <br/> and <br /> versions
    "div",
    "a",
    "img"
  ];
  const validElementsPattern = validElements.join("|");
  const htmlTagRegex = new RegExp(`<(${validElementsPattern})\\b[^>]*>`, "i");
  return htmlTagRegex.test(text3);
};

// src/components/QuoteCards/QuoteCard/Coverage/transformCoverage.ts
var formatAmount = (amount) => {
  if (!amount) return amount;
  return amount.replace(",000,000", "M").replace(/,(\d+)00,000/, (_, digits) => `.${digits}M`).replace(/,(\d+)0,000/, (_, digits) => `.${digits}M`).replace(",000", "K").replace(/([£$]\d+)k/g, "$1K").replace(/([£$]\d+)m/g, "$1M");
};
var findHelpText = (helpTextArray, coverage) => {
  const helpTextObject = helpTextArray.find(
    (item) => item.coverage.toLowerCase() === coverage.toLowerCase()
  );
  return helpTextObject && helpTextObject.text;
};
var formatCoverLimit = (cover, helpText = []) => {
  const [title, amount] = cover.split(": ");
  const explainer = findHelpText(helpText, title);
  let displayTitle = titleCase(title);
  if (displayTitle === "Claims Made Limit") {
    displayTitle = "Claim Limit";
  }
  return {
    title: displayTitle,
    amount: formatAmount(amount),
    explainer
  };
};
var extractCoverAmount = (cover) => {
  const [, amount] = cover.split(": ");
  return amount;
};
var formatExcesses = (displayExcess, specificExcesses = [], helpText = []) => {
  const allExcesses = [
    ...specificExcesses,
    { excessName: "Deductibles", excessValue: displayExcess }
  ];
  return allExcesses.map(({ excessName, excessValue }) => {
    return {
      title: titleCase(excessName),
      amount: formatAmount(excessValue),
      explainer: findHelpText(helpText, excessName)
    };
  });
};
var transformCoverage = (covers) => {
  return covers.filter(
    (c) => c.quoteDetailsDisplayLimits.length > 0 || c.coverName?.match(/^Other States Coverage?$/i)
  );
};
var transformExtraCoverage = (covers) => {
  return covers.filter((c) => c.extraCover);
};
var isAdditionalInsured = (cover) => {
  return cover.coverName.match(/^Additional insureds?$/i);
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/formatExcesses.ts
var formatExcesses2 = (displayExcess, specificExcesses = [], helpText = []) => {
  const otherClaimsWording = specificExcesses.length ? "All other Claims" : "All Claims";
  const otherClaimsValue = displayExcess + (isCurrency(displayExcess) ? " excess" : "");
  const allExcesses = [
    ...specificExcesses,
    { excessName: otherClaimsWording, excessValue: otherClaimsValue }
  ];
  return allExcesses.map(({ excessName, excessValue }) => {
    return {
      title: titleCase(excessName),
      amount: formatAmount(excessValue),
      explainer: findHelpText(helpText, excessName)
    };
  });
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/ViewExcess.tsx
import { Fragment as Fragment2, jsx as jsx16 } from "react/jsx-runtime";
var ViewExcess = ({
  displayName,
  displayExcess,
  quoteCardExcesses,
  onOpen
}) => {
  const { snowplow } = useSnowplowContext2();
  const excesses = formatExcesses2(
    displayExcess,
    quoteCardExcesses
  );
  const { down } = useBreakpoint2();
  const isMobileDevice = down("md");
  const handleLinkClick = ({ displayName: displayName2 }) => {
    snowplow?.trigger("deductiblesClickedUk", {
      label: displayName2,
      deviceType: isMobileDevice ? "mobile" : "desktop"
    });
    onOpen({
      displayName: displayName2,
      excesses
    });
  };
  return /* @__PURE__ */ jsx16(Fragment2, { children: excesses.length > 0 && /* @__PURE__ */ jsx16(
    Link3,
    {
      className: "mobius-quote-card__coverage-item-excess-link",
      onClick: () => handleLinkClick({ displayName }),
      children: "View excess"
    }
  ) });
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/ExcessWording.tsx
import { Fragment as Fragment3, jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var ExcessWording = ({
  displayLimit,
  indemnityPeriod
}) => {
  const formattedDisplayLimit = displayLimit ? formatAmount(displayLimit) : "";
  return /* @__PURE__ */ jsxs13(Fragment3, { children: [
    /* @__PURE__ */ jsx17("strong", { children: formattedDisplayLimit }),
    indemnityPeriod && /* @__PURE__ */ jsxs13(Fragment3, { children: [
      /* @__PURE__ */ jsx17("br", {}),
      /* @__PURE__ */ jsx17("strong", { children: indemnityPeriod })
    ] })
  ] });
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/CoverageItems.tsx
import { jsx as jsx18, jsxs as jsxs14 } from "react/jsx-runtime";
var CoverageItems = ({ covers, onOpen }) => {
  return /* @__PURE__ */ jsx18(
    Flex7,
    {
      flexDirection: "column",
      gap: "xs",
      className: "mobius-quote-card__coverage-items",
      children: covers.map(
        ({
          displayName,
          coverName,
          covered,
          displayLimit,
          indemnityPeriod,
          displayExcess,
          quoteCardExcesses
        }) => {
          const iconClassName = classNames7({
            "mobius-quote-card__coverage-tick-icon": covered,
            "mobius-quote-card__coverage-cross-icon": !covered
          });
          return /* @__PURE__ */ jsxs14("div", { className: "mobius-quote-card__coverage-item", children: [
            /* @__PURE__ */ jsx18("div", { children: /* @__PURE__ */ jsxs14(Flex7, { children: [
              /* @__PURE__ */ jsx18(
                Icon6,
                {
                  icon: covered ? tick : cross,
                  className: iconClassName,
                  "data-testid": "coverage-item-icon"
                }
              ),
              /* @__PURE__ */ jsx18(Text6, { className: "mobius-quote-card__coverage-header-title", children: displayName })
            ] }) }),
            /* @__PURE__ */ jsx18("div", { children: covered ? /* @__PURE__ */ jsx18(
              ViewExcess,
              {
                displayName,
                displayExcess,
                quoteCardExcesses,
                onOpen
              }
            ) : "Not included" }),
            /* @__PURE__ */ jsx18("div", { className: "mobius-quote-card__coverage-item-excess-wording", children: covered ? /* @__PURE__ */ jsx18(
              ExcessWording,
              {
                displayLimit,
                indemnityPeriod
              }
            ) : /* @__PURE__ */ jsx18("div", { children: "-" }) })
          ] }, coverName);
        }
      )
    }
  );
};

// src/components/QuoteCards/QuoteCard/Coverage/CoverageUK/Coverage.tsx
import { Fragment as Fragment4, jsx as jsx19, jsxs as jsxs15 } from "react/jsx-runtime";
var Coverage = ({ covers, className }) => {
  const [open, setOpen] = useState2(false);
  const [modalData, setModalData] = useState2({
    displayName: "",
    excesses: []
  });
  const { down } = useBreakpoint3(customBreakpoints);
  const isMobileDevice = down("md");
  const { snowplow } = useSnowplowContext3();
  const classes = classNames8("mobius-quote-card__coverage", className);
  const handleOpen = useCallback2(
    ({ displayName, excesses }) => {
      setModalData({ displayName, excesses });
      setOpen(true);
    },
    []
  );
  const handleOpenAccordion = useCallback2(() => {
    snowplow?.trigger("coverageInfoClicked", {
      deviceType: isMobileDevice ? "mobile" : "desktop"
    });
  }, [isMobileDevice, snowplow]);
  return /* @__PURE__ */ jsx19(Fragment4, { children: /* @__PURE__ */ jsxs15(Box, { className: classes, "data-testid": "quote-coverage-uk", children: [
    isMobileDevice ? /* @__PURE__ */ jsx19(
      Accordion,
      {
        showText: "Show coverage info",
        hideText: "Hide coverage info",
        onOpen: handleOpenAccordion,
        children: /* @__PURE__ */ jsx19(CoverageItems, { covers, onOpen: handleOpen })
      }
    ) : /* @__PURE__ */ jsxs15(Fragment4, { children: [
      /* @__PURE__ */ jsx19(Text7, { className: "mobius-quote-card__coverage-title", variant: "h3", children: "Coverage Information" }),
      /* @__PURE__ */ jsx19(CoverageItems, { covers, onOpen: handleOpen })
    ] }),
    /* @__PURE__ */ jsxs15(
      Modal2,
      {
        className: "mobius-quote-card__coverage-item-excess-modal",
        isOpen: open,
        onClose: () => setOpen(false),
        children: [
          /* @__PURE__ */ jsxs15(Modal2.Header, { children: [
            modalData.displayName,
            " excess"
          ] }),
          /* @__PURE__ */ jsx19(Modal2.Content, { children: modalData.excesses.map((cover) => /* @__PURE__ */ jsx19(
            CoverLimit,
            {
              ...cover,
              product: modalData.displayName
            },
            cover.title
          )) })
        ]
      }
    )
  ] }) });
};

// src/components/QuoteCards/QuoteCard/Coverage/Coverage.tsx
import { tick as tick4, fileCertificate } from "@simplybusiness/icons";
import { Box as Box4, Flex as Flex13, Icon as Icon12, Text as Text14 } from "@simplybusiness/mobius";
import classNames9 from "classnames/dedupe";

// src/components/QuoteCards/QuoteCard/PriceDetails/PriceDetails.tsx
import { telephone } from "@simplybusiness/icons";
import { Icon as Icon7, Link as Link4, Text as Text8 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext4 } from "@simplybusiness/services";
import { Fragment as Fragment5, jsx as jsx20, jsxs as jsxs16 } from "react/jsx-runtime";
var PriceDetails = ({ priceDetails }) => {
  const { snowplow } = useSnowplowContext4();
  const { displayText, phoneNumber } = priceDetails;
  const modalText = /* @__PURE__ */ jsxs16(Fragment5, { children: [
    displayText.map((line) => /* @__PURE__ */ jsx20(Text8, { children: line }, line)),
    /* @__PURE__ */ jsx20(Text8, { children: /* @__PURE__ */ jsx20("strong", { children: phoneNumber.displayText }) }),
    /* @__PURE__ */ jsx20(Text8, { children: /* @__PURE__ */ jsxs16(
      Link4,
      {
        className: "mobius-quote-card__price-details-phone",
        href: `tel:${phoneNumber.number}`,
        children: [
          /* @__PURE__ */ jsx20(
            Icon7,
            {
              icon: telephone,
              className: "mobius-quote-card__price-details-icon"
            }
          ),
          phoneNumber.formatted
        ]
      }
    ) })
  ] });
  return /* @__PURE__ */ jsx20("div", { className: "mobius-quote-card__price-details", children: /* @__PURE__ */ jsx20(
    CardModal,
    {
      onOpen: () => snowplow?.trigger("priceDetailsPopUpOpened"),
      toggleText: "Price Details",
      title: "Price Details",
      body: modalText,
      toggleIcon: false
    }
  ) });
};

// src/components/QuoteCards/QuoteCard/Coverage/Deductibles/Deductibles.tsx
import { Accordion as Accordion2, Flex as Flex8, Text as Text9 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext5 } from "@simplybusiness/services";
import { jsx as jsx21, jsxs as jsxs17 } from "react/jsx-runtime";
var Deductibles = ({
  excesses,
  excessTitle,
  coverName,
  variant
}) => {
  const { snowplow } = useSnowplowContext5();
  const hasExcesses = excesses.length > 0;
  if (excessTitle === "Deductible") {
    excessTitle += "s";
  }
  if (variant === "qcp") {
    return hasExcesses && /* @__PURE__ */ jsx21(
      Accordion2,
      {
        showText: excessTitle,
        hideText: excessTitle,
        onOpen: () => snowplow?.trigger("deductiblesClicked"),
        headerPosition: "top",
        children: excesses.map((cover) => /* @__PURE__ */ jsx21(CoverLimit, { ...cover, product: coverName }, cover.title))
      }
    );
  }
  return hasExcesses && /* @__PURE__ */ jsxs17(Flex8, { className: "mobius-quote-card__deductibles", flexDirection: "column", children: [
    /* @__PURE__ */ jsx21(Text9, { className: "mobius-quote-card__deductibles-title", children: excessTitle }),
    excesses.map((cover) => /* @__PURE__ */ jsx21(CoverLimit, { ...cover, product: coverName }, cover.title))
  ] });
};

// src/components/QuoteCards/QuoteCard/Coverage/ExtraCoverage/ExtraCoverage.tsx
import { circleInfo as circleInfo2, tick as tick2 } from "@simplybusiness/icons";
import { Flex as Flex9, Icon as Icon8, Text as Text10 } from "@simplybusiness/mobius";
import { jsx as jsx22, jsxs as jsxs18 } from "react/jsx-runtime";
var ExtraCoverage = ({
  extraCovers,
  parentCover,
  variant,
  helpText
}) => {
  return extraCovers && /* @__PURE__ */ jsx22(Flex9, { flexDirection: "column", children: extraCovers.filter((cover) => cover.parentCover == parentCover).map((cover) => /* @__PURE__ */ jsxs18("div", { children: [
    /* @__PURE__ */ jsxs18(
      Flex9,
      {
        flexGrow: 1,
        alignItems: "center",
        className: "mobius-quote-card__extra-coverage-item",
        children: [
          /* @__PURE__ */ jsx22(
            Icon8,
            {
              className: "mobius-quote-card__coverage-tick-icon",
              icon: tick2
            }
          ),
          /* @__PURE__ */ jsx22(
            CoverLimit,
            {
              title: isAdditionalInsured(cover) ? "Additional Insured" : cover.displayName,
              amount: isAdditionalInsured(cover) ? "Included" : formatAmount(cover.displayLimit),
              explainer: helpText && findHelpText(helpText, cover.displayName),
              withModal: true
            }
          )
        ]
      }
    ),
    variant == "qds" && isAdditionalInsured(cover) && /* @__PURE__ */ jsx22(AdditionalInsureds, {})
  ] }, cover.coverName)) });
};
var AdditionalInsureds = () => /* @__PURE__ */ jsxs18(
  Flex9,
  {
    alignItems: "center",
    gap: "sm",
    flexGrow: 1,
    className: "mobius-quote-card__additional-insureds",
    children: [
      /* @__PURE__ */ jsx22("div", { role: "img", "aria-label": "information icon", children: /* @__PURE__ */ jsx22(
        Icon8,
        {
          icon: circleInfo2,
          color: "var(--color-neutral-700)",
          size: "md",
          fixedWidth: true
        }
      ) }),
      /* @__PURE__ */ jsx22(Text10, { spacing: "loose", variant: "small", children: "Additional insured details can be added after purchase" })
    ]
  }
);

// src/components/QuoteCards/QuoteCard/Coverage/IncludedByInsurerCoverage/IncludedByInsurerCoverage.tsx
import { tick as tick3 } from "@simplybusiness/icons";
import { Flex as Flex10, Icon as Icon9 } from "@simplybusiness/mobius";
import { jsx as jsx23, jsxs as jsxs19 } from "react/jsx-runtime";
var IncludedByInsurerCoverage = ({
  coverageTitle,
  helpText
}) => {
  return /* @__PURE__ */ jsx23(Flex10, { flexDirection: "column", children: /* @__PURE__ */ jsx23("div", { children: /* @__PURE__ */ jsxs19(
    Flex10,
    {
      flexGrow: 1,
      alignItems: "center",
      className: "mobius-quote-card__included-by-insurer",
      children: [
        /* @__PURE__ */ jsx23(
          Icon9,
          {
            className: "mobius-quote-card__included-by-insurer-icon",
            icon: tick3
          }
        ),
        /* @__PURE__ */ jsx23(
          CoverLimit,
          {
            title: coverageTitle,
            amount: "Included",
            explainer: helpText && findHelpText(helpText, coverageTitle)
          }
        )
      ]
    }
  ) }, coverageTitle) });
};

// src/components/QuoteCards/QuoteCard/Upsells/Upsells.tsx
import { Box as Box3, Accordion as Accordion3 } from "@simplybusiness/mobius";

// src/components/QuoteCards/QuoteCard/FileCirclePlus/FileCirclePlus.tsx
import { fileCirclePlus } from "@simplybusiness/icons";
import { Flex as Flex11, Icon as Icon10, Text as Text11 } from "@simplybusiness/mobius";
import { jsx as jsx24, jsxs as jsxs20 } from "react/jsx-runtime";
var FileCirclePlus = ({ text: text3 }) => /* @__PURE__ */ jsxs20(Flex11, { className: "mobius-quote-card__file-circle-plus", gap: "xs", children: [
  /* @__PURE__ */ jsx24(Icon10, { icon: fileCirclePlus, size: "sm", color: "var(--color-text)" }),
  /* @__PURE__ */ jsx24(Text11, { variant: "small", children: text3 })
] });

// src/components/QuoteCards/QuoteCard/Upsells/UpsellItem.tsx
import { Box as Box2, Text as Text12 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext6 } from "@simplybusiness/services";
import { jsx as jsx25, jsxs as jsxs21 } from "react/jsx-runtime";
var UpsellItem = ({ item, displayVariant }) => {
  const { snowplow } = useSnowplowContext6();
  const onTooltipOpen = (upsellName) => {
    snowplow?.trigger(`${displayVariant}UpsellTooltipHelperClicked`, {
      label: upsellName
    });
  };
  return /* @__PURE__ */ jsxs21(Box2, { className: "mobius-quote-card__upsell-item", children: [
    /* @__PURE__ */ jsx25(
      InfoModal,
      {
        toggleText: item.primaryText,
        title: item.primaryText,
        body: item.secondaryText,
        onOpen: () => onTooltipOpen(item.primaryText)
      }
    ),
    /* @__PURE__ */ jsx25(Text12, { className: "mobius-quote-card__upsell-price", children: item.formattedPrice })
  ] });
};

// src/components/QuoteCards/QuoteCard/Upsells/Upsells.tsx
import { useSnowplowContext as useSnowplowContext7 } from "@simplybusiness/services";
import { jsx as jsx26, jsxs as jsxs22 } from "react/jsx-runtime";
var Upsells = ({ upsells, displayVariant }) => {
  const [firstUpsell, ...remainingUpsells] = upsells;
  const { snowplow } = useSnowplowContext7();
  const onAccordionOpen = () => {
    const remainingUpsellsList = remainingUpsells.map((item) => item.primaryText).join(", ");
    snowplow?.trigger(`${displayVariant}UpsellAccordionClicked`, {
      label: remainingUpsellsList
    });
  };
  return /* @__PURE__ */ jsxs22(Box3, { className: "mobius-quote-card__upsells", children: [
    /* @__PURE__ */ jsx26(FileCirclePlus, { text: "ADD-ONS AVAILABLE IN THE NEXT STEPS" }),
    /* @__PURE__ */ jsx26("div", { className: "mobius-quote-card__upsells-first-upsell", children: /* @__PURE__ */ jsx26(
      UpsellItem,
      {
        item: firstUpsell,
        displayVariant
      },
      firstUpsell.primaryText
    ) }),
    remainingUpsells.length > 0 && /* @__PURE__ */ jsx26(
      Accordion3,
      {
        showText: "View more available add-ons",
        hideText: "Show less add-ons",
        onOpen: onAccordionOpen,
        headerPosition: "bottom",
        children: remainingUpsells.map((item) => /* @__PURE__ */ jsx26(
          UpsellItem,
          {
            item,
            displayVariant
          },
          item.primaryText
        ))
      }
    )
  ] });
};

// src/components/QuoteCards/QuoteCard/Tag/Tag.tsx
import { tag } from "@simplybusiness/icons";
import { Flex as Flex12, Icon as Icon11, Text as Text13 } from "@simplybusiness/mobius";
import { jsx as jsx27, jsxs as jsxs23 } from "react/jsx-runtime";
var Tag = ({ text: text3 }) => /* @__PURE__ */ jsxs23(Flex12, { alignItems: "flex-start", className: "mobius-quote-card__tag", gap: "xxs", children: [
  /* @__PURE__ */ jsx27(Icon11, { icon: tag, size: "sm" }),
  /* @__PURE__ */ jsx27(Text13, { variant: "small", children: text3 })
] });

// src/components/QuoteCards/QuoteCard/Upsells/UpsellContent.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
var UpsellContent = ({
  upsells,
  additionalCoverage = false,
  displayVariant
}) => {
  if (upsells.length > 0) {
    return /* @__PURE__ */ jsx28(Upsells, { upsells, displayVariant });
  }
  if (additionalCoverage) {
    return /* @__PURE__ */ jsx28(Tag, { text: "Extra coverage available in the next steps" });
  }
};

// src/components/QuoteCards/QuoteCard/CoverLimits.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var CoverLimits = ({ coverLimits }) => {
  return coverLimits.map((coverLimit) => /* @__PURE__ */ jsx29(CoverLimit, { ...coverLimit }, coverLimit.title));
};

// src/components/QuoteCards/QuoteCard/Coverage/Coverage.tsx
import { jsx as jsx30, jsxs as jsxs24 } from "react/jsx-runtime";
var Coverage2 = ({
  helpText = [],
  covers,
  extraCovers,
  className,
  displayVariant,
  withModal,
  additionalCoverage,
  upsells = []
}) => {
  const transformedCovers = transformCoverage(covers);
  const hasOtherStatesCoverage = displayVariant !== "qcp" && transformedCovers.some(
    (cover) => cover.displayName === "Other States Coverage"
  );
  const hasAccidentPolicyCoverage = covers.some(
    (cover) => cover.displayName === "24/7 Medical Expense"
  );
  const displayCovers = transformedCovers.filter(
    (cover) => cover.displayName !== "Other States Coverage"
  );
  const coverageTitle = "Coverage Information";
  const coverageContainerStyles = classNames9(
    "mobius-quote-card__coverage",
    className
  );
  const showDeductibles = (name, variant) => !(name === "Workers Compensation" && variant === "qcp");
  const showOnQcp = (variant, oneLine = false, qds = false) => !qds && (oneLine || variant === "qcp");
  const coverLimits = (product, limits, withModal2) => {
    return limits.map((limit) => {
      const { title, amount, explainer } = formatCoverLimit(limit, helpText);
      return {
        product,
        title,
        amount,
        explainer,
        withModal: withModal2
      };
    });
  };
  return /* @__PURE__ */ jsxs24(Box4, { className: coverageContainerStyles, children: [
    /* @__PURE__ */ jsxs24(Text14, { className: "mobius-quote-card__coverage-title", variant: "h3", children: [
      /* @__PURE__ */ jsx30(Icon12, { "data-testid": "coverage-title-icon", icon: fileCertificate }),
      "\xA0",
      coverageTitle
    ] }),
    /* @__PURE__ */ jsxs24(
      Flex13,
      {
        flexDirection: "column",
        gap: "sm",
        className: "mobius-quote-card__coverage-items",
        children: [
          displayCovers.map(
            ({
              displayName,
              coverName,
              quoteDetailsDisplayLimits: limits,
              quoteCardExcesses,
              quoteSliderExcesses,
              excessTitle,
              displayExcess,
              priceDetails,
              oneLineDisplay,
              qdsDisplay
            }) => /* @__PURE__ */ jsx30(
              Flex13,
              {
                flexGrow: 1,
                alignItems: "flex-start",
                className: "mobius-quote-card__coverage-item",
                children: /* @__PURE__ */ jsxs24(Flex13, { flexDirection: "column", flexGrow: 1, children: [
                  (showOnQcp(displayVariant, oneLineDisplay, qdsDisplay) || displayVariant == "qds") && /* @__PURE__ */ jsxs24(Flex13, { children: [
                    /* @__PURE__ */ jsx30(
                      Icon12,
                      {
                        icon: tick4,
                        className: "mobius-quote-card__coverage-tick-icon"
                      }
                    ),
                    /* @__PURE__ */ jsx30(Text14, { className: "mobius-quote-card__coverage-header-title", children: oneLineDisplay ? /* @__PURE__ */ jsx30(
                      CoverLimit,
                      {
                        title: displayName,
                        amount: extractCoverAmount(limits[0]),
                        explainer: findHelpText(helpText, displayName),
                        withModal: true,
                        isCoreCover: true
                      }
                    ) : displayName })
                  ] }),
                  !oneLineDisplay && /* @__PURE__ */ jsx30(
                    CoverLimits,
                    {
                      coverLimits: coverLimits(coverName, limits, withModal)
                    }
                  ),
                  displayVariant === "qcp" && priceDetails && /* @__PURE__ */ jsx30(PriceDetails, { priceDetails }),
                  extraCovers && extraCovers.length > 1 && /* @__PURE__ */ jsx30(
                    ExtraCoverage,
                    {
                      extraCovers,
                      parentCover: coverName,
                      variant: displayVariant,
                      helpText
                    }
                  ),
                  (showOnQcp(displayVariant, oneLineDisplay, qdsDisplay) || displayVariant === "qds") && showDeductibles(displayName, displayVariant) && /* @__PURE__ */ jsx30(
                    Deductibles,
                    {
                      excesses: formatExcesses(
                        displayExcess,
                        displayVariant == "qcp" ? quoteCardExcesses : quoteSliderExcesses,
                        helpText
                      ),
                      excessTitle,
                      coverName,
                      variant: displayVariant
                    }
                  )
                ] })
              },
              coverName
            )
          ),
          hasOtherStatesCoverage && /* @__PURE__ */ jsx30(
            IncludedByInsurerCoverage,
            {
              coverageTitle: "Other States Coverage",
              helpText
            }
          ),
          hasAccidentPolicyCoverage && /* @__PURE__ */ jsx30(
            IncludedByInsurerCoverage,
            {
              coverageTitle: "24/7 Medical Expense",
              helpText
            }
          ),
          /* @__PURE__ */ jsx30(
            UpsellContent,
            {
              upsells,
              additionalCoverage,
              displayVariant
            }
          )
        ]
      }
    )
  ] });
};

// src/components/QuoteCards/variants.tsx
var UK_VARIANTS = [
  "referral-reasons",
  "without-qdp-drawer",
  "unsupported-trade-referral"
];
var variants = (variant) => {
  return UK_VARIANTS.includes(variant);
};

// src/components/QuoteCards/QuoteCard/Coverage/index.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
var Coverage3 = (props) => {
  const { variant } = props;
  const isUKVariant = variants(variant);
  if (isUKVariant) {
    return /* @__PURE__ */ jsx31(Coverage, { ...props });
  }
  return /* @__PURE__ */ jsx31(Coverage2, { ...props });
};

// src/components/CoverageSummary/QuoteSummary/QuoteSummary.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
var QuoteSummary = (props) => {
  const { quote } = props;
  const classes = classNames10("mobius", "mobius-quote-summary");
  return /* @__PURE__ */ jsx32("div", { role: "listitem", className: classes, children: /* @__PURE__ */ jsx32(
    ProductInfo,
    {
      logo: quote.insurerLogo,
      productTitle: quote.productDescription || quote.covers[0].displayName,
      premium: quote.premium,
      policyStartDate: quote.policyStartDate,
      children: /* @__PURE__ */ jsx32(
        Coverage3,
        {
          covers: quote.covers,
          displayVariant: "qcp",
          helpText: quote.helpText
        }
      )
    }
  ) });
};

// src/components/CoverageSummary/CoverageSummary.tsx
import { jsx as jsx33, jsxs as jsxs25 } from "react/jsx-runtime";
var CoverageSummary = forwardRef5(
  (props, ref) => {
    const { className, quotes, paymentInfo, componentName, ...otherProps } = props;
    const classes = classNames11("mobius", "mobius-coverage-summary", className);
    const { variant } = otherProps;
    return /* @__PURE__ */ jsxs25(
      "div",
      {
        ref,
        ...otherProps,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        "data-testid": "coverage-summary",
        children: [
          /* @__PURE__ */ jsx33("div", { role: "list", className: "mobius-coverage-summary__list", children: quotes.map((quote) => /* @__PURE__ */ jsx33(QuoteSummary, { quote }, quote.id)) }),
          /* @__PURE__ */ jsx33(PaymentSummary, { ...paymentInfo })
        ]
      }
    );
  }
);
CoverageSummary.displayName = "CoverageSummary";

// src/hooks/experiments/useExperiments.ts
import { useHydrateAtoms } from "jotai/utils";
var useExperiments = (initialExperiments) => {
  const experimentMap = new Map(
    initialExperiments ? Object.entries(initialExperiments) : []
  );
  useHydrateAtoms([[experimentsAtom, experimentMap]]);
};

// src/hooks/experiments/useExperiment.ts
import { useAtomValue } from "jotai";
var useExperiment = (experiment) => {
  const allExperiments = useAtomValue(experimentsAtom);
  return allExperiments.get(experiment);
};

// src/components/CoverTogglesContainer/CoverTogglesContainer.tsx
import { Accordion as Accordion4, useBreakpoint as useBreakpoint4 } from "@simplybusiness/mobius";
import classNames14 from "classnames";

// src/hooks/useToggleCovers/useToggleCovers.ts
import { getAirbrake } from "@simplybusiness/services";
import { useMutation } from "@tanstack/react-query";

// src/utils/apiRequest.tsx
var OPTIONS = {
  method: "POST",
  headers: {
    Accept: "application/json; charset=utf-8",
    "Content-Type": "application/json; charset=utf-8"
  }
};
var apiRequest = async (url, payload) => {
  const snakeCaseBody = snakeCaseKeys(payload);
  const body = JSON.stringify(snakeCaseBody);
  const headers = {
    ...OPTIONS.headers,
    "X-CSRF-Token": payload.authenticityToken ?? "not-provided"
  };
  return fetch(url, { ...OPTIONS, headers, body }).then((res) => res.json());
};

// src/hooks/tokens/useTokens.tsx
import { useAtom as useAtom2, useAtomValue as useAtomValue2 } from "jotai";
var useTokens = () => useAtom2(tokensAtom);
var useTokensValues = () => useAtomValue2(tokensAtom);

// src/hooks/useQuoteComparisonPageState/useQuoteComparisonPageState.tsx
import { useAtom as useAtom3 } from "jotai";
import { useHydrateAtoms as useHydrateAtoms2 } from "jotai/utils";
var useSetQcpState = (components) => {
  useHydrateAtoms2([[quoteComparisonPageAtom, components]]);
};
var useQuoteComparisonPageState = () => useAtom3(quoteComparisonPageAtom);

// src/hooks/useToggleCovers/useToggleCovers.ts
var airbrake = getAirbrake({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY
});
var useToggleCovers = () => {
  const [tokens, setTokens] = useTokens();
  const [, setComponents] = useQuoteComparisonPageState();
  const mutation = useMutation({
    mutationFn: (cover) => apiRequest("?step_action=toggle_qcp_component_cover", {
      ...tokens,
      coverToggleData: [
        {
          coverName: cover.name,
          coverValue: cover.value
        }
      ]
    }),
    onSuccess: ({ data }) => {
      setComponents(data.layout.components);
      setTokens(data.configuration);
    },
    onError: (error2) => {
      console.error(`Error toggling covers: ${error2.message}`);
      void airbrake.notify(error2);
    },
    mutationKey: ["toggleCovers"]
  });
  const { isLoading, isError, error, isSuccess, mutate } = mutation;
  return {
    toggleCovers: mutate,
    isSuccess,
    isPending: isLoading,
    isError,
    error
  };
};

// src/components/CoverTogglesContainer/CoverToggle/CoverToggle.tsx
import { Checkbox, Option, Select } from "@simplybusiness/mobius";
import classNames12 from "classnames";
import { useEffect, useState as useState3 } from "react";

// src/components/CoverTogglesContainer/CoverToggle/getCoverToggleValue.ts
var getCoverToggleValue = ({
  inputType,
  checked,
  value,
  toggleOnValue = "",
  toggleOffValue = ""
}) => {
  if (inputType === "checkbox") {
    return checked ? toggleOnValue : toggleOffValue;
  }
  return value;
};

// src/components/CoverTogglesContainer/CoverToggle/CoverToggle.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var CoverToggle = (props) => {
  const {
    fieldName,
    questionText,
    value,
    options,
    toggleOnValue,
    toggleOffValue,
    selected,
    onChange,
    isLoading,
    isError
  } = props;
  const [selectValue, setSelectValue] = useState3(value);
  const [checkedValue, setCheckedValue] = useState3(selected ?? false);
  const isSelect = Array.isArray(options) && options.length > 0;
  const classes = classNames12("mobius-cover-toggle", {
    "--is-select": isSelect,
    "--is-checkbox": !isSelect
  });
  useEffect(() => {
    if (isError) {
      setSelectValue(value);
      setCheckedValue(selected ?? false);
    }
  }, [isError, selectValue, setCheckedValue, value, selected]);
  const handleChange = (e) => {
    const isCheckbox = e.target.type === "checkbox";
    const toValue = getCoverToggleValue({
      inputType: e.target.type,
      checked: isCheckbox ? e.target.checked : void 0,
      value: e.target.value,
      toggleOnValue,
      toggleOffValue
    });
    setSelectValue(toValue);
    if (!isLoading && onChange) {
      onChange({
        label: questionText,
        fromValue: value,
        name: fieldName,
        toValue
      });
    }
  };
  if (isSelect) {
    return /* @__PURE__ */ jsx34(
      Select,
      {
        name: fieldName,
        label: questionText,
        value: selectValue,
        className: classes,
        onChange: handleChange,
        isDisabled: isLoading,
        children: (options || []).map((option) => /* @__PURE__ */ jsx34(Option, { value: option.value, children: option.label }, option.value))
      }
    );
  }
  return /* @__PURE__ */ jsx34(
    Checkbox,
    {
      name: fieldName,
      label: questionText,
      value,
      className: classes,
      onChange: handleChange,
      defaultSelected: checkedValue,
      isDisabled: isLoading
    }
  );
};

// src/components/shared/PaymentToggle/PaymentToggle.tsx
import { useSnowplowContext as useSnowplowContext8 } from "@simplybusiness/services";
import classNames13 from "classnames";
import { useAtom as useAtom5 } from "jotai";

// src/hooks/usePaymentToggleState/usePaymentToggleState.tsx
import { useAtom as useAtom4 } from "jotai";
import { useHydrateAtoms as useHydrateAtoms3 } from "jotai/utils";
var useSetPaymentToggleAtom = (paymentPeriod = ANNUAL) => {
  useHydrateAtoms3([[paymentToggleAtom, paymentPeriod]]);
};
var usePaymentToggleState = () => useAtom4(paymentToggleAtom);

// src/hooks/useTogglePaymentPreference/useTogglePaymentPreference.ts
import { getAirbrake as getAirbrake2 } from "@simplybusiness/services";
import { useMutation as useMutation2 } from "@tanstack/react-query";
var airbrake2 = getAirbrake2({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY
});
var useTogglePaymentPreference = () => {
  const [tokens] = useTokens();
  const mutation = useMutation2({
    mutationFn: (paymentPreference) => apiRequest("?step_action=toggle_payment_preference", {
      ...tokens,
      paymentPreference
    }),
    onSuccess: () => {
    },
    // No response to handle
    onError: (error2) => {
      console.error(`Error toggling payment preference: ${error2.message}`);
      void airbrake2.notify(error2);
    },
    mutationKey: ["togglePaymentPreference"]
  });
  const { isLoading, isError, error, isSuccess, mutate } = mutation;
  return {
    togglePaymentPreference: mutate,
    isSuccess,
    isPending: isLoading,
    isError,
    error
  };
};

// src/hooks/useLocale/useLocale.ts
import { useAtomValue as useAtomValue3 } from "jotai";
import { useHydrateAtoms as useHydrateAtoms4 } from "jotai/utils";
import { useEffect as useEffect2 } from "react";
function useLocale(defaultLocale = DEFAULT_LOCALE) {
  useHydrateAtoms4([[localeAtom, defaultLocale]]);
  useEffect2(() => {
    document.documentElement.lang = defaultLocale;
  }, [defaultLocale]);
  const locale = useAtomValue3(localeAtom);
  const isUK = locale === LOCALE_EN_GB;
  const isUS = locale === LOCALE_EN_US;
  const dateFormat = isUK ? "dd/mm/yyyy" : "mm/dd/yyyy";
  return {
    locale,
    isUK,
    isUS,
    dateFormat
  };
}

// src/components/shared/PaymentToggle/PaymentToggle.tsx
import { jsx as jsx35, jsxs as jsxs26 } from "react/jsx-runtime";
var PaymentToggle = ({
  paymentTogglePeriod,
  shouldRecordPreference
}) => {
  const { snowplow } = useSnowplowContext8();
  useSetPaymentToggleAtom(paymentTogglePeriod);
  const [paymentPeriod, setPaymentPeriod] = usePaymentToggleState();
  const [sliderIsOpen] = useAtom5(sliderStateAtom);
  const { togglePaymentPreference } = useTogglePaymentPreference();
  const { isUK } = useLocale();
  const isAnnual = paymentPeriod === ANNUAL;
  const handleClick = () => {
    const selectedPeriod = paymentPeriod === MONTHLY ? ANNUAL : MONTHLY;
    setPaymentPeriod(selectedPeriod);
    const category = `${sliderIsOpen ? "quote_details_slider" : "qcp"}_payment_toggle`;
    snowplow?.trigger("paymentToggleClicked", {
      category,
      label: isAnnual ? "monthly payments" : "one-time payment"
    });
    if (shouldRecordPreference) {
      togglePaymentPreference(selectedPeriod);
    }
  };
  const buttonClasses = classNames13("mobius-payment-toggle", {
    "--is-toggled": isAnnual
  });
  return /* @__PURE__ */ jsxs26(
    "button",
    {
      type: "button",
      className: buttonClasses,
      onClick: handleClick,
      role: "switch",
      "aria-checked": isAnnual,
      "aria-label": `Switch to ${isAnnual ? MONTHLY : YEARLY} payment`,
      "data-testid": "payment-toggle",
      children: [
        /* @__PURE__ */ jsx35(
          "div",
          {
            className: "mobius-payment-toggle__slider",
            role: "presentation",
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ jsx35(
          "span",
          {
            className: "mobius-payment-toggle__text --monthly",
            "aria-hidden": isAnnual,
            children: "Monthly"
          }
        ),
        /* @__PURE__ */ jsx35(
          "span",
          {
            className: "mobius-payment-toggle__text --yearly",
            "aria-hidden": !isAnnual,
            children: isUK ? "Annual" : "Yearly"
          }
        )
      ]
    }
  );
};

// src/components/CoverTogglesContainer/CoverTogglesContainer.tsx
import { jsx as jsx36, jsxs as jsxs27 } from "react/jsx-runtime";
var CoverTogglesContainer = (props) => {
  const {
    coverTogglesData,
    componentName,
    variant,
    paymentPeriod,
    showToggle = false,
    shouldRecordPreference = false
  } = props;
  const { up } = useBreakpoint4();
  const isDesktop = up("lg");
  const isPaymentAside = variant === "payment-aside";
  const outerClasses = classNames14("mobius-cover-toggles-container__outer", {
    "--is-payment-aside": isPaymentAside
  });
  const classes = classNames14("mobius-cover-toggles-container", {
    "--is-collapsible": isPaymentAside,
    "--is-desktop": isDesktop
  });
  const { toggleCovers, isPending, isError } = useToggleCovers();
  const showCoverToggles = coverTogglesData?.length > 0;
  const CoverToggles = (coverTogglesData || []).map((toggle) => /* @__PURE__ */ jsx36(
    CoverToggle,
    {
      ...toggle,
      onChange: (cover) => {
        toggleCovers({
          name: toggle.fieldName,
          value: cover.toValue
        });
      },
      isLoading: isPending,
      isError
    },
    toggle.fieldName
  ));
  const CoverTogglesContainerContent = () => /* @__PURE__ */ jsx36("div", { className: classes, "data-testid": "cover-toggles-container", children: CoverToggles });
  return /* @__PURE__ */ jsxs27(
    "div",
    {
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      className: outerClasses,
      "data-testid": "cover-toggles-outer-container",
      children: [
        showCoverToggles && (isPaymentAside ? /* @__PURE__ */ jsx36(
          Accordion4,
          {
            "data-testid": "cover-toggles-accordion",
            startOpen: isDesktop,
            showText: "Change limits",
            hideText: "Change limits",
            children: /* @__PURE__ */ jsx36(CoverTogglesContainerContent, {})
          }
        ) : /* @__PURE__ */ jsx36(CoverTogglesContainerContent, {})),
        showToggle && /* @__PURE__ */ jsx36(
          PaymentToggle,
          {
            paymentTogglePeriod: paymentPeriod,
            shouldRecordPreference
          }
        )
      ]
    }
  );
};

// src/components/CoverTogglesContainer/ExperimentGridView/CoverTogglesContainer.tsx
import { Accordion as Accordion5, useBreakpoint as useBreakpoint5 } from "@simplybusiness/mobius";
import classNames16 from "classnames";

// src/components/CoverTogglesContainer/ExperimentGridView/LayoutToggle/LayoutToggle.tsx
import { Button as Button4, Icon as Icon13, Text as Text15 } from "@simplybusiness/mobius";
import { list, grid2 } from "@simplybusiness/icons";
import classNames15 from "classnames/dedupe";

// src/hooks/useSetLayoutToggleState/useSetLayoutToggleState.tsx
import { useHydrateAtoms as useHydrateAtoms5 } from "jotai/utils";
var useSetLayoutToggleAtom = (defaultLayout) => {
  const variant = useExperiment("uk2505Gridvslistview") || "";
  const isTreatment = ["treatment_grid", "treatment_list"].includes(variant);
  const layout = isTreatment ? defaultLayout || (variant === "treatment_grid" ? "grid" : "list") : "list";
  useHydrateAtoms5([[qcpLayoutToggleAtom, layout]]);
};

// src/hooks/useToggleLayoutPreference/useToggleLayoutPreference.ts
import { getAirbrake as getAirbrake3 } from "@simplybusiness/services";
import { useMutation as useMutation3 } from "@tanstack/react-query";
var airbrake3 = getAirbrake3({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY
});
var useToggleLayoutPreference = () => {
  const [tokens] = useTokens();
  const mutation = useMutation3({
    mutationFn: (quotesLayoutPreference) => apiRequest("?step_action=toggle_layout_preference", {
      ...tokens,
      quotesLayoutPreference
    }),
    onSuccess: () => {
    },
    // No response to handle
    onError: (error2) => {
      console.error(`Error toggling layout preference: ${error2.message}`);
      void airbrake3.notify(error2);
    },
    mutationKey: ["toggleLayoutPreference"]
  });
  const { isLoading, isError, error, isSuccess, mutate } = mutation;
  return {
    toggleLayoutPreference: mutate,
    isSuccess,
    isPending: isLoading,
    isError,
    error
  };
};

// src/components/CoverTogglesContainer/ExperimentGridView/LayoutToggle/LayoutToggle.tsx
import { useAtom as useAtom6 } from "jotai";
import { useSnowplowContext as useSnowplowContext9 } from "@simplybusiness/services";
import { jsx as jsx37, jsxs as jsxs28 } from "react/jsx-runtime";
var LayoutToggle = ({ quotesLayoutPreference }) => {
  useSetLayoutToggleAtom(quotesLayoutPreference);
  const { toggleLayoutPreference } = useToggleLayoutPreference();
  const [layout, setLayout] = useAtom6(qcpLayoutToggleAtom);
  const { snowplow } = useSnowplowContext9();
  const handleClick = (newLayout) => {
    setLayout(newLayout);
    toggleLayoutPreference(newLayout);
    snowplow?.trigger("layoutToggleClickedExperiment", {
      layout: newLayout
    });
  };
  return /* @__PURE__ */ jsxs28("div", { className: "mobius-layout-toggle", children: [
    /* @__PURE__ */ jsxs28(
      Button4,
      {
        variant: "link",
        className: classNames15("mobius-layout-toggle__item", {
          "mobius-layout-toggle__item--active": layout === "grid"
        }),
        onClick: () => handleClick("grid"),
        children: [
          /* @__PURE__ */ jsx37(Text15, { variant: "small", children: "Grid view" }),
          /* @__PURE__ */ jsx37(Icon13, { icon: grid2 })
        ]
      }
    ),
    /* @__PURE__ */ jsx37("div", { className: "mobius-layout-toggle__divider" }),
    /* @__PURE__ */ jsxs28(
      Button4,
      {
        variant: "link",
        className: classNames15("mobius-layout-toggle__item", {
          "mobius-layout-toggle__item--active": layout === "list"
        }),
        onClick: () => handleClick("list"),
        children: [
          /* @__PURE__ */ jsx37(Icon13, { icon: list }),
          /* @__PURE__ */ jsx37(Text15, { variant: "small", children: "List view" })
        ]
      }
    )
  ] });
};

// src/components/CoverTogglesContainer/ExperimentGridView/CoverTogglesContainer.tsx
import { jsx as jsx38, jsxs as jsxs29 } from "react/jsx-runtime";
var CoverTogglesContainer2 = (props) => {
  const {
    coverTogglesData,
    componentName,
    variant,
    paymentPeriod,
    showToggle = false,
    shouldRecordPreference = false,
    quotesLayoutPreference
  } = props;
  const { up } = useBreakpoint5();
  const isDesktop = up("lg");
  const isPaymentAside = variant === "payment-aside";
  const outerClasses = classNames16("mobius-cover-toggles-container__outer", {
    "--is-payment-aside": isPaymentAside
  });
  const classes = classNames16("mobius-cover-toggles-container", {
    "--is-collapsible": isPaymentAside,
    "--is-desktop": isDesktop
  });
  const { toggleCovers, isPending, isError } = useToggleCovers();
  const showCoverToggles = coverTogglesData?.length > 0;
  const CoverToggles = (coverTogglesData || []).map((toggle) => /* @__PURE__ */ jsx38(
    CoverToggle,
    {
      ...toggle,
      onChange: (cover) => {
        toggleCovers({
          name: toggle.fieldName,
          value: cover.toValue
        });
      },
      isLoading: isPending,
      isError
    },
    toggle.fieldName
  ));
  const CoverTogglesContainerContent = () => /* @__PURE__ */ jsx38("div", { className: classes, "data-testid": "cover-toggles-container", children: CoverToggles });
  return /* @__PURE__ */ jsxs29(
    "div",
    {
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      className: outerClasses,
      "data-testid": "cover-toggles-outer-container",
      children: [
        showCoverToggles && (isPaymentAside ? /* @__PURE__ */ jsx38(
          Accordion5,
          {
            "data-testid": "cover-toggles-accordion",
            startOpen: isDesktop,
            showText: "Change limits",
            hideText: "Change limits",
            children: /* @__PURE__ */ jsx38(CoverTogglesContainerContent, {})
          }
        ) : /* @__PURE__ */ jsx38(CoverTogglesContainerContent, {})),
        /* @__PURE__ */ jsxs29("div", { className: "mobius-cover-toggles-container__extra-toggles", children: [
          /* @__PURE__ */ jsx38(LayoutToggle, { quotesLayoutPreference }),
          showToggle && /* @__PURE__ */ jsx38(
            PaymentToggle,
            {
              paymentTogglePeriod: paymentPeriod,
              shouldRecordPreference
            }
          )
        ] })
      ]
    }
  );
};

// src/components/CoverTogglesContainer/index.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
var CoverTogglesContainer3 = (props) => {
  const isTreatment = ["treatment_grid", "treatment_list"].includes(
    useExperiment("uk2505Gridvslistview") || ""
  );
  if (isTreatment) {
    return /* @__PURE__ */ jsx39(CoverTogglesContainer2, { ...props });
  }
  return /* @__PURE__ */ jsx39(CoverTogglesContainer, { ...props });
};

// src/components/ErrorBoundary/ErrorBoundary.tsx
import { getAirbrake as getAirbrake4 } from "@simplybusiness/services";
import { Component } from "react";

// src/components/ErrorBoundary/GenericError.tsx
import { Container, Link as Link5, Text as Text16 } from "@simplybusiness/mobius";
import { jsx as jsx40, jsxs as jsxs30 } from "react/jsx-runtime";
var GenericError = () => /* @__PURE__ */ jsx40(Container, { size: "sm", className: "error-boundary__container", children: /* @__PURE__ */ jsxs30("div", { className: "error-boundary__message", children: [
  /* @__PURE__ */ jsx40(Text16, { elementType: "h1", children: "Oops!" }),
  /* @__PURE__ */ jsxs30(Text16, { children: [
    "Something went wrong - please",
    " ",
    /* @__PURE__ */ jsx40(Link5, { href: "javascript:history.go(-1)", children: "go back" }),
    " or try again,",
    /* @__PURE__ */ jsx40("br", {}),
    "or call us on 0333 014 6683 if in the UK or (844) 654-7272 if in the US."
  ] })
] }) });

// src/components/ErrorBoundary/ErrorBoundary.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var ErrorBoundary = class extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    if (true) {
      console.error(error);
    }
    this.setState({ hasError: true });
    if (true) {
      return;
    }
    const airbrake8 = getAirbrake4({
      projectId: AIRBRAKE_PROJECT_ID,
      projectKey: AIRBRAKE_PROJECT_KEY
    });
    void airbrake8.notify({
      error,
      params: { info }
    });
  }
  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return /* @__PURE__ */ jsx41(GenericError, {});
    }
    return children;
  }
};

// src/components/Footer/CompareTheMarketFooter/Footer.tsx
import { Container as Container2 } from "@simplybusiness/mobius";
import classNames17 from "classnames/dedupe";

// src/components/Footer/CompareTheMarketFooter/FooterContent.tsx
import { Link as Link6, Text as Text17 } from "@simplybusiness/mobius";
import { jsx as jsx42, jsxs as jsxs31 } from "react/jsx-runtime";
var FooterContent = () => {
  return /* @__PURE__ */ jsxs31("div", { className: "mobius-footer-ctm__content", children: [
    /* @__PURE__ */ jsx42(Text17, { elementType: "h2", children: "Important Information" }),
    /* @__PURE__ */ jsxs31("p", { children: [
      "The Comparethemarket Business insurance comparison service is provided by Simply Business. Simply Business is a trading name of Xbridge Limited which is authorised and regulated by the\xA0",
      /* @__PURE__ */ jsx42(
        Link6,
        {
          href: "https://www.fca.org.uk/",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Financial Conduct Authority"
        }
      ),
      "\xA0(Financial Services Registration No: 313348). Xbridge Limited (No: 3967717) has its registered office at 4th Floor, Hylo, 105 Bunhill Row, London EC1Y 8LZ."
    ] }),
    /* @__PURE__ */ jsx42("p", { children: "Simply Business is not part of Compare the Market Limited." }),
    /* @__PURE__ */ jsxs31("p", { children: [
      "Comparethemarket is a trading name of Compare The Market Limited. Compare The Market Limited is an insurance intermediary, which is authorised and regulated by the\xA0",
      /* @__PURE__ */ jsx42(
        Link6,
        {
          href: "https://www.fca.org.uk/",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Financial Conduct Authority"
        }
      ),
      "\xA0 (Firm Reference Number 778488)."
    ] }),
    /* @__PURE__ */ jsxs31("p", { children: [
      "For help and information for health, accessibility or financial issues please visit our\xA0",
      /* @__PURE__ */ jsx42(
        Link6,
        {
          href: "https://www.comparethemarket.com/customer-support-hub/",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Customer Support Hub"
        }
      ),
      "."
    ] }),
    /* @__PURE__ */ jsxs31("p", { children: [
      "To find out how Comparethemarket works please click\xA0",
      /* @__PURE__ */ jsx42(
        Link6,
        {
          href: "https://www.comparethemarket.com/about-us/",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "here"
        }
      ),
      "."
    ] }),
    /* @__PURE__ */ jsxs31("p", { children: [
      "You can find information about how comparethemarket.com process the data that they receive from Simply Business and any data you may provide elsewhere on the comparethemarket.com website in the Comparethemarket\xA0",
      /* @__PURE__ */ jsx42(
        Link6,
        {
          href: "https://www.comparethemarket.com/information/privacy-policy/",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Privacy and Cookie Policy"
        }
      ),
      "."
    ] }),
    /* @__PURE__ */ jsxs31("p", { children: [
      "If you participate in Comparethemarket's customer rewards programme then please note that your participation will be subject to the Rewards'\xA0",
      /* @__PURE__ */ jsx42(
        Link6,
        {
          href: "https://www.comparethemarket.com/information/rewards-terms/",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Terms & Conditions"
        }
      ),
      ". If you have any questions relating to your use of the comparethemarket.com website and any of the services that Comparethemarket provides, please\xA0",
      /* @__PURE__ */ jsx42(
        Link6,
        {
          href: "https://help.comparethemarket.com/s/",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "contact us"
        }
      ),
      "."
    ] }),
    /* @__PURE__ */ jsx42("p", { children: /* @__PURE__ */ jsxs31("strong", { children: [
      "To obtain a reward, a qualifying product must be taken out. 1 membership per year.\xA0",
      /* @__PURE__ */ jsx42(
        Link6,
        {
          href: "https://www.comparethemarket.com/information/rewards-terms/",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Rewards T&Cs apply."
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxs31("p", { children: [
      /* @__PURE__ */ jsx42("strong", { children: "Caff\xE8 Nero:" }),
      " 25% off barista-made drinks & pastries. App only. 2 codes per day. T&Cs apply."
    ] }),
    /* @__PURE__ */ jsxs31("p", { children: [
      /* @__PURE__ */ jsx42("strong", { children: "Meerkat Movies:" }),
      " Participating cinemas. Tues or Weds. 2 standard tickets only, cheapest free."
    ] }),
    /* @__PURE__ */ jsxs31("p", { children: [
      /* @__PURE__ */ jsx42("strong", { children: "Meerkat Meals:" }),
      " App only. Participating outlets. Restrictions, limitations and T&Cs apply."
    ] }),
    /* @__PURE__ */ jsxs31("p", { children: [
      /* @__PURE__ */ jsx42("strong", { children: "Pizza Delivery:" }),
      " 50% off Pizzas, 7 days a week. Minimum spend, delivery fees and radius vary by outlet. Card only. Geographical restrictions may apply."
    ] }),
    /* @__PURE__ */ jsxs31("p", { children: [
      /* @__PURE__ */ jsx42("strong", { children: "Dine out - 25% off total bill:" }),
      " Days available vary by outlet. Min and Max group sizes apply."
    ] }),
    /* @__PURE__ */ jsxs31("p", { children: [
      "This site is protected by reCAPTCHA and the Google\xA0",
      /* @__PURE__ */ jsx42(
        Link6,
        {
          href: "https://policies.google.com/privacy",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Privacy Policy"
        }
      ),
      "\xA0and\xA0",
      /* @__PURE__ */ jsx42(
        Link6,
        {
          href: "https://policies.google.com/terms",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Terms of Service"
        }
      ),
      "\xA0apply."
    ] }),
    /* @__PURE__ */ jsx42("p", { children: "\xA9 2005 - 2025 Comparethemarket All rights reserved." })
  ] });
};

// src/components/Footer/CompareTheMarketFooter/Footer.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
var Footer = (props) => {
  const {
    className,
    phoneNumber,
    openingHours,
    addresses,
    links,
    smallPrint,
    componentName,
    ...otherProps
  } = props;
  const classes = classNames17("mobius", "mobius-footer-ctm", className);
  const { variant } = otherProps;
  return /* @__PURE__ */ jsx43(
    "footer",
    {
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      className: classes,
      children: /* @__PURE__ */ jsx43(Container2, { size: "sm", className: "mobius-footer-ctm__content", children: /* @__PURE__ */ jsx43(FooterContent, {}) })
    }
  );
};

// src/components/Footer/Footer.tsx
import { Container as Container3 } from "@simplybusiness/mobius";
import classNames19 from "classnames/dedupe";

// src/components/Footer/Addresses.tsx
import { Grid, Text as Text19 } from "@simplybusiness/mobius";
import classNames18 from "classnames";
import { Fragment as Fragment6 } from "react";

// src/components/Footer/Title.tsx
import { Text as Text18 } from "@simplybusiness/mobius";
import { jsx as jsx44 } from "react/jsx-runtime";
var Title = (props) => {
  const { children } = props;
  return /* @__PURE__ */ jsx44(Text18, { className: "mobius-footer__heading", variant: "small", elementType: "h3", children });
};

// src/components/Footer/Addresses.tsx
import { jsx as jsx45, jsxs as jsxs32 } from "react/jsx-runtime";
var Addresses = (props) => {
  const { addresses } = props;
  const classes = classNames18("mobius-footer__addresses", {
    "--is-single": addresses?.length === 1
  });
  if (!addresses) {
    console.warn("Addresses will not render. Prop addresses is empty.");
    return null;
  }
  return /* @__PURE__ */ jsx45("div", { className: classes, children: /* @__PURE__ */ jsxs32("div", { children: [
    /* @__PURE__ */ jsx45(Title, { children: "Address" }),
    /* @__PURE__ */ jsx45(Grid, { columns: addresses.length, columnGap: "sm", children: addresses.map((entry) => /* @__PURE__ */ jsx45(
      Text19,
      {
        variant: "small",
        className: "mobius-footer__address-entry",
        children: /* @__PURE__ */ jsx45("span", { itemProp: "address", children: entry.map((item) => /* @__PURE__ */ jsxs32(Fragment6, { children: [
          item,
          /* @__PURE__ */ jsx45("br", {})
        ] }, item)) })
      },
      entry[0]
    )) })
  ] }) });
};

// src/components/Footer/FooterLinks.tsx
import { Flex as Flex14, Link as Link7, Text as Text20 } from "@simplybusiness/mobius";
import { jsx as jsx46, jsxs as jsxs33 } from "react/jsx-runtime";
var FooterLinks = (props) => {
  const { links } = props;
  if (!links) {
    console.warn("Links will not render. Prop links is empty.");
    return null;
  }
  return /* @__PURE__ */ jsxs33("div", { children: [
    /* @__PURE__ */ jsx46(Title, { children: "Legal" }),
    /* @__PURE__ */ jsx46(Flex14, { flexDirection: "column", children: links.map(({ href, text: text3 }) => /* @__PURE__ */ jsx46(Text20, { variant: "small", elementType: "span", children: /* @__PURE__ */ jsx46(Link7, { href, target: "_blank", children: text3 }) }, href)) })
  ] });
};

// src/components/Footer/SmallPrint.tsx
import { Text as Text21 } from "@simplybusiness/mobius";
import { jsx as jsx47 } from "react/jsx-runtime";
var SmallPrint = (props) => {
  const { text: text3 } = props;
  if (!text3) {
    console.warn("SmallPrint will not render. Prop text is empty.");
    return null;
  }
  return /* @__PURE__ */ jsx47(Text21, { variant: "legal", className: "mobius-footer__small-print", children: /* @__PURE__ */ jsx47("span", { dangerouslySetInnerHTML: { __html: text3 } }) });
};

// src/components/Footer/Support.tsx
import { telephone as telephone2 } from "@simplybusiness/icons";
import { Icon as Icon15, LinkButton as LinkButton2, Text as Text24 } from "@simplybusiness/mobius";

// src/components/Footer/OpeningHours.tsx
import { chevronDown } from "@simplybusiness/icons";
import { Icon as Icon14, Text as Text23 } from "@simplybusiness/mobius";

// src/components/Footer/OpeningHoursEntry.tsx
import { Text as Text22 } from "@simplybusiness/mobius";
import { Fragment as Fragment7, jsx as jsx48, jsxs as jsxs34 } from "react/jsx-runtime";
var OpeningHoursEntry = (props) => {
  const { day, hours } = props;
  return /* @__PURE__ */ jsxs34(Fragment7, { children: [
    /* @__PURE__ */ jsx48(Text22, { variant: "small", elementType: "span", children: day }),
    /* @__PURE__ */ jsx48(Text22, { variant: "small", elementType: "span", children: hours })
  ] });
};

// src/components/Footer/OpeningHours.tsx
import { jsx as jsx49, jsxs as jsxs35 } from "react/jsx-runtime";
var OpeningHours = (props) => {
  const { openingHours } = props;
  if (!openingHours) {
    console.warn("OpeningHours will not render. Prop openingHours is empty.");
    return null;
  }
  return /* @__PURE__ */ jsxs35("details", { className: "mobius-footer__opening-hours-container", children: [
    /* @__PURE__ */ jsxs35("summary", { className: "mobius-footer__opening-hours-toggle", children: [
      /* @__PURE__ */ jsx49(Text23, { variant: "small", elementType: "span", children: "See our opening hours" }),
      /* @__PURE__ */ jsx49(
        Icon14,
        {
          className: "mobius-footer__opening-hours-toggle-icon",
          icon: chevronDown,
          size: "xs"
        }
      )
    ] }),
    /* @__PURE__ */ jsx49("ul", { className: "mobius-footer__opening-hours-list", children: openingHours.map((entry) => {
      const { day, hours } = entry;
      return /* @__PURE__ */ jsx49("li", { className: "mobius-footer__opening-hours-list-item", children: /* @__PURE__ */ jsx49(OpeningHoursEntry, { day, hours }) }, day);
    }) })
  ] });
};

// src/components/Footer/Support.tsx
import { Fragment as Fragment8, jsx as jsx50, jsxs as jsxs36 } from "react/jsx-runtime";
var Support = (props) => {
  const { openingHours, phoneNumber } = props;
  return /* @__PURE__ */ jsxs36("div", { className: "mobius-footer__support", children: [
    phoneNumber && /* @__PURE__ */ jsxs36(Fragment8, { children: [
      /* @__PURE__ */ jsxs36(Title, { children: [
        "Need help?",
        " ",
        /* @__PURE__ */ jsx50("span", { className: "mobius-footer__heading-partial", children: "Call us" })
      ] }),
      /* @__PURE__ */ jsxs36(
        LinkButton2,
        {
          size: "sm",
          href: `tel:${phoneNumber}`,
          className: "mobius-footer__call-us-link",
          children: [
            /* @__PURE__ */ jsx50(Icon15, { icon: telephone2, size: "xs" }),
            "Call us"
          ]
        }
      ),
      /* @__PURE__ */ jsxs36(
        Text24,
        {
          variant: "h3",
          elementType: "p",
          className: "mobius-footer__phone-number",
          children: [
            phoneNumber,
            /* @__PURE__ */ jsx50(Underline, { className: "mobius-footer__phone-number-underline" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx50(OpeningHours, { openingHours })
  ] });
};

// src/components/Footer/Footer.tsx
import { jsx as jsx51, jsxs as jsxs37 } from "react/jsx-runtime";
var Footer2 = (props) => {
  const {
    className,
    phoneNumber,
    openingHours,
    addresses,
    links,
    smallPrint,
    componentName,
    ...otherProps
  } = props;
  const classes = classNames19("mobius", "mobius-footer", className);
  const { variant } = otherProps;
  return /* @__PURE__ */ jsx51(
    "footer",
    {
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      className: classes,
      children: /* @__PURE__ */ jsxs37(Container3, { size: "sm", className: "mobius-footer__content", children: [
        /* @__PURE__ */ jsx51(Support, { phoneNumber, openingHours }),
        /* @__PURE__ */ jsx51(Addresses, { addresses }),
        /* @__PURE__ */ jsx51(FooterLinks, { links }),
        /* @__PURE__ */ jsx51(SmallPrint, { text: smallPrint })
      ] })
    }
  );
};

// src/components/Footer/MoneySuperMarketFooter/Footer.tsx
import { Container as Container4, Flex as Flex15, Link as Link8, Text as Text25 } from "@simplybusiness/mobius";
import classNames20 from "classnames/dedupe";

// src/components/Footer/MoneySuperMarketFooter/footerLinks.ts
var footerLinks = [
  {
    text: "Contact Us",
    href: "https://www.moneysupermarket.com/c/customer-care/"
  },
  {
    text: "Investor Relations",
    href: "http://corporate.moneysupermarket.com/"
  },
  {
    text: "Privacy",
    href: "https://www.moneysupermarket.com/legal/privacy-policy/"
  },
  {
    text: "Careers",
    href: "http://www.moneysupermarketjobs.com/"
  },
  {
    text: "News",
    href: "https://www.moneysupermarket.com/press-releases/"
  },
  {
    text: "Terms & Conditions",
    href: "https://www.moneysupermarket.com/legal/terms/"
  },
  {
    text: "Security",
    href: "https://www.moneysupermarket.com/legal/security/"
  },
  {
    text: "Cookie Policy",
    href: "https://www.moneysupermarket.com/legal/cookie-policy/"
  }
];

// src/components/Footer/MoneySuperMarketFooter/Footer.tsx
import { jsx as jsx52, jsxs as jsxs38 } from "react/jsx-runtime";
var Footer3 = (props) => {
  const {
    className,
    phoneNumber,
    openingHours,
    addresses,
    links,
    smallPrint,
    componentName,
    ...otherProps
  } = props;
  const classes = classNames20("mobius", "mobius-footer-msm", className);
  const { variant } = otherProps;
  return /* @__PURE__ */ jsx52(
    "footer",
    {
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      className: classes,
      children: /* @__PURE__ */ jsxs38(Container4, { size: "sm", className: "mobius-footer-msm__content", children: [
        /* @__PURE__ */ jsx52("div", { className: "mobius-footer-msm__logo" }),
        /* @__PURE__ */ jsx52(Flex15, { className: "mobius-footer-msm__links", flexWrap: "wrap", children: footerLinks.map(({ href, text: text3 }) => /* @__PURE__ */ jsx52(Link8, { href, target: "_blank", rel: "nofollow", children: text3 }, href)) }),
        /* @__PURE__ */ jsx52(Text25, { variant: "legal", className: "mobius-footer-msm__small-print", children: smallPrint })
      ] })
    }
  );
};

// src/components/Footer/index.tsx
import { jsx as jsx53 } from "react/jsx-runtime";
var Footer4 = (props) => {
  const { variant } = props;
  switch (variant) {
    case "moneysupermarket":
      return /* @__PURE__ */ jsx53(Footer3, { ...props });
    case "comparethemarket":
      return /* @__PURE__ */ jsx53(Footer, { ...props });
    default:
      return /* @__PURE__ */ jsx53(Footer2, { ...props });
  }
};

// src/components/Header/CompareTheMarketHeader/CompareTheMarketHeader.tsx
import classNames21 from "classnames/dedupe";
import { Container as Container5 } from "@simplybusiness/mobius";

// src/components/Header/Logo.tsx
import { Box as Box5, Link as Link9, VisuallyHidden } from "@simplybusiness/mobius";
import { jsx as jsx54 } from "react/jsx-runtime";
var Logo2 = ({ poweredBySb, url }) => {
  if (!poweredBySb && url) {
    return /* @__PURE__ */ jsx54(Link9, { href: url, className: "mobius-header__logo", children: /* @__PURE__ */ jsx54(VisuallyHidden, { children: "Simply Business - Insurance for your business" }) });
  }
  return /* @__PURE__ */ jsx54(Box5, { className: "mobius-header__logo" });
};

// src/components/Header/ContactDetails.tsx
import { telephone as telephone3 } from "@simplybusiness/icons";
import {
  Button as Button5,
  DropdownMenu,
  Flex as Flex16,
  Icon as Icon16,
  Link as Link10,
  LinkButton as LinkButton3
} from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext10 } from "@simplybusiness/services";

// src/components/Header/PoweredBySb.tsx
import { jsx as jsx55, jsxs as jsxs39 } from "react/jsx-runtime";
var PoweredBySb = () => {
  return /* @__PURE__ */ jsx55(
    "svg",
    {
      className: "mobius-header__powered-by-icon",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 139 27",
      children: /* @__PURE__ */ jsxs39("g", { fillRule: "evenodd", stroke: "none", strokeWidth: "1", children: [
        /* @__PURE__ */ jsx55(
          "path",
          {
            className: "mobius-header__powered-by-icon-text",
            d: "M78.791 17.327c.255 0 .415.108.495.35l1.592 4.122c.12.337.24.824.24.824h.027s.107-.46.228-.811l1.538-4.12c.08-.257.227-.365.494-.365h.482c.32 0 .468.202.348.513l-2.983 7.526C80.851 26.433 80.01 27 79.06 27c-.388 0-.708-.121-.936-.216-.254-.108-.308-.351-.2-.581l.106-.23c.107-.243.308-.283.495-.23.134.055.308.15.535.15.548 0 .95-.487 1.164-1.027l.334-.784-2.622-6.242c-.133-.31.014-.513.335-.513h.52zm-7.716-.163c1.819 0 2.968 1.46 2.968 3.58 0 2.176-1.297 3.581-3.062 3.581a2.315 2.315 0 01-2.1-1.216h-.026s.04.243.04.595v2.715c0 .298-.147.446-.428.446h-.415c-.294 0-.441-.148-.441-.446v-8.647c0-.297.147-.445.441-.445h.308c.294 0 .441.148.441.377v.406c0 .203-.027.365-.027.365h.027s.575-1.31 2.274-1.31v-.001zm53.437 0c1.872 0 2.915 1.352 2.915 3.257a.453.453 0 01-.455.459h-4.52c.08 1.486 1.137 2.31 2.34 2.31.735 0 1.311-.31 1.619-.54.254-.135.454-.108.601.148l.12.203c.134.23.094.46-.133.595a3.995 3.995 0 01-2.287.73c-2.126 0-3.584-1.554-3.584-3.581 0-2.176 1.458-3.58 3.383-3.58l.001-.001zm-26.668.163c.28 0 .428.148.428.445v3.635c0 .945.2 1.702 1.27 1.702 1.391 0 2.207-1.23 2.207-2.58v-2.757c0-.297.147-.445.441-.445h.415c.28 0 .441.148.441.445v5.945c0 .298-.16.446-.441.446h-.375c-.294 0-.441-.148-.441-.446v-.608c0-.202.04-.391.04-.391h-.026c-.295.675-1.191 1.607-2.515 1.607-1.525 0-2.3-.81-2.3-2.621v-3.932c0-.297.147-.445.441-.445h.415zm-49.608-2.865c1.124 0 2.006.446 2.367.73.228.162.254.365.134.608l-.187.338c-.16.283-.375.256-.602.121-.361-.216-.936-.554-1.738-.554-.977 0-1.699.514-1.699 1.338 0 2.054 4.547 1.5 4.547 4.566 0 1.5-1.11 2.716-2.996 2.716a4.65 4.65 0 01-2.834-.986c-.174-.163-.255-.351-.054-.621l.227-.325c.16-.216.348-.243.602-.081.334.243 1.056.77 2.06.77 1.003 0 1.658-.54 1.658-1.365 0-2.107-4.547-1.634-4.547-4.606 0-1.608 1.337-2.649 3.062-2.649zm88.476 2.702c.936 0 1.551.325 1.872.527.24.122.281.352.147.595l-.12.203c-.134.243-.334.27-.588.148a2.665 2.665 0 00-1.378-.392c-.642 0-1.137.284-1.137.865 0 1.365 3.491.878 3.491 3.202 0 1.162-.976 2.013-2.434 2.013a3.75 3.75 0 01-2.273-.743c-.228-.149-.242-.378-.095-.608l.134-.19c.174-.229.348-.242.616-.094.307.203.869.554 1.658.554.669 0 1.15-.324 1.15-.905 0-1.337-3.49-.892-3.49-3.202 0-1.297 1.123-1.973 2.447-1.973zm-5.766 0c.937 0 1.552.325 1.873.527.24.122.28.352.146.595l-.12.203c-.133.243-.334.27-.588.148a2.664 2.664 0 00-1.377-.392c-.642 0-1.137.284-1.137.865 0 1.365 3.49.878 3.49 3.202 0 1.162-.976 2.013-2.434 2.013-1.123 0-1.9-.46-2.273-.743-.227-.149-.241-.378-.094-.608l.134-.19c.174-.229.347-.242.615-.094.308.203.87.554 1.658.554.67 0 1.15-.324 1.15-.905 0-1.337-3.49-.892-3.49-3.202 0-1.297 1.123-1.973 2.447-1.973zm-23.944 0c.937 0 1.552.325 1.873.527.24.122.281.352.147.595l-.12.203c-.134.243-.335.27-.589.148a2.666 2.666 0 00-1.377-.392c-.642 0-1.137.284-1.137.865 0 1.365 3.49.878 3.49 3.202 0 1.162-.976 2.013-2.433 2.013a3.756 3.756 0 01-2.274-.743c-.227-.149-.24-.378-.094-.608l.134-.19c.174-.229.348-.242.615-.094.308.203.87.554 1.659.554.668 0 1.15-.324 1.15-.905 0-1.337-3.49-.892-3.49-3.202 0-1.297 1.123-1.973 2.446-1.973zm-30.684-2.54c.28 0 .441.15.441.446v7.066c0 .77.335.879.616.906.2.027.347.134.347.391v.324c0 .284-.12.46-.454.46-.723 0-1.806-.203-1.806-1.918V15.07c0-.297.147-.445.441-.445l.415-.001zm35.156 2.703c.294 0 .44.148.44.445v5.945c0 .298-.146.446-.44.446h-.415c-.281 0-.441-.148-.441-.446v-5.945c0-.297.16-.445.44-.445h.416zm-19.111-2.702c1.59 0 2.728.891 2.728 2.431 0 .933-.442 1.676-1.164 2.054v.027c.99.297 1.552 1.243 1.552 2.31 0 1.797-1.378 2.716-3.05 2.716h-2.928c-.295 0-.442-.149-.442-.446V15.07c0-.297.147-.445.442-.445h2.862zm25.137 2.54c1.592 0 2.314.878 2.314 2.62v3.932c0 .298-.147.446-.442.446h-.414c-.281 0-.442-.148-.442-.446v-3.635c0-.959-.187-1.715-1.27-1.715-1.311 0-2.26 1.108-2.26 2.527v2.823c0 .298-.147.446-.442.446h-.414c-.28 0-.442-.148-.442-.446v-5.945c0-.296.162-.445.442-.445h.374c.295 0 .442.149.442.445v.608c0 .203-.04.392-.04.392h.026a2.806 2.806 0 012.568-1.608v.001zm-64.143.162c.294 0 .44.148.44.445v5.945c0 .298-.146.446-.44.446h-.415c-.281 0-.441-.148-.441-.446v-5.945c0-.297.16-.445.441-.445h.415zm10.266-.163c1.538 0 2.233.879 2.233 2.622v3.931c0 .298-.147.446-.44.446H65c-.28 0-.44-.148-.44-.446V20.07c0-.96-.188-1.716-1.19-1.716-1.258 0-2.007 1.31-2.007 2.622v2.742c0 .298-.147.446-.428.446h-.428c-.281 0-.428-.148-.428-.446V20.07c0-.891-.134-1.716-1.177-1.716-1.284 0-2.033 1.352-2.033 2.622v2.742c0 .298-.147.446-.44.446h-.415c-.282 0-.442-.148-.442-.446v-5.945c0-.296.16-.445.442-.445h.374c.295 0 .441.149.441.445v.608c0 .203-.04.392-.04.392h.027c.334-.797 1.284-1.608 2.354-1.608 1.137 0 1.792.527 2.032 1.554h.027c.361-.797 1.298-1.554 2.394-1.554v-.001zm7.196 1.149c-1.016 0-1.952.716-1.952 2.459 0 1.216.669 2.418 1.912 2.418 1.07 0 1.953-.878 1.953-2.432 0-1.486-.79-2.445-1.913-2.445zm21.677 1.432H90.37v3.256h2.126c1.016 0 1.632-.649 1.632-1.622 0-.972-.642-1.634-1.632-1.634zm31.99-1.554c-.99 0-1.792.676-1.98 1.824h3.625c-.04-1.202-.75-1.824-1.645-1.824zm-32.15-2.405h-1.965v2.851h1.993c.856 0 1.39-.608 1.39-1.446 0-.837-.521-1.405-1.417-1.405h-.001zm19.165-1.161c.281 0 .442.148.442.445v.446c0 .284-.16.446-.442.446h-.454c-.295 0-.441-.162-.441-.446v-.446c0-.297.146-.445.44-.445h.455zm-58.117 0c.281 0 .442.148.442.445v.446c0 .284-.16.446-.442.446h-.454c-.294 0-.442-.162-.442-.446v-.446c0-.297.148-.445.442-.445h.454zM99.347 2.948c.168 0 .258.068.314.215l1.582 3.943c.1.283.202.6.202.6h.022s.078-.317.19-.6l1.548-3.932c.056-.158.146-.226.314-.226h.247c.202 0 .291.124.224.328l-2.658 6.527c-.292.736-.874 1.223-1.626 1.223-.325 0-.594-.113-.774-.204a.26.26 0 01-.123-.362l.067-.125c.078-.147.202-.181.337-.136.123.057.291.147.493.147.505 0 .841-.442 1.054-.94l.337-.804-2.22-5.326c-.08-.192.01-.328.212-.328h.258zm-19.592-.136c1.503 0 2.356 1.099 2.356 2.719a.282.282 0 01-.292.283h-4.06c.034 1.45 1.02 2.277 2.187 2.277a2.41 2.41 0 001.48-.52c.157-.103.28-.08.37.067l.09.136c.079.136.056.272-.078.374a3.194 3.194 0 01-1.884.635c-1.683 0-2.95-1.224-2.95-2.98 0-1.87 1.256-2.991 2.781-2.991zm8.27-2.13c.18 0 .27.102.27.283v7.398c0 .182-.09.284-.27.284h-.19c-.18 0-.28-.09-.28-.272v-.43c0-.205.045-.352.045-.352h-.023s-.482 1.19-1.962 1.19c-1.514 0-2.457-1.224-2.457-2.992 0-1.8 1.055-2.98 2.535-2.98a2.022 2.022 0 011.85 1.145h.023s-.034-.193-.034-.43V.965c0-.181.101-.283.28-.283h.213zm5.597 0c.18 0 .28.102.28.283v2.55c0 .26-.045.464-.045.464h.022s.494-1.167 1.94-1.167c1.515 0 2.457 1.224 2.457 2.98 0 1.812-1.066 2.99-2.546 2.99-1.368 0-1.884-1.189-1.884-1.189h-.022s.044.17.044.42v.373c0 .159-.1.26-.28.26h-.18c-.179 0-.268-.101-.268-.283V.965c0-.181.09-.283.269-.283h.213zm-23.718 2.13c1.503 0 2.355 1.099 2.355 2.719a.282.282 0 01-.291.283h-4.06c.033 1.45 1.02 2.277 2.187 2.277a2.41 2.41 0 001.48-.52c.157-.103.28-.08.37.067l.09.136c.079.136.056.272-.079.374a3.195 3.195 0 01-1.884.635c-1.682 0-2.949-1.224-2.949-2.98 0-1.87 1.256-2.991 2.78-2.991h.001zm-15.482 0c1.649 0 2.983 1.269 2.983 2.957 0 1.722-1.334 3.014-2.972 3.014-1.648 0-2.983-1.292-2.983-3.014 0-1.688 1.335-2.957 2.972-2.957zm21.77.102c.202 0 .292.09.292.272v.204c0 .181-.123.283-.314.283-1.189 0-1.76 1.37-1.76 2.56v2.13c0 .182-.09.284-.27.284h-.213c-.18 0-.28-.102-.28-.284V3.231c0-.181.1-.283.28-.283h.202c.168 0 .27.102.27.283v.77a2.3 2.3 0 01-.046.454h.023c.269-.827.92-1.541 1.816-1.541zm-17.687.034c.157 0 .27.068.314.238l1.29 4.01c.05.152.096.324.127.447l.03.12.01.045h.023s.09-.34.18-.612l1.312-3.999c.045-.159.157-.226.314-.226h.269c.157 0 .269.067.314.226l1.312 4c.09.271.18.611.18.611h.022s.067-.328.168-.612l1.29-4.01c.045-.17.157-.238.314-.238h.235c.202 0 .28.124.225.317l-1.728 5.144c-.044.17-.157.238-.313.238h-.348c-.168 0-.27-.068-.314-.238L62.42 4.59c-.09-.284-.169-.612-.169-.612h-.022s-.078.328-.18.612l-1.3 3.818c-.045.17-.146.238-.314.238h-.348c-.168 0-.27-.068-.325-.238l-1.727-5.144c-.056-.193.033-.317.235-.317l.235.001zM48.276.682c1.414 0 2.434.929 2.434 2.402 0 1.484-1.02 2.436-2.434 2.436h-1.951v2.843c0 .182-.1.284-.27.284h-.235c-.18 0-.269-.102-.269-.284V.965c0-.181.09-.283.27-.283h2.455zM85.76 3.514c-.998 0-1.817.839-1.817 2.277 0 1.406.73 2.3 1.783 2.3.943 0 1.828-.68 1.828-2.3 0-1.155-.582-2.277-1.794-2.277zm-31.327-.011c-1.211 0-2.198.974-2.198 2.266 0 1.325.987 2.322 2.198 2.322 1.2 0 2.187-.997 2.187-2.322 0-1.292-.987-2.266-2.187-2.266zm41.275.011c-.942 0-1.829.68-1.829 2.289 0 1.167.584 2.288 1.783 2.288 1.01 0 1.828-.838 1.828-2.288 0-1.394-.74-2.289-1.782-2.289zm-15.975-.068c-.942 0-1.76.635-1.94 1.79h3.544c-.045-1.2-.763-1.79-1.604-1.79zm-9.851 0c-.942 0-1.761.635-1.94 1.79h3.544c-.046-1.2-.763-1.79-1.604-1.79zM48.187 1.385h-1.862v3.432h1.85c1.055 0 1.739-.645 1.739-1.733 0-1.076-.684-1.7-1.727-1.7v.001z"
          }
        ),
        /* @__PURE__ */ jsxs39(
          "g",
          {
            transform: "translate(-.001)",
            className: "mobius-header__powered-by-icon-logo",
            children: [
              /* @__PURE__ */ jsx55("path", { d: "M26.143.304c2.252 0 4.157.727 5.507 2.103 1.244 1.266 1.93 3.012 1.93 4.918 0 1.623-.47 2.952-1.437 4.059 1.023.53 1.834 1.24 2.411 2.113.681 1.03 1.027 2.263 1.027 3.664 0 2.125-.759 4.04-2.136 5.394-1.486 1.462-3.624 2.235-6.182 2.235h-7.237c-1.51 0-2.65-1.151-2.65-2.677V2.98c0-1.55 1.114-2.675 2.65-2.675l6.117-.001zm.001 2.399h-6.117c-.22 0-.27.051-.27.276v19.134c0 .202.072.278.27.278h7.237c1.924 0 3.487-.537 4.52-1.553.914-.899 1.418-2.204 1.418-3.677 0-.92-.21-1.705-.627-2.333-.988-1.719-4.832-2.717-4.832-2.717S31.2 9.998 31.2 7.325c0-1.27-.44-2.417-1.24-3.231-1.13-1.15-2.698-1.391-3.816-1.391z" }),
              /* @__PURE__ */ jsx55("path", { d: "M8.471 0c1.28 0 2.477.192 3.592.575 1.115.384 1.986.81 2.615 1.277.453.323.68.7.68 1.134 0 .256-.084.529-.25.818l-.616 1.118c-.255.5-.604.75-1.047.75-.266 0-.56-.09-.882-.272-.432-.261-.81-.474-1.13-.639-.322-.164-.768-.326-1.34-.485a6.381 6.381 0 00-1.72-.238c-1.12 0-2.013.25-2.678.753-.666.503-.998 1.167-.998 1.993 0 .614.208 1.16.622 1.634.415.474.951.88 1.61 1.214a30.75 30.75 0 002.182.997c.796.33 1.592.698 2.388 1.105.795.408 1.52.869 2.173 1.382.653.514 1.186 1.181 1.597 2.002.412.82.618 1.756.618 2.806 0 .987-.179 1.913-.537 2.778a6.806 6.806 0 01-1.534 2.279c-.666.654-1.505 1.17-2.517 1.547s-2.129.566-3.35.566c-1.517 0-2.925-.26-4.222-.776C2.43 23.8 1.382 23.236.588 22.624a1.798 1.798 0 01-.464-.517.95.95 0 01-.116-.484.425.425 0 010-.167c.022-.256.144-.528.365-.817l.761-1.085c.265-.367.552-.573.86-.617a.64.64 0 01.15-.017c.272 0 .583.108.933.322 1.673 1.21 3.297 1.814 4.872 1.814 1.106 0 1.983-.257 2.63-.77.647-.514.97-1.184.97-2.01 0-.492-.126-.941-.38-1.35a3.632 3.632 0 00-1.038-1.063 12.08 12.08 0 00-1.502-.87 38.76 38.76 0 00-1.775-.822 41.7 41.7 0 01-1.849-.854 12.676 12.676 0 01-1.754-1.047 9.184 9.184 0 01-1.486-1.306A5.245 5.245 0 01.74 9.239a6.314 6.314 0 01-.377-2.22c0-1.386.358-2.617 1.076-3.692.717-1.076 1.69-1.899 2.913-2.47C5.575.284 6.95 0 8.472 0z" })
            ]
          }
        )
      ] })
    }
  );
};

// src/components/Header/ContactDetails.tsx
import { Fragment as Fragment9, jsx as jsx56, jsxs as jsxs40 } from "react/jsx-runtime";
var ContactDetails = ({
  phoneNumber,
  poweredBySb,
  openingHours,
  supportUrl,
  openingHoursLabel
}) => {
  const { snowplow } = useSnowplowContext10();
  const handleHoursClick = () => snowplow?.trigger("operatingHoursClick");
  return /* @__PURE__ */ jsxs40(Flex16, { alignItems: "center", children: [
    poweredBySb && /* @__PURE__ */ jsx56(PoweredBySb, {}),
    /* @__PURE__ */ jsxs40(
      Flex16,
      {
        flexDirection: "column",
        alignItems: "end",
        className: "mobius-header__contact --is-desktop",
        children: [
          /* @__PURE__ */ jsx56(Flex16, { gap: "xs", alignItems: "center", children: phoneNumber && /* @__PURE__ */ jsxs40(Fragment9, { children: [
            /* @__PURE__ */ jsx56(Icon16, { className: "mobius-header__phone-icon", icon: telephone3 }),
            /* @__PURE__ */ jsx56("strong", { className: "mobius-header__phone-number", children: phoneNumber })
          ] }) }),
          supportUrl ? /* @__PURE__ */ jsx56(
            Link10,
            {
              className: "mobius-header__contact-link",
              href: supportUrl,
              variant: "secondary",
              onClick: handleHoursClick,
              children: openingHoursLabel
            }
          ) : /* @__PURE__ */ jsx56(
            DropdownMenu,
            {
              trigger: /* @__PURE__ */ jsx56(Button5, { variant: "link", onPress: handleHoursClick, children: openingHoursLabel }),
              className: "mobius-header__dropdown",
              children: openingHours?.map(({ day, hours }) => /* @__PURE__ */ jsx56(DropdownMenu.Item, { children: /* @__PURE__ */ jsxs40("span", { children: [
                day,
                " ",
                hours
              ] }) }, day))
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx56(
      Flex16,
      {
        alignItems: "center",
        justifyContent: "center",
        className: "mobius-header__contact --is-mobile",
        children: /* @__PURE__ */ jsxs40(LinkButton3, { "aria-label": "Phone Us", href: `tel:${phoneNumber}`, size: "sm", children: [
          /* @__PURE__ */ jsx56(Icon16, { icon: telephone3 }),
          "Call us"
        ] })
      }
    )
  ] });
};

// src/components/Header/CompareTheMarketHeader/ProvidedBySimplyBusinessLogo.tsx
import { jsx as jsx57, jsxs as jsxs41 } from "react/jsx-runtime";
var ProvidedBySimplyBusinessLogo = () => /* @__PURE__ */ jsxs41(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "88",
    height: "24",
    fill: "none",
    viewBox: "0 0 88 24",
    children: [
      /* @__PURE__ */ jsxs41("g", { clipPath: "url(#clip0_530_515)", children: [
        /* @__PURE__ */ jsx57(
          "path",
          {
            fill: "#0E0A2B",
            d: "M44.732 7.382c0-1.612-1.322-2.163-2.49-2.651-.865-.36-1.609-.67-1.609-1.339 0-.56.501-.922 1.277-.922.683 0 1.17.287 1.495.472.125.065.31.145.486.09a.54.54 0 0 0 .301-.287l.223-.405c.17-.308.11-.574-.178-.778-.345-.25-1.217-.675-2.303-.675-1.777 0-3.02 1.065-3.02 2.59 0 1.564 1.308 2.13 2.461 2.63.88.383 1.635.711 1.635 1.399 0 .568-.491.935-1.25.935-.837 0-1.442-.42-1.739-.622l-.014-.01c-.35-.19-.589-.156-.797.13l-.273.392c-.288.392-.096.64.087.795a4.78 4.78 0 0 0 2.736.897c1.75-.002 2.972-1.088 2.972-2.641M47.616 9.297V4.066c0-.372-.202-.574-.568-.574h-.544c-.367 0-.569.205-.569.574v5.231q.002.574.569.574h.544c.372.003.568-.196.568-.574M46.486 2.785h.495c.34 0 .527-.181.527-.512v-.335c0-.332-.192-.523-.527-.523h-.495c-.333 0-.516.186-.516.523v.335c.002.33.183.512.516.512M60.237 15.883h.495c.34 0 .528-.182.528-.513v-.334c0-.333-.193-.523-.527-.523h-.496c-.333 0-.516.185-.516.523v.334c.004.331.183.513.516.513M56.166 3.347c-.998 0-1.56.62-1.923 1.227-.289-.804-.93-1.227-1.868-1.227-.888 0-1.392.573-1.772 1.161V4.07c0-.372-.202-.574-.57-.574h-.48c-.366 0-.567.205-.567.574v5.23c0 .383.192.575.567.575h.554c.371 0 .568-.2.568-.574V7.005c0-1.452.577-2.114 1.336-2.114.651 0 .782.456.782 1.192v3.218c0 .372.206.573.577.573h.545c.372 0 .568-.198.568-.573V7.006c0-1.452.566-2.114 1.312-2.114.673 0 .806.478.806 1.192v3.218c0 .382.2.573.577.573h.533c.374 0 .577-.204.577-.573V5.785c.005-1.62-.71-2.438-2.122-2.438M63.187 10.02c1.742 0 2.958-1.372 2.958-3.338 0-1.998-1.154-3.34-2.872-3.34a2.38 2.38 0 0 0-1.983.98V3.98c0-.299-.223-.49-.568-.49h-.396c-.37 0-.578.21-.578.573v7.688c0 .372.207.573.578.573h.532c.38 0 .577-.199.577-.573V9.544c0-.138-.006-.257-.014-.348a2.17 2.17 0 0 0 1.766.825M61.39 6.719c0-.884.402-1.912 1.539-1.912.896 0 1.5.765 1.5 1.905s-.613 1.88-1.525 1.88c-.993-.004-1.512-.941-1.512-1.873zM69.823 9.347v-.418c0-.287-.16-.472-.439-.502-.218-.023-.44-.123-.44-.69V1.61c0-.366-.208-.573-.569-.573h-.545c-.366 0-.568.204-.568.573v6.252c0 .815.225 1.397.668 1.728.417.31.948.346 1.312.346s.58-.209.58-.588M75.957 3.49h-.62c-.336 0-.546.154-.639.47L73.584 7.17c-.06.2-.126.46-.167.634a9 9 0 0 0-.192-.661L72.037 3.95c-.11-.313-.314-.458-.64-.458h-.673c-.273 0-.4.107-.458.196s-.104.246.007.49l2.392 5.545-.225.53c-.163.382-.496.798-.947.798a1 1 0 0 1-.422-.105h-.01c-.278-.066-.496.044-.627.318l-.11.267a.57.57 0 0 0-.038.467.5.5 0 0 0 .305.278c.286.119.592.184.902.192 1.058 0 1.934-.63 2.334-1.684l2.597-6.61c.068-.191.057-.363-.03-.484-.086-.121-.23-.202-.437-.202M43.986 18.35c.63-.383 1.004-1.069 1.004-1.867 0-1.402-1.094-2.308-2.785-2.308H39.58c-.367 0-.569.205-.569.574v7.689c0 .376.198.573.569.573h2.662c.872 0 1.622-.215 2.167-.622.607-.454.928-1.135.928-1.968 0-.974-.527-1.776-1.351-2.071m-3.27-.614v-2.078h1.462c.66 0 1.058.383 1.058 1.022 0 .638-.399 1.056-1.016 1.056zm2.863 2.591c0 .743-.466 1.205-1.215 1.205h-1.646v-2.398h1.648c.738 0 1.215.468 1.215 1.193zM51.79 16.63h-.529c-.374 0-.577.206-.577.575v2.358c0 1.41-.887 2.051-1.71 2.051-.652 0-.917-.351-.917-1.216v-3.187c0-.372-.206-.573-.578-.573h-.546c-.37 0-.577.21-.577.573v3.51c0 1.62.758 2.442 2.253 2.442a2.56 2.56 0 0 0 2.13-1.14v.417c0 .376.193.573.568.573h.481c.375 0 .577-.204.577-.573V17.21c.006-.37-.206-.58-.575-.58M56.309 19.172c-.595-.204-1.107-.382-1.107-.765 0-.478.497-.554.793-.554.41.013.812.116 1.177.302q.539.234.77-.222l.124-.225c.162-.334.085-.613-.21-.765a3.6 3.6 0 0 0-1.786-.46c-1.48 0-2.475.78-2.475 1.94 0 1.315 1.129 1.712 2.035 2.03.589.206 1.098.382 1.098.759 0 .356-.314.578-.819.578-.599 0-1.045-.24-1.34-.4l-.044-.023c-.343-.177-.584-.134-.783.142l-.149.221a.6.6 0 0 0-.118.468.5.5 0 0 0 .259.316c.63.428 1.375.654 2.138.65 1.45 0 2.463-.82 2.463-1.99-.001-1.304-1.124-1.69-2.026-2.002M60.798 16.63h-.546c-.366 0-.567.206-.567.575v5.232c0 .377.192.573.567.573h.546c.371 0 .568-.198.568-.573V17.21c0-.37-.208-.58-.568-.58M66.85 16.484a2.53 2.53 0 0 0-2.183 1.165v-.444c0-.371-.201-.573-.567-.573h-.481c-.367 0-.568.204-.568.573v5.233c0 .376.193.573.568.573h.545c.372 0 .568-.199.568-.573v-2.42c0-1.154.74-1.991 1.76-1.991.66 0 .93.353.93 1.217v3.194c0 .37.206.573.577.573h.532c.38 0 .577-.199.577-.573v-3.511c.005-1.62-.757-2.443-2.259-2.443M73.648 16.483c-1.924 0-3.27 1.374-3.27 3.34 0 1.936 1.452 3.34 3.454 3.34a4.07 4.07 0 0 0 2.172-.635c.289-.17.364-.451.192-.77l-.143-.244c-.17-.299-.423-.363-.77-.197h-.005c-.398.252-.858.39-1.33.396-1.003 0-1.715-.626-1.827-1.599h3.78a.61.61 0 0 0 .605-.588c0-1.847-1.121-3.043-2.858-3.043m-.038 1.302c.697 0 1.168.495 1.212 1.268h-2.661c.162-.79.716-1.268 1.45-1.268M80.215 19.172c-.595-.204-1.107-.382-1.107-.765 0-.478.497-.554.793-.554.41.014.81.119 1.174.306q.542.234.77-.222l.125-.225c.161-.334.085-.614-.21-.765a3.6 3.6 0 0 0-1.789-.463c-1.48 0-2.474.78-2.474 1.94 0 1.315 1.128 1.712 2.035 2.03.588.206 1.097.382 1.097.759 0 .356-.313.578-.818.578-.6 0-1.046-.24-1.341-.4l-.043-.023c-.344-.177-.585-.134-.784.142l-.15.221a.6.6 0 0 0-.117.468.5.5 0 0 0 .258.316c.63.427 1.376.654 2.14.65 1.45 0 2.462-.82 2.462-1.99.004-1.305-1.12-1.691-2.021-2.003M85.926 19.172c-.594-.204-1.106-.382-1.106-.765 0-.478.497-.554.793-.554.41.013.811.116 1.176.302q.54.234.77-.222l.124-.225c.162-.333.084-.613-.21-.765a3.6 3.6 0 0 0-1.781-.46c-1.48 0-2.475.78-2.475 1.94 0 1.315 1.128 1.712 2.034 2.03.59.206 1.099.382 1.099.759 0 .356-.314.578-.819.578-.599 0-1.045-.24-1.342-.4l-.042-.023c-.343-.177-.585-.134-.784.142l-.149.221a.6.6 0 0 0-.117.468.5.5 0 0 0 .258.316c.63.427 1.376.654 2.139.65 1.45 0 2.463-.82 2.463-1.99-.005-1.304-1.128-1.69-2.03-2.002"
          }
        ),
        /* @__PURE__ */ jsx57(
          "path",
          {
            fill: "url(#paint0_linear_530_515)",
            d: "M14.81 14.474q.599 1.172.598 2.672a6.8 6.8 0 0 1-.52 2.647 6.5 6.5 0 0 1-1.484 2.17q-.967.935-2.436 1.475a9.4 9.4 0 0 1-3.243.538 11.1 11.1 0 0 1-4.087-.741Q1.754 22.497.6 21.622a1.7 1.7 0 0 1-.449-.49.9.9 0 0 1-.112-.462.4.4 0 0 1 0-.158c.04-.288.163-.559.352-.78L1.13 18.7q.385-.524.833-.59a.6.6 0 0 1 .144-.014q.396 0 .903.306 2.43 1.728 4.713 1.728 1.605 0 2.546-.734a2.32 2.32 0 0 0 .94-1.913 2.35 2.35 0 0 0-.37-1.284 3.5 3.5 0 0 0-1.004-1.013q-.697-.466-1.454-.83a37 37 0 0 0-1.718-.781q-.9-.384-1.79-.814a12.3 12.3 0 0 1-1.698-1 9 9 0 0 1-1.443-1.243 5 5 0 0 1-.993-1.644 5.9 5.9 0 0 1-.353-2.116q0-1.977 1.035-3.517A6.7 6.7 0 0 1 4.241.888Q6.02.072 8.231.072a10.8 10.8 0 0 1 3.477.548q1.62.548 2.532 1.216.657.462.656 1.081c-.01.276-.093.545-.24.779L14.06 4.76q-.37.716-1.015.715a1.8 1.8 0 0 1-.853-.26 19 19 0 0 0-1.094-.608A7.3 7.3 0 0 0 9.8 4.145a6.3 6.3 0 0 0-1.666-.225q-1.625 0-2.591.718a2.26 2.26 0 0 0-.962 1.898 2.28 2.28 0 0 0 .602 1.557c.44.481.969.874 1.558 1.157q.955.479 2.116.948a30 30 0 0 1 2.308 1.052c.742.37 1.446.812 2.103 1.317a5.5 5.5 0 0 1 1.542 1.906m20.319 1.901c0 2.068-.752 3.934-2.116 5.26-1.468 1.418-3.577 2.174-6.092 2.174h-6.934c-1.584 0-2.778-1.187-2.778-2.76V3.002a2.66 2.66 0 0 1 .788-1.977 2.7 2.7 0 0 1 1.99-.782h5.862c2.223 0 4.106.71 5.445 2.053 1.237 1.238 1.918 2.945 1.918 4.804 0 1.483-.408 2.715-1.244 3.756a6.16 6.16 0 0 1 2.138 1.933c.68 1.01 1.024 2.217 1.024 3.586zm-7.872-4.964c.032-.02 3.197-1.955 3.197-4.31 0-1.135-.397-2.158-1.12-2.88-1.023-1.027-2.46-1.244-3.486-1.244h-5.882V21.07h6.955c1.78 0 3.221-.483 4.166-1.396.829-.803 1.285-1.974 1.285-3.298 0-.82-.192-1.515-.56-2.069v-.012c-.884-1.516-4.446-2.441-4.482-2.45l-.544-.14z"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs41("defs", { children: [
        /* @__PURE__ */ jsxs41(
          "linearGradient",
          {
            id: "paint0_linear_530_515",
            x1: "29.338",
            x2: "4.353",
            y1: "25.285",
            y2: "0.153",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx57("stop", { stopColor: "#4632D8" }),
              /* @__PURE__ */ jsx57("stop", { offset: "1", stopColor: "#9084E8" })
            ]
          }
        ),
        /* @__PURE__ */ jsx57("clipPath", { id: "clip0_530_515", children: /* @__PURE__ */ jsx57("path", { fill: "#fff", d: "M0 0h88v24H0z" }) })
      ] })
    ]
  }
);

// src/components/Header/CompareTheMarketHeader/ProvidedBySB.tsx
import { jsx as jsx58, jsxs as jsxs42 } from "react/jsx-runtime";
function ProvidedBySB() {
  return /* @__PURE__ */ jsxs42("div", { className: "mobius-header__provided-by", children: [
    "Provided by ",
    /* @__PURE__ */ jsx58(ProvidedBySimplyBusinessLogo, {})
  ] });
}

// src/components/Header/CompareTheMarketHeader/CompareTheMarketHeader.tsx
import { jsx as jsx59, jsxs as jsxs43 } from "react/jsx-runtime";
function CompareTheMarketHeader({
  componentName,
  variant,
  className,
  url,
  productTitle,
  phoneNumber,
  openingHours,
  supportUrl,
  partnerSubHeader,
  partnerSubHeaderText,
  ...otherProps
}) {
  const classes = classNames21("mobius", "mobius-header", className);
  return /* @__PURE__ */ jsx59(
    "header",
    {
      className: classes,
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      children: /* @__PURE__ */ jsx59("div", { className: "mobius-header__container", children: /* @__PURE__ */ jsxs43(Container5, { size: "sm", className: "mobius-header__content", children: [
        /* @__PURE__ */ jsx59(Logo2, { url }),
        productTitle && /* @__PURE__ */ jsx59("span", { className: "mobius-header__product-title", children: productTitle }),
        /* @__PURE__ */ jsx59(ProvidedBySB, {}),
        /* @__PURE__ */ jsx59(
          ContactDetails,
          {
            phoneNumber,
            openingHours,
            supportUrl,
            openingHoursLabel: "See our opening hours"
          }
        )
      ] }) })
    }
  );
}

// src/components/Header/Header.tsx
import { Container as Container6 } from "@simplybusiness/mobius";
import classNames23 from "classnames/dedupe";

// src/components/Header/SubHeader.tsx
import { Flex as Flex17, Box as Box6 } from "@simplybusiness/mobius";
import classNames22 from "classnames/dedupe";
import { jsx as jsx60, jsxs as jsxs44 } from "react/jsx-runtime";
var SubHeader = ({
  partnerSubHeaderText,
  partnerName
}) => {
  const subheaderLogoClasses = classNames22("mobius-header__subheader-logo", {
    [`${partnerName}`]: partnerName
  });
  return /* @__PURE__ */ jsx60("div", { className: "mobius-header__subheader", children: /* @__PURE__ */ jsxs44(
    Flex17,
    {
      className: "mobius-header__subheader-content",
      justifyContent: "center",
      alignItems: "center",
      gap: "xxs",
      children: [
        /* @__PURE__ */ jsx60("span", { children: "In partnership with" }),
        partnerSubHeaderText ? /* @__PURE__ */ jsx60("strong", { children: partnerSubHeaderText }) : /* @__PURE__ */ jsx60(Box6, { className: subheaderLogoClasses })
      ]
    }
  ) });
};

// src/components/Header/Header.tsx
import { jsx as jsx61, jsxs as jsxs45 } from "react/jsx-runtime";
var Header = ({
  className,
  poweredBySb = false,
  url,
  phoneNumber,
  openingHours,
  supportUrl,
  openingHoursLabel,
  componentName,
  partnerSubHeader,
  partnerSubHeaderText,
  partnerName,
  productTitle,
  ...otherProps
}) => {
  const classes = classNames23("mobius", "mobius-header", className);
  const { variant } = otherProps;
  return /* @__PURE__ */ jsxs45(
    "header",
    {
      className: classes,
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      children: [
        /* @__PURE__ */ jsx61("div", { className: "mobius-header__container", children: /* @__PURE__ */ jsxs45(Container6, { size: "sm", className: "mobius-header__content", children: [
          /* @__PURE__ */ jsx61(Logo2, { url, poweredBySb }),
          productTitle && /* @__PURE__ */ jsx61("span", { className: "mobius-header__product-title", children: productTitle }),
          /* @__PURE__ */ jsx61(
            ContactDetails,
            {
              phoneNumber,
              poweredBySb,
              openingHours,
              supportUrl,
              openingHoursLabel
            }
          )
        ] }) }),
        partnerSubHeader && /* @__PURE__ */ jsx61(
          SubHeader,
          {
            partnerSubHeaderText,
            partnerName
          }
        )
      ]
    }
  );
};

// src/components/Header/constants.ts
var OPENING_HOURS_LABEL = "See our opening hours";
var OPENING_HOURS_US = [
  { day: "Mon-Fri", hours: "8am-8pm" },
  { day: "Sat", hours: "Closed" },
  { day: "Sun", hours: "Closed" }
];
var OPENING_HOURS_UK = [
  {
    day: "Thu",
    hours: "9.30am-5.30pm"
  },
  {
    day: "Fri",
    hours: "9.00am-5.30pm"
  },
  {
    day: "Sat",
    hours: "9.00am-2.00pm"
  },
  {
    day: "Sun",
    hours: "Closed"
  },
  {
    day: "Mon",
    hours: "9.00am-5.30pm"
  },
  {
    day: "Tue",
    hours: "9.00am-5.30pm"
  },
  {
    day: "Wed",
    hours: "9.00am-5.30pm"
  }
];
var LOGO_LINK = "https://www.simplybusiness.co.uk/";

// src/components/Header/index.tsx
import { jsx as jsx62 } from "react/jsx-runtime";
function Header2({ variant, ...props }) {
  if (variant === "comparethemarket") {
    return /* @__PURE__ */ jsx62(CompareTheMarketHeader, { variant, ...props });
  }
  return /* @__PURE__ */ jsx62(Header, { variant, ...props });
}

// src/hooks/useMutationStatus/useMutationStatus.tsx
import { useIsMutating } from "@tanstack/react-query";
function useMutationStatus(mutationKey) {
  return useIsMutating({ mutationKey: [mutationKey] }) > 0;
}

// src/components/Headline/Headline.tsx
import classNames24 from "classnames/dedupe";
import { forwardRef as forwardRef6 } from "react";

// src/components/Headline/ExtraUKText.tsx
import { Container as Container7, Link as Link11, Text as Text26 } from "@simplybusiness/mobius";
import { jsx as jsx63, jsxs as jsxs46 } from "react/jsx-runtime";
function ExtraUKText({ phoneNumber }) {
  return /* @__PURE__ */ jsx63(Container7, { children: /* @__PURE__ */ jsxs46(
    Text26,
    {
      className: "mobius-quote-headline__text mobius-quote-headline__text--variant-without-qdp-drawer",
      style: { color: "var(--color-text-lead)" },
      children: [
        "You can make changes to the covers you selected here: Can't find the cover you're looking for?",
        /* @__PURE__ */ jsx63("br", {}),
        "Give us a call on",
        " ",
        /* @__PURE__ */ jsx63(
          Link11,
          {
            "aria-label": "Contact telephone number",
            "data-testid": "phone-number-link",
            href: `tel:${phoneNumber}`,
            style: { color: "var(--color-text-lead)" },
            children: phoneNumber
          }
        ),
        " ",
        "and one of our team could help."
      ]
    }
  ) });
}

// src/components/Headline/QuoteHeadline.tsx
import { Container as Container8, Text as Text27 } from "@simplybusiness/mobius";

// src/utils/numberToWord.tsx
function numberToWord(number) {
  if (number < 0) return "zero";
  const words = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
    "twenty"
  ];
  return words[number] || "More than twenty";
}

// src/components/Headline/QuoteHeadline.tsx
import { jsx as jsx64, jsxs as jsxs47 } from "react/jsx-runtime";
var QuoteHeadline = ({
  quoteCount,
  customerName,
  trade,
  verticalHeadlineWording
}) => {
  if (quoteCount === 0) {
    return /* @__PURE__ */ jsx64("div", { className: "mobius-quote-headline__no-quotes-title", children: /* @__PURE__ */ jsx64("strong", { children: "Edit your limits and covers" }) });
  }
  const highlightClasses = "mobius-quote-headline__highlight";
  return /* @__PURE__ */ jsx64(Container8, { size: "sm", children: /* @__PURE__ */ jsxs47(
    Text27,
    {
      className: "mobius-quote-headline__text",
      style: { color: "var(--color-text-lead)" },
      children: [
        "Thanks",
        " ",
        /* @__PURE__ */ jsx64("span", { className: highlightClasses, children: /* @__PURE__ */ jsx64("strong", { className: "has-pii", children: customerName }) }),
        ", we've searched through our trusted panel of insurers and found",
        " ",
        /* @__PURE__ */ jsx64("span", { className: highlightClasses, children: /* @__PURE__ */ jsx64("strong", { children: numberToWord(quoteCount) }) }),
        " ",
        "provider",
        quoteCount > 1 ? "s" : "",
        " who can give you a quote for your",
        " ",
        /* @__PURE__ */ jsx64("span", { className: highlightClasses, children: /* @__PURE__ */ jsx64("strong", { children: trade }) }),
        verticalHeadlineWording ? " " + verticalHeadlineWording + "." : "."
      ]
    }
  ) });
};

// src/components/Headline/QuoteHeadlineWithBacklink.tsx
import { Text as Text28, Container as Container9, Link as Link12, Icon as Icon17 } from "@simplybusiness/mobius";
import { leftArrow } from "@simplybusiness/icons";
import { useSnowplowContext as useSnowplowContext11 } from "@simplybusiness/services";
import { jsx as jsx65, jsxs as jsxs48 } from "react/jsx-runtime";
var QuoteHeadlineWithBacklink = ({
  quoteCount,
  product,
  backLinkUrl,
  journeyId,
  vertical
}) => {
  const { snowplow } = useSnowplowContext11();
  if (quoteCount === 0) {
    return null;
  }
  const handleBackLinkClick = () => {
    if (journeyId && vertical) {
      snowplow?.trigger("backToApplication", { journeyId, vertical });
    }
  };
  return /* @__PURE__ */ jsxs48(Container9, { size: "sm", children: [
    backLinkUrl && /* @__PURE__ */ jsxs48(
      Link12,
      {
        href: backLinkUrl,
        className: "mobius-quote-headline__link",
        onClick: handleBackLinkClick,
        children: [
          /* @__PURE__ */ jsx65(
            Icon17,
            {
              icon: leftArrow,
              size: "xs",
              className: "mobius-quote-headline__back-icon"
            }
          ),
          /* @__PURE__ */ jsx65("span", { children: "Back" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs48(Text28, { className: "mobius-quote-headline__title", children: [
      "Your ",
      /* @__PURE__ */ jsx65("strong", { children: product }),
      " quotes"
    ] }),
    /* @__PURE__ */ jsxs48(Text28, { className: "mobius-quote-headline__description", children: [
      "We searched through multiple carriers and found",
      " ",
      /* @__PURE__ */ jsxs48("strong", { children: [
        quoteCount,
        " quote",
        quoteCount > 1 ? "s" : "",
        " "
      ] }),
      "for your business"
    ] })
  ] });
};

// src/components/Headline/QuoteHeadlineWithEditlink.tsx
import { Container as Container10, Link as Link13, Text as Text29 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext12 } from "@simplybusiness/services";
import { jsx as jsx66, jsxs as jsxs49 } from "react/jsx-runtime";
var QuoteHeadlineWithEditlink = ({
  quoteCount,
  product,
  backLinkUrl,
  journeyId,
  vertical
}) => {
  const { snowplow } = useSnowplowContext12();
  if (quoteCount === 0) {
    return null;
  }
  const handleBackLinkClick = () => {
    if (journeyId && vertical) {
      snowplow?.trigger("backToApplication", { journeyId, vertical });
    }
  };
  return /* @__PURE__ */ jsxs49(Container10, { size: "sm", children: [
    backLinkUrl && /* @__PURE__ */ jsx66(
      Link13,
      {
        href: backLinkUrl,
        className: "mobius-quote-headline__link",
        onClick: handleBackLinkClick,
        children: /* @__PURE__ */ jsx66("span", { children: "Edit application" })
      }
    ),
    /* @__PURE__ */ jsxs49(Text29, { className: "mobius-quote-headline__title", children: [
      "Your ",
      /* @__PURE__ */ jsx66("strong", { children: product }),
      " quotes"
    ] }),
    /* @__PURE__ */ jsxs49(Text29, { className: "mobius-quote-headline__description", children: [
      "We searched through multiple carriers and found",
      " ",
      /* @__PURE__ */ jsxs49("strong", { children: [
        quoteCount,
        " quote",
        quoteCount > 1 ? "s" : "",
        " "
      ] }),
      "for your business"
    ] })
  ] });
};

// src/components/Headline/Headline.tsx
import { Fragment as Fragment10, jsx as jsx67, jsxs as jsxs50 } from "react/jsx-runtime";
var Headline = forwardRef6((props, ref) => {
  const {
    className,
    componentName,
    quoteCount,
    variant = "control",
    phoneNumber,
    ...otherProps
  } = props;
  const classes = classNames24("mobius", "mobius-quote-headline", className);
  const { isUK } = useLocale();
  const showExtraText = quoteCount > 0;
  const passProps = { ...otherProps, quoteCount };
  return /* @__PURE__ */ jsxs50(
    "div",
    {
      ref,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      className: classes,
      children: [
        variant === "backlink" && /* @__PURE__ */ jsx67(
          QuoteHeadlineWithBacklink,
          {
            ...passProps
          }
        ),
        variant === "editlink" && /* @__PURE__ */ jsx67(
          QuoteHeadlineWithEditlink,
          {
            ...passProps
          }
        ),
        isUK && /* @__PURE__ */ jsxs50(Fragment10, { children: [
          /* @__PURE__ */ jsx67(
            QuoteHeadline,
            {
              ...passProps
            }
          ),
          showExtraText && /* @__PURE__ */ jsx67(ExtraUKText, { phoneNumber })
        ] })
      ]
    }
  );
});
Headline.displayName = "Headline";

// src/components/Headline/HeadlineSkeleton.tsx
import { Link as Link14, Text as Text30 } from "@simplybusiness/mobius";
import { SkeletonTheme as SkeletonTheme2 } from "react-loading-skeleton";

// src/components/QuoteCards/QuotesSkeleton/index.tsx
import classNames26 from "classnames/dedupe";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

// src/components/QuoteCards/Section/Section.tsx
import { Flex as Flex18 } from "@simplybusiness/mobius";
import classNames25 from "classnames/dedupe";
import { jsx as jsx68 } from "react/jsx-runtime";
var Section = ({
  children,
  color,
  className,
  ...otherProps
}) => {
  const classes = classNames25("mobius-quote-card__section", className, {
    "--is-light": color === "light",
    "--is-dark": color === "dark"
  });
  return /* @__PURE__ */ jsx68("div", { ...otherProps, className: classes, children: /* @__PURE__ */ jsx68(
    Flex18,
    {
      flexDirection: "column",
      className: "mobius-quote-card__section-container",
      children
    }
  ) });
};

// src/components/QuoteCards/QuotesSkeleton/QuotesSkeleton.tsx
import { Flex as Flex19 } from "@simplybusiness/mobius";
import { jsx as jsx69, jsxs as jsxs51 } from "react/jsx-runtime";
var CardSkeleton = () => /* @__PURE__ */ jsxs51("li", { className: "mobius-quote-card", children: [
  /* @__PURE__ */ jsxs51(Flex19, { className: "mobius-quote-card__header", flexDirection: "column", children: [
    /* @__PURE__ */ jsx69(
      StyledSkeleton,
      {
        className: "mobius-quote-card__header-logo",
        height: "40px"
      }
    ),
    /* @__PURE__ */ jsxs51(Flex19, { className: "mobius-quote-card__ratings --has-reinsurer-text", children: [
      /* @__PURE__ */ jsx69(StyledSkeleton, {}),
      /* @__PURE__ */ jsx69(StyledSkeleton, {})
    ] })
  ] }),
  /* @__PURE__ */ jsxs51("div", { className: "mobius-quote-card__pricing", children: [
    /* @__PURE__ */ jsx69(StyledSkeleton, { width: "70%", height: "30px" }),
    /* @__PURE__ */ jsx69(StyledSkeleton, { width: "40%" }),
    /* @__PURE__ */ jsx69(StyledSkeleton, { style: { marginBottom: "10px" } }),
    /* @__PURE__ */ jsx69("div", { className: "mobius-quote-card__badges", children: /* @__PURE__ */ jsx69("div", { style: { width: "100%" }, children: /* @__PURE__ */ jsx69(StyledSkeleton, { height: "34px" }) }) })
  ] }),
  /* @__PURE__ */ jsxs51(
    Flex19,
    {
      flexDirection: "column",
      gap: "sm",
      className: "mobius-quote-card__coverage",
      children: [
        /* @__PURE__ */ jsx69(StyledSkeleton, { width: "56%" }),
        /* @__PURE__ */ jsx69(StyledSkeleton, { width: "45%" }),
        /* @__PURE__ */ jsx69(StyledSkeleton, {}),
        /* @__PURE__ */ jsx69(StyledSkeleton, {}),
        /* @__PURE__ */ jsx69(StyledSkeleton, { width: "50%" })
      ]
    }
  ),
  /* @__PURE__ */ jsxs51(
    Flex19,
    {
      justifyContent: "space-between",
      gap: "sm",
      className: "mobius-quote-actions",
      children: [
        /* @__PURE__ */ jsx69("div", { className: "mobius-quote-actions__button qa-view-details-option", children: /* @__PURE__ */ jsx69(StyledSkeleton, { height: "40px" }) }),
        /* @__PURE__ */ jsx69("div", { className: "mobius-quote-actions__button qa-buy-quote-option", children: /* @__PURE__ */ jsx69(StyledSkeleton, { height: "40px" }) })
      ]
    }
  )
] });

// src/components/QuoteCards/QuotesSkeleton/QuotesSkeletonUK.tsx
import { Flex as Flex20, useBreakpoint as useBreakpoint6 } from "@simplybusiness/mobius";
import { jsx as jsx70, jsxs as jsxs52 } from "react/jsx-runtime";
var CardSkeletonUK = () => {
  const { down } = useBreakpoint6(customBreakpoints);
  const isMobileDevice = down("md");
  return /* @__PURE__ */ jsxs52("li", { className: "mobius-quote-card", children: [
    /* @__PURE__ */ jsx70(
      Flex20,
      {
        className: "mobius-quote-card__header --is-uk",
        flexDirection: "column",
        gap: "xxs",
        children: /* @__PURE__ */ jsx70("div", { className: "mobius-quote-card__header-logo --is-uk", children: /* @__PURE__ */ jsx70(StyledSkeleton, { height: "40px" }) })
      }
    ),
    /* @__PURE__ */ jsxs52("div", { className: "mobius-quote-card__pricing --is-uk", children: [
      /* @__PURE__ */ jsxs52(Flex20, { justifyContent: "space-between", gap: "md", children: [
        /* @__PURE__ */ jsx70("div", { style: { width: "50%", marginBottom: "6px" }, children: /* @__PURE__ */ jsx70(StyledSkeleton, { height: "34px" }) }),
        !isMobileDevice && /* @__PURE__ */ jsx70("div", { style: { width: "50%" }, children: /* @__PURE__ */ jsx70(
          StyledSkeleton,
          {
            height: "34px",
            className: "mobius-quote-card__badges --is-uk"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs52(Flex20, { style: { marginBottom: "6px" }, flexDirection: "column", gap: "xs", children: [
        /* @__PURE__ */ jsx70(StyledSkeleton, { width: "100%" }),
        /* @__PURE__ */ jsx70(StyledSkeleton, { width: "100%" })
      ] }),
      isMobileDevice && /* @__PURE__ */ jsx70(
        StyledSkeleton,
        {
          className: "mobius-quote-card__badges --is-uk",
          height: "34px",
          width: "50%"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs52("div", { className: "mobius-quote-card__coverage", children: [
      /* @__PURE__ */ jsx70("p", { className: "mobius mobius-text --is-h3 mobius-quote-card__coverage-title", children: /* @__PURE__ */ jsx70(StyledSkeleton, {}) }),
      !isMobileDevice && /* @__PURE__ */ jsxs52(
        Flex20,
        {
          gap: "sm",
          className: "mobius-quote-card__coverage-items",
          flexDirection: "column",
          children: [
            /* @__PURE__ */ jsx70(StyledSkeleton, {}),
            /* @__PURE__ */ jsx70(StyledSkeleton, {}),
            /* @__PURE__ */ jsx70(StyledSkeleton, {}),
            /* @__PURE__ */ jsx70(StyledSkeleton, {}),
            /* @__PURE__ */ jsx70(StyledSkeleton, {}),
            /* @__PURE__ */ jsx70(StyledSkeleton, {}),
            /* @__PURE__ */ jsx70(StyledSkeleton, {})
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx70(Flex20, { className: "mobius-quote-actions-form", children: /* @__PURE__ */ jsxs52(
      Flex20,
      {
        gap: "sm",
        justifyContent: "space-between",
        className: "mobius-quote-actions",
        children: [
          /* @__PURE__ */ jsx70("div", { className: "mobius-quote-actions__button mobius-quote-actions__button--is-details", children: /* @__PURE__ */ jsx70(StyledSkeleton, { height: "40px" }) }),
          /* @__PURE__ */ jsx70("div", { className: "mobius-quote-actions__button mobius-quote-actions__button--is-select", children: /* @__PURE__ */ jsx70(StyledSkeleton, { height: "40px" }) })
        ]
      }
    ) })
  ] });
};

// src/components/QuoteCards/QuotesSkeleton/index.tsx
import { jsx as jsx71 } from "react/jsx-runtime";
var StyledSkeleton = (props) => /* @__PURE__ */ jsx71(
  Skeleton,
  {
    borderRadius: "var(--radius-2)",
    ...props,
    containerClassName: "mobius-skeleton"
  }
);
var QuotesSkeleton = ({ count = 3, variant }) => {
  const isUKVariant = variants(variant);
  const classes = classNames26("mobius-quote-cards__grid", {
    "--is-horizontal": isUKVariant
  });
  return /* @__PURE__ */ jsx71(
    SkeletonTheme,
    {
      baseColor: "var(--color-background-light)",
      highlightColor: "var(--color-background)",
      children: /* @__PURE__ */ jsx71(Section, { "data-variant": variant, children: /* @__PURE__ */ jsx71("ul", { className: classes, children: Array(count).fill(void 0).map(
        (_, index) => isUKVariant ? /* @__PURE__ */ jsx71(CardSkeletonUK, {}, index) : /* @__PURE__ */ jsx71(CardSkeleton, {}, index)
      ) }) })
    }
  );
};

// src/components/Headline/HeadlineSkeleton.tsx
import { Fragment as Fragment11, jsx as jsx72, jsxs as jsxs53 } from "react/jsx-runtime";
var HeadlineSkeleton = ({ quoteCount }) => {
  const { isUK } = useLocale();
  return /* @__PURE__ */ jsx72("div", { className: "mobius-quote-headline", children: /* @__PURE__ */ jsx72(
    SkeletonTheme2,
    {
      baseColor: "var(--color-background-light)",
      highlightColor: "var(--color-background)",
      children: isUK ? quoteCount === 0 ? /* @__PURE__ */ jsx72(
        "div",
        {
          className: "mobius-quote-headline__no-quotes-title",
          style: { display: "block", textAlign: "center" },
          children: /* @__PURE__ */ jsx72(StyledSkeleton, { width: "30%" })
        }
      ) : /* @__PURE__ */ jsxs53(
        "div",
        {
          className: "mobius-quote-headline__text",
          style: {
            height: "122px"
            /* Fix div height to match Text */
          },
          children: [
            /* @__PURE__ */ jsx72(StyledSkeleton, {}),
            /* @__PURE__ */ jsx72(StyledSkeleton, { width: "50%" }),
            /* @__PURE__ */ jsxs53("div", { className: "mobius-quote-headline__text mobius-quote-headline__text--variant-without-qdp-drawer", children: [
              /* @__PURE__ */ jsx72(StyledSkeleton, { width: "65%" }),
              /* @__PURE__ */ jsx72(StyledSkeleton, { width: "40%" })
            ] })
          ]
        }
      ) : /* @__PURE__ */ jsxs53(Fragment11, { children: [
        /* @__PURE__ */ jsx72(
          Link14,
          {
            style: { display: "block" },
            className: "mobius-quote-headline__link",
            children: /* @__PURE__ */ jsx72(StyledSkeleton, { width: "8%" })
          }
        ),
        /* @__PURE__ */ jsx72(Text30, { className: "mobius-quote-headline__title", children: /* @__PURE__ */ jsx72(StyledSkeleton, { width: "42%" }) }),
        /* @__PURE__ */ jsx72(Text30, { className: "mobius-quote-headline__description", children: /* @__PURE__ */ jsx72(StyledSkeleton, { width: "55%" }) })
      ] })
    }
  ) });
};

// src/components/Headline/index.tsx
import { jsx as jsx73 } from "react/jsx-runtime";
var Headline2 = (props) => {
  const isToggling = useMutationStatus("toggleCovers");
  if (isToggling) {
    return /* @__PURE__ */ jsx73(HeadlineSkeleton, { ...props });
  }
  return /* @__PURE__ */ jsx73(Headline, { ...props });
};

// src/components/NextCoverage/NextCoverage.tsx
import { LinkButton as LinkButton4, Text as Text31 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext13 } from "@simplybusiness/services";
import classNames27 from "classnames/dedupe";
import { forwardRef as forwardRef7 } from "react";
import { jsx as jsx74, jsxs as jsxs54 } from "react/jsx-runtime";
var NextCoverage = forwardRef7(
  (props, ref) => {
    const { snowplow } = useSnowplowContext13();
    const {
      className,
      continuationUrl,
      coverageName,
      componentName,
      ...otherProps
    } = props;
    const classes = classNames27("mobius", "mobius-next-coverage", className);
    const { variant } = otherProps;
    return /* @__PURE__ */ jsxs54(
      "div",
      {
        ref,
        ...otherProps,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        "data-testid": "next-coverage",
        children: [
          /* @__PURE__ */ jsxs54(Text31, { elementType: "h2", children: [
            "You can still finish your ",
            coverageName,
            " quote online"
          ] }),
          /* @__PURE__ */ jsx74(Text31, { variant: "body", className: "mobius-next-coverage__text", children: "You're almost there - just answer a few more questions to receive your quote." }),
          /* @__PURE__ */ jsx74(
            LinkButton4,
            {
              href: continuationUrl,
              variant: "secondary",
              size: "sm",
              onClick: () => snowplow?.trigger("nextCoverageClicked", { url: continuationUrl }),
              children: "Finish quote"
            }
          )
        ]
      }
    );
  }
);
NextCoverage.displayName = "NextCoverage";

// src/components/PreFooter/InsuranceBenefits.tsx
import {
  creditCard,
  fileCertificate as fileCertificate2,
  messageQuestion
} from "@simplybusiness/icons";
import { Container as Container11, Icon as Icon18, Text as Text32 } from "@simplybusiness/mobius";
import { jsx as jsx75, jsxs as jsxs55 } from "react/jsx-runtime";
var BENEFITS = [
  {
    icon: creditCard,
    title: "Buy a policy online",
    description: "Get instant coverage today by paying all at once or choosing a payment plan, all 100% online."
  },
  {
    icon: fileCertificate2,
    title: "Instant certificate of insurance (COI)",
    description: "Once you purchase, we'll send your COI via email. You can also access it anytime in your customer account."
  },
  {
    icon: messageQuestion,
    title: "Help after you purchase",
    description: "Have a question or need to make a change? No worries - we're here to help with anything you need."
  }
];
var InsuranceBenefits = () => {
  return /* @__PURE__ */ jsx75("div", { className: "mobius-insurance-benefits", children: /* @__PURE__ */ jsxs55(Container11, { size: "sm", className: "mobius-insurance-benefits__content", children: [
    /* @__PURE__ */ jsx75(Text32, { variant: "h3", className: "mobius-insurance-benefits__title", children: "Online insurance made easy" }),
    /* @__PURE__ */ jsx75("ul", { className: "mobius-insurance-benefits__list", children: BENEFITS.map(({ icon, title, description }) => /* @__PURE__ */ jsxs55("li", { className: "mobius-insurance-benefits__item", children: [
      /* @__PURE__ */ jsx75(
        Icon18,
        {
          icon,
          size: "md",
          className: "mobius-insurance-benefits__item-icon"
        }
      ),
      /* @__PURE__ */ jsx75(
        Text32,
        {
          variant: "h4",
          className: "mobius-insurance-benefits__item-title",
          children: title
        }
      ),
      /* @__PURE__ */ jsx75(Text32, { className: "mobius-insurance-benefits__item-description", children: description })
    ] }, title)) })
  ] }) });
};

// src/components/PreFooter/PreFooter.tsx
import { Container as Container12, Text as Text33, Trust } from "@simplybusiness/mobius";
import classNames28 from "classnames/dedupe";
import { forwardRef as forwardRef8 } from "react";

// src/components/PreFooter/LogoFooterShield.tsx
import { jsx as jsx76, jsxs as jsxs56 } from "react/jsx-runtime";
var LogoFooterShield = ({
  className,
  ...props
}) => /* @__PURE__ */ jsxs56(
  "svg",
  {
    width: "20",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    ...props,
    children: [
      /* @__PURE__ */ jsx76("title", { children: "Simply Business Shield logo" }),
      /* @__PURE__ */ jsx76("g", { fill: "#F3F3F3", children: /* @__PURE__ */ jsx76("path", { d: "M2.5 5.42188C2.46094 7.14062 2.77344 9.60156 3.78906 12.0234C4.92188 14.5625 6.79688 17.0234 10 18.4688C13.1641 17.0234 15.0391 14.5625 16.1719 12.0234C17.2266 9.60156 17.5391 7.14062 17.5 5.42188L10 2.53125L2.5 5.42188ZM19.3359 4.91406C19.4531 6.86719 19.1406 9.875 17.8906 12.7656C16.6016 15.7344 14.3359 18.625 10.4688 20.3047L10 20.5L9.49219 20.3047C5.625 18.625 3.35938 15.7344 2.07031 12.7656C0.820312 9.875 0.507812 6.86719 0.625 4.91406L0.664062 4.13281L1.40625 3.82031L9.53125 0.695312L10 0.5L10.4297 0.695312L18.5547 3.82031L19.2969 4.13281L19.3359 4.91406ZM14.4141 8.66406L9.41406 13.6641L8.75 14.3281L8.08594 13.6641L5.58594 11.1641L4.92188 10.5L6.25 9.21094L6.91406 9.875L8.75 11.7109L13.0859 7.375L13.75 6.71094L15.0781 8L14.4141 8.66406Z" }) }),
      /* @__PURE__ */ jsx76("defs", { children: /* @__PURE__ */ jsx76("clipPath", { id: "a", children: /* @__PURE__ */ jsx76("path", { fill: "#fff", d: "M0 0H20V21H0z" }) }) })
    ]
  }
);

// src/components/PreFooter/PreFooter.tsx
import { Fragment as Fragment12, jsx as jsx77, jsxs as jsxs57 } from "react/jsx-runtime";
var PreFooter = forwardRef8((props, ref) => {
  const { componentName, ...otherProps } = props;
  const classes = classNames28(
    "mobius",
    "mobius-pre-footer",
    otherProps.className
  );
  const { variant } = otherProps;
  return /* @__PURE__ */ jsxs57(Fragment12, { children: [
    /* @__PURE__ */ jsx77(InsuranceBenefits, {}),
    /* @__PURE__ */ jsx77(
      "div",
      {
        ref,
        ...otherProps,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        children: /* @__PURE__ */ jsxs57(Container12, { size: "sm", className: "mobius-pre-footer__content", children: [
          /* @__PURE__ */ jsx77(
            Trust,
            {
              locale: "en-US",
              variant: "micro-combo",
              theme: "dark",
              className: "mobius-pre-footer__widget"
            }
          ),
          /* @__PURE__ */ jsx77(LogoFooterShield, {}),
          /* @__PURE__ */ jsx77(Text33, { className: "mobius-pre-footer__text", children: "Insuring over 1 million small business owners worldwide." })
        ] })
      }
    )
  ] });
});
PreFooter.displayName = "PreFooter";

// src/components/ProgressSteps/ProgressSteps.tsx
import { Container as Container13 } from "@simplybusiness/mobius";
import classNames30 from "classnames/dedupe";
import { forwardRef as forwardRef10 } from "react";

// src/components/ProgressSteps/ProgressStepsItem.tsx
import { tick as tick5 } from "@simplybusiness/icons";
import { Icon as Icon19, Link as Link15, Text as Text34 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext14 } from "@simplybusiness/services";
import classNames29 from "classnames/dedupe";
import { forwardRef as forwardRef9 } from "react";
import { Fragment as Fragment13, jsx as jsx78, jsxs as jsxs58 } from "react/jsx-runtime";
var ProgressStepsItem = forwardRef9((props, ref) => {
  const {
    isComplete,
    url,
    to,
    name,
    isActive,
    index,
    className,
    activeName,
    activeIndex,
    ...otherProps
  } = props;
  const { snowplow } = useSnowplowContext14();
  const classes = classNames29(
    "mobius",
    "mobius-progress-steps__item",
    {
      "--is-active": isActive,
      "--is-complete": isComplete,
      "--is-incomplete": !isComplete && !isActive
    },
    className
  );
  const linkClasses = classNames29(
    "mobius-progress-steps__item-link",
    "mobius-link"
  );
  const shapeClasses = "mobius-progress-steps__item-shape";
  const nameClasses = "mobius-progress-steps__item-name";
  const nameInnerClasses = "mobius-progress-steps__item-name-inner";
  const ariaLabel = `Step ${index}${name ? `, ${name}` : ""}${isComplete ? ", Complete" : ""}`;
  const handleProgressStepItemClick = () => {
    snowplow?.trigger("progressbarClicked", {
      fromStepIndex: activeIndex,
      fromStepName: activeName,
      stepIndex: index,
      stepName: name
    });
    return false;
  };
  return /* @__PURE__ */ jsx78(
    "li",
    {
      ref,
      "aria-label": ariaLabel,
      "aria-current": isActive ? "step" : void 0,
      ...otherProps,
      className: classes,
      children: isComplete ? /* @__PURE__ */ jsxs58(
        Link15,
        {
          className: linkClasses,
          href: url,
          to,
          onClick: handleProgressStepItemClick,
          children: [
            /* @__PURE__ */ jsx78("div", { className: shapeClasses, children: /* @__PURE__ */ jsx78(
              Icon19,
              {
                icon: tick5,
                className: "mobius-progress-steps__item-icon",
                size: "md"
              }
            ) }),
            /* @__PURE__ */ jsx78(Text34, { variant: "small", className: nameClasses, children: name })
          ]
        }
      ) : /* @__PURE__ */ jsxs58(Fragment13, { children: [
        /* @__PURE__ */ jsx78("div", { className: shapeClasses, children: /* @__PURE__ */ jsx78("span", { className: "mobius-progress-steps__item-number", children: index }) }),
        /* @__PURE__ */ jsx78(Text34, { variant: "small", className: nameClasses, children: /* @__PURE__ */ jsx78("span", { className: nameInnerClasses, children: name }) })
      ] })
    }
  );
});
ProgressStepsItem.displayName = "ProgressStepsItem";

// src/components/ProgressSteps/ProgressSteps.tsx
import { jsx as jsx79 } from "react/jsx-runtime";
var ProgressSteps = forwardRef10(
  (props, ref) => {
    const { className, steps, componentName, ...otherProps } = props;
    const { variant } = otherProps;
    if (!steps) {
      console.warn("ProgressSteps will not render. Prop steps is empty.");
      return null;
    }
    const classes = classNames30("mobius", "mobius-progress-steps", className);
    const itemCount = steps.length;
    const activeStep = steps.find((step) => step.isActive);
    return /* @__PURE__ */ jsx79(
      Container13,
      {
        size: "sm",
        elementType: "ol",
        ref,
        ...otherProps,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        style: { gridTemplateColumns: `repeat(${itemCount}, 1fr)` },
        children: steps.map((step, index) => /* @__PURE__ */ jsx79(
          ProgressStepsItem,
          {
            index: index + 1,
            activeIndex: activeStep?.index,
            activeName: activeStep?.name,
            ...step
          },
          step.name
        ))
      }
    );
  }
);
ProgressSteps.displayName = "ProgressSteps";

// src/components/Questionnaire/Questionnaire.tsx
import {
  useBreakpoint as useBreakpoint7
} from "@simplybusiness/mobius";
import classNames43 from "classnames/dedupe";
import { forwardRef as forwardRef20, useCallback as useCallback8, useEffect as useEffect10, useRef as useRef5 } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";

// src/hooks/usePrepopulateAnswers/usePrepopulateAnswers.tsx
import { useMutation as useMutation4 } from "@tanstack/react-query";

// src/hooks/useQuestionnaire/useQuestionnaire.tsx
import { useAtom as useAtom7 } from "jotai";
import { atomWithReducer } from "jotai/utils";
import { useCallback as useCallback3, useEffect as useEffect3, useMemo } from "react";

// src/components/Questionnaire/validation/question/rules/dateRange.ts
var dateRange = ({ name, answer, validation }) => {
  const { futureOnly, minDays, maxDays } = validation.value;
  const invalid = () => ({
    id: name,
    valid: false,
    message: validation.message
  });
  if (futureOnly) {
    const today = (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
    const date = new Date(answer).toISOString().split("T")[0];
    if (date < today) {
      return invalid();
    }
  }
  if (minDays) {
    const today = /* @__PURE__ */ new Date();
    const date = new Date(answer);
    const minDate = new Date(today.setDate(today.getDate() + minDays));
    if (date < minDate) {
      return invalid();
    }
  }
  if (maxDays) {
    const today = /* @__PURE__ */ new Date();
    const date = new Date(answer);
    const maxDate = new Date(today.setDate(today.getDate() + maxDays));
    if (date > maxDate) {
      return invalid();
    }
  }
  return {
    id: name,
    valid: true
  };
};

// src/components/Questionnaire/validation/question/rules/regex.ts
var regex = ({ name, answer, validation }) => {
  const expression = validation.value;
  const valid = new RegExp(expression).test(answer);
  return {
    id: name,
    valid,
    message: valid ? void 0 : validation.message
  };
};
var caseInsensitiveRegex = ({
  name,
  answer,
  validation
}) => {
  const expression = validation.value;
  const valid = new RegExp(expression, "i").test(answer);
  return {
    id: name,
    valid,
    message: valid ? void 0 : validation.message
  };
};

// src/components/Questionnaire/validation/question/rules/email.ts
var email = ({ name, answer }) => {
  const expression = "^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9_-]{0,61}[a-z0-9])?(?:.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])){1,}$";
  return caseInsensitiveRegex({
    name,
    answer,
    validation: {
      type: "regex",
      value: expression,
      message: ERRORS.INVALID_EMAIL
    }
  });
};

// src/components/Questionnaire/validation/question/rules/postcode.ts
var postcode = ({ name, answer }) => {
  const expression = "^\\s*([A-Z]{1,2}[0-9R][0-9A-Z]?)\\s*(([0-9])([ABDEFGHJLNPQRSTUW]{2}))\\s*$";
  return caseInsensitiveRegex({
    name,
    answer,
    validation: {
      type: "regex",
      value: expression,
      message: ERRORS.INVALID_POSTCODE
    }
  });
};

// src/components/Questionnaire/validation/question/rules/list.ts
var list2 = ({ name, answer, validation }) => {
  const allowedValues = validation.value;
  const valid = allowedValues.includes(answer);
  return {
    id: name,
    valid,
    message: valid ? void 0 : validation.message
  };
};

// src/components/Questionnaire/validation/question/rules/percentages.ts
var percentages = ({ name, answer, validation }) => {
  const fail = (message2) => ({
    id: name,
    valid: false,
    message: message2 || validation.message || "Percentages must total 100%"
  });
  if (!answer) return fail();
  const parts = answer.split(",").map((p) => p.trim()).filter(Boolean);
  if (!parts.length) return fail();
  let total = 0;
  for (const p of parts) {
    const num = Number(p);
    if (!Number.isFinite(num) || num < 0) return fail();
    total += num;
  }
  const valid = total === 100;
  return {
    id: name,
    valid,
    message: valid ? void 0 : validation.message || "Percentages must total 100%"
  };
};

// src/components/Questionnaire/validation/question/rules/range.ts
var range = ({ name, answer, validation }) => {
  const { min, max } = validation.value;
  let answerValue2 = answer;
  let valid = false;
  if (typeof min === "number" && typeof max === "number") {
    answerValue2 = Number(answer);
  }
  valid = (answerValue2 >= min ? true : false) && (answerValue2 <= max ? true : false);
  return {
    id: name,
    valid,
    message: valid ? void 0 : validation.message
  };
};

// src/components/Questionnaire/validation/question/rules/tel.ts
var tel = ({ name, answer }) => {
  const phoneRegex = /^(\+44|0044|44|0)\d{9,11}$/;
  const strippedAnswer = answer.replace(/[()\s-]/g, "");
  const valid = phoneRegex.test(strippedAnswer);
  return {
    id: name,
    valid,
    message: valid ? void 0 : ERRORS.INVALID_TEL
  };
};

// src/components/Questionnaire/validation/question/rules/index.ts
var ok = (name) => ({
  id: name,
  valid: true,
  message: void 0
});
var validators = {
  range,
  list: list2,
  regex,
  email,
  postcode,
  tel,
  date: dateRange,
  percentages
};
var applyRules = ({ name, validation, answer }) => {
  if (!answer) {
    return {
      id: name,
      valid: false,
      message: ERRORS.REQUIRED
    };
  }
  const { type } = validation;
  if (!(type in validators)) {
    return ok(name);
  }
  const validator = validators[type];
  return validator({ name, validation, answer });
};

// src/components/validation/question/validate.ts
var buildPercentagesAnswer = (name, answers) => {
  const prefix = `${name}[`;
  const parts = [];
  for (const [k, v] of Object.entries(answers)) {
    if (k.startsWith(prefix) && k.endsWith("]")) {
      const num = Number(v);
      if (Number.isFinite(num) && num >= 0) {
        parts.push(num);
      }
    }
  }
  return parts.join(",");
};
var inferredValidationList = ["tel", "email", "postcode"];
var validateQuestion = (question, answers) => {
  const { name, validation, visible, display } = question;
  let inferredValidation = validation;
  if (display?.type && inferredValidationList.includes(display?.type)) {
    inferredValidation = { type: display.type };
  }
  if (!inferredValidation || !visible) {
    return ok(name);
  }
  let answer = (answers[name] ?? "").toString();
  if (question.validation?.type === "percentages") {
    answer = buildPercentagesAnswer(name, answers);
  }
  const result = applyRules({ name, validation: inferredValidation, answer });
  return result ?? ok(name);
};

// src/components/Questionnaire/validation/question/validate.ts
var validateQuestion2 = (question, answers) => {
  return validateQuestion(question, answers);
};

// src/components/Questionnaire/validation/form/compare.ts
var compare = (op) => (a, b) => {
  switch (op) {
    case "eq":
      return a === b;
    case "neq":
      return a !== b;
    case "lt":
      return a < b;
    case "lte":
      return a <= b;
    case "gt":
      return a > b;
    case "gte":
      return a >= b;
    case "in":
      return a.includes(b);
    case "nin":
      return !a.includes(b);
    default:
      throw new Error("Unsupported comparison operator");
  }
};
var compareFunctions = /* @__PURE__ */ new Map();
var getCompareFunction = (operator) => {
  if (!compareFunctions.has(operator)) {
    compareFunctions.set(operator, compare(operator));
  }
  return compareFunctions.get(operator);
};

// src/components/Questionnaire/validation/form/types.ts
var isRule = (rule) => {
  return "operator" in rule && !("rules" in rule);
};
var isRuleSet = (rule) => {
  return "message" in rule;
};

// src/components/Questionnaire/validation/form/validate.ts
var compileRule = (rule) => {
  const evaluateRule = getCompareFunction(rule.operator);
  return (answers, visibilityMap = {}) => {
    if (!visibilityMap[rule.id]) {
      return {
        id: rule.id,
        valid: true,
        // Consider invisible questions as valid
        message: void 0
      };
    }
    const compareValue = rule.valueSource ? answers[rule.valueSource] : rule.value;
    const valid = !answers[rule.id] || !compareValue ? false : evaluateRule(answers[rule.id].toString(), compareValue.toString());
    return {
      id: rule.id,
      valid,
      message: valid && isRuleSet(rule) ? void 0 : rule.message
    };
  };
};
var compileCombinator = (combinator) => {
  const compiledRules = combinator.rules.map(
    (ruleOrCombinator) => {
      if (isRule(ruleOrCombinator)) {
        return compileRule(ruleOrCombinator);
      }
      return compileCombinator(ruleOrCombinator);
    }
  );
  return (answers, visibilityMap = {}) => {
    const results = compiledRules.map((rule) => rule(answers, visibilityMap));
    const visibleResults = results.filter(
      (result) => visibilityMap[result.id] !== false
    );
    if (visibleResults.length === 0) {
      return {
        id: combinator.id,
        valid: true,
        message: void 0
      };
    }
    const valid = combinator.combinator === "and" ? visibleResults.every((result) => result.valid) : visibleResults.some((result) => result.valid);
    return {
      id: combinator.id,
      valid,
      message: valid && isRuleSet(combinator) ? void 0 : combinator.message
    };
  };
};
var compileRuleSet = (ruleSet) => {
  return isRule(ruleSet) ? compileRule(ruleSet) : compileCombinator(ruleSet);
};
var isRequiredButEmpty = (question, answer) => {
  if (!question.visible) return false;
  if (!(question.required || question.isRequired)) return false;
  return !answer || Array.isArray(answer) && !answer.length;
};
var createValidator = (validations) => {
  const compiledRuleset = validations.map(compileRuleSet);
  return (question, answers, visibilityMap) => {
    const answer = answers[question.name];
    if (!question.visible) {
      return ok(question.name);
    }
    if (isRequiredButEmpty(question, answer)) {
      return { id: question.name, valid: false, message: ERRORS.REQUIRED };
    }
    const localValidation = validateQuestion2(question, answers);
    if (!localValidation.valid) {
      return localValidation;
    }
    const formValidation = compiledRuleset.map((ruleFunction) => ruleFunction(answers, visibilityMap)).filter(
      (result) => result.id === question.name && result.valid === false
    )[0];
    return formValidation ?? ok(question.name);
  };
};

// src/hooks/useQuestionnaire/reducer/constants.ts
var ACTIONS = {
  SET: "SET",
  SET_VALIDATIONS: "SET_VALIDATIONS",
  SET_CONFIG: "SET_CONFIG",
  SET_ERRORS: "SET_ERRORS",
  MERGE: "MERGE",
  UPDATE_ANSWER: "UPDATE_ANSWER",
  NEXT_SECTION: "NEXT_SECTION",
  PREVIOUS_SECTION: "PREVIOUS_SECTION",
  VALIDATE_FORM: "VALIDATE_FORM",
  REMOVE_ERROR: "REMOVE_ERROR",
  SHOW_QUESTION: "SHOW_QUESTION",
  SET_ADDRESS_MODE: "SET_ADDRESS_MODE",
  SET_EDIT_MODE: "SET_EDIT_MODE",
  EDIT_QUESTION: "EDIT_QUESTION",
  APPEND_QUESTIONS: "APPEND_QUESTIONS",
  CONFIRM_GROUP: "CONFIRM_GROUP"
};

// src/components/Questionnaire/Section/Question/types.ts
var getItemType = (item) => {
  if ("type" in item && item.type !== void 0) {
    return item.type;
  }
  return "question";
};
var isQuestion = (item) => getItemType(item) === "question";
var isYesNoToggleGroup = (group) => getItemType(group) === "consolidated_question_group";
var isMultiselectGroup = (group) => getItemType(group) === "boolean_group";
var isMultiselectToggleGroup = (group) => getItemType(group) === "consolidated_boolean_group";
var isAddressLookupGroup = (group) => getItemType(group) === "address_autocomplete_group";
var isQuestionInGroup = (questionName, groups) => {
  return Object.values(groups).some(
    (group) => group.names.includes(questionName)
  );
};

// src/hooks/useQuestionnaire/getVisibilityMap.ts
var getVisibilityMap = (sections, addressModes, groups, visibility) => sections.flatMap(
  ({ questions }) => questions.flatMap((q) => {
    if (!q.name) return [];
    if (isQuestionInGroup(q.name, groups)) {
      return [{ [q.name]: visibility?.[q.name] ?? false }];
    }
    if (q.associatedQuestionName && addressModes[q.associatedQuestionName] === "lookup") {
      return [{ [q.name]: false }];
    }
    return [{ [q.name]: q.visible ?? false }];
  })
).reduce((acc, q) => ({ ...acc, ...q }), {});

// src/hooks/useQuestionnaire/formatAnswer.ts
var formatAnswer = (question, answer) => {
  if (question.display?.type === "date") {
    return toISODate(answer);
  }
  return answer;
};

// src/hooks/useQuestionnaire/reducer/actions/setAction/initialiseAnswers.ts
var initialiseAnswers = (answers, payload) => {
  const newAnswers = payload.reduce(
    (acc, section) => section.questions.reduce((acc2, question) => {
      if (question.answer !== void 0) {
        const answer = formatAnswer(question, question.answer);
        return {
          ...acc2,
          [question.name]: answer
        };
      }
      return acc2;
    }, acc),
    {}
  );
  return { ...answers, ...newAnswers };
};

// src/hooks/useQuestionnaire/setAddressMode.ts
var setAddressQuestionVisibility = (lookupName, sections, addressModes, answers) => {
  const updatedAnswers = { ...answers };
  const updatedSections = sections.map((section) => {
    const updatedQuestions = section.questions.map((question) => {
      const { name, associatedQuestionName } = question;
      if (name && addressModes[name] && name === lookupName) {
        return addressModes[name] !== "lookup" ? { ...question, visible: false } : { ...question, visible: true };
      }
      if (associatedQuestionName && addressModes[associatedQuestionName] && associatedQuestionName === lookupName) {
        if (addressModes[associatedQuestionName] === "manual") {
          updatedAnswers[name] = "";
          return { ...question, answer: "", visible: true };
        }
        return { ...question, visible: false };
      }
      return question;
    });
    return { ...section, questions: updatedQuestions };
  });
  return {
    sections: updatedSections,
    answers: updatedAnswers
  };
};
var setManualQuestionVisibility = (sections, addressModes) => {
  return sections.map((section) => {
    const updatedQuestions = section.questions.map((question) => {
      const { associatedQuestionName } = question;
      if (associatedQuestionName && addressModes[associatedQuestionName]) {
        return addressModes[associatedQuestionName] === "manual" ? { ...question, answer: "", visible: true } : { ...question, visible: false };
      }
      return question;
    });
    return { ...section, questions: updatedQuestions };
  });
};
var setAddressModes = (sections) => {
  const addressModes = sections.reduce((acc, section) => {
    section.questions.forEach(({ name, display, visible }) => {
      if (display.type === "address_lookup") {
        acc[name] = visible ? "lookup" : "none";
      }
    });
    return acc;
  }, {});
  const updatedSections = setManualQuestionVisibility(sections, addressModes);
  return {
    addressModes,
    sections: updatedSections
  };
};

// src/hooks/useQuestionnaire/reducer/actions/groups/flattenGroup.ts
var getPrimaryAnswer = (primaryQuestion, answers) => {
  const answer = primaryQuestion.answer || answers[primaryQuestion.name];
  return typeof answer === "string" ? answer : null;
};
var filterQuestions = (questions) => {
  return questions.filter(isQuestion);
};
var mergeAnswers = (baseAnswers, newAnswers) => {
  return { ...baseAnswers, ...newAnswers };
};
var createShadowQuestion = (title, visibleQuestions = [], answers) => {
  const name = `Shadow::${title}`;
  const answer = visibleQuestions.filter((q) => answers?.[q.name] === "yes").map((q) => q.name);
  return {
    question: {
      id: snakeCase(`shadow::${title}`),
      name,
      primaryText: title,
      visible: true,
      includeAnswer: false,
      options: visibleQuestions.map((q) => ({
        label: q.name,
        value: q.name
      })),
      display: {
        type: "multiselect",
        config: { lastItemDisables: true }
      }
    },
    answer
  };
};
var createAddressLookupQuestion = (group) => {
  const { title, countryCode, manualEntryDisabled, apiKey } = group;
  return {
    id: snakeCase(`shadow::${title}`),
    name: `Shadow::${title}`,
    primaryText: title,
    visible: true,
    includeAnswer: false,
    // The display type acts as a pseudo primary question controlling address behaviour
    display: {
      type: "address_lookup_group",
      config: {
        countryCode,
        manualEntryDisabled: !!manualEntryDisabled,
        apiKey
      }
    }
  };
};
var mapQuestionsWithAnswers = (questions, answers, primaryAnswerIsYes, visibility = {}) => {
  const updatedAnswers = { ...answers };
  const updatedVisibility = { ...visibility };
  const updatedQuestions = questions.map((q) => {
    const answer = primaryAnswerIsYes ? q.answer || null : "no";
    if (answer !== null) {
      updatedAnswers[q.name] = answer;
    }
    updatedVisibility[q.name] = primaryAnswerIsYes;
    return { ...q };
  });
  return {
    questions: updatedQuestions,
    answers: updatedAnswers,
    visibility: updatedVisibility
  };
};
var mapQuestionsWithHiddenVisibility = (questions, answers, visibility = {}) => {
  const updatedAnswers = { ...answers };
  const updatedVisibility = { ...visibility };
  const updatedQuestions = questions.map((q) => {
    if (q.answer) {
      updatedAnswers[q.name] = q.answer;
    }
    updatedVisibility[q.name] = false;
    return { ...q, includeAnswer: !!q.visible };
  });
  return {
    questions: updatedQuestions,
    answers: updatedAnswers,
    visibility: updatedVisibility
  };
};
var flattenMultiselectToggleGroup = (group, answers, visibility) => {
  const { title, primaryQuestion, booleanGroups } = group;
  if (!primaryQuestion || !booleanGroups) {
    return { questions: [], answers, groups: {}, visibility: {} };
  }
  const primaryAnswer = getPrimaryAnswer(primaryQuestion, answers);
  const primaryAnswerIsYes = primaryAnswer === "yes";
  const allBooleanQuestions = booleanGroups.flatMap((bg) => bg.groupQuestions).filter(isQuestion);
  const visibleQuestions = allBooleanQuestions.filter((q) => q.visible);
  const result = mapQuestionsWithAnswers(
    allBooleanQuestions,
    answers,
    primaryAnswerIsYes,
    visibility
  );
  const shadowQuestion = createShadowQuestion(
    title,
    visibleQuestions,
    result.answers
  );
  return {
    questions: [primaryQuestion, ...result.questions, shadowQuestion.question],
    groups: {
      [shadowQuestion.question.name]: {
        kind: "shadow",
        names: visibleQuestions.map((q) => q.name)
      },
      [primaryQuestion.name]: {
        kind: "group",
        names: [shadowQuestion.question.name]
      }
    },
    visibility: {
      ...result.visibility,
      [shadowQuestion.question.name]: primaryAnswerIsYes
    },
    answers: mergeAnswers(result.answers, {
      [primaryQuestion.name]: primaryAnswer || "",
      [shadowQuestion.question.name]: shadowQuestion.answer
    })
  };
};
var flattenMultiselectGroup = (group, answers, visibility = {}) => {
  const { title, groupQuestions = [] } = group;
  const questions = filterQuestions(groupQuestions);
  const visibleQuestions = questions.filter((q) => q.visible);
  const result = mapQuestionsWithHiddenVisibility(
    questions,
    answers,
    visibility
  );
  const shadowQuestion = createShadowQuestion(
    title,
    visibleQuestions,
    result.answers
  );
  return {
    questions: [...result.questions, shadowQuestion.question],
    groups: {
      [shadowQuestion.question.name]: {
        kind: "shadow",
        names: visibleQuestions.map((q) => q.name)
      }
    },
    visibility: { ...result.visibility, [shadowQuestion.question.name]: true },
    answers: mergeAnswers(result.answers, {
      [shadowQuestion.question.name]: shadowQuestion.answer
    })
  };
};
var flattenYesNoToggleGroup = (group, answers, visibility) => {
  const { primaryQuestion, groupQuestions } = group;
  if (!primaryQuestion || !groupQuestions) {
    return { questions: [], answers, visibility, groups: {} };
  }
  const primaryAnswer = getPrimaryAnswer(primaryQuestion, answers);
  const primaryAnswerIsYes = primaryAnswer === "yes";
  const result = mapQuestionsWithAnswers(
    filterQuestions(groupQuestions),
    answers,
    primaryAnswerIsYes,
    visibility
  );
  return {
    questions: [primaryQuestion, ...result.questions],
    groups: {
      [primaryQuestion.name]: {
        kind: "group",
        names: result.questions.map((q) => q.name)
      }
    },
    visibility: result.visibility,
    answers: mergeAnswers(result.answers, {
      [primaryQuestion.name]: primaryAnswer || ""
    })
  };
};
var flattenAddressGroup = (group, answers, visibility) => {
  const { groupQuestions } = group;
  const addressLookupQuestion = createAddressLookupQuestion(group);
  const updatedVisibility = {
    ...visibility,
    [addressLookupQuestion.name]: true
  };
  const updatedAnswers = { ...answers };
  const flattenedFieldQuestions = groupQuestions.map((q) => {
    const hiddenOnAutocomplete = !!q.hiddenOnAutocomplete;
    const hasAnswer = !!(q.answer || updatedAnswers[q.name]);
    const shouldBeVisible = !!q.visible && !hiddenOnAutocomplete && hasAnswer;
    updatedVisibility[q.name] = shouldBeVisible;
    if (q.answer) {
      updatedAnswers[q.name] = q.answer;
    }
    return { ...q };
  });
  return {
    questions: [addressLookupQuestion, ...flattenedFieldQuestions],
    groups: {
      [addressLookupQuestion.name]: {
        kind: "address",
        names: flattenedFieldQuestions.map((q) => q.name)
      }
    },
    visibility: updatedVisibility,
    answers: updatedAnswers
  };
};
var flattenGroup = ({
  group,
  answers,
  visibility = {}
}) => {
  if (isYesNoToggleGroup(group)) {
    return flattenYesNoToggleGroup(group, answers, visibility);
  }
  if (isMultiselectGroup(group)) {
    return flattenMultiselectGroup(group, answers, visibility);
  }
  if (isMultiselectToggleGroup(group)) {
    return flattenMultiselectToggleGroup(group, answers, visibility);
  }
  if (isAddressLookupGroup(group)) {
    return flattenAddressGroup(group, answers, visibility);
  }
  return { questions: [], groups: {}, answers, visibility };
};

// src/hooks/useQuestionnaire/reducer/actions/groups/flattenSections.ts
var flattenSections = (sections, answers, visibility = {}) => {
  const updatedAnswers = { ...answers };
  const updatedVisibility = { ...visibility };
  const groups = {};
  const flattenedSections = sections.map((section) => {
    return {
      ...section,
      questions: (section.questions ?? []).flatMap((question) => {
        if (isQuestion(question)) {
          return [question];
        } else {
          const result = flattenGroup({
            group: question,
            answers: updatedAnswers,
            visibility: updatedVisibility
          });
          Object.assign(groups, result.groups);
          Object.assign(updatedVisibility, result.visibility);
          Object.assign(updatedAnswers, result.answers);
          return result.questions;
        }
      })
    };
  });
  return {
    sections: flattenedSections,
    answers: updatedAnswers,
    groups,
    visibility: updatedVisibility
  };
};

// src/hooks/useQuestionnaire/reducer/actions/setAction/setAction.ts
var handleSetAction = (state, payload) => {
  const { answers } = state;
  const {
    sections: flattenedSections,
    answers: updatedAnswers,
    groups,
    visibility: groupChildrenVisibility
  } = flattenSections(payload, answers);
  const { addressModes, sections } = setAddressModes(flattenedSections);
  const visibility = getVisibilityMap(
    sections,
    addressModes,
    groups,
    groupChildrenVisibility
  );
  return {
    ...state,
    sections,
    answers: initialiseAnswers(updatedAnswers, sections),
    visibility,
    addressModes,
    groups
  };
};

// src/hooks/useQuestionnaire/reducer/actions/setConfigAction.ts
var handleSetConfigAction = (state, payload) => {
  return {
    ...state,
    config: payload
  };
};

// src/hooks/useQuestionnaire/reducer/actions/setErrorsAction.ts
var handleSetErrorsAction = (state, payload) => {
  return {
    ...state,
    errors: payload
  };
};

// src/hooks/useQuestionnaire/reducer/actions/setEditModeAction.ts
var handleSetEditModeAction = (state, payload) => {
  return {
    ...state,
    isEditing: payload
  };
};

// src/hooks/useQuestionnaire/reducer/actions/setValidationsAction.ts
var handleSetValidationsAction = (state, payload) => {
  return {
    ...state,
    validations: payload
  };
};

// src/hooks/useQuestionnaire/reducer/actions/mergeAction/mergeState.ts
var mergeState = (state, payload) => {
  const {
    sections: stateSections,
    answers: stateAnswers,
    addressModes: stateAddressModes = {},
    ...rest
  } = state;
  const answers = { ...stateAnswers };
  const addressModes = { ...stateAddressModes };
  const sections = stateSections.map(
    (section, sectionIndex) => ({
      ...section,
      ...payload[sectionIndex],
      questions: section.questions.map((question, questionIndex) => {
        if (section.displayAs === "edit") return question;
        const answer = payload[sectionIndex]?.questions[questionIndex]?.answer;
        let visible = payload[sectionIndex]?.questions[questionIndex]?.visible;
        if (addressModes[question.name]) {
          const addressMode = addressModes[question.name];
          visible = addressMode === "lookup" ? true : false;
        }
        if (question.associatedQuestionName) {
          const addressMode = addressModes[question.associatedQuestionName];
          visible = addressMode === "manual" ? true : false;
        }
        if (answer) {
          if (question.display?.type === "date") {
            answers[question.name] = formatAnswer(question, answer);
            return {
              ...question,
              ...payload[sectionIndex]?.questions[questionIndex],
              answer: answers[question.name]
            };
          } else {
            answers[question.name] = answer;
          }
        } else {
          delete answers[question.name];
        }
        return {
          ...question,
          ...payload[sectionIndex]?.questions[questionIndex],
          visible: visible ?? question.visible
        };
      })
    })
  );
  return { sections, answers, addressModes, ...rest };
};

// src/hooks/useQuestionnaire/reducer/actions/mergeAction/mergeAction.ts
var handleMergeAction = (state, payload) => {
  const { sections, groups } = flattenSections(
    payload,
    state.answers,
    state.visibility
  );
  const newState = mergeState(state, sections);
  const visibility = getVisibilityMap(
    newState.sections,
    newState.addressModes ?? {},
    {},
    {}
  );
  return {
    ...newState,
    // Merge in any group mappings discovered while flattening the payload
    groups: { ...state.groups, ...groups },
    visibility
  };
};

// src/hooks/useQuestionnaire/getVisibleSection.ts
var hasUnansweredRequiredQuestions = (questions, answers) => questions.some((q) => isRequired(q) && !answers[q.name]);
var isRequired = (q) => q.visible && q.required;
var isVisible = (question) => question.visible ?? false;
var getVisibleSection = (state, direction) => {
  const { sections: sectionsFromState, answers, currentSectionIndex } = state;
  const sections = sectionsFromState;
  if (direction === "next") {
    const sectionVisibility2 = sections.map((section, index) => {
      if (index === currentSectionIndex) {
        return hasUnansweredRequiredQuestions(section.questions, answers);
      }
      return section.questions.some(isVisible);
    });
    const nextIndex = sectionVisibility2.indexOf(true, currentSectionIndex);
    if (nextIndex === -1) {
      return sections.length - 1;
    }
    return nextIndex < currentSectionIndex ? currentSectionIndex : nextIndex;
  }
  const sectionVisibility = sections.map(
    ({ questions }) => questions.some(isVisible)
  );
  const prevIndex = sectionVisibility.lastIndexOf(
    true,
    currentSectionIndex - 1
  );
  if (prevIndex === -1) {
    return currentSectionIndex;
  }
  return prevIndex > currentSectionIndex ? currentSectionIndex : prevIndex;
};
var getNextVisibleSection = (state) => getVisibleSection(state, "next");
var getPreviousVisibleSection = (state) => getVisibleSection(state, "previous");

// src/hooks/useQuestionnaire/reducer/actions/previousSectionAction.ts
var handlePreviousSectionAction = (state) => {
  const { sections } = state;
  const updatedSections = sections.filter(
    (section) => section.displayAs !== "edit"
  );
  return {
    ...state,
    sections: updatedSections,
    currentSectionIndex: getPreviousVisibleSection(state),
    isEditing: false
  };
};

// src/hooks/useQuestionnaire/reducer/actions/nextSectionAction.ts
var handleNextSectionAction = (state) => {
  const { sections, lastViewedSectionIndex } = state;
  const nextSectionIndex = getNextVisibleSection(state);
  const updatedSections = sections.map(
    (section, index) => index < nextSectionIndex ? { ...section, isVisited: true } : section
  );
  const updatedLastViewedSectionIndex = Math.max(
    nextSectionIndex,
    lastViewedSectionIndex
  );
  return {
    ...state,
    currentSectionIndex: nextSectionIndex,
    lastViewedSectionIndex: updatedLastViewedSectionIndex,
    sections: updatedSections,
    isValid: false
  };
};

// src/hooks/useQuestionnaire/validateAction.ts
var getQuestionList = (sections, currentSectionIndex) => {
  if (currentSectionIndex === void 0) {
    return sections.reduce(
      (acc, section) => acc.concat(section.questions),
      []
    );
  }
  const completedSections = sections.slice(0, currentSectionIndex + 1);
  return completedSections.reduce(
    (acc, section) => acc.concat(section.questions),
    []
  );
};
var getFirstInvalidSection = (results, sections) => {
  if (results.length === 0) {
    return void 0;
  }
  const invalidQuestionIds = results.map(({ id }) => id);
  return sections.findIndex(
    (section) => section.questions.some(({ name }) => invalidQuestionIds.includes(name))
  );
};
var validateAction = ({
  answers,
  sections: sectionsFromState,
  validations,
  visibility,
  currentSectionIndex,
  lastViewedSectionIndex
}) => {
  const sections = sectionsFromState;
  const errors = {};
  let isValid = true;
  const sectionIndexToValidateUpTo = Math.max(
    lastViewedSectionIndex,
    currentSectionIndex
  );
  const questionList = getQuestionList(sections, sectionIndexToValidateUpTo);
  if (questionList.length === 0) {
    return { errors, isValid: false };
  }
  const validateQuestion4 = createValidator(validations || []);
  const validateQuestions = (questions, answers2, visibility2) => questions.map((question) => validateQuestion4(question, answers2, visibility2)).filter(({ valid }) => !valid);
  const results = validateQuestions(questionList, answers, visibility);
  results.forEach(({ id, message: message2, valid }) => {
    errors[id] = message2;
    if (!valid) {
      isValid = false;
    }
  });
  const firstInvalidSectionIndex = getFirstInvalidSection(results, sections);
  return {
    isValid,
    errors,
    firstInvalidSectionIndex
  };
};

// src/hooks/useQuestionnaire/reducer/actions/validateFormAction.ts
var handleValidateFormAction = (state) => {
  const { errors, firstInvalidSectionIndex } = validateAction(state);
  const { currentSectionIndex } = state;
  const errorCount = Object.keys(errors).length;
  const isValid = errorCount === 0;
  const updatedSectionIndex = Math.min(
    firstInvalidSectionIndex ?? currentSectionIndex,
    getVisibleSection(state, "next")
  );
  return {
    ...state,
    errors,
    isValid,
    currentSectionIndex: updatedSectionIndex
  };
};

// src/hooks/useQuestionnaire/reducer/actions/removeErrorAction.ts
var handleRemoveErrorAction = (state, payload) => {
  const { errors } = state;
  const updatedErrors = { ...errors };
  delete updatedErrors[payload];
  const isValid = Object.keys(updatedErrors).length === 0;
  return {
    ...state,
    errors: updatedErrors,
    isValid
  };
};

// src/hooks/useQuestionnaire/reducer/actions/setAddressModeAction.ts
var handleSetAddressModeAction = (state, payload) => {
  const { name, mode } = payload;
  const { addressModes } = state;
  const updatedAddressModes = {
    ...addressModes,
    [name]: mode
  };
  const { sections, answers } = setAddressQuestionVisibility(
    name,
    state.sections,
    updatedAddressModes,
    state.answers
  );
  return {
    ...state,
    sections,
    visibility: getVisibilityMap(sections, updatedAddressModes, {}, {}),
    addressModes: updatedAddressModes,
    answers
  };
};

// src/hooks/useQuestionnaire/reducer/actions/showQuestionAction.ts
var handleShowQuestionAction = (state, payload) => {
  const { sections: sectionsFromState, currentSectionIndex } = state;
  const sections = sectionsFromState;
  const sectionIndex = sections.findIndex(
    ({ questions }) => questions.some((q) => q.name === payload)
  );
  return {
    ...state,
    currentSectionIndex: sectionIndex !== -1 ? sectionIndex : currentSectionIndex,
    selectedQuestion: payload,
    changedQuestions: []
  };
};

// src/hooks/useQuestionnaire/reducer/actions/editQuestionAction.ts
var handleEditQuestionAction = (state, payload) => {
  const { questionName, groupIndex } = payload;
  const { sections: sectionsFromState } = state;
  const sections = sectionsFromState;
  const sectionIndex = sections.findIndex(
    ({ questions }) => questions.some((q) => q.name === questionName)
  );
  if (sectionIndex === -1) {
    return state;
  }
  const section = sections[sectionIndex];
  const question = section.questions.find((q) => q.name === questionName);
  if (!question) {
    return state;
  }
  const editSection = {
    ...section,
    displayAs: "edit",
    questions: [question],
    isVisited: true
  };
  const updatedSections = [...sections, editSection];
  return {
    ...state,
    sections: updatedSections,
    // Set current section to the new edit section
    currentSectionIndex: updatedSections.length - 1,
    // Reset changed list
    selectedQuestion: questionName,
    changedQuestions: [],
    changedGroupIndex: groupIndex ?? state.changedGroupIndex
  };
};

// src/hooks/useQuestionnaire/reducer/actions/appendQuestionsAction.ts
var handleAppendQuestionsAction = (state, payload) => {
  const {
    sections: sectionsFromState,
    currentSectionIndex,
    changedQuestions,
    visibility
  } = state;
  const sections = sectionsFromState;
  const changes = changedQuestions || [];
  const questionNames = payload.map(({ name }) => name);
  const first = questionNames[0];
  const firstIndex = changes.indexOf(first);
  const filteredQuestions = Array.from(
    new Set(firstIndex > -1 ? changes.splice(0, firstIndex) : changes)
  );
  const updatedChangedQuestions = [...filteredQuestions, ...questionNames];
  const updatedSections = sections.map(
    (section, index) => index === currentSectionIndex ? {
      ...section,
      questions: [
        ...section.questions.filter(
          (q) => filteredQuestions.includes(q.name)
        ),
        ...payload
      ]
    } : section
  );
  const updatedVisibility = { ...visibility };
  payload.forEach((question) => {
    updatedVisibility[question.name] = question.visible ?? false;
  });
  return {
    ...state,
    sections: updatedSections,
    changedQuestions: updatedChangedQuestions,
    visibility: updatedVisibility
  };
};

// src/hooks/useQuestionnaire/reducer/actions/confirmGroupAction.ts
var handleConfirmGroupAction = (state, payload) => {
  const { confirmedGroups } = state;
  const updatedConfirmedGroups = new Set(confirmedGroups);
  updatedConfirmedGroups.add(payload);
  return {
    ...state,
    confirmedGroups: updatedConfirmedGroups
  };
};

// src/hooks/useQuestionnaire/mergeAnswers.ts
var trimValue = (value) => {
  if (!value) {
    return "";
  }
  if (Array.isArray(value)) {
    return value;
  }
  return value.toString().trim();
};
var addressSyncMap = {
  "UK address lookup": "UK correspondence address lookup",
  address_1: "customer[address_1]",
  address_2: "customer[address_2]",
  town: "customer[town]",
  uk_postcode: "customer[uk_postcode]"
};
function syncAddresses(answers) {
  for (const [key, value] of Object.entries(addressSyncMap)) {
    answers[value] = trimValue(answers[key]);
  }
  return answers;
}
function keepAddressesInSync(answers) {
  if (answers["Same correspondence address pre quote"] === "yes") {
    return syncAddresses(answers);
  }
  return answers;
}
function clearCorrespondenceAddress(answers) {
  for (const key of Object.values(addressSyncMap)) {
    delete answers[key];
  }
  return answers;
}
var mergeAnswers2 = (answers, payload) => {
  const { name, value } = payload;
  if (isObject(value)) {
    return keepAddressesInSync({
      ...answers,
      ...value
    });
  }
  const updatedAnswers = payload ? { ...answers, [name]: trimValue(value) } : answers;
  if (name === "Same correspondence address pre quote" && value === "no") {
    return clearCorrespondenceAddress(updatedAnswers);
  }
  return keepAddressesInSync(updatedAnswers);
};

// src/hooks/useQuestionnaire/types.ts
var isShadowGroup = (g) => Boolean(g && g.kind === "shadow");

// src/hooks/useQuestionnaire/reducer/actions/updateAnswerAction/applyGroupAnswerAndVisibility.ts
var deriveShadowChildrenAnswers = (shadowGroup, selectedValues, answers) => {
  const selected = new Set(selectedValues);
  const updated = { ...answers };
  for (const child of shadowGroup.names) {
    updated[child] = selected.has(child) ? "yes" : "no";
  }
  return updated;
};
var deriveNoGroupUpdates = ({
  groupNames,
  groups,
  answers,
  visibility
}) => {
  let nextAnswers = { ...answers };
  const nextVisibility = { ...visibility };
  for (const child of groupNames) {
    const childGroup = groups[child];
    if (isShadowGroup(childGroup)) {
      nextAnswers[child] = [];
      nextAnswers = deriveShadowChildrenAnswers(childGroup, [], nextAnswers);
    } else {
      nextAnswers[child] = "no";
    }
    nextVisibility[child] = false;
  }
  return { answers: nextAnswers, visibility: nextVisibility };
};
var deriveYesGroupUpdates = ({
  groupNames,
  groups,
  answers,
  visibility,
  serverVisibleByName
}) => {
  let nextAnswers = { ...answers };
  const nextVisibility = { ...visibility };
  for (const child of groupNames) {
    const childGroup = groups[child];
    if (isShadowGroup(childGroup)) {
      nextAnswers[child] = [];
      nextAnswers = deriveShadowChildrenAnswers(childGroup, [], nextAnswers);
    } else {
      delete nextAnswers[child];
    }
    nextVisibility[child] = serverVisibleByName[child] ?? false;
  }
  return { answers: nextAnswers, visibility: nextVisibility };
};
var applyGroupAnswerAndVisibility = (state, payload, serverVisibleByName) => {
  const { groups, answers, visibility } = state;
  const group = groups[payload.name];
  if (!group || group.names?.length === 0) {
    return { answers, visibility };
  }
  let nextAnswers = { ...answers };
  let nextVisibility = { ...visibility };
  if (group.kind === "group") {
    if (payload.value === "no") {
      const res = deriveNoGroupUpdates({
        groupNames: group.names,
        groups,
        answers: nextAnswers,
        visibility: nextVisibility
      });
      nextAnswers = res.answers;
      nextVisibility = res.visibility;
    } else if (payload.value === "yes") {
      const res = deriveYesGroupUpdates({
        groupNames: group.names,
        groups,
        answers: nextAnswers,
        visibility: nextVisibility,
        serverVisibleByName
      });
      nextAnswers = res.answers;
      nextVisibility = res.visibility;
    }
  } else if (isShadowGroup(group)) {
    const selectedValues = Array.isArray(payload.value) ? payload.value : [];
    nextAnswers = deriveShadowChildrenAnswers(
      group,
      selectedValues,
      nextAnswers
    );
  }
  return { answers: nextAnswers, visibility: nextVisibility };
};

// src/hooks/useQuestionnaire/reducer/actions/updateAnswerAction/updateAnswerAction.ts
var handleUpdateAnswerAction = (state, payload) => {
  const { answers, changedQuestions, isEditing } = state;
  if (payload.value === answers[payload.name]) return state;
  const mergedAnswers = mergeAnswers2(answers, payload);
  const updatedChangedQuestions = [...changedQuestions ?? [], payload.name];
  const updatedState = {
    ...state,
    answers: mergedAnswers,
    changedQuestions: isEditing ? updatedChangedQuestions : changedQuestions
  };
  const currentSection = state.sections[state.currentSectionIndex];
  const serverVisibleState = Object.fromEntries(
    (currentSection?.questions ?? []).map(
      ({ name, visible }) => [name, Boolean(visible)]
    )
  );
  const { answers: groupAnswers, visibility: groupVisibility } = applyGroupAnswerAndVisibility(updatedState, payload, serverVisibleState);
  return {
    ...updatedState,
    answers: groupAnswers,
    visibility: groupVisibility
  };
};

// src/hooks/useQuestionnaire/reducer/questionnaireReducer.tsx
var questionnaireReducer = (state, action) => {
  const { type } = action;
  switch (type) {
    case ACTIONS.SET: {
      return handleSetAction(state, action.payload);
    }
    case ACTIONS.SET_CONFIG: {
      return handleSetConfigAction(state, action.payload);
    }
    case ACTIONS.SET_ERRORS: {
      return handleSetErrorsAction(state, action.payload);
    }
    case ACTIONS.SET_EDIT_MODE: {
      return handleSetEditModeAction(state, action.payload);
    }
    case ACTIONS.SET_VALIDATIONS: {
      return handleSetValidationsAction(state, action.payload);
    }
    case ACTIONS.MERGE: {
      return handleMergeAction(state, action.payload);
    }
    case ACTIONS.UPDATE_ANSWER: {
      return handleUpdateAnswerAction(state, action.payload);
    }
    case ACTIONS.PREVIOUS_SECTION: {
      return handlePreviousSectionAction(state);
    }
    case ACTIONS.NEXT_SECTION: {
      return handleNextSectionAction(state);
    }
    case ACTIONS.VALIDATE_FORM: {
      return handleValidateFormAction(state);
    }
    case ACTIONS.REMOVE_ERROR: {
      return handleRemoveErrorAction(state, action.payload);
    }
    case ACTIONS.SET_ADDRESS_MODE: {
      return handleSetAddressModeAction(state, action.payload);
    }
    case ACTIONS.SHOW_QUESTION: {
      return handleShowQuestionAction(state, action.payload);
    }
    case ACTIONS.EDIT_QUESTION: {
      return handleEditQuestionAction(state, action.payload);
    }
    case ACTIONS.APPEND_QUESTIONS: {
      return handleAppendQuestionsAction(state, action.payload);
    }
    case ACTIONS.CONFIRM_GROUP: {
      return handleConfirmGroupAction(state, action.payload);
    }
    default: {
      return state;
    }
  }
};

// src/hooks/useQuestionnaire/useQuestionnaire.tsx
var questionnaireInitialState = {
  config: {},
  sections: [],
  groups: {},
  validations: [],
  answers: {},
  visibility: {},
  errors: {},
  currentSectionIndex: 0,
  lastViewedSectionIndex: 0,
  isValid: false,
  isEditing: false,
  selectedQuestion: null,
  changedQuestions: [],
  changedGroupIndex: 0,
  confirmedGroups: /* @__PURE__ */ new Set(),
  addressModes: {}
};
var questionnaireReducerAtom = atomWithReducer(
  questionnaireInitialState,
  questionnaireReducer
);
var useQuestionnaire = (sections, validations, config = {}) => {
  const [state, dispatch] = useAtom7(questionnaireReducerAtom);
  const currentSectionIndex = state.currentSectionIndex;
  const currentSection = state.sections[currentSectionIndex] || sections?.[0];
  const isFirstSection = currentSectionIndex === 0;
  const isLastSection = currentSectionIndex === state.sections.length - 1;
  const setSections = useCallback3(
    (sections2) => {
      dispatch({
        type: ACTIONS.SET,
        payload: sections2
      });
    },
    [dispatch]
  );
  const setValidations = useCallback3(
    (validations2) => {
      dispatch({
        type: ACTIONS.SET_VALIDATIONS,
        payload: validations2
      });
    },
    [dispatch]
  );
  const setConfig = useCallback3(
    (config2) => {
      dispatch({
        type: ACTIONS.SET_CONFIG,
        payload: config2
      });
    },
    [dispatch]
  );
  const setErrors = useCallback3(
    (errors) => {
      dispatch({
        type: ACTIONS.SET_ERRORS,
        payload: errors
      });
    },
    [dispatch]
  );
  const setEditMode = useCallback3(
    (isEditing) => {
      dispatch({
        type: ACTIONS.SET_EDIT_MODE,
        payload: isEditing
      });
    },
    [dispatch]
  );
  const setAddressMode = useCallback3(
    (name, mode) => {
      dispatch({
        type: ACTIONS.SET_ADDRESS_MODE,
        payload: { name, mode }
      });
    },
    [dispatch]
  );
  const merge = useCallback3(
    (sections2) => {
      dispatch({
        type: ACTIONS.MERGE,
        payload: sections2
      });
    },
    [dispatch]
  );
  useEffect3(() => {
    if (sections) {
      setSections(sections);
    }
  }, [sections, setSections]);
  useEffect3(() => {
    if (config && Object.keys(config).length) {
      setConfig(config);
    }
  }, [config, setConfig]);
  useEffect3(() => {
    if (validations && Object.keys(validations).length) {
      setValidations(validations);
    }
  }, [validations, setValidations]);
  const updateAnswer = useCallback3(
    (event) => {
      const { target } = event;
      const { name, value } = target;
      dispatch({
        type: ACTIONS.UPDATE_ANSWER,
        payload: { name, value }
      });
    },
    [dispatch]
  );
  const navigatePrev = useCallback3(() => {
    if (isFirstSection) return;
    dispatch({ type: ACTIONS.PREVIOUS_SECTION });
  }, [dispatch, isFirstSection]);
  const navigateNext = useCallback3(() => {
    if (isLastSection) return;
    dispatch({
      type: ACTIONS.NEXT_SECTION
    });
  }, [dispatch, isLastSection]);
  const validateAction2 = useCallback3(() => {
    dispatch({ type: ACTIONS.VALIDATE_FORM });
  }, [dispatch]);
  const validateQuestion4 = useMemo(
    () => createValidator(state.validations ?? []),
    [state.validations]
  );
  const removeError = useCallback3(
    (questionName) => {
      dispatch({
        type: ACTIONS.REMOVE_ERROR,
        payload: questionName
      });
    },
    [dispatch]
  );
  const showQuestion = useCallback3(
    (questionName) => {
      dispatch({
        type: ACTIONS.SHOW_QUESTION,
        payload: questionName
      });
    },
    [dispatch]
  );
  const editQuestion = useCallback3(
    ({
      questionName,
      groupIndex
    }) => {
      dispatch({
        type: ACTIONS.EDIT_QUESTION,
        payload: { questionName, groupIndex }
      });
    },
    [dispatch]
  );
  const appendQuestions = useCallback3(
    (questions) => {
      dispatch({
        type: ACTIONS.APPEND_QUESTIONS,
        payload: questions
      });
    },
    [dispatch]
  );
  const confirmGroup = useCallback3(
    (payload) => {
      dispatch({
        type: ACTIONS.CONFIRM_GROUP,
        payload
      });
    },
    [dispatch]
  );
  return {
    ...state,
    currentSection,
    currentSectionIndex,
    updateAnswer,
    navigateNext,
    navigatePrev,
    setSections,
    merge,
    isFirstSection,
    isLastSection,
    setEditMode,
    showQuestion,
    editQuestion,
    appendQuestions,
    validateQuestion: validateQuestion4,
    validateAction: validateAction2,
    validateForm: validateAction,
    setErrors,
    removeError,
    setAddressMode,
    confirmGroup
  };
};

// src/hooks/usePrepopulateAnswers/usePrepopulateAnswers.tsx
function prepopulateAnswersApi(config, tokens) {
  return async function prepopulateAnswers(answers) {
    const isCommercial = answers.landlord_type !== "residential";
    const vertical = isCommercial ? "commercial_landlord" : config?.vertical;
    const body = snakeCaseKeys({
      ...tokens ?? {},
      ...config ?? {},
      vertical,
      partial_proposal: answers
    });
    return fetch(PREPOP_ENDPOINT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json; charset=utf-8"
      },
      body: JSON.stringify(body)
    }).then((response) => {
      if (!response.ok) {
        return Promise.reject(new Error("Failed to prepopulate answers"));
      }
      return response.json();
    });
  };
}
function usePrepopulateAnswers() {
  const { sections, config, visibility } = useQuestionnaire();
  const { locale } = useLocale();
  const [tokens] = useTokens();
  const isPrepopulatingAnswers = useMutationStatus("prepopulateAnswers");
  const { mutateAsync } = useMutation4({
    mutationKey: ["prepopulateAnswers"],
    mutationFn: prepopulateAnswersApi(config, tokens)
  });
  const prepopulateAnswers = async (answers) => {
    const transformedAnswers = transformAnswers(
      answers,
      sections,
      visibility,
      locale
    );
    await mutateAsync(transformedAnswers).then((response) => {
      if (response.url) {
        window.location.replace(response.url);
      }
    });
  };
  return {
    prepopulateAnswers,
    isPending: isPrepopulatingAnswers
  };
}

// src/hooks/useSendAnswers/useSendAnswers.ts
import { getAirbrake as getAirbrake5 } from "@simplybusiness/services";
import { useMutation as useMutation5 } from "@tanstack/react-query";

// src/hooks/redirect/useRedirect.tsx
import { useAtom as useAtom8 } from "jotai";
var useRedirect = (sectionIndex) => {
  const [{ url, index } = { url: void 0, index: 0 }, setRedirectUrl] = useAtom8(redirectAtom);
  const shouldRedirect = sectionIndex ? sectionIndex > index : false;
  return {
    url,
    setRedirectUrl,
    shouldRedirect
  };
};

// src/hooks/useSendAnswers/useSendAnswers.ts
var airbrake4 = getAirbrake5({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY
});
var useSendAnswers = () => {
  const [tokens, setTokens] = useTokens();
  const { setRedirectUrl: setUrl } = useRedirect();
  const { merge, sections, visibility, currentSectionIndex } = useQuestionnaire();
  const { locale } = useLocale();
  const isSendingAnswers = useMutationStatus("sendAnswers");
  const mutation = useMutation5({
    mutationFn: (answers) => {
      const transformedAnswers = transformAnswers(
        answers,
        sections,
        visibility,
        locale
      );
      const answersArray = mapToArray(transformedAnswers);
      return apiRequest("?step_action=questions", {
        ...tokens,
        questions: answersArray
      });
    },
    onSuccess: ({ data }) => {
      const { sections: sections2 } = getPropsByName({
        name: "questionnaire",
        components: data.layout.components
      });
      merge(sections2);
      setTokens(data.configuration);
      setUrl({
        url: data.layout.components[0].props.config?.redirectUrl,
        index: currentSectionIndex
      });
      return Promise.resolve(sections2);
    },
    onError: (error2) => {
      console.error(`Error updating questions: ${error2.message}`);
      airbrake4.notify(error2);
      return Promise.reject(error2);
    },
    mutationKey: ["sendAnswers"]
  });
  const { isError, error, isSuccess, mutateAsync } = mutation;
  return {
    sendAnswers: mutateAsync,
    isSuccess,
    isPending: isSendingAnswers,
    isError,
    error
  };
};

// src/components/Questionnaire/Actions/index.tsx
import { forwardRef as forwardRef13 } from "react";

// src/components/Questionnaire/Actions/Actions.tsx
import { chevronLeft, rightArrow } from "@simplybusiness/icons";
import { Flex as Flex21, Icon as Icon20 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext15 } from "@simplybusiness/services";
import classNames31 from "classnames/dedupe";
import { forwardRef as forwardRef11 } from "react";

// src/components/Questionnaire/Actions/LinkOrButton.tsx
import { Button as Button6, LinkButton as LinkButton5 } from "@simplybusiness/mobius";
import { jsx as jsx80 } from "react/jsx-runtime";
var LinkOrButton = ({
  href,
  children,
  ...rest
}) => {
  if (!children) return null;
  if (href) {
    return /* @__PURE__ */ jsx80(LinkButton5, { ...rest, href, children });
  }
  return /* @__PURE__ */ jsx80(Button6, { ...rest, children });
};

// src/components/Questionnaire/Actions/Actions.tsx
import { jsx as jsx81, jsxs as jsxs59 } from "react/jsx-runtime";
var Actions = forwardRef11(
  (props, ref) => {
    const {
      className,
      backButton,
      nextButton,
      backLabel,
      nextLabel,
      category,
      ...rest
    } = props;
    const { onClick: onBackButtonClick } = backButton ?? {};
    const { onClick: onNextButtonClick } = nextButton ?? {};
    const { snowplow } = useSnowplowContext15();
    const classes = classNames31("mobius", "mobius-actions", className);
    const handleClick = (label, cb) => {
      snowplow?.trigger("navButtonClicked", {
        label,
        category
      });
      cb();
    };
    const backButtonProps = {
      ...backButton,
      onClick: () => handleClick("Back button", onBackButtonClick),
      className: "mobius-actions__back",
      variant: "link",
      size: "sm"
    };
    const nextButtonProps = {
      ...nextButton,
      onClick: () => handleClick("Next button", onNextButtonClick),
      className: "mobius-actions__next",
      size: "md"
    };
    return /* @__PURE__ */ jsxs59(
      Flex21,
      {
        ref,
        className: classes,
        justifyContent: "space-between",
        alignItems: "center",
        ...rest,
        children: [
          backLabel && /* @__PURE__ */ jsxs59(LinkOrButton, { href: backButton?.href, ...backButtonProps, children: [
            /* @__PURE__ */ jsx81(Icon20, { icon: chevronLeft }),
            backLabel
          ] }),
          nextLabel && /* @__PURE__ */ jsxs59(LinkOrButton, { href: nextButton?.href, ...nextButtonProps, children: [
            nextLabel,
            /* @__PURE__ */ jsx81(Icon20, { icon: rightArrow })
          ] })
        ]
      }
    );
  }
);
Actions.displayName = "Actions";

// src/hooks/environment/useEnvironment.tsx
import { useAtom as useAtom9, useAtomValue as useAtomValue4 } from "jotai";
var useEnvironment = () => useAtom9(environmentAtom);
var useEnvironmentValues = () => useAtomValue4(environmentAtom);

// src/components/Questionnaire/Actions/MoneySuperMarketActions/Actions.tsx
import { leftArrow as leftArrow2, rightArrow as rightArrow2 } from "@simplybusiness/icons";
import { Flex as Flex22, Icon as Icon21 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext16 } from "@simplybusiness/services";
import classNames32 from "classnames/dedupe";
import { forwardRef as forwardRef12 } from "react";
import { jsx as jsx82, jsxs as jsxs60 } from "react/jsx-runtime";
var Actions2 = forwardRef12(
  (props, ref) => {
    const {
      className,
      backButton,
      nextButton,
      backLabel,
      nextLabel,
      category,
      ...rest
    } = props;
    const { onClick: onBackButtonClick } = backButton ?? {};
    const { onClick: onNextButtonClick } = nextButton ?? {};
    const { snowplow } = useSnowplowContext16();
    const classes = classNames32(
      "mobius",
      "mobius-actions",
      "mobius-actions-msm",
      className
    );
    const handleClick = (label, cb) => {
      snowplow?.trigger("navButtonClicked", {
        label,
        category
      });
      cb();
    };
    const backButtonProps = {
      ...backButton,
      onClick: () => handleClick("Back button", onBackButtonClick),
      className: "mobius-actions__back",
      variant: "link",
      size: "sm"
    };
    const nextButtonProps = {
      ...nextButton,
      onClick: () => handleClick("Next button", onNextButtonClick),
      className: "mobius-actions__next",
      size: "md"
    };
    return /* @__PURE__ */ jsxs60(
      Flex22,
      {
        ref,
        className: classes,
        justifyContent: "space-between",
        alignItems: "center",
        ...rest,
        children: [
          backLabel && /* @__PURE__ */ jsxs60(LinkOrButton, { href: backButton?.href, ...backButtonProps, children: [
            /* @__PURE__ */ jsx82(Icon21, { icon: leftArrow2 }),
            backLabel
          ] }),
          nextLabel && /* @__PURE__ */ jsxs60(LinkOrButton, { href: nextButton?.href, ...nextButtonProps, children: [
            nextLabel,
            /* @__PURE__ */ jsx82(Icon21, { icon: rightArrow2 })
          ] })
        ]
      }
    );
  }
);
Actions2.displayName = "Actions";

// src/components/Questionnaire/Actions/index.tsx
import { jsx as jsx83 } from "react/jsx-runtime";
var Actions3 = forwardRef13(
  (props, ref) => {
    const { site } = useEnvironmentValues();
    if (site === "moneysupermarket") {
      return /* @__PURE__ */ jsx83(Actions2, { ...props, ref });
    }
    return /* @__PURE__ */ jsx83(Actions, { ...props, ref });
  }
);
Actions3.displayName = "Actions";

// src/components/Questionnaire/Section/index.tsx
import { forwardRef as forwardRef19 } from "react";

// src/components/Questionnaire/Section/EditSection.tsx
import {
  Box as Box7,
  Button as Button13
} from "@simplybusiness/mobius";
import classNames36 from "classnames/dedupe";
import { forwardRef as forwardRef15, useEffect as useEffect7 } from "react";

// src/hooks/useDependentQuestions/useDependentQuestions.ts
import { getAirbrake as getAirbrake6 } from "@simplybusiness/services";
import { useMutation as useMutation6 } from "@tanstack/react-query";
var airbrake5 = getAirbrake6({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY
});
var useDependentQuestions = () => {
  const [tokens, setTokens] = useTokens();
  const { sections, visibility, appendQuestions } = useQuestionnaire();
  const { locale } = useLocale();
  const isSendingAnswers = useMutationStatus("dependentQuestions");
  const mutation = useMutation6({
    mutationFn: ({ answers, targetQuestion }) => {
      const transformedAnswers = transformAnswers(
        answers,
        sections,
        visibility,
        locale
      );
      const answersArray = mapToArray(transformedAnswers);
      return apiRequest("?step_action=dependent_questions", {
        ...tokens,
        answers: answersArray,
        targetQuestion
      });
    },
    onSuccess: ({ data }) => {
      const { questions } = data;
      appendQuestions(questions);
      setTokens(data.configuration);
      return Promise.resolve(sections);
    },
    onError: (error2) => {
      if (error2.name !== "AbortError" && error2.name !== "TimeoutError") {
        console.error(`Error updating questions: ${error2.message}`);
        airbrake5.notify(error2);
      }
      return Promise.reject(error2);
    },
    mutationKey: ["dependentQuestions"]
  });
  const { isError, error, isSuccess, mutateAsync } = mutation;
  return {
    sendAnswers: (answers, targetQuestion) => mutateAsync({ answers, targetQuestion }),
    isSuccess,
    isPending: isSendingAnswers,
    isError,
    error
  };
};

// src/components/Questionnaire/Section/Question/Question.tsx
import { useLabel, useValidationClasses } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext19 } from "@simplybusiness/services";
import classNames34 from "classnames/dedupe";
import { useId } from "react";

// src/components/Questionnaire/SecurityLocks/SecurityLocks.tsx
import classNames33 from "classnames/dedupe";
import { Image, Text as Text35 } from "@simplybusiness/mobius";

// src/components/Questionnaire/SecurityLocks/securityLocksData.ts
var securityLocksData = [
  {
    imageSrc: "data:image/webp;base64,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",
    caption: "A mortice deadlock"
  },
  {
    imageSrc: "data:image/webp;base64,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",
    caption: "A mortice deadlock conforming to BS3621"
  },
  {
    imageSrc: "data:image/webp;base64,UklGRmocAABXRUJQVlA4IF4cAAAwzgCdASr+Af4BPpFInkulpCasohPKaZASCWlJ8l+zlvjXJt5/wIFgA5/Pl/GzwS7ZeEtdM+dKTtnPIY6ZfkMHXVofs4eXyLQsHnzQ4inut/rmdGFfGXcXRD8kmI9/f7fxr/Z+Myh/OGoL/6gn39Fz7J0RPhn/cBinp7BQvP6mXw5UvfCSOcpIvaVQHGc8oWWqeYPBxcsGrzUH4JCbQd8CedwbO6fZULhQ4WNp5nlpTeFB+e9bDzoy+QTnefSvlgLji3Iesxl5ux5NhcKHCxtPYH9p+U5P/VYnlUgVVyQhsFvLiqULYlniy7EsetC4UOFjaewT0W2yNTwii7vxPOfhihCFOhZHvye8xShja2xdlGXyCg3zxGcsz9vl8qKEr48B6CnChwsbT2Chd5Eci/Wdbw1aqmlCK9XU/aPJqNOJjkpXIUDUBan5qMOeXKaqtMPMfFBhRXq/aLhQ4WNp7BQtZEX80ALjIVqAFgoUC7T/+Er/IFZxn4QYJjJzLwMBxsyl1oe/80n65/KhcKHCxtVD3nD42XgFNWRRnvt1Znzo1ktaKLVdQ1E1/Dh+/ShLG09goXn/XT2zXTznpDufhC/54GMdSsB9vafYdAOLiZ5jfwKi4UOFjaewUK/Rw6DRysn3bA1Q9kC4RTpVQRlMDqzKlaDOIgTE+kg8W6Crn8qFwocLG0ylKUspcIoFtbdPuSBPXQK69302JpAigRokRJxROiITgXnK2VPYKF5/1z+VBWowKmr3fF32RJbKjltQCLxc76KBg/t+XplbChwsbT2Chef0jBUca0LOj9sDF2eoeM3TvyPBxpCaaB8NnKM1gxlgJ6359fxZAlvz/zFVsVG0WwocK4a5zVRI6DQ/1z+VBKOP47b8oV4KYAPbGI6TeJc/tSBoMxJEUNq4ZyWc3QanWQcRztvFCbwvP+cSQmRiM10fQoUnys+3Jc8LNX1qtpnB6tlLVmkOSwkmxVOKyuiDZDPvWzz4nD9mRjaL8d+AqeGgnDdeqRoxhVsjgkb4knF22ZTfzRlJlyJQ0d2FmVL8ckOWthtuXG09S8hC0MZLWThE+mWbdwuQX9V3eATP7nvP85AoX/ecb4jSf551qEDwvehEdvtJ8ZYEHKtXMy8nV17T++MhSvmiZu5M8TAl+7hIHsVWybLBmzkrOwJWJUXpVaRqGxroZsLX9MqClw83mrT2+1CWBxgbLAdQjB5agOXmtz6bgx4e5ewKySs9WPMZYdNI11iCa8rKT9Xq1qFBqf+8gtui3EAX7X9lVZwUb+2rtTfkBRdg8qfgNeLAZODSqBNcFonDdZTM4EaABut6NeyD3xROT09goXn/Z3wJJANCxDMRkIZqerOXyNfA8mjet0U0VeoAIs7oXL/i8kRSjaXChwsbT2CheB0R2e7+Nb0xVGIL1cg5Y4vCHe7T2+06FP5ULfQniCXHR2vCUpyehiFSa+yaV/PnmcMKHp0ljaewULz/oGjOKMmsfw1GWphaX5KTDNSTikrw5cKHCxtPYJ9wtFsI98u4j6N0qMEGI8OppuA975BDiWpEg38V1zPPOgX6Crn8qFwocLG00bOPSOLCitvHBSN210G4GsNP5scwDTVBA3s1n4KIZQuoXChwsbT2CfdMyrKqlMjtc33Mna35MA7do0b8TMAqssEVNCne7T2+06FP5ULf2C4srEm0DzRTmjgoJiZ7zpvqzqANNX69YBjOKUAfn9AVFJDfQI5CQOksbT2Chef9AysOROXqFmNJQoMqUJ93c1mOpI5pt/Dwjg+jfNZfdPaYkbmfpvnQHky42nsFC8/65+Wuv8bl9le5DIUbythXxlKykGxEjRnWeyMmyZbPBLKasqeufyoXChwsbTR3VctdiLGCsnYalOnPubf39lxV5Bf9qlZgtKwWrSqFvYU+G32nQp/KhcKDLZS/26Y8oj+3m4HG2Qt3q2gw9h5DQHIW301xmRkB3KJoT2hYll5ezbp5+06FP5ULhQ4PZd8f57Qj6Z2iu3PRPcq2i6XyBamGp3hbF9c+anUdNHsFC8/65/KSCBhHiKXAZK7fawfgnQgzKv1dxHfZso0vJVZhSvZQuW1pQVS5ZWdzXq9+auVYXn/XP5ULhQ3B5ePwfbZAiWde2EgU0q0i0DKqv76ztd6tHGOz+OqLmZflOgUBAJH1nrZ1DhY2nsFC8/5ooMt5gjWmjQVa93YCwWpjb1iq7CgsAAD+/6IwATr1PT5uP7GTzYzx1OC/W+KzVRPWAcRDS0ms3eeoTP8TsodoEX1BiDkvYkeo1t4FnyZjuGM0IAtv24CRSetjnE+KK+SjUYK1Kij+krxenm9h181yjUNAAnhfzCNTqwxWJvcog2HoVaCiuiD73/nx4a9JrSHl34S9yjLpH//khD/tKetAIE89dn7r6c8Qc1s4bEu8BR+acAB3HsL+tWCxh3FW3iq6CBasO6KhRERvZ8Y64UnL7eO7yTmC+3zvtkZTsI/p5ScxMQ7+QjVYW3aYh19W2gVqWra/KABbrofIxoBe0FzdbkeZP3zYbJU1HmXHaoViZx8AEjjh0X5dKGv5ZN2bRAfYdsD3HWBeILZEAtZ0mj1atha90cCYIuWmyBImuVxqgfPNFslzr9ahTn4AJcT/RFeu0QtAzgFbJBti/UzmhogM0BozdxWolDLrdwOncM+CJY5t3EfcBnCYnh7n8EeUtAKQhwDEey1X4zFc7T8IFbDGWj9WvUtdDKENzatVyx5+5umgTYdI9q96GKkPoAFc6ujZzTjo2uMLNq+COjxHTOocrHhDKTdRi/6227nyvrWxNrCJun4iMZ6Y7g2woz2q4dtqpuXKM2z4FYSQLI4yvAV99UkEiWGHsCG/uXTtgyXHduQLXss+qy4gSNdP17YADYML8vGyxhqZeDXXkDuYmGyWvJ7u1nWlPyDqHl3VvCg9CL40/35yiZIW0busG0o2UbpYn77G/Rk4W2yEDvnxQD1TULYnlRAv5wQgkB6TVagBOztgw06p/X26GsWVxuRi5t7ZXlcY0El8l8aGJ0bIgFf9y4K182PgMRKNRdFKsBIMtL3eSqck6XOJjDETgieyoAbADK7XycIyHF4eKVR6ldHUCXOiYGgqMTjk89gSkoG+fzbYyOUHGOUsWQABgzQWojo07OS2dFATwADS38qexmPtUvjPpdkFX+X5NVyOfDW/QTEgZhbb6+rEdTWN5RUJ/EUXvtkK9jwgXBJXErfbxFRxhMD1fNicjpsMB8tMXjVGfOXDaL88Z9LDdy+Oj1f/C7G0NvcvAPlTygPAvJ71aYY2t299xi462fHdY8mH1tno2DyO3YihQLbAb3/EED0jjGZKbH3F0bJNArwAQ7DASrqi5BOUG+yxyxqr01P1m4Xn9s/vfgVUalVKM2oBKcpdDX0zSPvjjwVr58ZV89GJkt/Ndq+Jcw+45RHOaRsRV6JNDrgCISrnhTD6LBgXS4rLsljwuEbCSFonF+W4qvgaVeoZCK2hAaz5rcA+r4j+pPVy1LqzIABQ7PuUsivLm7Hsu1/VAxkO7g1WT3g7ggi/Z6l5lLxOCEPJwi4itITS1M4BL9vzeUTCEWil11usRXzvqvAWeEzu1xTcquA7jeTpOlw6wVRN7TkHBtAnFpqf5K6o4125dvHqzzq/TWy/M97JL1eABKTVR6BPRFIrCbRjADXWQcrJInmRAnYgk4IgUt+iUticToNXkqOGJ5J2e7qZlNyLE1y6AhPW2FB9LK1qlaM1PEPYXtJkr0P1RmEm6CEJw36/8TE0HViPsXcx99tExCtH/76OqZxe8oHJv92WKZzQt3SjvAr96q9GePB6W1w3MvTvRrBW8bFD6H3ASYC/Dp31j4kX8WtHOKbZGAAJnmdjBfJOw7UMUIr3v+7FdHRHTnB3rk3d+6Ay2DZQEA087LZI3+zUVCdzlcJCzRKtK1jw1yUNNxZTP0Hzhr1OBwrKUl88hJkFu2BIUfKGlRrSqD/EOxn7p+G7K3YWt01gmoKw0uyetp3oC5rkn1QioMSl3kBdBGuPyBwAJffnV1GgkjoaVnSHP4jPVfGK16TtRwsQxlF3HyfRnSV2ZHFEISRGSr9ph4HD9/zQd/972WW53siwRRgtB9pFJ/7rjX1ptLp3KBVqKvHf14Vkq+J7uJXeqN56bzqmV7GyCzO51TSuqAL0tFrzU6vbUNGPGyfUXNEVDEbkPAvYZylibN9rEaO5XhMPVdQ4ABkxsWQoe32F+ga/zo5qyv0kRsrXoXQTI9Jn4V3rMA0qPoOSJlAg89j4YWhBWt0vEg5nYjHxcsePazHidnqfGwmdilFVsx58bKwUmfJa4EG3x3AaJ0B8BKDzg6xJ56z7uJ0r2IRJDBNddKeKYB7unYAHaRWyY6NftP29EFxEpwEaUCe30Z21Sjmv0RjLu4+3jHfriDZp3IIrLcHBY9Fs9c1McpRqxOHEq3/zkJV/LwpIMUND6PkokPnKlEe4zjLqbX21/wFwBmw/dk1+4XiM82k2aKB15L02XNZaglctAJmkj8Yp+407HaTs23+hwHhorS0wM4O5H4HM00ZfMrzdaN0Oer36JfzqmWZlG63fauBB1e3DPNwChrZkQHxA1mJGy1SUO6794fxr7uH7+w4o4mOb+QYgDNDgBNzEbnbm8ceLO2yZf9jgjG9Fb3QITXmYt+KiRSiAXVcrr3cH3lupMko8bamMFl6BYrumLCptFkJkuYUOOjhUuTsNvn0FSUHAIeEQ9TXCfO0GQjR5aMNWRvMg0gw3u+Kl1iHzLq4VrFsaW73JRHQhdmlNqJjbSDkP7jnJ9ehqjj1p3C/wj8S2bbG8yvS3JiO/9HMLb+qpWw6J2H+HVWyXGu5fdM/CsbsQ9+XeWt9P6WbY0DcLqtRrn+nnA9jckvZODvkn0dFN9c0SVnwrOWjjrJJ8uNJOO8V41iFJPSH0UFderLlOctU+TOEva2wvRpSv602L+zi435gCKUb6zxQ1VQM1/Ve+am1GvahiWHYpPwHIGfOWqeyDFshjV5qU/40thuXzfJisteL+f2ZlAm3TWmY37MmtQnAUMv4tS7HEQ/zU+LartbnPIoR5nfImFpKasX0gfA1xTkF3Ikj5ReAttpxV7JKkRGUrXjIk5sfKk1+9vp9E44hI26j4pe7n90zl2f3enLyjB77Q8ZDPQ2xGXJaii1joCHumJftdER+8aeLDwVmWkDxyELjJXM8mnRMexYsnho1fqHgSPb+7w71TghOop5eI8zhCh1HBYE3UThZWlQ7FuEDM51CQhC6Z1ZWqHhFMIsDPbzy2CvjCPNaUtxM5rU2g2qtus+Ir1Iqh4QPb/avxIYXfxa+voRosHYWOsb1cBO9Id3Tr5KqepL4pJ0iRwKzia/ox6BYJ21uDJoaRhpro6+ZLjJELhWjHJFoCpDJVZIw9gnCALByuYmSe1u55W6YyIqjAc9notwT4OEwiSrxCCWQ7E5RuO8Vybb0k6huZvriIKysP5EPO8VmJyXDVHPhSKKvQdqUBUuzD806rbrDXvP/61kCtFQDxG5g2obb5Zj9P5JjJGWI9jhds3Vt9r/fWwxGmGj9qeOGCIsJx60gG8UIMF6uPOuec/Z3QiCpQbqwjgbmEBA5pTcFrd2ZsjLKuEW8PP2d85e/8QdY8duroC9oXvRnNIiQQdV7jUPr9BsjXnl9qxz2zIs4F1XpR/gwLYT2UjTqH01M1FMyIQKOKoxOmWVkk6drd8XYPKTHCnyQE/wOy92JsV5xr6eV/SOII6J0owNXjm/ldYIzgVYaIVBwsFlwNxVrjUCNXkK2RH2NGByDVBPpvow6ccxT44x6yqWZWIqmVhbTdzEVHUWaFiy/PFnFQMIQ3LKMUBGA0AeJA+WtTvmoH5/qIaEdinxXZ0KZIzlRTAul/U2B8byxaxonQ6yVlpyRy6fu3QkYyr0zcrlYPS0ijVyxI3lXvWNX5Vyn+9Gt/SdIdZGvrHV3YwjXmusxDgVKcPIwdFnOrKK+hDpVxLy3jiomyca6ePgNPf+aHSBDvwB4bpi5PiaLGeDefGSGxopC6lYIKkUKsIWt+l6EjvDw06WfIllWO4r8dd/YhR3yKMBjPgFjpo+wy2b8UUuhiCDwLNq9bwmLoSTFTkzx7zJ3snauglVxYhsLLmAJugylz+qUewTuaPopLUV4/I5B3Exxwc3wUL3GLwgjFm+sgiLo7clXp19OBua+pC3FXVuV10Zb+Nruggw8erfBkHhP6o/Mp1IijIvZdoeKczSWRWSzXJKLZLjWsMynucjEB7ea5htDcQrJ3LTTsojExxcx/IR4IlFlWQKByAaY7cHT3wfxegD83rQS4j/MUt0UjvrOGDZWIl6thrNEdP7QdBi4P+dakdw/gZR2whnlOGzxv99dLlPXWr2Y7OEmh2mO8TwXokWkYVohDday7/Dx3AA3fY4kessQtKi67yE+XQCNYp+yAnyr6iHfJqVjKlzrv6iwjycc/xAm0G/XiZh90LOUhVSsyvK35NPpzi6nvNL3uzMvgHBXmzmyLvQWFoj46/MAciguIRIAaDqY2oBFmiiWyV5jrfbSZKxd9W1Wtwu7TvCHfBegCGqf56V/19QWcL9KdVBrWX6sB9uBxY75SmdLAhq9JnVC9We8P/uvLU5X1nvBpHw0Uj5rsb5BAnRiX5fefLtWRI1DmyxijwztZr+MEH55OYS4WYe97w0DNp9JpGAL5RfX71VEWWItyaPU66o+pIrj5/YY8qv1jdI9kmImKE5NGFpEvJ7J346GTejT0ZZfxE9u6wrgCBSdtaEEbQSe+66acAMPGCwY96AAAAho/5lysq9LmyED5T8dDRfC3Z4+BwFUCLnp1nA/QsPwzAq506EtwyIL/lW9evBbQI/gNWp7WQUHo/TgFkd76hJAF8Pbh79mIxU4/Dcm8n51c+tUs/q5wACMLBZwRbToMyMzXtFEzyPblm3DilGIkA6BTOMuUm/BPmcXaM4sGwue0H0IopN1zgpYnauepjXrG8BH2pseBUXpMO88OtXnYlK+3Dl7GIaswHv8K2nvDt1wto4fd2cdpDyyufJn2kaAAabYWyVMZsNy5u0WBxSiMRnAP4BM11Gmm4aSKD4dFxTyNahZgffO7KjvBl7rOgHYmOnY50YvudauQ31KV2kz0gAGtRxOnW1ergUHCasIaCFZHivjEsfL4H+zmMSDnDyVY4C06Qakz8HHbmGcxBUoQ93yj4bhEXdJCjgst063elDiJ0tRK0xdmT3L+KvRHEUW69M4ABzN8TVNC8hmWtwWixMZZOYJcnrxX0TerUobECB9Ut/PAcuBWx9loLZkxpsqNGXAY6PQ+GJ1hHaUTZCX1wvSsa2V5sMw/yuNG5w4+bL+xCTHoVKzk/UF0mR59lAijGVtX5Bcv3mAJrsCRyLhuMrGge2i8gAPvWiN2bTN4P5UUjwzJMURktKtSIXzDmNmK5QjPBhkpjVrSc5FNe4G4eGpUop3r86mAsT6Q/okgTWNpumAHJesp5bE7Q03WPvVXwO39GtgLhJxm/vTiHoBH/bI0CiMnMsKXnjEvbqfbe9qHZ/bxAAd+tSHN1oNhCgHRKOcyhXmpn5ZTPGfFuIZ3GuFiy8xook5YUIieN2oDzTqjqkpHTgnVUcnjt9qG6B0cbUaJJAqz72wy+aomVtehWTWZlI1PnpkgigG+QFSPtfUmiXtdeJQPS0aWgtNd0GYxNvYfPlKoeOitNCZVfE6WHRwTmQF6kK9ccEVWLWUQo8914xOfPB5DHVRoLHex2+mmhkvgADVVjpQzpWAgfbdutxxrv+ofP4oxnTfTKthNoKbAHLmE6qPHEok327lAaXBYslUbTaNhcEZC2d5EZFIAWYa/8Fg56WkPmRZzkVxEhNjGpuceu/0uVDxv5jaG0UiMoX/vWmjYwk47b1daOa4q3z/pNYF5EZbgEiP9ciyIha959JQhXbU73wqTVbZbarm4qyqC1pFCyDn5MtC9Pr2DiIrOYSHZ+f0HtmoYIUc07KPuPkzvKba7Q4wi7p0Hb2glE9CMNmizcVieCBM4AFWgpaasI982+TOQ/FK4g2dkq8z6tq2zA0Wpp/l6PauMxbKNcxY/+unarDtAQRoZ8urF0gVKJWyWyJ6K62AU8cQ0SGYA8AMrzlYL8TFhsx5HSYnvL+2d2mnwsizw/L5MZ/4ajyNUxH7zHSQDdEGJ6X/xePMEmrnkx72yTct3coSQx4+OBuLGceS1obRU0rVoZvZylmJxxuZNcFU6sqZawRiItS2IWV61uRiKSh6+42hbEdDo64fhR7VJZT2fxkMXjraxiHRBdHNWFdUOvKMkPU1qsfjxDnYgn/D1J7h/nYahMfDCrST7VdeBObY5IcOjwADmw3VwXFJgE1qPoCytoCQGw7GBZD2b4xJv7g0wkwIaIMO6Ul0erHLBSp+8ju/SrPnnYL+tWDLmsFI7f3RYEDeqKiCw224Zv43ZhKL+ZIz80M2Nze53MePOYpwwmpu2AclslUP8zftwxlP6m0+I1SxGuzKiAfGfbIleLN/1fbAB6IhPZeUtNLclCiLoOxTwbbH1S3WO4it4rEACz8InPEyKAuKlHIh3Vx9IA/af3Hie9yPt1h0MZYLTnEW1WnJ9HwJIc8ynrPntZOAyRqwI+VruU+AuqaJ87ZmMmpLqcU4+ZXtFJ7WygDltNMInrOSbjxiwFivcHXl5vbAHlUeffaFqHiYSlYG1Mnr7DBQEyROMq45k6eX78umI4IfcfUc7uoI6pQzWQLFfZzuCpSOWOeVe6zByAAPQdBy1pY0OpqnYxhzut/kF0kbLt1I/mnZFvQ+mIrpIQL05WnHFkTe9pWHALlWvuNq1pOvKDsegdFGt572JmJ42Hrfkyjcvqr8I3/3bYRbY3c14ayyE/gC9+ApXDv53QdhFNx+zLvYrMV0c+tD/Jidx0QfLp9f5IvdmHT0iRw6UlDr8YxCNPLiNrObSvIvk1pwIUtl+lkB26gw+goAtXO6pTH1aWJbMwFCeIAASH9uMnbWYXFLtOECkfG2j+zo2aYbZH/h+brHiTTftkrfjeEenM4HhwaV1TxB7jymWjteXSnSlXI6HimI2D2ScK6GDlyUgG1H+AJldqcIF4wFPvGgwL6OzXy9DTJ2WLsdjL301iAyTzwLqJPphuhRQAAt/c35vlknOJHBT97j7MSwI+hi2IsriQ2HvbAcxT3F3TUpRmieIkOe1YEqTY0HxMdLJf/QytN1YiSsIDs5nwfS8X5Nx/ENQADbZHPM1lgxaFnscshfJOM8vWpQUnai4uyti77ayAxknS6dpeQ7eUomKgDCeCjbe4Wc1vuu4TnTo2/pW+RXt/tuILV9d016cpvPNXmiZ15rREZB7PlrEPp5RIUu5QaGyXUmLVD3QrmTQzWpqrThKoABSuVNHwk97HyfMPFppqOuDtLSKOxlus9wO/IDFodWSWsdlRi/Xz9kz4QT1wSf96XXJpB8D4FcsGMTZg61WOo9GfKpi2F3B5LeSZ19mnnrjLEbnFtTDu/aUwBWPnAxhgC3YNNHY99zG2gSN5SUxFeU4/ESbGToUK+y+K8mnHF+PJ4Stgmg2PDAyZBxSCzjok7IWVnfM53SfZhtEummmggQAB2to9FOFERmZFnTGUuJl56G0Wk5YuWqByPkXVW+Vm2HEpnlwdHHEKIJjICLss1CihhQZMnB1YKNiWaKb1QAAAA==",
    caption: "A key-operated multipoint lock"
  },
  {
    imageSrc: "data:image/webp;base64,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",
    caption: "A rim automatic deadlatch with key-locking handle"
  }
];

// src/components/Questionnaire/SecurityLocks/SecurityLocks.tsx
import { jsx as jsx84, jsxs as jsxs61 } from "react/jsx-runtime";
var SecurityLocks = () => {
  const classes = classNames33("mobius", "mobius-security-locks");
  return /* @__PURE__ */ jsx84("div", { className: classes, children: securityLocksData.map(({ imageSrc, caption }) => /* @__PURE__ */ jsxs61("figure", { children: [
    /* @__PURE__ */ jsx84(Image, { src: imageSrc, alt: caption }),
    /* @__PURE__ */ jsx84("figcaption", { children: /* @__PURE__ */ jsx84(Text35, { variant: "h4", children: caption }) })
  ] }, caption)) });
};

// src/components/Questionnaire/Section/Question/HelpLink/HelpLink.tsx
import { circleInfo as circleInfo3 } from "@simplybusiness/icons";
import { Button as Button7, Drawer, Icon as Icon22 } from "@simplybusiness/mobius";
import { useState as useState4 } from "react";
import { Fragment as Fragment14, jsx as jsx85, jsxs as jsxs62 } from "react/jsx-runtime";
var HelpLink = ({
  headline,
  label,
  text: text3,
  displayAsButton,
  onOpenDrawer
}) => {
  const [open, setOpen] = useState4(false);
  const openDrawer = () => {
    if (onOpenDrawer) {
      onOpenDrawer();
    }
    setOpen(true);
  };
  const closeDrawer = () => {
    setOpen(false);
  };
  return /* @__PURE__ */ jsxs62(Fragment14, { children: [
    displayAsButton ? /* @__PURE__ */ jsxs62(
      Button7,
      {
        className: "mobius-question__help-button",
        onClick: openDrawer,
        size: "sm",
        variant: "ghost",
        children: [
          /* @__PURE__ */ jsx85(Icon22, { icon: circleInfo3 }),
          " ",
          label
        ]
      }
    ) : /* @__PURE__ */ jsxs62(
      Button7,
      {
        className: "mobius-question__help-link",
        onClick: openDrawer,
        variant: "link",
        size: "sm",
        children: [
          /* @__PURE__ */ jsx85(Icon22, { fixedWidth: true, icon: circleInfo3, size: "sm" }),
          /* @__PURE__ */ jsx85("span", { children: label })
        ]
      }
    ),
    /* @__PURE__ */ jsxs62(
      Drawer,
      {
        className: "mobius-question__help-link-drawer",
        isOpen: open,
        direction: "right",
        closeLabel: "Close",
        onClose: closeDrawer,
        children: [
          /* @__PURE__ */ jsx85(Drawer.Header, { children: headline }),
          /* @__PURE__ */ jsx85(Drawer.Content, { children: /* @__PURE__ */ jsx85("div", { dangerouslySetInnerHTML: { __html: text3 } }) })
        ]
      }
    )
  ] });
};

// src/components/Questionnaire/Section/Question/QuestionFactory/QuestionFactory.tsx
import { useSnowplowContext as useSnowplowContext18 } from "@simplybusiness/services";
import { useCallback as useCallback5, useEffect as useEffect6, useMemo as useMemo2, useState as useState10 } from "react";

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/AddressLookupQuestion/AddressLookupQuestion.tsx
import {
  AddressLookup,
  Button as Button8,
  LoqateAddressLookupService
} from "@simplybusiness/mobius";
import { useRef } from "react";
import { useSnowplowContext as useSnowplowContext17 } from "@simplybusiness/services";

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/AddressLookupQuestion/transformAddressData.ts
var ADDRESS_FIELD_MAP = {
  "1": "Line1",
  "2": "Line2",
  town: "City",
  postcode: "PostalCode"
};
var transformAddressData = ({
  questionName,
  addressData,
  mappedFields
}) => mappedFields.reduce(
  (acc, { associatedQuestionId }) => {
    const lowerCaseId = associatedQuestionId.toLowerCase();
    for (const [key, value] of Object.entries(ADDRESS_FIELD_MAP)) {
      if (lowerCaseId.includes(key)) {
        acc[associatedQuestionId] = addressData[value] || "";
        break;
      }
    }
    return acc;
  },
  {
    [questionName]: addressData.Label?.replace(/\n/g, ", ")
  }
);

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/AddressLookupQuestion/AddressLookupQuestion.tsx
import { jsx as jsx86, jsxs as jsxs63 } from "react/jsx-runtime";
import { createElement } from "react";
var AddressLookupQuestion = ({
  questionFieldProps,
  config,
  sectionTitle,
  setAddressMode
}) => {
  const {
    value,
    onChange,
    onFocus,
    questionLabelProps,
    helpInfo,
    ...otherProps
  } = questionFieldProps;
  const typedConfig = config;
  const { apiKey, mappedFields } = typedConfig;
  const { snowplow } = useSnowplowContext17();
  const { name } = questionFieldProps;
  const sendAddressLookupEvent = useRef(false);
  const handleFocus = (event) => {
    snowplow?.trigger("addressLookupFocused", {
      category: name,
      label: "Address lookup focused"
    });
    onFocus?.(event);
  };
  const handleOptionsDiplayed = () => {
    snowplow?.trigger("addressOptionsDisplayed", {
      category: name,
      label: "Address options displayed"
    });
  };
  const handleChange = (data) => {
    const transformedData = transformAddressData({
      questionName: name,
      addressData: data,
      mappedFields
    });
    onChange?.({
      target: { name, value: transformedData }
    });
  };
  const showManualFields = () => {
    snowplow?.trigger("manualAddressClicked", {
      category: sectionTitle || questionFieldProps.label || questionFieldProps.name
    });
    setAddressMode?.(name, "manual");
  };
  const handleAddressInput = (e) => {
    const { value: value2 } = e.target;
    if (value2.length === 1 && !sendAddressLookupEvent?.current) {
      snowplow?.trigger("addressLookupTypedIn", {
        category: e.target.name,
        label: "First character input"
      });
      sendAddressLookupEvent.current = true;
    }
  };
  const loquateService = new LoqateAddressLookupService({ apiKey, countries: ["GB"] });
  return /* @__PURE__ */ jsxs63("div", { className: "mobius-address-lookup__container", children: [
    /* @__PURE__ */ createElement(
      AddressLookup,
      {
        addressLookupService: loquateService,
        ...otherProps,
        onChange: handleAddressInput,
        value,
        key: value,
        placeholder: "Enter your postcode",
        onAddressSelected: handleChange,
        onOptionsDisplayed: handleOptionsDiplayed,
        onFocus: handleFocus,
        minSearchLength: 5
      }
    ),
    /* @__PURE__ */ jsx86(Button8, { size: "sm", variant: "link", onClick: showManualFields, children: "Enter address manually" })
  ] });
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/DateInputQuestion.tsx
import { DateField } from "@simplybusiness/mobius";
import { jsx as jsx87 } from "react/jsx-runtime";
var DateInputQuestion = ({
  questionFieldProps
}) => {
  const {
    id,
    name,
    validation,
    onBlur,
    value,
    onChange,
    readOnly,
    questionLabelProps,
    helpInfo,
    ...otherProps
  } = questionFieldProps;
  let minDate;
  let maxDate;
  if (validation?.type === "range") {
    const { min, max } = validation.value;
    minDate = min;
    maxDate = max;
  }
  const handleBlur = (event) => {
    const { value: value2 } = event.target;
    onBlur?.({
      target: { name: questionFieldProps.name, value: value2 }
    });
  };
  return /* @__PURE__ */ jsx87(
    DateField,
    {
      ...otherProps,
      defaultValue: value,
      onBlur: handleBlur,
      min: minDate,
      max: maxDate,
      isReadOnly: !!readOnly
    }
  );
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/DateQuestion/DateQuestion.tsx
import { Button as Button9 } from "@simplybusiness/mobius";
import { DatePicker } from "@simplybusiness/mobius-datepicker";
import { useState as useState5 } from "react";

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/DateQuestion/utils.ts
var getFormattedDate = (date) => {
  return date.toISOString().slice(0, 10);
};
var getTodayDate = () => {
  return getFormattedDate(/* @__PURE__ */ new Date());
};
var getTomorrowDate = () => {
  return getFutureDate(1);
};
var getFutureDate = (days) => {
  const futureDate = /* @__PURE__ */ new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return getFormattedDate(futureDate);
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/DateQuestion/DateQuestion.tsx
import { jsx as jsx88, jsxs as jsxs64 } from "react/jsx-runtime";
var DateQuestion = ({
  questionFieldProps,
  config
}) => {
  const {
    value,
    onChange,
    isRequired: isRequired2,
    questionLabelProps,
    helpInfo,
    ...otherProps
  } = questionFieldProps;
  const { minDays, maxDays, futureOnly } = config ?? {};
  const [localValue, setLocalValue] = useState5(value);
  let minDate = void 0;
  if (futureOnly) {
    minDate = getTodayDate();
  }
  if (minDays) {
    minDate = minDays;
  }
  const handleChange = (date = "") => {
    setLocalValue(date);
    onChange({
      target: { name: questionFieldProps.name, value: date }
    });
  };
  return /* @__PURE__ */ jsxs64("div", { className: "mobius-question__date-question", children: [
    /* @__PURE__ */ jsxs64("div", { className: "mobius-question__date-question-actions", children: [
      /* @__PURE__ */ jsx88(
        Button9,
        {
          size: "md",
          type: "button",
          variant: "secondary",
          onClick: () => handleChange(getTodayDate()),
          children: "Today"
        }
      ),
      /* @__PURE__ */ jsx88(
        Button9,
        {
          size: "md",
          type: "button",
          variant: "secondary",
          onClick: () => handleChange(getTomorrowDate()),
          children: "Tomorrow"
        }
      )
    ] }),
    /* @__PURE__ */ jsx88(
      DatePicker,
      {
        onChange: handleChange,
        defaultValue: localValue,
        min: minDate,
        max: maxDays ? getFutureDate(maxDays) : void 0,
        ...otherProps
      }
    )
  ] });
};

// src/components/Questionnaire/Section/Question/QuestionLabel.tsx
import { Label, Text as Text36 } from "@simplybusiness/mobius";
import { Fragment as Fragment15, jsx as jsx89, jsxs as jsxs65 } from "react/jsx-runtime";
var QuestionLabel = ({
  primaryText,
  secondaryText,
  labelClasses,
  labelElementType,
  labelProps,
  secondaryTextId
}) => {
  return /* @__PURE__ */ jsxs65(Fragment15, { children: [
    /* @__PURE__ */ jsx89(
      Label,
      {
        className: labelClasses,
        elementType: labelElementType,
        ...labelProps,
        children: /* @__PURE__ */ jsx89("span", { dangerouslySetInnerHTML: { __html: primaryText } })
      }
    ),
    !!secondaryText && /* @__PURE__ */ jsx89(Text36, { id: secondaryTextId, className: "mobius-question__secondary-text", children: /* @__PURE__ */ jsx89("span", { dangerouslySetInnerHTML: { __html: secondaryText } }) })
  ] });
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/InfoQuestion/InfoQuestion.tsx
import { Alert } from "@simplybusiness/mobius";
import { jsx as jsx90 } from "react/jsx-runtime";
var InfoQuestion = ({
  questionFieldProps,
  config
}) => {
  const { questionLabelProps } = questionFieldProps;
  const { primaryText, secondaryText } = questionLabelProps;
  const { level } = config ?? {};
  if (typeof level === "string") {
    return /* @__PURE__ */ jsx90(Alert, { header: primaryText, variant: level, show: true, children: !!secondaryText && /* @__PURE__ */ jsx90("span", { dangerouslySetInnerHTML: { __html: secondaryText } }) });
  }
  return /* @__PURE__ */ jsx90(QuestionLabel, { ...questionLabelProps });
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/MultiSelectQuestion.tsx
import { Checkbox as Checkbox2, CheckboxGroup } from "@simplybusiness/mobius";
import { jsx as jsx91 } from "react/jsx-runtime";
var makeLabel = (label) => {
  if (containsHtmlMarkup(label)) {
    return /* @__PURE__ */ jsx91("span", { dangerouslySetInnerHTML: { __html: label } });
  }
  return label;
};
var MultiSelectQuestion = ({
  options,
  config,
  questionFieldProps
}) => {
  const { value, onChange, questionLabelProps, helpInfo, ...otherProps } = questionFieldProps;
  if (!options?.length) {
    console.warn(`No required options found`);
    return null;
  }
  const handleChange = (values) => {
    onChange({ target: { name: questionFieldProps.name, value: values } });
  };
  return /* @__PURE__ */ jsx91(
    CheckboxGroup,
    {
      ...otherProps,
      lastItemDisables: !!config?.lastItemDisables,
      defaultValue: value,
      onChange: handleChange,
      children: options.map((option) => {
        return /* @__PURE__ */ jsx91(
          Checkbox2,
          {
            label: makeLabel(option.label),
            value: option.value
          },
          option.value
        );
      })
    }
  );
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/NumberQuestion.tsx
import { NumberField, Text as Text37 } from "@simplybusiness/mobius";
import { jsx as jsx92 } from "react/jsx-runtime";
var getRangeProps = (value) => {
  return {
    minValue: value?.min || void 0,
    maxValue: value?.max || void 0
  };
};
var NumberQuestion = ({
  questionFieldProps,
  config
}) => {
  const {
    value,
    validation,
    readOnly,
    onChange,
    questionLabelProps,
    helpInfo,
    ...otherProps
  } = questionFieldProps;
  const { wholeNumber = false, prefix } = config ?? {};
  const rangeProps = getRangeProps(validation?.value);
  if (Array.isArray(value)) {
    throw new TypeError("NumberQuestion: defaultValue must be a number");
  }
  const parsedDefaultValue = value != null ? Number(value) : void 0;
  const realPrefix = prefix != null ? /* @__PURE__ */ jsx92(Text37, { children: prefix }) : void 0;
  return /* @__PURE__ */ jsx92(
    NumberField,
    {
      ...otherProps,
      step: wholeNumber ? 1 : 0.01,
      defaultValue: parsedDefaultValue,
      prefixInside: realPrefix,
      ...rangeProps,
      isReadOnly: !!readOnly
    }
  );
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/PercentageQuestion/PercentageQuestion.tsx
import {
  ErrorMessage,
  Flex as Flex23,
  Grid as Grid2,
  NumberField as NumberField2,
  useTextField
} from "@simplybusiness/mobius";
import { useCallback as useCallback4, useRef as useRef2, useState as useState6, Fragment as Fragment16 } from "react";

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/PercentageQuestion/percentageQuestionUtils.ts
var computeTotal = (percentages2) => Object.values(percentages2).reduce((acc, curr) => acc + curr, 0);
var clampForLabel = (percentages2, label, maxOverall = 100) => {
  const total = computeTotal(percentages2);
  const current = percentages2[label] || 0;
  return maxOverall - total + current;
};
var buildInitialPercentages = (labels, answers, questionName) => {
  const result = {};
  (labels || []).forEach((label) => {
    const answerKey = `${questionName}[${label}]`;
    const raw = answers?.[answerKey];
    const num = Number(raw);
    result[label] = Number.isFinite(num) && num >= 0 ? num : 0;
  });
  return result;
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/PercentageQuestion/PercentageQuestion.tsx
import { jsx as jsx93, jsxs as jsxs66 } from "react/jsx-runtime";
var PercentageQuestion = ({
  questionFieldProps,
  answers,
  config
}) => {
  const {
    value,
    validation,
    onChange,
    // we deliberately extract onBlur so it isn't passed to each field
    onBlur,
    questionLabelProps,
    helpInfo,
    errorMessage,
    name,
    id,
    ...otherProps
  } = questionFieldProps;
  const { labels } = config || {};
  const [percentages2, setPercentages] = useState6(
    () => buildInitialPercentages(labels, answers, name)
  );
  const total = computeTotal(percentages2);
  const { errorMessageProps } = useTextField({
    ...otherProps,
    "aria-errormessage": questionFieldProps.errorMessage
  });
  const containerRef = useRef2(null);
  const handleContainerBlur = useCallback4(
    (e) => {
      const nextFocus = e.relatedTarget;
      if (containerRef.current && nextFocus && containerRef.current.contains(nextFocus)) {
        return;
      }
      if (onBlur) {
        const flattened = Object.fromEntries(
          Object.entries(percentages2).map(([label, value2]) => [
            `${questionFieldProps.name}[${label}]`,
            String(value2)
          ])
        );
        onBlur({
          target: {
            name: questionFieldProps.name,
            value: flattened
          }
        });
      }
    },
    [onBlur, percentages2, questionFieldProps.name]
  );
  return /* @__PURE__ */ jsx93("div", { onBlur: handleContainerBlur, ref: containerRef, tabIndex: -1, children: /* @__PURE__ */ jsxs66(Flex23, { flexDirection: "column", gap: "sm", children: [
    /* @__PURE__ */ jsxs66(Grid2, { columns: 2, alignItems: "center", rowGap: "sm", children: [
      labels?.map((label) => {
        const handleChange = (e) => {
          const newPercentages = { ...percentages2 };
          newPercentages[label] = Number(e.target.value);
          setPercentages(newPercentages);
        };
        return /* @__PURE__ */ jsxs66(Fragment16, { children: [
          /* @__PURE__ */ jsx93("label", { children: label }),
          /* @__PURE__ */ jsx93(
            NumberField2,
            {
              ...otherProps,
              step: 1,
              id: `${id}-${label}`,
              onChange: handleChange,
              minValue: 0,
              maxValue: clampForLabel(percentages2, label, 100),
              suffixInside: /* @__PURE__ */ jsx93("span", { children: "%" })
            }
          )
        ] }, `${id}-${label}`);
      }),
      /* @__PURE__ */ jsx93("label", { children: "Total" }),
      /* @__PURE__ */ jsxs66("span", { className: "mobius-percentage-question__total", children: [
        total,
        "%"
      ] })
    ] }),
    !!errorMessage && /* @__PURE__ */ jsx93(ErrorMessage, { ...errorMessageProps, errorMessage })
  ] }) });
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/RadioButtonsQuestion/RadioButtonsQuestion.tsx
import { Icon as Icon23, Radio, RadioGroup } from "@simplybusiness/mobius";
import { useState as useState8 } from "react";

// src/hooks/useIsClient/useIsClient.tsx
import { useEffect as useEffect4, useState as useState7 } from "react";
function useIsClient() {
  const [isClient, setIsClient] = useState7(false);
  useEffect4(() => {
    setIsClient(true);
  }, []);
  return isClient;
}

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/RadioButtonsQuestion/RadioButtonsQuestion.tsx
import { jsx as jsx94, jsxs as jsxs67 } from "react/jsx-runtime";
var RadioButtonsQuestion = ({
  options,
  questionFieldProps,
  setAddressMode
}) => {
  const {
    value,
    isDisabled = false,
    questionLabelProps,
    helpInfo,
    ...otherProps
  } = questionFieldProps;
  const [errorMessage, _] = useState8(void 0);
  const isClient = useIsClient();
  if (!options?.length) {
    console.warn(`No required options found`);
    return null;
  }
  const handleChange = (event) => {
    const { value: value2, name } = event.target;
    if (name === LINK_ADDRESS_QUESTION_NAME) {
      setAddressMode?.(
        LINKED_ADDRESS_QUESTION_NAME,
        value2 === "yes" ? "none" : "lookup"
      );
    }
    questionFieldProps.onChange?.(event);
  };
  return /* @__PURE__ */ jsx94(
    RadioGroup,
    {
      ...otherProps,
      isDisabled: !isClient || isDisabled,
      value,
      onChange: handleChange,
      errorMessage: errorMessage || questionFieldProps.errorMessage,
      className: "mobius-radio-buttons-question",
      children: options.map(({ image, label, value: value2 }) => {
        if (!image || !isValidIconKey(image)) {
          if (image && !isValidIconKey(image)) {
            console.warn(
              `Invalid icon name provided to the radio button labelled "${label}"`
            );
          }
          return /* @__PURE__ */ jsx94(Radio, { label, value: value2 }, value2);
        }
        return /* @__PURE__ */ jsxs67(Radio, { value: value2, children: [
          /* @__PURE__ */ jsx94(Icon23, { icon: iconMap[image], size: "sm" }),
          label
        ] }, value2);
      })
    }
  );
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/RadioButtonsQuestion/iconMap.ts
import {
  buildingCircleCheck,
  carBuilding,
  houseChimney
} from "@simplybusiness/icons";
var isValidIconKey = (key) => {
  return key in iconMap;
};
var iconMap = {
  "home-only": houseChimney,
  offsite: carBuilding,
  "own-rent-space": buildingCircleCheck
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/SelectQuestion.tsx
import { Option as Option2, Select as Select2 } from "@simplybusiness/mobius";
import { jsx as jsx95 } from "react/jsx-runtime";
var SelectQuestion = ({
  options,
  questionFieldProps
}) => {
  const { placeholder, value, questionLabelProps, helpInfo, ...otherProps } = questionFieldProps;
  if (!options?.length) {
    console.warn(`No required options found`);
    return null;
  }
  const displayOptions = placeholder ? [{ label: placeholder, value: "" }, ...options] : options;
  return /* @__PURE__ */ jsx95(Select2, { ...otherProps, value, children: displayOptions.map((option) => /* @__PURE__ */ jsx95(Option2, { value: option.value, children: option.label }, option.value)) });
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/TextQuestion/TextQuestion.tsx
import { Button as Button10, TextField } from "@simplybusiness/mobius";
import { Fragment as Fragment17, jsx as jsx96, jsxs as jsxs68 } from "react/jsx-runtime";
var TEXT_FIELD_TYPES = [
  "text",
  "email",
  "tel",
  "number",
  "postcode"
];
var DEFAULT_TYPE = "text";
var isValidFieldType = (type) => TEXT_FIELD_TYPES.includes(type);
var TextQuestion = ({
  questionFieldProps,
  type = DEFAULT_TYPE,
  addressModes,
  setAddressMode,
  associatedQuestionName
}) => {
  const {
    value,
    onChange,
    readOnly,
    questionLabelProps,
    helpInfo,
    ...otherProps
  } = questionFieldProps;
  const { id, name } = questionFieldProps;
  const inputType = isValidFieldType(type) ? type : DEFAULT_TYPE;
  const addressMode = associatedQuestionName ? addressModes?.[associatedQuestionName] : void 0;
  const isAddressQuestion = !!addressMode;
  if (isAddressQuestion && addressMode === "lookup") {
    return null;
  }
  const handleChange = (event) => {
    const { value: value2 } = event.target;
    onChange?.({
      target: { name, value: { [id]: value2, [name]: value2 } }
    });
  };
  return /* @__PURE__ */ jsxs68(Fragment17, { children: [
    /* @__PURE__ */ jsx96(
      TextField,
      {
        ...otherProps,
        type: inputType,
        value: value ?? "",
        onChange: handleChange,
        isReadOnly: !!readOnly
      }
    ),
    QUESTIONS_WITH_TOGGLE.includes(id) && /* @__PURE__ */ jsx96(
      Button10,
      {
        className: "mobius-text-question__button-link",
        size: "sm",
        variant: "link",
        onClick: () => setAddressMode?.(associatedQuestionName, "lookup"),
        children: "Use address lookup"
      }
    )
  ] });
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/TradeQuestion/TradeQuestion.tsx
import { TradeSelector } from "@simplybusiness/mobius-trade-selector";
import { Link as Link16 } from "@simplybusiness/mobius";
import { useEffect as useEffect5, useState as useState9 } from "react";

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/TradeQuestion/TradeQuestionSelected/TradeQuestionSelectedUK.tsx
import { Button as Button11, Icon as Icon24, Text as Text38 } from "@simplybusiness/mobius";
import { penToSquare } from "@simplybusiness/icons";
import { jsx as jsx97, jsxs as jsxs69 } from "react/jsx-runtime";
var TradeQuestionSelectedUK = ({
  trade,
  onEditTrade
}) => /* @__PURE__ */ jsx97(
  "div",
  {
    className: "mobius-trade-question--selected",
    "data-testid": "trade-selected-uk",
    children: /* @__PURE__ */ jsxs69("div", { className: "mobius-trade-question__grid-container", children: [
      /* @__PURE__ */ jsxs69("div", { className: "mobius-trade-question__content", children: [
        /* @__PURE__ */ jsx97(
          Text38,
          {
            elementType: "p",
            className: "mobius-trade-question__selected-text",
            "data-testid": "trade-selected-text",
            children: /* @__PURE__ */ jsx97("strong", { children: "Trade/profession" })
          }
        ),
        /* @__PURE__ */ jsx97(Text38, { elementType: "p", className: "mobius-trade-question__selected-text", children: trade.value })
      ] }),
      /* @__PURE__ */ jsxs69(
        Button11,
        {
          className: "mobius-question__help-link mobius-trade-question__edit-btn",
          onClick: onEditTrade,
          variant: "link",
          size: "sm",
          type: "button",
          "aria-label": "Edit selected trade or profession",
          children: [
            /* @__PURE__ */ jsx97("span", { children: "Edit" }),
            /* @__PURE__ */ jsx97(Icon24, { fixedWidth: true, icon: penToSquare, size: "sm" })
          ]
        }
      )
    ] })
  }
);

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/TradeQuestion/TradeQuestionSelected/TradeQuestionSelected.tsx
import { Button as Button12, Icon as Icon25, Text as Text39 } from "@simplybusiness/mobius";
import { penToSquare as penToSquare2 } from "@simplybusiness/icons";
import { jsx as jsx98, jsxs as jsxs70 } from "react/jsx-runtime";
var TradeQuestionSelected = ({
  trade,
  onEditTrade
}) => /* @__PURE__ */ jsx98("div", { className: "mobius-trade-question--selected", children: /* @__PURE__ */ jsxs70("div", { className: "mobius-trade-question__grid-container", children: [
  /* @__PURE__ */ jsxs70("div", { className: "mobius-trade-question__content", children: [
    /* @__PURE__ */ jsxs70(
      Text39,
      {
        elementType: "p",
        className: "mobius-trade-question__selected-text",
        "data-testid": "trade-selected-text",
        children: [
          "You have selected \u2018",
          /* @__PURE__ */ jsx98("strong", { children: trade.value }),
          "\u2019 as your trade/profession."
        ]
      }
    ),
    trade?.definition && /* @__PURE__ */ jsx98(
      HelpLink,
      {
        headline: "How do we define this type of business?",
        label: "How do we define this type of business?",
        text: trade.definition
      }
    )
  ] }),
  /* @__PURE__ */ jsxs70(
    Button12,
    {
      className: "mobius-question__help-link mobius-trade-question__edit-btn",
      onClick: onEditTrade,
      variant: "link",
      size: "sm",
      type: "button",
      "aria-label": "Edit selected trade or profession",
      children: [
        /* @__PURE__ */ jsx98("span", { children: "Edit" }),
        /* @__PURE__ */ jsx98(Icon25, { fixedWidth: true, icon: penToSquare2, size: "sm" })
      ]
    }
  )
] }) });

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/TradeQuestion/TradeQuestionSelected/index.tsx
import { jsx as jsx99 } from "react/jsx-runtime";
var TradeQuestionSelected2 = (props) => {
  const { isUK } = useLocale();
  if (isUK) {
    return /* @__PURE__ */ jsx99(TradeQuestionSelectedUK, { ...props });
  }
  return /* @__PURE__ */ jsx99(TradeQuestionSelected, { ...props });
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/TradeQuestion/TradeQuestion.tsx
import { Fragment as Fragment18, jsx as jsx100, jsxs as jsxs71 } from "react/jsx-runtime";
var EMPTY_TRADE_OPTION = Object.freeze({
  label: "",
  value: "",
  definition: "",
  vertical: ""
});
var getTradeOptionFromAnswer = (trade) => ({
  ...EMPTY_TRADE_OPTION,
  label: trade,
  value: trade
});
var TradeQuestion = ({
  questionFieldProps,
  config,
  answers,
  type
}) => {
  const {
    onChange,
    name,
    label,
    errorMessage,
    questionLabelProps,
    helpInfo,
    ...otherQuestionProps
  } = questionFieldProps;
  const { occupationsPageUrl, ...tradeSelectorConfig } = config || {};
  const answeredTrade = answers?.[name]?.toString() ?? "";
  const { vertical, affclie, journeyId } = useEnvironmentValues();
  const [selectedTrade, setSelectedTrade] = useState9(
    getTradeOptionFromAnswer(answeredTrade)
  );
  useEffect5(() => {
    if (answeredTrade && answeredTrade !== selectedTrade.value) {
      setSelectedTrade(getTradeOptionFromAnswer(answeredTrade));
    }
  }, [answeredTrade]);
  const variant = type === "trade_search_ai" ? "ai" : "default";
  const handleSelectTrade = (trade) => {
    onChange?.({ target: { name, value: trade.value } });
    setSelectedTrade(trade);
    redirect({
      currentVertical: vertical,
      nextVertical: trade.vertical,
      affclie,
      journeyId,
      trade: trade.value
    });
  };
  return /* @__PURE__ */ jsx100("div", { className: "mobius-trade-question", children: selectedTrade.value ? /* @__PURE__ */ jsx100(
    TradeQuestionSelected2,
    {
      trade: selectedTrade,
      onEditTrade: () => setSelectedTrade(EMPTY_TRADE_OPTION)
    }
  ) : /* @__PURE__ */ jsxs71(Fragment18, { children: [
    /* @__PURE__ */ jsx100(QuestionLabel, { ...questionLabelProps }),
    helpInfo && /* @__PURE__ */ jsx100(HelpLink, { ...helpInfo }),
    /* @__PURE__ */ jsx100(
      TradeSelector,
      {
        defaultValue: answeredTrade,
        onSelectTrade: handleSelectTrade,
        variant,
        ...tradeSelectorConfig,
        ...otherQuestionProps
      }
    ),
    typeof occupationsPageUrl === "string" && /* @__PURE__ */ jsxs71("div", { className: "mobius-trade-question__note", children: [
      "Or choose from the",
      " ",
      /* @__PURE__ */ jsx100(Link16, { href: occupationsPageUrl, children: "full list of occupations" })
    ] })
  ] }) });
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/TradeQuestion/redirect.ts
var getRedirectUrl = (data) => {
  const { currentVertical, nextVertical, affclie, journeyId, trade } = data;
  if (!currentVertical || currentVertical === nextVertical) return void 0;
  const params = new URLSearchParams({
    vertical: nextVertical,
    trade,
    journey_id: journeyId,
    ...affclie ? { AFFCLIE: affclie } : {}
  });
  return `/route_trade?${params.toString()}`;
};
var redirect = (data) => {
  const url = getRedirectUrl(data);
  if (url) {
    window.location.assign(url);
  }
};

// src/components/Questionnaire/Section/Question/QuestionFactory/questions/questionMap.tsx
var TRIGGERS = {
  CHANGE: "change",
  BLUR: "blur"
};
var ELEMENT_TYPES = {
  LABEL: "label",
  SPAN: "span"
};
var questionMap = {
  default: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  info: {
    component: InfoQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  address_lookup: {
    component: AddressLookupQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN
  },
  address_lookup_group: {
    component: AddressLookupQuestion,
    // TODO: this is a placeholder, to be replaced by AddressLookupGroupQuestion
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN
  },
  multiselect: {
    component: MultiSelectQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN
  },
  radio_buttons: {
    component: RadioButtonsQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN
  },
  select: {
    component: SelectQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  text: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  number: {
    component: NumberQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  rebuild_cost_estimate: {
    component: NumberQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  datepicker: {
    component: DateQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  date: {
    component: DateInputQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  trade_search: {
    component: TradeQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN
  },
  trade_search_ai: {
    component: TradeQuestion,
    trigger: TRIGGERS.CHANGE,
    labelElementType: ELEMENT_TYPES.SPAN
  },
  // Items below need to be reconciled
  given_name: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  family_name: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  email: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  tel: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  percentage_split: {
    component: PercentageQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  },
  postcode: {
    component: TextQuestion,
    trigger: TRIGGERS.BLUR,
    labelElementType: ELEMENT_TYPES.LABEL
  }
};

// src/components/Questionnaire/Section/Question/QuestionFactory/QuestionFactory.tsx
import { jsx as jsx101 } from "react/jsx-runtime";
var QuestionFactory = (props) => {
  const {
    display: { type, config, component: displayType },
    options,
    shouldUpdate,
    trackAs,
    associatedQuestionName,
    questionFieldProps
  } = props;
  const {
    answers,
    visibility,
    updateAnswer,
    currentSection,
    validateQuestion: validateQuestion4,
    errors,
    removeError,
    validations,
    currentSectionIndex,
    addressModes,
    setAddressMode,
    isEditing
  } = useQuestionnaire();
  const { snowplow } = useSnowplowContext18();
  const { sendAnswers, isPending } = useSendAnswers();
  const { sendAnswers: sendAssumptions, isPending: isPendingAssumptions } = useDependentQuestions();
  const stateError = errors?.[questionFieldProps.name] ?? "";
  const [errorMessage, setErrorMessage] = useState10(stateError);
  const [isValid, setIsValid] = useState10(!!stateError);
  const [isDirty, setIsDirty] = useState10(false);
  const validationCompareRule = useMemo2(
    () => validations?.find(
      (validation) => validation.id === questionFieldProps.name
    ),
    [questionFieldProps.name, validations]
  );
  const validate = useCallback5(
    (event) => {
      const payload = event.target;
      const mergedAnswers = mergeAnswers2(
        answers,
        payload
      );
      const validation = {
        validation: questionFieldProps.validation,
        ...(type === "email" || type === "tel") && { validation: { type } }
      };
      const result = validateQuestion4(
        { ...questionFieldProps, ...validation, visible: true },
        mergedAnswers,
        visibility
      );
      setIsDirty(true);
      if (result?.valid) {
        setIsValid(true);
        if (stateError) {
          removeError(questionFieldProps.name);
        }
        setErrorMessage("");
      } else {
        setIsValid(false);
        setErrorMessage(result?.message ?? "");
      }
    },
    [
      answers,
      questionFieldProps,
      type,
      validateQuestion4,
      visibility,
      stateError,
      removeError
    ]
  );
  useEffect6(() => {
    if (validationCompareRule && isDirty) {
      validate({
        target: {
          name: questionFieldProps.name,
          value: answers[questionFieldProps.name]
        }
      });
    }
  }, [
    validationCompareRule,
    questionFieldProps.name,
    answers,
    validate,
    isDirty
  ]);
  const componentType = displayType ?? type;
  const Component2 = questionMap[componentType]?.component;
  const trigger = questionMap[componentType]?.trigger;
  if (!Component2) {
    console.warn(`No component found to render as: ${componentType}`);
    return null;
  }
  const handleActions = (event) => {
    updateAnswer(event);
    if (shouldUpdate) {
      const payload = event.target;
      const mergedAnswers = mergeAnswers2(
        answers,
        payload
      );
      if (isEditing) {
        void sendAssumptions(mergedAnswers, questionFieldProps.name);
      } else {
        void sendAnswers(mergedAnswers);
      }
    }
    trackQuestionAnswer(event);
    validate(event);
  };
  const handleBlurChanges = (event) => {
    updateAnswer(event);
    validate(event);
  };
  const trackQuestionAnswer = (event) => {
    const payload = event.target;
    const { name } = payload;
    let { value } = payload;
    if (isObject(value)) {
      value = String(value[name]);
    }
    if (trackAs === "form_question_answered" && !!value) {
      snowplow?.trigger("questionAnswered", {
        section: currentSection?.title ?? "",
        question: snakeCase(questionFieldProps.name),
        answer: value
      });
    }
    if (trackAs === "primary_detail_selected" && !!value) {
      snowplow?.trigger("primaryDetailSelected", {
        answer: value
      });
    }
  };
  const enhancedQuestionProps = {
    ...questionFieldProps,
    ...trigger === TRIGGERS.CHANGE && { onChange: handleActions },
    ...trigger === TRIGGERS.BLUR && {
      onBlur: handleActions,
      onChange: handleBlurChanges
    },
    isInvalid: !isValid && isDirty || !!stateError,
    errorMessage: errorMessage || stateError,
    isDisabled: isPending || isPendingAssumptions
  };
  return /* @__PURE__ */ jsx101(
    Component2,
    {
      options,
      type,
      config,
      questionFieldProps: enhancedQuestionProps,
      answers,
      sectionTitle: currentSection?.title,
      sectionIndex: currentSectionIndex,
      addressModes,
      setAddressMode,
      associatedQuestionName
    }
  );
};

// src/components/Questionnaire/Section/Question/Question.tsx
import { jsx as jsx102, jsxs as jsxs72 } from "react/jsx-runtime";
var SIMPLE_WRAPPER_TYPES = /* @__PURE__ */ new Set([
  "info",
  "trade_search",
  "trade_search_ai"
]);
var Question = (props) => {
  const {
    id,
    name,
    primaryText,
    secondaryText,
    helpInfo,
    placeholder,
    shouldUpdate,
    readOnly,
    required,
    display,
    options,
    isInvalid,
    className,
    visible,
    validation,
    answers,
    trackAs,
    associatedQuestionName,
    chatConfig
  } = props;
  const secondaryTextId = useId();
  const classes = classNames34("mobius", "mobius-question", className);
  const validationClasses = useValidationClasses({ isInvalid });
  const labelClasses = classNames34("mobius-question__label", validationClasses);
  const { labelElementType } = questionMap[display.type] ?? {};
  const { labelProps, fieldProps } = useLabel({
    label: primaryText,
    id,
    labelElementType
  });
  const { snowplow } = useSnowplowContext19();
  if (!visible) return null;
  const isSecurityLockQuestion = id === "sof_door_locks";
  const showSecondaryText = secondaryText && !isSecurityLockQuestion;
  const questionLabelProps = {
    primaryText,
    secondaryText: showSecondaryText ? secondaryText : void 0,
    labelClasses,
    labelElementType,
    labelProps,
    secondaryTextId
  };
  const onOpenDrawer = () => {
    snowplow?.trigger("helpTextOpened", {
      label: helpInfo?.label,
      helpText: helpInfo?.headline,
      //schema getting broken here
      primaryText
    });
  };
  const questionFactoryProps = {
    display,
    options,
    shouldUpdate,
    trackAs,
    associatedQuestionName,
    questionFieldProps: {
      id,
      name,
      placeholder,
      readOnly,
      isRequired: required,
      "aria-describedby": secondaryText ? secondaryTextId : void 0,
      value: answers?.[name],
      validation,
      questionLabelProps,
      helpInfo: helpInfo ? { ...helpInfo, onOpenDrawer } : void 0,
      ...fieldProps
    }
  };
  if (SIMPLE_WRAPPER_TYPES.has(display.type)) {
    return /* @__PURE__ */ jsx102("div", { className: classes, children: /* @__PURE__ */ jsx102(QuestionFactory, { ...questionFactoryProps }) });
  }
  return /* @__PURE__ */ jsxs72("div", { className: classes, children: [
    /* @__PURE__ */ jsx102(QuestionLabel, { ...questionLabelProps }),
    helpInfo && /* @__PURE__ */ jsx102(HelpLink, { ...helpInfo, onOpenDrawer }),
    isSecurityLockQuestion && /* @__PURE__ */ jsx102(SecurityLocks, {}),
    /* @__PURE__ */ jsx102(QuestionFactory, { ...questionFactoryProps }),
    chatConfig && /* @__PURE__ */ jsx102(QuestionChatBox, { chatConfig, questionName: name })
  ] });
};

// src/components/shared/ChatBox/ChatBox.tsx
import {
  Flex as Flex24,
  Image as Image2
} from "@simplybusiness/mobius";
import classNames35 from "classnames/dedupe";
import { forwardRef as forwardRef14 } from "react";

// src/components/shared/ChatBox/ChatLink.tsx
import { Link as Link17, Icon as Icon26 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext20 } from "@simplybusiness/services";
import { jsx as jsx103, jsxs as jsxs73 } from "react/jsx-runtime";
var ChatLink = ({
  label = "Chat with a licensed agent",
  icon,
  questionName
}) => {
  const { snowplow } = useSnowplowContext20();
  const handleClick = () => {
    snowplow?.trigger("helpChatLinkClicked", { label: questionName });
    if (window?.zE) {
      window.zE("messenger", "show");
      window.zE("messenger", "open");
    }
  };
  return /* @__PURE__ */ jsxs73("div", { className: "mobius-chatbox__chat-link", children: [
    icon && /* @__PURE__ */ jsx103(Icon26, { fixedWidth: true, icon }),
    /* @__PURE__ */ jsx103(Link17, { onClick: handleClick, children: /* @__PURE__ */ jsx103("span", { children: label }) })
  ] });
};

// src/components/shared/ChatBox/AvatarData.ts
var DEFAULT_AVATAR = "data:image/webp;base64,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";

// src/components/shared/ChatBox/ChatBox.tsx
import { jsx as jsx104, jsxs as jsxs74 } from "react/jsx-runtime";
var ChatBoxComponent = forwardRef14((props, ref) => {
  const {
    elementType: Element = "div",
    children,
    componentName,
    position = "center",
    avatarSrc = DEFAULT_AVATAR,
    avatarAlt = "",
    ...otherProps
  } = props;
  const classes = classNames35(
    "mobius",
    "mobius-chatbox",
    `mobius-chatbox--${position}`,
    otherProps.className
  );
  const { variant } = otherProps;
  return /* @__PURE__ */ jsx104(
    Element,
    {
      ref,
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      className: classes,
      children: /* @__PURE__ */ jsxs74("div", { className: "mobius-chatbox__grid", children: [
        /* @__PURE__ */ jsx104("div", { className: "mobius-chatbox__avatar-container", children: /* @__PURE__ */ jsx104(
          Image2,
          {
            className: "mobius-chatbox__avatar",
            src: avatarSrc,
            alt: avatarAlt
          }
        ) }),
        /* @__PURE__ */ jsx104("div", { className: "mobius-chatbox__message", children: /* @__PURE__ */ jsx104(
          Flex24,
          {
            flexDirection: "column",
            gap: "xs",
            className: "mobius-chatbox__inner",
            children
          }
        ) })
      ] })
    }
  );
});
ChatBoxComponent.displayName = "ChatBox";
var ChatBox = Object.assign(ChatBoxComponent, {
  ChatLink
});

// src/components/Questionnaire/Section/Question/QuestionChatBox.tsx
import { Flex as Flex25, Text as Text40 } from "@simplybusiness/mobius";
import { jsx as jsx105, jsxs as jsxs75 } from "react/jsx-runtime";
var QuestionChatBox = ({
  questionName,
  chatConfig: { text: text3, hintText, chatLabel }
}) => {
  return /* @__PURE__ */ jsxs75(ChatBox, { className: "mobius-question__chatbox", position: "left", children: [
    /* @__PURE__ */ jsx105(Text40, { variant: "body", children: text3 }),
    !!hintText && /* @__PURE__ */ jsx105(Text40, { variant: "body", children: /* @__PURE__ */ jsxs75("strong", { children: [
      "Hint: ",
      hintText
    ] }) }),
    /* @__PURE__ */ jsxs75(Flex25, { className: "mobius-question__chatbox-link-container", children: [
      /* @__PURE__ */ jsx105(Text40, { variant: "body", children: "Still unsure?" }),
      /* @__PURE__ */ jsx105(ChatBox.ChatLink, { label: chatLabel, questionName })
    ] })
  ] });
};

// src/components/Questionnaire/Section/EditSection.tsx
import { jsx as jsx106, jsxs as jsxs76 } from "react/jsx-runtime";
var EditSection = forwardRef15((props, ref) => {
  const { questions, className } = props;
  const classes = classNames36("mobius", "mobius-edit-section", className);
  const {
    answers,
    sections,
    validations,
    visibility,
    currentSectionIndex,
    lastViewedSectionIndex,
    navigatePrev,
    validateForm,
    setErrors,
    setEditMode
  } = useQuestionnaire();
  const { isPending } = useDependentQuestions();
  const { sendAnswers, isPending: isSending } = useSendAnswers();
  useEffect7(() => {
    setEditMode(true);
  }, [setEditMode]);
  const handleSaveAndContinue = () => {
    const result = validateForm({
      answers,
      sections,
      validations,
      visibility,
      currentSectionIndex,
      lastViewedSectionIndex
    });
    if (!result.isValid) {
      setErrors(result.errors);
    } else {
      setErrors({});
      sendAnswers(answers).then(navigatePrev).catch((err) => console.error("Error sending answers:", err));
    }
  };
  return /* @__PURE__ */ jsxs76("section", { "data-testid": "mobius-section", ref, className: classes, children: [
    /* @__PURE__ */ jsx106("div", { className: "mobius-section__question-container", children: questions.map((question) => /* @__PURE__ */ jsx106(Question, { ...question, answers }, question.name)) }),
    /* @__PURE__ */ jsx106(Box7, { paddingBlockStart: "sm", paddingBlockEnd: "sm", children: /* @__PURE__ */ jsx106(
      Button13,
      {
        onClick: handleSaveAndContinue,
        isDisabled: isPending || isSending,
        children: "Save and Continue"
      }
    ) })
  ] });
});
EditSection.displayName = "EditSection";

// src/components/Questionnaire/Section/ReviewSection.tsx
import { Text as Text43 } from "@simplybusiness/mobius";
import classNames40 from "classnames/dedupe";
import { forwardRef as forwardRef17, useEffect as useEffect9, useMemo as useMemo4, useState as useState13 } from "react";

// src/components/Questionnaire/Collapsible/Collapsible.tsx
import classNames39 from "classnames/dedupe";
import { forwardRef as forwardRef16, useCallback as useCallback6, useEffect as useEffect8, useRef as useRef3, useState as useState11 } from "react";

// src/components/Questionnaire/Collapsible/Content.tsx
import { List, ListItem, Text as Text41 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext21 } from "@simplybusiness/services";
import classNames38 from "classnames/dedupe";

// src/components/Questionnaire/Collapsible/ContentTextBlock.tsx
import { penToSquare as penToSquare3 } from "@simplybusiness/icons";
import { Button as Button14, Icon as Icon27 } from "@simplybusiness/mobius";
import classNames37 from "classnames/dedupe";
import { Fragment as Fragment19, jsx as jsx107, jsxs as jsxs77 } from "react/jsx-runtime";
function ContentTextBlock({
  block,
  answer,
  shouldAddAnswer,
  blockIndex,
  hasSensitiveData,
  readOnly,
  onEditQuestion
}) {
  const answerClasses = classNames37({
    "has-pii": hasSensitiveData
  });
  const casedAnswer = blockIndex > 0 ? answer?.charAt(0).toLowerCase() + answer?.slice(1) : answer;
  const casedAnswerElement = !readOnly ? /* @__PURE__ */ jsxs77(
    Button14,
    {
      "aria-label": `Edit answer: ${casedAnswer}`,
      variant: "link",
      size: "sm",
      className: classNames37(
        "mobius-collapsible__content-edit-button",
        answerClasses
      ),
      onClick: () => onEditQuestion?.(),
      children: [
        casedAnswer,
        " ",
        /* @__PURE__ */ jsx107(Icon27, { icon: penToSquare3 })
      ]
    }
  ) : casedAnswer;
  if (block === "")
    return /* @__PURE__ */ jsx107("strong", { className: answerClasses, children: casedAnswerElement });
  if (shouldAddAnswer)
    return /* @__PURE__ */ jsxs77("span", { children: [
      /* @__PURE__ */ jsx107("strong", { className: answerClasses, children: casedAnswerElement }),
      block
    ] });
  return /* @__PURE__ */ jsx107(Fragment19, { children: block });
}

// src/components/Questionnaire/Collapsible/parseHtml.ts
var parseHtml = (html) => {
  const text3 = html.replace(/<ul>.*?<\/ul>/g, "").replace(/<b>/g, "").replace(/<\/b>/g, "").trim();
  const listItems = html.match(/<li>(.*?)<\/li>/g)?.map((item) => item.replace(/<\/?li>/g, "").trim()) || [];
  return {
    text: text3,
    listItems
  };
};

// src/components/Questionnaire/Collapsible/Content.tsx
import { jsx as jsx108, jsxs as jsxs78 } from "react/jsx-runtime";
function Content({
  id,
  name,
  text: text3,
  answer = "",
  group,
  hasSensitiveData,
  readOnly,
  onEditQuestion
}) {
  const { changedQuestions } = useQuestionnaire();
  const { snowplow } = useSnowplowContext21();
  const { text: t, listItems } = parseHtml(text3);
  const textBlocks = t.split("${answer}");
  const addAnswerInMiddle = textBlocks.filter((b) => b !== "").length > 1;
  const shouldShowLocks = id === "sof_door_locks";
  const isChanged = changedQuestions?.includes(name);
  const classes = classNames38({
    "mobius-collapsible__changed_question": isChanged
  });
  const handleClick = () => {
    snowplow?.trigger("assumptionLinkClicked", {
      category: group,
      label: name,
      property: answer
    });
    onEditQuestion?.();
  };
  return /* @__PURE__ */ jsxs78("div", { id: name, className: "mobius-collapsible__bottom-divider", children: [
    /* @__PURE__ */ jsxs78("div", { className: classes, children: [
      /* @__PURE__ */ jsx108("div", { className: "mobius-collapsible__content-blocks", children: /* @__PURE__ */ jsx108(Text41, { children: textBlocks.map((block, index) => {
        const shouldAddAnswer = addAnswerInMiddle && index === 1;
        return /* @__PURE__ */ jsx108(
          ContentTextBlock,
          {
            block,
            answer,
            shouldAddAnswer,
            blockIndex: index,
            hasSensitiveData,
            readOnly,
            onEditQuestion: handleClick
          },
          index
        );
      }) }, "text") }),
      listItems.length > 0 && /* @__PURE__ */ jsx108(List, { children: listItems.map((item) => /* @__PURE__ */ jsx108(ListItem, { children: item }, item)) })
    ] }),
    shouldShowLocks && /* @__PURE__ */ jsx108("div", { className: "mobius-collapsible__locks-spacer", children: /* @__PURE__ */ jsx108(SecurityLocks, {}) })
  ] });
}

// src/components/Questionnaire/Collapsible/Actions.tsx
import { rightArrow as rightArrow3 } from "@simplybusiness/icons";
import { Button as Button15, Flex as Flex26, Icon as Icon28 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext22 } from "@simplybusiness/services";
import { jsx as jsx109, jsxs as jsxs79 } from "react/jsx-runtime";
var Actions4 = ({
  presentationGroup,
  onConfirm,
  groupIndex
}) => {
  const { snowplow } = useSnowplowContext22();
  const handleConfirm = () => {
    snowplow?.trigger("assumptionsButtonClicked", {
      source: "Confirm",
      presentationGroup
    });
    onConfirm(groupIndex);
  };
  return /* @__PURE__ */ jsx109(Flex26, { gap: "sm", className: "mobius-collapsible__actions", children: /* @__PURE__ */ jsxs79(Button15, { variant: "primary", size: "sm", onClick: handleConfirm, children: [
    /* @__PURE__ */ jsx109("span", { children: "Confirm" }),
    /* @__PURE__ */ jsx109(Icon28, { icon: rightArrow3 })
  ] }) });
};

// src/components/Questionnaire/Collapsible/Summary.tsx
import { filePen, home, lock, tick as tick6, users } from "@simplybusiness/icons";
import {
  Button as Button16,
  Icon as Icon29,
  Text as Text42
} from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext23 } from "@simplybusiness/services";
import { jsx as jsx110, jsxs as jsxs80 } from "react/jsx-runtime";
var headerIconsMap = {
  "about your property": home,
  security: lock,
  "property use": users,
  "financial and claims": filePen
};
var Summary = ({
  header: header2,
  isConfirmed,
  isOpen,
  groupIndex,
  onReOpen,
  helpText
}) => {
  const { snowplow } = useSnowplowContext23();
  const showHelpButton = helpText !== "" && isOpen;
  const handleReview = () => {
    snowplow?.trigger("assumptionsButtonClicked", {
      source: "Review",
      presentationGroup: header2
    });
    onReOpen(groupIndex);
  };
  const onOpenDrawer = () => {
    snowplow?.trigger("assumptionsButtonClicked", {
      source: "More Info",
      presentationGroup: header2
    });
  };
  return /* @__PURE__ */ jsx110(
    "summary",
    {
      className: "mobius-collapsible__summary",
      onClick: (e) => e.preventDefault(),
      children: /* @__PURE__ */ jsxs80("div", { className: "mobius-collapsible__summary-content", children: [
        isConfirmed && !isOpen && /* @__PURE__ */ jsx110(Icon29, { "data-testid": "tick-icon", icon: tick6, size: "md" }),
        (!isConfirmed || isOpen) && /* @__PURE__ */ jsx110(
          Icon29,
          {
            "data-testid": "header-icon",
            className: "mobius-collapsible__summary-header-icon",
            icon: headerIconsMap[header2.toLowerCase()] || home,
            size: "md"
          }
        ),
        /* @__PURE__ */ jsx110(Text42, { variant: "h2", children: header2 }),
        isConfirmed && !isOpen && /* @__PURE__ */ jsx110(Button16, { variant: "secondary", size: "sm", onClick: handleReview, children: "Review" }),
        showHelpButton && /* @__PURE__ */ jsx110(
          HelpLink,
          {
            headline: header2,
            label: "More info",
            text: helpText ?? "",
            displayAsButton: true,
            onOpenDrawer
          }
        )
      ] })
    }
  );
};

// src/components/Questionnaire/Collapsible/Details.tsx
import { jsx as jsx111, jsxs as jsxs81 } from "react/jsx-runtime";
var Details = ({
  id,
  header: header2,
  isOpen,
  isConfirmed,
  onReOpen,
  onConfirm,
  groupIndex,
  children,
  helpText
}) => {
  return /* @__PURE__ */ jsxs81("details", { id, open: isOpen, className: "mobius-collapsible__details", children: [
    /* @__PURE__ */ jsx111(
      Summary,
      {
        header: header2,
        isConfirmed,
        isOpen,
        onReOpen,
        groupIndex,
        helpText
      }
    ),
    /* @__PURE__ */ jsx111("div", { className: "mobius-collapsible__content", children }),
    /* @__PURE__ */ jsx111(
      Actions4,
      {
        presentationGroup: header2,
        onConfirm,
        groupIndex
      }
    )
  ] });
};

// src/components/Questionnaire/Collapsible/scrollToGroup.tsx
var IOS_SCROLL_TIMEOUT = 300;
var scrollToGroup = (group) => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return;
  }
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !Object.prototype.hasOwnProperty.call(window, "MSStream");
  const nextGroup = document.getElementById(`group-${group}`);
  if (nextGroup && isIOS) {
    const elementPosition = nextGroup.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 20;
    setTimeout(() => {
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }, IOS_SCROLL_TIMEOUT);
  } else if (nextGroup) {
    nextGroup.scrollIntoView({ behavior: "smooth" });
  } else {
    const submission = document.getElementById("mobius-submission");
    submission?.scrollIntoView({ behavior: "smooth" });
  }
};

// src/components/Questionnaire/Collapsible/Collapsible.tsx
import { jsx as jsx112 } from "react/jsx-runtime";
var Collapsible = forwardRef16((props, ref) => {
  const {
    groups,
    className,
    onConfirmGroup,
    onAllConfirmed,
    expandedGroup,
    confirmedGroups,
    onEditQuestion,
    onGroupExpanded,
    ...rest
  } = props;
  const sentAllConfirmed = useRef3(false);
  const [openGroup, setOpenGroup] = useState11(expandedGroup ?? 0);
  const [_confirmedGroups, setConfirmedGroups] = useState11(
    confirmedGroups ?? /* @__PURE__ */ new Set()
  );
  const allGroupsConfirmed = useCallback6(() => {
    return groups.length === _confirmedGroups.size;
  }, [groups, _confirmedGroups]);
  useEffect8(() => {
    if (allGroupsConfirmed() && onAllConfirmed && !sentAllConfirmed.current) {
      sentAllConfirmed.current = true;
      onAllConfirmed();
    }
  }, [allGroupsConfirmed, confirmedGroups, onAllConfirmed]);
  const handleExpandGroup = (group) => {
    setOpenGroup(group);
    onGroupExpanded?.(group);
  };
  const handleConfirm = (group) => {
    onConfirmGroup?.(group);
    if (document.startViewTransition) {
      document.startViewTransition?.(() => {
        setConfirmedGroups((prev) => new Set(prev).add(group));
        handleExpandGroup(group + 1);
      });
    } else {
      setConfirmedGroups((prev) => new Set(prev).add(group));
      handleExpandGroup(group + 1);
    }
  };
  useEffect8(() => {
    if (openGroup) {
      scrollToGroup(openGroup);
    }
  }, [openGroup]);
  const handleReOpen = (group) => {
    handleExpandGroup(group);
    scrollToGroup(group);
  };
  const classes = classNames39("mobius", "mobius-collapsible", className);
  return /* @__PURE__ */ jsx112("div", { ref, className: classes, ...rest, children: groups.map(({ header: header2, content, help }, index) => /* @__PURE__ */ jsx112(
    Details,
    {
      id: `group-${index}`,
      header: header2,
      onReOpen: handleReOpen,
      groupIndex: index,
      isOpen: openGroup === index,
      isConfirmed: _confirmedGroups.has(index),
      onConfirm: handleConfirm,
      helpText: help,
      children: content.map((question) => /* @__PURE__ */ jsx112(
        Content,
        {
          "data-group-index": index,
          group: header2,
          onEditQuestion: () => onEditQuestion?.(question.name),
          ...question
        },
        question.name
      ))
    },
    header2
  )) });
});
Collapsible.displayName = "Collapsible";

// src/components/Questionnaire/Section/Submission.tsx
import { rightArrow as rightArrow4, loading } from "@simplybusiness/icons";
import { Button as Button17, Icon as Icon30 } from "@simplybusiness/mobius";
import { useCallback as useCallback7, useState as useState12 } from "react";

// src/components/Questionnaire/Section/QuestionnaireForm/QuestionnaireForm.tsx
import { useMemo as useMemo3, useRef as useRef4 } from "react";

// src/hooks/useQuestionnaireFormUrl/useQuestionnaireFormUrl.tsx
import { useAtom as useAtom10 } from "jotai";
import { useHydrateAtoms as useHydrateAtoms6 } from "jotai/utils";
var useSetQuestionnaireFormUrl = (url) => {
  useHydrateAtoms6([[questionnaireFormUrlAtom, url]]);
};
var useQuestionnaireFormUrl = () => {
  const serverUrl = useAtom10(questionnaireFormUrlAtom);
  return window?.location?.pathname ?? serverUrl[0];
};

// src/components/Questionnaire/Section/QuestionnaireForm/QuestionnaireForm.tsx
import { jsx as jsx113, jsxs as jsxs82 } from "react/jsx-runtime";
var QuestionnaireForm = (props) => {
  const { children } = props;
  const formRef = useRef4(null);
  const tokens = useTokensValues();
  const { locale } = useLocale();
  const state = useQuestionnaire();
  const { answers, sections, validateForm, setErrors, visibility } = state;
  const url = useQuestionnaireFormUrl();
  const transformedAnswers = useMemo3(
    () => transformAnswers(answers, sections, visibility, locale),
    [answers, sections, visibility, locale]
  );
  const validate = () => validateForm(state);
  const inputValues = Object.entries(transformedAnswers).reduce(
    (acc, [key, value]) => {
      if (!value) {
        return acc;
      }
      if (Array.isArray(value)) {
        return [...acc, ...value.map((v) => [`${key}[]`, v])];
      }
      return [...acc, [key, value.toString()]];
    },
    []
  );
  const handleSubmit = (event) => {
    event.preventDefault();
    const { isValid, errors } = validate();
    if (isValid) {
      formRef.current?.submit();
    } else {
      setErrors(errors);
    }
  };
  return /* @__PURE__ */ jsxs82(
    "form",
    {
      ref: formRef,
      className: "mobius-submission__questionnaire-form",
      action: url,
      method: "POST",
      acceptCharset: "UTF-8",
      noValidate: true,
      onSubmit: handleSubmit,
      children: [
        inputValues.map(([key, value], i) => /* @__PURE__ */ jsx113("input", { type: "hidden", name: key, value }, `${key}-${i}`)),
        /* @__PURE__ */ jsx113(
          "input",
          {
            type: "hidden",
            name: "authenticity_token",
            value: tokens.authenticityToken
          }
        ),
        /* @__PURE__ */ jsx113("input", { type: "hidden", name: "journey_token", value: tokens.journeyToken }),
        children
      ]
    }
  );
};

// src/components/Questionnaire/Section/Submission.tsx
import { jsx as jsx114, jsxs as jsxs83 } from "react/jsx-runtime";
var Submission = ({
  children,
  isDisabled,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState12(false);
  const handleSubmit = useCallback7(() => {
    setIsLoading(true);
    onSubmit?.();
  }, [onSubmit]);
  return /* @__PURE__ */ jsxs83("div", { id: "mobius-submission", className: "mobius-submission", children: [
    /* @__PURE__ */ jsx114("div", { children }),
    /* @__PURE__ */ jsx114(QuestionnaireForm, { children: /* @__PURE__ */ jsxs83(Button17, { onClick: handleSubmit, isDisabled, type: "submit", children: [
      "Continue to quotes",
      " ",
      isLoading ? /* @__PURE__ */ jsx114(Icon30, { icon: loading, spin: true, fixedWidth: true }) : /* @__PURE__ */ jsx114(Icon30, { icon: rightArrow4, fixedWidth: true })
    ] }) })
  ] });
};

// src/hooks/useQuestionnaire/makeFullAddress.ts
var makeFullAddress = (questionName, state) => {
  const { sections: sectionsFromState, answers = {} } = state;
  const sections = sectionsFromState;
  const question = sections.flatMap((section) => section.questions).find((q) => q.name === questionName);
  if (!question) {
    return "";
  }
  const mappedFields = question.display.config?.mappedFields || [];
  const questionIds = Array.isArray(mappedFields) ? mappedFields.map(
    (field) => field.associatedQuestionId
  ) : [];
  const questionNames = sections.flatMap((section) => section.questions).filter((q) => questionIds.includes(q.id)).map((q) => q.name);
  const manualAnswers = questionNames.map((name) => answers[name]);
  const fullAddress = manualAnswers.filter(Boolean).join(", ");
  return fullAddress;
};

// src/components/Questionnaire/Section/transformQuestionsToGroups.ts
var getAnswerText = (answer, options) => {
  if (Array.isArray(answer)) {
    return answer.join(", ");
  }
  return options?.find((o) => o.value === answer)?.label || (typeof answer === "object" ? "" : answer?.toString());
};
var makeContent = ({
  question,
  answers,
  sections,
  addressModes,
  locale
}) => {
  const { id, name, presentationText, options, hasSensitiveData, display } = question;
  const { type } = display;
  const isAddress = type === "address_lookup";
  const isDate = type === "date";
  let answer;
  if (isAddress && addressModes?.[name] === "manual") {
    answer = makeFullAddress(name, { sections, answers });
  } else if (isDate && answers[name]) {
    answer = formatDateByLocale(answers[name], locale);
  } else {
    answer = getAnswerText(answers[name], options);
  }
  return {
    id,
    name,
    text: presentationText || "",
    answer,
    hasSensitiveData,
    readOnly: isAddress
  };
};
var transformQuestionsToGroups = ({
  questions,
  answers,
  sections,
  addressModes,
  locale
}) => {
  const groupedQuestions = questions.reduce(
    (acc, question) => {
      const group = question.presentationGroup || "";
      if ((question.visible || question.display.type === "address_lookup") && group !== "") {
        acc[group] = acc[group] || [];
        acc[group].push(question);
      }
      return acc;
    },
    {}
  );
  return Object.entries(groupedQuestions).map(([group, groupQuestions]) => ({
    header: group,
    content: groupQuestions.map(
      (question) => makeContent({ question, answers, addressModes, sections, locale })
    ),
    help: groupQuestions.filter(({ helpInfo }) => helpInfo).map(
      ({ helpInfo }) => `<h3>${helpInfo?.headline}</h3>
${helpInfo?.text}`
    ).join("\n")
  }));
};

// src/components/Questionnaire/Section/ReviewSection.tsx
import { jsx as jsx115, jsxs as jsxs84 } from "react/jsx-runtime";
var ReviewSection = forwardRef17((props, ref) => {
  const {
    title,
    preamble,
    postamble = "By continuing, you agree that the above statements are up to date and correct to the best of your knowledge.",
    questions,
    className
  } = props;
  const classes = classNames40("mobius", "mobius-section", className);
  const {
    sections: sectionsFromState,
    currentSectionIndex,
    answers,
    showQuestion,
    editQuestion,
    selectedQuestion,
    changedQuestions,
    changedGroupIndex,
    confirmedGroups,
    confirmGroup,
    setEditMode,
    addressModes
  } = useQuestionnaire();
  const sections = sectionsFromState;
  const isMutating = useMutationStatus("prepopulateAnswers");
  const [allowSubmission, setAllowSubmission] = useState13(false);
  const [expandedGroup, setExpandedGroup] = useState13(changedGroupIndex);
  const { locale } = useLocale();
  useEffect9(() => {
    const questionName = changedQuestions?.[0] || selectedQuestion;
    if (questionName) {
      const element = document.getElementById(questionName);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
    setEditMode(false);
  }, []);
  const groupsData = useMemo4(
    () => transformQuestionsToGroups({
      questions,
      answers,
      sections,
      addressModes,
      locale
    }),
    [questions, answers, sections, addressModes, locale]
  );
  const handleEditQuestion = (questionName) => {
    const foundIndex = sections.findIndex(
      ({ questions: questions2 }) => questions2.some(({ name }) => name === questionName)
    );
    if (foundIndex < currentSectionIndex) {
      showQuestion(questionName);
    } else {
      editQuestion({ questionName, groupIndex: expandedGroup });
    }
  };
  return /* @__PURE__ */ jsxs84("section", { "data-testid": "mobius-review-section", ref, className: classes, children: [
    title && /* @__PURE__ */ jsx115("h2", { className: "mobius-section__title", children: title }),
    preamble && /* @__PURE__ */ jsx115(Text43, { className: "mobius-section__preamble", children: /* @__PURE__ */ jsx115("span", { dangerouslySetInnerHTML: { __html: preamble } }) }),
    /* @__PURE__ */ jsx115(
      Collapsible,
      {
        groups: groupsData,
        expandedGroup,
        confirmedGroups,
        onAllConfirmed: () => setAllowSubmission(true),
        onEditQuestion: handleEditQuestion,
        onGroupExpanded: setExpandedGroup,
        onConfirmGroup: confirmGroup
      }
    ),
    /* @__PURE__ */ jsx115(Submission, { isDisabled: isMutating || !allowSubmission, children: /* @__PURE__ */ jsx115(Text43, { className: "mobius-section__postamble", children: /* @__PURE__ */ jsx115("span", { dangerouslySetInnerHTML: { __html: postamble } }) }) })
  ] });
});
ReviewSection.displayName = "ReviewSection";

// src/components/Questionnaire/Section/Section.tsx
import { Text as Text44 } from "@simplybusiness/mobius";
import classNames42 from "classnames/dedupe";
import { forwardRef as forwardRef18 } from "react";

// src/components/Questionnaire/Section/Insurers/Insurers.tsx
import { Flex as Flex27 } from "@simplybusiness/mobius";
import classNames41 from "classnames/dedupe";
import { jsx as jsx116 } from "react/jsx-runtime";
var VERTICALS = ["landlord", "shop"];
var SHOP_INSURERS = [
  "hiscox",
  "axa",
  "zurich",
  "aig",
  "rsa",
  "maltings",
  "churchill",
  "chiswell",
  "covea",
  "finsbury"
];
var LANDLORD_INSURERS = [
  "axa",
  "churchill",
  "zurich",
  "covea",
  "aro",
  "modus",
  "melius",
  "uno",
  "chiswell",
  "finsbury",
  "maltings"
];
var getVerticalFromPreambleName = (preambleName) => {
  if (!preambleName?.includes("insurer_logos")) {
    return null;
  }
  const vertical = preambleName.split("_")[0];
  if (!vertical || !VERTICALS.includes(vertical)) {
    return null;
  }
  return vertical;
};
var Insurers = (props) => {
  const { className } = props;
  const classes = classNames41("mobius", "mobius-insurers", className);
  const insurersSet = props.insurersLogosSet === "landlord" ? LANDLORD_INSURERS : SHOP_INSURERS;
  return /* @__PURE__ */ jsx116(
    Flex27,
    {
      "data-testid": `mobius-insurers-${props.insurersLogosSet}`,
      justifyContent: "space-between",
      flexWrap: "wrap",
      alignItems: "center",
      className: classes,
      children: insurersSet.map((insurer) => /* @__PURE__ */ jsx116(
        "div",
        {
          className: `mobius-insurers-${props.insurersLogosSet} mobius-insurers__insurer--${insurer}`
        },
        insurer
      ))
    }
  );
};

// src/components/Questionnaire/Section/Section.tsx
import { jsx as jsx117, jsxs as jsxs85 } from "react/jsx-runtime";
var Section2 = forwardRef18((props, ref) => {
  const { title, preamble, postamble, preambleName, questions, className } = props;
  const classes = classNames42("mobius", "mobius-section", className);
  const showInsurers = getVerticalFromPreambleName(preambleName);
  const { visibility, answers } = useQuestionnaire();
  return /* @__PURE__ */ jsxs85("section", { "data-testid": "mobius-section", ref, className: classes, children: [
    title && /* @__PURE__ */ jsx117("h2", { className: "mobius-section__title", children: title }),
    showInsurers && /* @__PURE__ */ jsx117(Insurers, { insurersLogosSet: showInsurers }),
    preamble && /* @__PURE__ */ jsx117(Text44, { className: "mobius-section__preamble", children: /* @__PURE__ */ jsx117("span", { dangerouslySetInnerHTML: { __html: preamble } }) }),
    /* @__PURE__ */ jsx117("div", { className: "mobius-section__question-container", children: questions.filter(isQuestion).map((question) => /* @__PURE__ */ jsx117(
      Question,
      {
        ...question,
        answers,
        visible: visibility?.[question.name] ?? question.visible
      },
      question.name
    )) }),
    postamble && /* @__PURE__ */ jsx117(Text44, { className: "mobius-section__postamble", children: /* @__PURE__ */ jsx117("span", { dangerouslySetInnerHTML: { __html: postamble } }) })
  ] });
});
Section2.displayName = "Section";

// src/components/Questionnaire/Section/index.tsx
import { jsx as jsx118 } from "react/jsx-runtime";
var Section3 = forwardRef19((props, ref) => {
  const { displayAs, ...otherProps } = props;
  if (displayAs === "review") {
    return /* @__PURE__ */ jsx118(ReviewSection, { ...otherProps, ref });
  }
  if (displayAs === "edit") {
    return /* @__PURE__ */ jsx118(EditSection, { ...otherProps, ref });
  }
  return /* @__PURE__ */ jsx118(Section2, { ...otherProps, ref });
});
Section3.displayName = "Section";

// src/components/Questionnaire/Questionnaire.tsx
import { jsx as jsx119, jsxs as jsxs86 } from "react/jsx-runtime";
var Questionnaire = forwardRef20(
  (props, ref) => {
    const {
      elementType: Element = "div",
      config,
      sections,
      validations,
      componentName,
      actions,
      ...otherProps
    } = props;
    const sectionRef = useRef5(null);
    const state = useQuestionnaire(sections, validations, config);
    const {
      currentSection: currentSectionFromState,
      currentSectionIndex,
      answers,
      navigateNext,
      navigatePrev,
      isFirstSection,
      isLastSection,
      validateForm,
      validateAction: validateAction2,
      setErrors
    } = state;
    const currentSection = currentSectionFromState;
    const { up } = useBreakpoint7();
    const isDesktop = up("md");
    const prevSectionIndexRef = useRef5(currentSectionIndex);
    const isSlideBack = currentSectionIndex < prevSectionIndexRef.current;
    const { sendAnswers, isPending } = useSendAnswers();
    const { prepopulateAnswers } = usePrepopulateAnswers();
    const { url, shouldRedirect } = useRedirect(currentSectionIndex);
    const isEditSection = currentSection.displayAs === "edit";
    useEffect10(() => {
      prevSectionIndexRef.current = currentSectionIndex;
    }, [currentSectionIndex]);
    useEffect10(() => {
      if (url && shouldRedirect) {
        window.location.assign(url);
      }
    }, [url, shouldRedirect]);
    const classes = classNames43(
      "mobius",
      "mobius-questionnaire",
      otherProps.className,
      {
        "mobius-questionnaire--slide-next": !isSlideBack,
        "mobius-questionnaire--slide-back": isSlideBack
      }
    );
    const { variant } = otherProps;
    const navEventCategory = currentSection.id ?? `step-${currentSectionIndex + 1}`;
    const goBack = useCallback8(() => {
      if (isFirstSection) return;
      navigatePrev();
    }, [navigatePrev, isFirstSection]);
    const handleSectionUpdate = useCallback8(() => {
      try {
        const validate = () => validateForm(state);
        const { isValid, errors, firstInvalidSectionIndex } = validate();
        if (answers && answers["Landlord type"] && answers["Landlord type"] !== "residential") {
          const value = answers["Landlord type"];
          prepopulateAnswers({
            ...answers,
            "Landlord type": value,
            "Property type": value
          }).catch(() => {
            setErrors({ "Landlord type": "Unable to continue" });
          });
          return;
        }
        if (firstInvalidSectionIndex !== void 0) {
          validateAction2();
          return;
        }
        if (!isValid) {
          setErrors(errors);
          return;
        }
        sendAnswers(answers).then(navigateNext).catch(console.error);
      } catch (e) {
        console.error(e);
      }
    }, [
      answers,
      validateForm,
      state,
      validateAction2,
      setErrors,
      sendAnswers,
      navigateNext,
      prepopulateAnswers
    ]);
    return /* @__PURE__ */ jsxs86(
      Element,
      {
        ref,
        ...otherProps,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        children: [
          isDesktop && !isEditSection && /* @__PURE__ */ jsx119(
            "div",
            {
              "data-testid": "desktop-actions",
              className: classNames43("mobius-questionnaire__actions-container", {
                "--is-first-section": isFirstSection
              }),
              children: /* @__PURE__ */ jsx119(
                Actions3,
                {
                  backLabel: !isFirstSection ? "Back" : void 0,
                  backButton: { onClick: goBack },
                  category: navEventCategory
                }
              )
            }
          ),
          /* @__PURE__ */ jsx119(SwitchTransition, { children: /* @__PURE__ */ jsx119(
            CSSTransition,
            {
              nodeRef: sectionRef,
              timeout: 200,
              onEntered: () => !isDesktop && window?.scrollTo({
                top: 0,
                behavior: "smooth"
              }),
              classNames: "mobius-section__transition",
              children: /* @__PURE__ */ jsx119(Section3, { ref: sectionRef, ...currentSection })
            },
            currentSectionIndex
          ) }),
          !isEditSection && /* @__PURE__ */ jsx119(
            Actions3,
            {
              backLabel: !isDesktop && !isFirstSection ? "Back" : void 0,
              nextLabel: !isLastSection ? "Next" : void 0,
              backButton: { onClick: goBack },
              nextButton: {
                onClick: handleSectionUpdate,
                isLoading: isPending,
                isDisabled: isPending
              },
              category: navEventCategory
            }
          )
        ]
      }
    );
  }
);
Questionnaire.displayName = "Questionnaire";

// src/components/QuoteCards/QuoteCards.tsx
import { useAtom as useAtom15 } from "jotai";
import classNames49 from "classnames/dedupe";
import { useBreakpoint as useBreakpoint8 } from "@simplybusiness/mobius";

// src/components/QuoteCards/NoQuotesCard/NoQuotesCard.tsx
import { Text as Text45 } from "@simplybusiness/mobius";
import { jsx as jsx120, jsxs as jsxs87 } from "react/jsx-runtime";
function NoQuotesCard() {
  return /* @__PURE__ */ jsx120(
    "div",
    {
      role: "listitem",
      className: "mobius-no-quotes-card",
      "data-testid": "no-quotes-card",
      children: /* @__PURE__ */ jsxs87("div", { className: "mobius-no-quotes-card__body", children: [
        /* @__PURE__ */ jsx120(Text45, { variant: "h2", children: "Let's try this again" }),
        /* @__PURE__ */ jsx120(Text45, { children: "Sorry, it doesn't look like we have anyone who can cover the limits you've selected. Not to worry. If you change your coverage limits above, you may be able to see available quotes." })
      ] })
    }
  );
}

// src/components/QuoteCards/NoQuotesReferral/NoQuotesReferral.tsx
import { Box as Box8, Link as Link18, Text as Text46 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext24 } from "@simplybusiness/services";
import { jsx as jsx121, jsxs as jsxs88 } from "react/jsx-runtime";
function NoQuotesReferral({
  quotes,
  referenceNumber,
  contactPhoneNumber,
  customerName,
  coverOptionsUrl
}) {
  const insurersPanel = (quotes || []).map((quote) => ({
    insurerName: quote.insurerNameParametrized,
    insurerLogo: quote.insurerLogo
  }));
  const { snowplow } = useSnowplowContext24();
  const handleCoverOptionsClick = () => snowplow?.trigger("coverOptionsLinkClicked");
  const handlePhoneNumberClick = () => snowplow?.trigger("phoneNumberLinkClicked");
  return /* @__PURE__ */ jsxs88(Box8, { className: "no-quotes-referral__container", children: [
    /* @__PURE__ */ jsxs88(Text46, { children: [
      "Hi ",
      /* @__PURE__ */ jsx121("strong", { children: customerName }),
      ", we've searched through our panel of trusted providers but we havent been able to find results to match your cover detail selections. You can expand your search by editing your choices on the",
      " ",
      /* @__PURE__ */ jsx121(Link18, { href: coverOptionsUrl, onClick: handleCoverOptionsClick, children: "Cover Options" }),
      " ",
      "page or through the filters above."
    ] }),
    /* @__PURE__ */ jsx121(Box8, { className: "no-quotes-referral__insurer-panel", children: insurersPanel.map((insurer, index) => /* @__PURE__ */ jsx121(
      Logo,
      {
        logoPath: insurer.insurerLogo,
        alt: insurer.insurerName,
        className: "no-quotes-referral-logo"
      },
      index
    )) }),
    /* @__PURE__ */ jsxs88(Text46, { className: "no-quotes-referral__summary", children: [
      "If you prefer to speak with us, our team will give you a call to see if we can find a quote that is right for your business. If you\u2019d prefer to call us, we're here to help on",
      " ",
      /* @__PURE__ */ jsx121(
        Link18,
        {
          href: `tel:${contactPhoneNumber}`,
          onClick: handlePhoneNumberClick,
          children: contactPhoneNumber
        }
      ),
      " ",
      "and give us your reference number ",
      /* @__PURE__ */ jsx121("strong", { children: referenceNumber })
    ] })
  ] });
}

// src/components/QuoteCards/PartialQuotesReferral/PartialQuotesReferral.tsx
import { Link as Link19, Text as Text47 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext25 } from "@simplybusiness/services";
import { jsx as jsx122, jsxs as jsxs89 } from "react/jsx-runtime";
function PartialQuotesReferral({
  quotes,
  customerName,
  coverOptionsUrl
}) {
  const insurersPanel = (quotes || []).map((quote) => ({
    insurerName: quote.insurerNameParametrized,
    insurerLogo: quote.insurerLogo
  }));
  const { snowplow } = useSnowplowContext25();
  const handleCoverOptionsClick = () => snowplow?.trigger("referralReasonsVariantBCoverOptionsLinkClicked");
  return /* @__PURE__ */ jsx122(
    "div",
    {
      "data-testid": "partial-quotes-referral",
      className: "partial-quotes-referral__container partial-quotes-referral__container-variant-b",
      children: /* @__PURE__ */ jsxs89("div", { className: "partial-quotes-referral__main", children: [
        /* @__PURE__ */ jsx122("div", { className: "partial-quotes-referral__info", children: /* @__PURE__ */ jsxs89(Text47, { children: [
          "Hi ",
          customerName,
          ", we've searched through our panel of trusted providers but we havent been able to find many results that match your cover detail selections. You can expand your search by editing your choices on the",
          " ",
          /* @__PURE__ */ jsx122(Link19, { href: coverOptionsUrl, onClick: handleCoverOptionsClick, children: "Cover Options" }),
          " ",
          "page or through the filters above."
        ] }) }),
        /* @__PURE__ */ jsx122("div", { className: "partial-quotes-referral__insurer-panel", children: insurersPanel.map((insurer, index) => /* @__PURE__ */ jsx122(
          Logo,
          {
            logoPath: insurer.insurerLogo,
            alt: insurer.insurerName,
            className: "partial-quotes-referral-logo"
          },
          index
        )) })
      ] })
    }
  );
}

// src/components/QuoteCards/QuoteCard/filterCovers.tsx
var filterCovers = (quote) => quote.vertical === "workers_compensation" ? quote.covers.filter(
  (cover) => cover.displayName !== "Employer's Liability" && cover.displayName !== "Other States Coverage"
) : quote.covers;

// src/components/QuoteCards/QuoteCard/Header/Header.tsx
import { Flex as Flex29 } from "@simplybusiness/mobius";

// src/components/QuoteCards/QuoteCard/Ratings/Ratings.tsx
import { Box as Box9, Flex as Flex28, Text as Text48 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext26 } from "@simplybusiness/services";
import classNames44 from "classnames";
import { useAtom as useAtom11 } from "jotai";
import { useCallback as useCallback9 } from "react";
import { Fragment as Fragment20, jsx as jsx123, jsxs as jsxs90 } from "react/jsx-runtime";
var Ratings = ({ data }) => {
  const { snowplow } = useSnowplowContext26();
  const { reinsurerText, ratingBody, ratingType, rating } = data;
  const ratingAgency = creditRatingAgencyDescriptions[ratingType];
  const blankSpace = /* @__PURE__ */ jsx123(Fragment20, { children: "\xA0" });
  const containerClasses = classNames44("mobius-quote-card__ratings", {
    "--has-reinsurer-text": reinsurerText
  });
  const [sliderIsOpen] = useAtom11(sliderStateAtom);
  const handleOpen = useCallback9(() => {
    const category = `${sliderIsOpen ? "quote_details_slider" : "qcp"}_insurer_rating_help`;
    if (ratingAgency) {
      snowplow?.trigger("ratingsModalOpened", {
        category,
        label: ratingAgency.label
      });
    }
  }, [ratingAgency, sliderIsOpen, snowplow]);
  return /* @__PURE__ */ jsxs90(
    Flex28,
    {
      flexDirection: "column",
      className: containerClasses,
      "data-testid": "ratings-control",
      children: [
        /* @__PURE__ */ jsx123(
          Text48,
          {
            className: "mobius-quote-card__ratings-text",
            "data-testid": "ratings-text",
            children: reinsurerText || blankSpace
          }
        ),
        (ratingBody || rating) && /* @__PURE__ */ jsxs90(Box9, { className: "mobius-quote-card__ratings-body", children: [
          ratingAgency && /* @__PURE__ */ jsx123(
            InfoModal,
            {
              toggleText: ratingBody || "",
              title: ratingAgency.label,
              body: ratingAgency.description,
              onOpen: handleOpen
            }
          ),
          rating && /* @__PURE__ */ jsx123(Text48, { variant: "small", className: "mobius-quote-card__ratings-value", children: rating })
        ] })
      ]
    }
  );
};

// src/components/QuoteCards/QuoteCard/Ratings/index.tsx
import { jsx as jsx124 } from "react/jsx-runtime";
var Ratings2 = (props) => {
  return /* @__PURE__ */ jsx124(Ratings, { ...props });
};

// src/components/QuoteCards/QuoteCard/Header/Header.tsx
import { jsx as jsx125, jsxs as jsxs91 } from "react/jsx-runtime";
var Header3 = ({
  logo,
  insurerName,
  insurerFinancialStrengthRatings: ratings
}) => {
  const showRatings = ratings?.rating && ratings?.ratingType;
  const logoAltText = insurerName ? `${insurerName} insurer logo` : "Provider logo";
  return /* @__PURE__ */ jsxs91(
    Flex29,
    {
      flexDirection: "column",
      gap: "xxs",
      className: "mobius-quote-card__header",
      children: [
        logo && /* @__PURE__ */ jsx125(
          "img",
          {
            src: logo,
            alt: logoAltText,
            className: "mobius-quote-card__header-logo"
          }
        ),
        showRatings && /* @__PURE__ */ jsx125(Ratings2, { data: ratings })
      ]
    }
  );
};

// src/components/QuoteCards/QuoteCard/Header/HeaderUK.tsx
import { Text as Text49 } from "@simplybusiness/mobius";
import { jsx as jsx126, jsxs as jsxs92 } from "react/jsx-runtime";
var HeaderUK = ({
  logo,
  insurerName,
  underWriterText
}) => {
  const logoAltText = insurerName ? `${insurerName} insurer logo` : "Provider logo";
  return /* @__PURE__ */ jsxs92("div", { className: "mobius-quote-card__header --is-uk", children: [
    logo && /* @__PURE__ */ jsx126("div", { className: "mobius-quote-card__header-logo --is-uk", children: /* @__PURE__ */ jsx126(
      "img",
      {
        src: logo,
        alt: logoAltText,
        className: "mobius-quote-card__header-logo --is-uk"
      }
    ) }),
    underWriterText && /* @__PURE__ */ jsxs92(Text49, { className: "header__underwriter-text", children: [
      /* @__PURE__ */ jsx126("span", { children: "Underwritten by:" }),
      /* @__PURE__ */ jsx126("br", {}),
      /* @__PURE__ */ jsx126("span", { children: underWriterText })
    ] })
  ] });
};

// src/components/QuoteCards/QuoteCard/NoQuoteCard/NoQuoteCard.tsx
import { Flex as Flex30, Text as Text50 } from "@simplybusiness/mobius";
import { jsx as jsx127, jsxs as jsxs93 } from "react/jsx-runtime";
var NoQuoteCard = ({ insurer, insurerLogo }) => {
  return /* @__PURE__ */ jsxs93(
    "div",
    {
      role: "listitem",
      className: "mobius-quote-card__no-quote",
      "data-testid": "no-quote-card",
      children: [
        /* @__PURE__ */ jsx127("div", { className: "mobius-quote-card__no-quote-logo", children: /* @__PURE__ */ jsx127(Logo, { logoPath: insurerLogo, alt: `${insurer} logo` }) }),
        /* @__PURE__ */ jsx127(Flex30, { alignItems: "center", className: "", children: /* @__PURE__ */ jsx127(Text50, { variant: "small", children: "Based on the details you've given us, this provider can't provide a quote" }) })
      ]
    }
  );
};

// src/components/QuoteCards/QuoteCard/Pricing/Pricing.tsx
import {
  calendarClock,
  chartMixedUpCircleDollar,
  circleDollar
} from "@simplybusiness/icons";
import { Flex as Flex32, Icon as Icon31, Text as Text52 } from "@simplybusiness/mobius";
import { useAtom as useAtom12 } from "jotai";

// src/components/QuoteCards/QuoteCard/QuoteCardBadges/QuoteCardBadges.tsx
import classNames45 from "classnames";
import { jsx as jsx128 } from "react/jsx-runtime";
function QuoteCardBadges({ children, className }) {
  const quoteCardBadgesClasses = classNames45(
    "mobius-quote-card__badges",
    className
  );
  return /* @__PURE__ */ jsx128("div", { className: quoteCardBadgesClasses, "data-testid": "quote-card-badges", children });
}

// src/components/QuoteCards/QuoteCard/QuoteCardBadges/QuoteCardBadge.tsx
import classNames46 from "classnames";
import { jsx as jsx129, jsxs as jsxs94 } from "react/jsx-runtime";
function QuoteCardBadge({
  icon,
  children,
  "data-testid": dataTestId,
  className
}) {
  const quoteCardBadgeClasses = classNames46(
    "mobius-quote-card__badge",
    className
  );
  return /* @__PURE__ */ jsxs94("div", { className: quoteCardBadgeClasses, "data-testid": dataTestId, children: [
    icon && /* @__PURE__ */ jsx129("span", { className: "mobius-quote-card__badge-icon", children: icon }),
    children
  ] });
}

// src/components/QuoteCards/QuoteCard/Pricing/Premium.tsx
import { Flex as Flex31, Text as Text51 } from "@simplybusiness/mobius";
import { jsx as jsx130, jsxs as jsxs95 } from "react/jsx-runtime";
var Premium = (props) => {
  const { isMonthly, hasInstallments, installmentsAmount, premium } = props;
  const primaryAmountClasses = "mobius-quote-card__pricing-primary-amount";
  const periodSuffixClasses = "mobius-quote-card__pricing-period-suffix";
  if (!isMonthly) {
    return /* @__PURE__ */ jsxs95(Flex31, { alignItems: "baseline", children: [
      /* @__PURE__ */ jsx130(Text51, { className: primaryAmountClasses, "data-testid": "premium-amount", children: premium }),
      /* @__PURE__ */ jsx130(
        Text51,
        {
          elementType: "span",
          variant: "small",
          className: periodSuffixClasses,
          children: " / year"
        }
      )
    ] });
  }
  return hasInstallments && installmentsAmount ? /* @__PURE__ */ jsxs95(Flex31, { alignItems: "baseline", children: [
    /* @__PURE__ */ jsx130(Text51, { className: primaryAmountClasses, "data-testid": "installment-amount", children: installmentsAmount }),
    /* @__PURE__ */ jsx130(Text51, { className: periodSuffixClasses, elementType: "span", variant: "small", children: "/ month" })
  ] }) : /* @__PURE__ */ jsxs95(Flex31, { flexDirection: "column", children: [
    /* @__PURE__ */ jsx130(
      Text51,
      {
        variant: "small",
        className: "mobius-quote-card__pricing-unavailable-installment",
        children: "Monthly installments not available"
      }
    ),
    /* @__PURE__ */ jsxs95("div", { "data-testid": "unavailable-monthly-installment-amount", children: [
      /* @__PURE__ */ jsx130(Text51, { elementType: "span", className: primaryAmountClasses, children: premium }),
      /* @__PURE__ */ jsx130(
        Text51,
        {
          elementType: "span",
          variant: "small",
          className: periodSuffixClasses,
          children: " / year"
        }
      )
    ] })
  ] });
};

// src/components/QuoteCards/QuoteCard/Pricing/Pricing.tsx
import { Fragment as Fragment21, jsx as jsx131, jsxs as jsxs96 } from "react/jsx-runtime";
var Pricing = ({
  quote,
  displayBadges,
  showInstallmentsInformation
}) => {
  const {
    installmentsAvailable,
    downpaymentAmount,
    installmentsAmount,
    installmentsCount,
    installmentsTotal,
    premium,
    externalPaymentOptions
  } = quote;
  const [paymentPeriod] = useAtom12(paymentToggleAtom);
  const isMonthly = paymentPeriod === "monthly";
  const hasInstallments = installmentsAvailable && installmentsAmount;
  const showZeroInterestBadge = hasInstallments && isMonthly && !externalPaymentOptions;
  const premiumEqualsInstallments = !externalPaymentOptions || externalPaymentOptions && premium === installmentsTotal;
  const showTotalCostBadge = hasInstallments && !isMonthly && premiumEqualsInstallments;
  const { processingFee } = quote;
  const amountDueClasses = "mobius-quote-card__pricing-amount-due";
  const showInstalments = isMonthly && hasInstallments && showInstallmentsInformation;
  return /* @__PURE__ */ jsx131(Flex32, { flexDirection: "column", className: "mobius-quote-card__pricing", children: /* @__PURE__ */ jsxs96(Flex32, { flexDirection: "column", children: [
    /* @__PURE__ */ jsxs96(Fragment21, { children: [
      /* @__PURE__ */ jsx131(Flex32, { alignItems: "baseline", gap: "xxs", children: /* @__PURE__ */ jsx131(
        Premium,
        {
          isMonthly,
          hasInstallments,
          installmentsAmount,
          premium
        }
      ) }),
      showInstalments && /* @__PURE__ */ jsxs96(Fragment21, { children: [
        /* @__PURE__ */ jsxs96(Text52, { variant: "small", className: amountDueClasses, children: [
          "Due today ",
          downpaymentAmount
        ] }),
        /* @__PURE__ */ jsxs96(Text52, { variant: "small", className: amountDueClasses, children: [
          "Then ",
          installmentsCount,
          " monthly installments of",
          " ",
          installmentsAmount
        ] }),
        /* @__PURE__ */ jsx131(Flex32, { gap: "xxs", className: "mobius-quote-card__pricing-total", children: /* @__PURE__ */ jsxs96(
          Text52,
          {
            "data-testid": "pricing__pricing-total-amount",
            className: "mobius-quote-card__pricing-total-amount",
            elementType: "span",
            variant: "small",
            children: [
              "Total",
              " ",
              externalPaymentOptions && installmentsTotal ? installmentsTotal : premium
            ]
          }
        ) })
      ] }),
      processingFee && /* @__PURE__ */ jsx131(Flex32, { gap: "xxs", className: "mobius-quote-card__pricing-total", children: /* @__PURE__ */ jsx131(
        Text52,
        {
          "data-testid": "pricing__processing-fees",
          elementType: "span",
          variant: "small",
          children: `Inc. ${processingFee} processing fee`
        }
      ) })
    ] }),
    displayBadges && /* @__PURE__ */ jsxs96(QuoteCardBadges, { children: [
      /* @__PURE__ */ jsx131(
        QuoteCardBadge,
        {
          icon: /* @__PURE__ */ jsx131(Icon31, { icon: calendarClock }),
          "data-testid": "quote-card-badge-12-month-policy",
          children: "12 month policy"
        }
      ),
      showZeroInterestBadge && /* @__PURE__ */ jsx131(
        QuoteCardBadge,
        {
          icon: /* @__PURE__ */ jsx131(Icon31, { icon: chartMixedUpCircleDollar }),
          "data-testid": "quote-card-badge-zero-interest",
          children: "Zero interest"
        }
      ),
      showTotalCostBadge && /* @__PURE__ */ jsx131(
        QuoteCardBadge,
        {
          icon: /* @__PURE__ */ jsx131(Icon31, { icon: circleDollar }),
          "data-testid": "quote-card-badge-annual-cost-same-as-monthly",
          children: "Total annual cost same as monthly"
        }
      )
    ] })
  ] }) });
};

// src/components/QuoteCards/QuoteCard/Pricing/index.tsx
import { jsx as jsx132 } from "react/jsx-runtime";
var Pricing2 = (props) => {
  return /* @__PURE__ */ jsx132(Pricing, { ...props });
};

// src/components/QuoteCards/QuoteCard/PricingUK/Pricing.tsx
import { calendarClock as calendarClock2 } from "@simplybusiness/icons";
import { Flex as Flex35, Icon as Icon32, Text as Text55 } from "@simplybusiness/mobius";
import { useAtom as useAtom13 } from "jotai";

// src/components/QuoteCards/QuoteCard/PricingUK/MonthlyPremium.tsx
import { Flex as Flex33, Text as Text53 } from "@simplybusiness/mobius";
import { jsx as jsx133, jsxs as jsxs97 } from "react/jsx-runtime";
var MonthlyPremium = ({ installmentsAmount }) => {
  return /* @__PURE__ */ jsxs97(Flex33, { alignItems: "baseline", flexWrap: "wrap", columnGap: "xxs", children: [
    /* @__PURE__ */ jsx133(
      Text53,
      {
        className: "mobius-quote-card__pricing-primary-amount --is-uk",
        "data-testid": "installment-amount",
        children: installmentsAmount
      }
    ),
    /* @__PURE__ */ jsx133(
      Text53,
      {
        className: "mobius-quote-card__pricing-period-suffix --is-uk",
        elementType: "span",
        variant: "small",
        children: "/\xA0month"
      }
    )
  ] });
};

// src/components/QuoteCards/QuoteCard/PricingUK/AnnualPremium.tsx
import { Flex as Flex34, Text as Text54 } from "@simplybusiness/mobius";
import { jsx as jsx134, jsxs as jsxs98 } from "react/jsx-runtime";
var AnnualPremium = ({ premium, message: message2 }) => {
  return /* @__PURE__ */ jsxs98(Flex34, { alignItems: "baseline", flexWrap: "wrap", columnGap: "xxs", children: [
    message2 && /* @__PURE__ */ jsx134(
      Text54,
      {
        variant: "small",
        className: "mobius-quote-card__pricing-unavailable-installment",
        children: message2
      }
    ),
    /* @__PURE__ */ jsxs98(
      Flex34,
      {
        "data-testid": "unavailable-monthly-installment-amount",
        alignItems: "baseline",
        columnGap: "xxs",
        children: [
          /* @__PURE__ */ jsx134(
            Text54,
            {
              elementType: "span",
              className: "mobius-quote-card__pricing-primary-amount --is-uk",
              children: premium
            }
          ),
          /* @__PURE__ */ jsx134(
            Text54,
            {
              elementType: "span",
              variant: "small",
              className: "mobius-quote-card__pricing-period-suffix --is-uk",
              children: "/\xA0annual"
            }
          )
        ]
      }
    )
  ] });
};

// src/components/QuoteCards/QuoteCard/PricingUK/Premium.tsx
import { jsx as jsx135 } from "react/jsx-runtime";
var Premium2 = (props) => {
  const { isMonthly, hasInstallments, installmentsAmount, premium } = props;
  if (!isMonthly) {
    return /* @__PURE__ */ jsx135(AnnualPremium, { premium });
  }
  return hasInstallments && installmentsAmount ? /* @__PURE__ */ jsx135(MonthlyPremium, { installmentsAmount }) : /* @__PURE__ */ jsx135(
    AnnualPremium,
    {
      premium,
      message: "Monthly instalments not available"
    }
  );
};

// src/components/QuoteCards/QuoteCard/PricingUK/Pricing.tsx
import { Fragment as Fragment22, jsx as jsx136, jsxs as jsxs99 } from "react/jsx-runtime";
var Pricing3 = ({
  quote,
  showInstallmentsInformation
}) => {
  const {
    installmentsAvailable,
    downpaymentAmount,
    installmentsAmount,
    installmentsCount,
    installmentsTotal,
    premium
  } = quote;
  const [paymentPeriod] = useAtom13(paymentToggleAtom);
  const isMonthly = paymentPeriod === "monthly";
  const hasInstallments = installmentsAvailable && installmentsAmount;
  const showInstalments = isMonthly && hasInstallments && showInstallmentsInformation;
  const instalmentsText = downpaymentAmount ? `Then ${installmentsCount} monthly payments of` : `${installmentsCount} monthly payments of`;
  return /* @__PURE__ */ jsxs99("div", { className: "mobius-quote-card__pricing --is-uk", children: [
    /* @__PURE__ */ jsxs99(Flex35, { alignItems: "flex-start", gap: "xxs", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsx136(
        Premium2,
        {
          isMonthly,
          hasInstallments,
          installmentsAmount,
          premium
        }
      ),
      /* @__PURE__ */ jsx136(QuoteCardBadges, { className: "--is-uk --is-desktop", children: /* @__PURE__ */ jsx136(
        QuoteCardBadge,
        {
          icon: /* @__PURE__ */ jsx136(Icon32, { icon: calendarClock2, color: "var(--color-accent)" }),
          "data-testid": "quote-card-badge-12-month-policy",
          children: "12 month policy"
        }
      ) })
    ] }),
    showInstalments && /* @__PURE__ */ jsxs99("div", { className: "mobius-quote-card__instalments-grid", children: [
      downpaymentAmount && /* @__PURE__ */ jsxs99(Fragment22, { children: [
        /* @__PURE__ */ jsx136(Text55, { children: "First payment" }),
        /* @__PURE__ */ jsx136(Text55, { className: "mobius-quote-card__instalment_amount", children: /* @__PURE__ */ jsx136("strong", { children: downpaymentAmount }) })
      ] }),
      /* @__PURE__ */ jsx136(Text55, { children: instalmentsText }),
      /* @__PURE__ */ jsx136(Text55, { className: "mobius-quote-card__instalment_amount", children: /* @__PURE__ */ jsx136("strong", { children: installmentsAmount }) }),
      /* @__PURE__ */ jsx136(Text55, { children: "Total over 12 months" }),
      /* @__PURE__ */ jsx136(Text55, { className: "mobius-quote-card__instalment_amount", children: /* @__PURE__ */ jsx136("strong", { children: installmentsTotal }) })
    ] }),
    /* @__PURE__ */ jsx136(QuoteCardBadges, { className: "--is-mobile", children: /* @__PURE__ */ jsx136(
      QuoteCardBadge,
      {
        icon: /* @__PURE__ */ jsx136(Icon32, { icon: calendarClock2, color: "var(--color-accent)" }),
        "data-testid": "quote-card-badge-12-month-policy",
        children: "12 month policy"
      }
    ) })
  ] });
};

// src/components/QuoteCards/QuoteCard/QuoteActions/ActionsWithoutQdpDrawer.tsx
import { Button as Button18 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext27 } from "@simplybusiness/services";

// src/utils/storybook/isStorybook.ts
function isStorybook() {
  return "__STORYBOOK_ADDONS_CHANNEL__" in globalThis;
}

// src/components/QuoteCards/QuoteCard/QuoteActions/ActionsWithoutQdpDrawer.tsx
import { jsx as jsx137, jsxs as jsxs100 } from "react/jsx-runtime";
var ActionsWithoutQdpDrawer = ({ quote }) => {
  const { snowplow } = useSnowplowContext27();
  const tokens = useTokensValues();
  if (!tokens) {
    return null;
  }
  function getSubmitterName(e) {
    const nativeEvent = e.nativeEvent;
    const submitter = nativeEvent.submitter;
    return submitter?.name;
  }
  function handleSubmit(e) {
    const submitterName = getSubmitterName(e);
    const snowplowEventName = {
      details_button_clicked: "detailsClicked",
      buy_button_clicked: "selectClicked"
    }[submitterName];
    if (snowplowEventName) {
      snowplow?.trigger(snowplowEventName);
    }
    if (isStorybook()) {
      e.preventDefault();
    }
  }
  return /* @__PURE__ */ jsx137(
    "form",
    {
      method: "POST",
      onSubmit: handleSubmit,
      className: "mobius-quote-actions-form",
      children: /* @__PURE__ */ jsxs100("div", { className: "mobius-quote-actions", children: [
        /* @__PURE__ */ jsx137(
          "input",
          {
            type: "hidden",
            name: "authenticity_token",
            value: tokens.authenticityToken
          }
        ),
        /* @__PURE__ */ jsx137("input", { type: "hidden", name: "journey_token", value: tokens.journeyToken }),
        /* @__PURE__ */ jsx137("input", { type: "hidden", name: "quote_id", value: quote.id }),
        /* @__PURE__ */ jsx137(
          "input",
          {
            type: "hidden",
            name: "insurer",
            value: quote.covers[0]?.coverInsurer
          }
        ),
        /* @__PURE__ */ jsx137(
          Button18,
          {
            type: "submit",
            variant: "secondary",
            className: "mobius-quote-actions__button mobius-quote-actions__button--is-details",
            name: "details_button_clicked",
            value: "yes",
            size: "sm",
            children: "Details"
          }
        ),
        /* @__PURE__ */ jsx137(
          Button18,
          {
            type: "submit",
            name: "buy_button_clicked",
            value: "yes",
            className: "mobius-quote-actions__button mobius-quote-actions__button--is-select",
            size: "sm",
            children: "Buy"
          }
        )
      ] })
    }
  );
};

// src/components/QuoteCards/QuoteCard/QuoteActions/QuoteActions.tsx
import { Accordion as Accordion6, Button as Button20, Drawer as Drawer2 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext29 } from "@simplybusiness/services";
import classNames48 from "classnames";
import { useAtom as useAtom14, useSetAtom } from "jotai";
import { useRef as useRef6, useState as useState15 } from "react";

// src/components/QuoteCards/QuoteCard/QuoteActions/QuoteDetails/AdditionalCoverageInformation/AdditionalCoverageInformation.tsx
import { Box as Box10, Text as Text56 } from "@simplybusiness/mobius";
import { Fragment as Fragment23, jsx as jsx138, jsxs as jsxs101 } from "react/jsx-runtime";
var renderedLayout = (items) => {
  if (items.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxs101(
    Box10,
    {
      className: "mobius-additional-coverage-info --has-divider",
      "data-testid": "additional-coverage-info",
      children: [
        /* @__PURE__ */ jsx138(Text56, { className: "mobius-additional-coverage-info__title", variant: "h3", children: "Additional Coverage Information" }),
        /* @__PURE__ */ jsx138("ul", { children: items.map((item, index) => /* @__PURE__ */ jsx138("li", { children: /* @__PURE__ */ jsx138("p", { className: "mobius-additional-coverage-info__text", children: item }) }, index)) })
      ]
    }
  );
};
var AdditionalCoverageInformation = ({
  vertical,
  additionalDisclosures
}) => {
  const additionalDisclosuresInformation = () => {
    if (vertical === "workers_compensation") {
      return Object.entries(additionalDisclosures || {}).map(
        ([key, value]) => /* @__PURE__ */ jsxs101(Fragment23, { children: [
          /* @__PURE__ */ jsx138("strong", { children: camelToTitleCase(key) }),
          ": ",
          value
        ] })
      );
    }
    return Object.values(additionalDisclosures)[0];
  };
  return renderedLayout(additionalDisclosuresInformation());
};

// src/components/QuoteCards/QuoteCard/QuoteActions/QuoteDetails/Footer.tsx
import { Flex as Flex37 } from "@simplybusiness/mobius";

// src/components/QuoteCards/QuoteCard/QuoteActions/QuoteDetails/SubmissionForm/SubmissionForm.tsx
import { Button as Button19, Flex as Flex36 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext28 } from "@simplybusiness/services";
import classNames47 from "classnames";
import { useAtomValue as useAtomValue5 } from "jotai";
import { useState as useState14 } from "react";

// src/components/QuoteCards/QuoteCard/quoteUnavailableForPurchaseModal.tsx
import { Modal as Modal3 } from "@simplybusiness/mobius";
import { jsx as jsx139, jsxs as jsxs102 } from "react/jsx-runtime";
var QuoteUnavailableForPurchase = ({
  modalOpen,
  onClose,
  insurerName
}) => /* @__PURE__ */ jsxs102(
  Modal3,
  {
    isOpen: modalOpen,
    onClose,
    className: "mobius-quote-card__modal-container",
    animation: "fade",
    closeLabel: "Close",
    children: [
      /* @__PURE__ */ jsx139(Modal3.Header, { children: "Sorry, this policy is only available to purchase during office hours." }),
      /* @__PURE__ */ jsxs102(Modal3.Content, { children: [
        "Please come back during ",
        insurerName,
        "'s office hours, Mon-Fri 6:30am - 11pm (ET) or Sat-Sun 2pm - 8pm (ET) to finalize your purchase. We will email you a link shortly."
      ] })
    ]
  }
);

// src/components/QuoteCards/QuoteCard/QuoteActions/QuoteDetails/SubmissionForm/SubmissionForm.tsx
import { Fragment as Fragment24, jsx as jsx140, jsxs as jsxs103 } from "react/jsx-runtime";
var SubmissionForm = ({
  quote,
  hasInstallments
}) => {
  const { snowplow } = useSnowplowContext28();
  const [isPending, setIsPending] = useState14(false);
  const [isSuccess, setIsSuccess] = useState14(false);
  const [modalOpen, setModalOpen] = useState14(false);
  const paymentPeriod = useAtomValue5(paymentToggleAtom);
  const [tokens] = useTokens();
  const handleSubmit = (event) => {
    setIsPending(true);
    snowplow?.trigger("nextStepsClicked");
    try {
      event.currentTarget.submit();
      setIsPending(false);
      setIsSuccess(true);
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      } else {
        throw new Error(JSON.stringify({ error }));
      }
    }
  };
  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  const handleButtonClick = () => {
    if (quote.quoteAvailableForPurchase === false) {
      openModal();
    } else {
      document.getElementById(`form-${quote.id}`)?.submit();
    }
  };
  const actionsButtonClasses = classNames47(
    "mobius-quote-actions__button",
    // `qa-buy-quote-option` class is used in cypress tests
    // keeping it to comply with shakedowns
    "qa-buy-quote-option"
  );
  const hiddenInputs = [
    {
      id: "authenticity_token",
      name: "authenticity_token",
      value: tokens?.authenticityToken || ""
    },
    {
      id: "journey_token",
      name: "journey_token",
      value: tokens?.journeyToken || ""
    },
    {
      id: "quote_id",
      name: "quote_id",
      value: quote.id
    },
    {
      id: "insurer",
      name: "insurer",
      value: quote.covers[0]?.coverInsurer
    },
    {
      id: "payment_period",
      name: "payment_period",
      value: hasInstallments ? paymentPeriod : "annual"
    },
    {
      id: "buy_button_clicked",
      name: "buy_button_clicked",
      value: "yes"
    },
    {
      id: "rfq_id",
      name: "rfq_id",
      value: quote.rfqId
    }
  ];
  return /* @__PURE__ */ jsxs103(Fragment24, { children: [
    /* @__PURE__ */ jsxs103(
      "form",
      {
        id: `form-${quote.id}`,
        method: "POST",
        onSubmit: handleSubmit,
        "data-testid": `form-${quote.id}`,
        children: [
          hiddenInputs.map((el) => /* @__PURE__ */ jsx140(
            "input",
            {
              "data-testid": el.id,
              id: el.id,
              type: "hidden",
              value: el.value,
              name: el.name,
              onChange: () => {
              }
            },
            el.id
          )),
          /* @__PURE__ */ jsx140(
            Flex36,
            {
              className: "mobius-quote-actions",
              justifyContent: "space-between",
              gap: "sm",
              children: /* @__PURE__ */ jsx140(
                Button19,
                {
                  id: `select-${quote.id}`,
                  className: actionsButtonClasses,
                  size: "sm",
                  type: "button",
                  isDisabled: isPending || isSuccess,
                  onClick: () => handleButtonClick(),
                  children: isPending || isSuccess ? "Please wait..." : "Next step"
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx140(
      QuoteUnavailableForPurchase,
      {
        modalOpen,
        onClose: closeModal,
        insurerName: quote.covers[0]?.coverInsurer
      }
    )
  ] });
};

// src/components/QuoteCards/QuoteCard/QuoteActions/QuoteDetails/Footer.tsx
import { jsx as jsx141, jsxs as jsxs104 } from "react/jsx-runtime";
var Footer5 = ({
  quote,
  paymentInformationRef,
  hasInstallments
}) => {
  function scrollToPaymentInformation() {
    paymentInformationRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
  }
  return /* @__PURE__ */ jsxs104(
    Flex37,
    {
      className: "mobius-quote-details-drawer__footer",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ jsxs104(Flex37, { className: "mobius-quote-details-drawer__footer-payment-info", children: [
          hasInstallments && /* @__PURE__ */ jsx141(PaymentToggle, { "data-test-id": "footer-payment-toggle" }),
          /* @__PURE__ */ jsx141(Pricing2, { quote })
        ] }),
        /* @__PURE__ */ jsx141(
          "button",
          {
            className: "mobius-quote-details-drawer__footer-payment-info-link",
            onClick: () => scrollToPaymentInformation(),
            children: "See payment information"
          }
        ),
        /* @__PURE__ */ jsx141(SubmissionForm, { quote, hasInstallments })
      ]
    }
  );
};

// src/components/QuoteCards/QuoteCard/QuoteActions/QuoteDetails/PaymentInformation/index.tsx
import { forwardRef as forwardRef22 } from "react";

// src/components/QuoteCards/QuoteCard/QuoteActions/QuoteDetails/PaymentInformation/PaymentInformation.tsx
import { forwardRef as forwardRef21 } from "react";
import {
  calendarClock as calendarClock3,
  chartMixedUpCircleDollar as chartMixedUpCircleDollar2,
  circleDollar as circleDollar2
} from "@simplybusiness/icons";
import { Box as Box11, Flex as Flex38, Icon as Icon33, Text as Text57, Segment as Segment2 } from "@simplybusiness/mobius";
import { Fragment as Fragment25, jsx as jsx142, jsxs as jsxs105 } from "react/jsx-runtime";
var PaymentInformation = forwardRef21(
  (props, ref) => {
    const {
      quote: {
        installmentsAvailable,
        downpaymentAmount,
        installmentsAmount,
        installmentsCount,
        installmentsTotal,
        premium,
        processingFee,
        covers,
        multiProductPremiums,
        insurerLogo,
        policyStartDate,
        externalPaymentOptions,
        primaryProductTitle
      },
      paymentPeriod = "monthly"
    } = props;
    const isMonthly = paymentPeriod === "monthly";
    const hasInstallments = installmentsAvailable && installmentsAmount;
    const showZeroInterestBadge = hasInstallments && isMonthly && !externalPaymentOptions;
    const premiumEqualsInstallments = !externalPaymentOptions || externalPaymentOptions && premium === installmentsTotal;
    const showTotalCostBadge = hasInstallments && !isMonthly && premiumEqualsInstallments;
    const productTitle = primaryProductTitle || transformCoverage(covers)[0].displayName;
    const totalPrice = isMonthly && externalPaymentOptions ? installmentsTotal : premium;
    const processingFeeDetailsText = processingFee ? `(inc. tax + ${processingFee} processing fee)` : "(inc. tax + fees)";
    return /* @__PURE__ */ jsxs105(
      Box11,
      {
        className: "mobius-payment-info --has-divider",
        ref,
        "data-testid": "payment-information",
        children: [
          /* @__PURE__ */ jsx142(Text57, { className: "mobius-payment-info__title", variant: "h3", children: "Payment Information" }),
          /* @__PURE__ */ jsxs105(QuoteCardBadges, { children: [
            /* @__PURE__ */ jsx142(
              QuoteCardBadge,
              {
                icon: /* @__PURE__ */ jsx142(Icon33, { icon: calendarClock3 }),
                "data-testid": "quote-card-badge-12-month-policy",
                children: "12 month policy"
              }
            ),
            showZeroInterestBadge && /* @__PURE__ */ jsx142(
              QuoteCardBadge,
              {
                icon: /* @__PURE__ */ jsx142(Icon33, { icon: chartMixedUpCircleDollar2 }),
                "data-testid": "quote-card-badge-zero-interest",
                children: "Zero interest"
              }
            ),
            showTotalCostBadge && /* @__PURE__ */ jsx142(
              QuoteCardBadge,
              {
                icon: /* @__PURE__ */ jsx142(Icon33, { icon: circleDollar2 }),
                "data-testid": "quote-card-badge-annual-cost-same-as-monthly",
                children: "Total annual cost same as monthly"
              }
            )
          ] }),
          multiProductPremiums ? /* @__PURE__ */ jsxs105(Fragment25, { children: [
            /* @__PURE__ */ jsx142(
              ProductInfo,
              {
                logo: insurerLogo,
                productTitle: "General Liability",
                premium: multiProductPremiums?.generalLiability,
                policyStartDate
              }
            ),
            /* @__PURE__ */ jsx142(
              ProductInfo,
              {
                logo: insurerLogo,
                productTitle: "Professional Liability",
                premium: multiProductPremiums?.professionalLiability,
                policyStartDate
              }
            )
          ] }) : /* @__PURE__ */ jsx142(
            ProductInfo,
            {
              logo: insurerLogo,
              productTitle,
              premium: totalPrice,
              policyStartDate
            }
          ),
          /* @__PURE__ */ jsx142(Flex38, { flexDirection: "column", children: /* @__PURE__ */ jsxs105("div", { className: "mobius-payment-info__total-outer-container", children: [
            /* @__PURE__ */ jsxs105(Fragment25, { children: [
              /* @__PURE__ */ jsxs105(
                Flex38,
                {
                  justifyContent: "space-between",
                  gap: "xs",
                  className: "mobius-payment-info__total-today",
                  flexGrow: 1,
                  children: [
                    /* @__PURE__ */ jsx142("span", { children: "To pay today" }),
                    /* @__PURE__ */ jsx142("span", { children: isMonthly && hasInstallments ? downpaymentAmount : premium })
                  ]
                }
              ),
              isMonthly && hasInstallments && /* @__PURE__ */ jsxs105(
                Flex38,
                {
                  justifyContent: "space-between",
                  gap: "xs",
                  className: "mobius-payment-info__installments",
                  flexGrow: 1,
                  children: [
                    /* @__PURE__ */ jsxs105("span", { children: [
                      installmentsCount,
                      " monthly payments of"
                    ] }),
                    /* @__PURE__ */ jsx142("span", { children: installmentsAmount })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ jsx142(Segment2, { colour: "subtle", className: "mobius-payment-info__total", children: /* @__PURE__ */ jsxs105(Flex38, { justifyContent: "space-between", gap: "xs", flexGrow: 1, children: [
              /* @__PURE__ */ jsxs105("span", { children: [
                /* @__PURE__ */ jsx142("strong", { children: "Total" }),
                " ",
                processingFeeDetailsText
              ] }),
              /* @__PURE__ */ jsx142("span", { children: /* @__PURE__ */ jsx142("strong", { "data-testid": "payment-information-total", children: externalPaymentOptions && isMonthly && installmentsTotal ? installmentsTotal : premium }) })
            ] }) })
          ] }) })
        ]
      }
    );
  }
);
PaymentInformation.displayName = "PaymentInformation";

// src/components/QuoteCards/QuoteCard/QuoteActions/QuoteDetails/PaymentInformation/index.tsx
import { jsx as jsx143 } from "react/jsx-runtime";
var PaymentInformation2 = forwardRef22(
  (props, ref) => {
    return /* @__PURE__ */ jsx143(PaymentInformation, { ...props, ref });
  }
);
PaymentInformation2.displayName = "PaymentInformation";

// src/components/QuoteCards/QuoteCard/QuoteActions/QuoteActions.tsx
import { Fragment as Fragment26, jsx as jsx144, jsxs as jsxs106 } from "react/jsx-runtime";
var QuoteActions = ({ quote }) => {
  const { snowplow } = useSnowplowContext29();
  const [paymentPeriod] = useAtom14(paymentToggleAtom);
  const [drawerOpen, setDrawerOpen] = useState15(false);
  const setSliderIsOpen = useSetAtom(sliderStateAtom);
  const {
    installmentsAvailable,
    installmentsAmount,
    covers,
    vertical,
    additionalDisclosures,
    insurerLogo,
    ratings,
    insurerDetails,
    upsells,
    helpText
  } = quote;
  const extraCovers = transformExtraCoverage(covers);
  const hasInstallments = Boolean(installmentsAvailable && installmentsAmount);
  const detailsActionClasses = classNames48(
    "mobius-quote-actions__button",
    "mobius-quote-actions__button--is-details",
    "qa-view-details-option"
  );
  const selectActionClasses = classNames48(
    "mobius-quote-actions__button",
    "mobius-quote-actions__button--is-select",
    "qa-buy-quote-option"
  );
  const [detailsLabel, selectLabel] = ["Details", "Select"];
  const openDrawer = (label) => {
    setDrawerOpen(true);
    setSliderIsOpen(true);
    snowplow?.trigger("sliderOpened", { label });
  };
  const closeDrawer = () => {
    setDrawerOpen(false);
    setSliderIsOpen(false);
  };
  const paymentInformationRef = useRef6(null);
  const handleInsurerDetailsOpen = () => {
    snowplow?.trigger("insurerDetailsAccordionClicked");
  };
  return /* @__PURE__ */ jsxs106(Fragment26, { children: [
    /* @__PURE__ */ jsxs106("div", { className: "mobius-quote-actions", children: [
      /* @__PURE__ */ jsx144(
        Button20,
        {
          variant: "secondary",
          className: detailsActionClasses,
          size: "sm",
          onClick: () => openDrawer(detailsLabel),
          children: detailsLabel
        }
      ),
      /* @__PURE__ */ jsx144(
        Button20,
        {
          className: selectActionClasses,
          size: "sm",
          onClick: () => openDrawer(selectLabel),
          children: selectLabel
        }
      )
    ] }),
    /* @__PURE__ */ jsxs106(
      Drawer2,
      {
        isOpen: drawerOpen,
        onClose: closeDrawer,
        className: "mobius-quote-details__drawer",
        closeLabel: "Close",
        direction: "right",
        children: [
          /* @__PURE__ */ jsx144(Drawer2.Header, { children: /* @__PURE__ */ jsx144(Logo, { logoPath: insurerLogo }) }),
          /* @__PURE__ */ jsxs106(Drawer2.Content, { children: [
            ratings && /* @__PURE__ */ jsx144(Ratings2, { data: ratings }),
            insurerDetails && /* @__PURE__ */ jsx144(
              Accordion6,
              {
                className: "mobius-quote-details__insurer-container",
                showText: "See more",
                hideText: "See less",
                onOpen: handleInsurerDetailsOpen,
                children: /* @__PURE__ */ jsx144(
                  "div",
                  {
                    className: "mobius-quote-details__insurer",
                    dangerouslySetInnerHTML: {
                      __html: insurerDetails
                    }
                  }
                )
              }
            ),
            covers && /* @__PURE__ */ jsx144(
              Coverage3,
              {
                helpText,
                covers,
                extraCovers,
                upsells,
                displayVariant: "qds",
                className: "--has-divider",
                withModal: true
              }
            ),
            additionalDisclosures && Object.keys(additionalDisclosures).length > 0 && /* @__PURE__ */ jsx144(
              AdditionalCoverageInformation,
              {
                vertical,
                additionalDisclosures
              }
            ),
            /* @__PURE__ */ jsx144(
              PaymentInformation2,
              {
                quote,
                paymentPeriod,
                ref: paymentInformationRef
              }
            )
          ] }),
          /* @__PURE__ */ jsx144(
            Footer5,
            {
              quote,
              paymentInformationRef,
              hasInstallments
            }
          )
        ]
      }
    )
  ] });
};

// src/components/QuoteCards/QuoteCard/QuoteActions/index.tsx
import { jsx as jsx145 } from "react/jsx-runtime";
var QuoteActions2 = ({ quote, variant }) => {
  const isUKVariant = variants(variant);
  if (isUKVariant) {
    return /* @__PURE__ */ jsx145(ActionsWithoutQdpDrawer, { quote });
  }
  return /* @__PURE__ */ jsx145(QuoteActions, { quote });
};

// src/components/QuoteCards/QuoteCard/QuoteCard.tsx
import { Fragment as Fragment27, jsx as jsx146, jsxs as jsxs107 } from "react/jsx-runtime";
var QuoteCard = ({
  quote,
  variant,
  hideNoQuoteCard
}) => {
  const { status, helpText } = quote;
  const insurer = quote.covers[0]?.coverInsurer;
  const insurerParametrized = insurer?.toLowerCase().replaceAll(" ", "-");
  const chopinTestId = `buy-${insurerParametrized}-block`;
  const { isUK } = useLocale();
  const filteredCovers = filterCovers(quote);
  const quoteCardClass = "mobius-quote-card";
  if (status === "referred") {
    if (hideNoQuoteCard === true) {
      return /* @__PURE__ */ jsx146(Fragment27, {});
    }
    return /* @__PURE__ */ jsx146(NoQuoteCard, { insurer, insurerLogo: quote.insurerLogo });
  }
  return /* @__PURE__ */ jsxs107(
    "div",
    {
      role: "listitem",
      className: quoteCardClass,
      id: chopinTestId,
      "data-testid": "quote-cards-list-item",
      children: [
        isUK ? /* @__PURE__ */ jsx146(
          HeaderUK,
          {
            logo: quote.insurerLogo,
            insurerName: quote.insurerNameParametrized,
            underWriterText: quote.underwriter
          }
        ) : /* @__PURE__ */ jsx146(
          Header3,
          {
            logo: quote.insurerLogo,
            insurerName: quote.insurerNameParametrized,
            insurerFinancialStrengthRatings: quote.ratings
          }
        ),
        isUK ? /* @__PURE__ */ jsx146(Pricing3, { quote, displayBadges: true, showInstallmentsInformation: true }) : /* @__PURE__ */ jsx146(Pricing2, { quote, displayBadges: true, showInstallmentsInformation: true }),
        /* @__PURE__ */ jsx146(
          Coverage3,
          {
            helpText,
            covers: filteredCovers,
            additionalCoverage: quote.additionalCoverage,
            displayVariant: "qcp",
            withModal: true,
            variant,
            upsells: quote.upsells
          }
        ),
        /* @__PURE__ */ jsx146(QuoteActions2, { quote, variant })
      ]
    }
  );
};

// src/components/QuoteCards/sortByPrice.tsx
var convertCurrencyToNumber = (amount) => {
  const cleaned = amount?.replace(/[$£,]/g, "");
  return +(cleaned || Infinity);
};
var sortByPrice = (a, b) => {
  const left = convertCurrencyToNumber(a.premium ?? "0");
  const right = convertCurrencyToNumber(b.premium ?? "0");
  return left - right;
};

// src/components/QuoteCards/Unquotable/Unquotable.tsx
import { Link as Link20 } from "@simplybusiness/mobius";
import { jsx as jsx147, jsxs as jsxs108 } from "react/jsx-runtime";
var Unquotable = ({
  contactPhoneNumber,
  referenceNumber
}) => {
  return /* @__PURE__ */ jsxs108("div", { className: "mobius mobius-unquotable-card", children: [
    /* @__PURE__ */ jsx147("h2", { className: "mobius-unquotable-card__title", children: "No quotes showing?" }),
    /* @__PURE__ */ jsxs108("p", { className: "mobius-unquotable-card__text", children: [
      "Our team will give you a call to see if we can put this right and find you a quote. If you\u2019d prefer to call us, we\u2019re here to help on",
      " ",
      /* @__PURE__ */ jsx147(
        Link20,
        {
          className: "mobius-unquotable-card__contact-phone-number",
          href: `tel:${contactPhoneNumber}`,
          children: contactPhoneNumber
        }
      ),
      ". Please have your reference number",
      " ",
      /* @__PURE__ */ jsx147("strong", { className: "mobius-unquotable-card__reference-number", children: referenceNumber }),
      " ",
      "to hand."
    ] })
  ] });
};

// src/components/QuoteCards/QuoteCards.tsx
import { jsx as jsx148, jsxs as jsxs109 } from "react/jsx-runtime";
var QuoteCards = (props) => {
  const { quotes, ...otherProps } = props;
  const isToggling = useMutationStatus("toggleCovers");
  const { componentName, variant, customerName, coverOptionsUrl } = otherProps;
  const { up } = useBreakpoint8(customBreakpoints);
  const isDesktop = up("lg");
  const [layout] = useAtom15(qcpLayoutToggleAtom);
  const unquotedQuotes = (quotes || []).filter(
    (quote) => quote.status !== "quoted"
  );
  const quotedQuotes = (quotes || []).filter(
    (quote) => quote.status === "quoted"
  );
  const eligibleForPartialQuotesReferral = variant === "referral-reasons";
  const withoutQdpDrawer = variant === "without-qdp-drawer";
  const variantWithoutQdpDrawer = withoutQdpDrawer || eligibleForPartialQuotesReferral;
  const sortedQuotes = quotedQuotes.sort(sortByPrice);
  const quotesList = [...sortedQuotes, ...unquotedQuotes];
  const quotedQuotesCount = quotedQuotes.length;
  const showNoQuotesReferral = withoutQdpDrawer && quotedQuotesCount === 0;
  if (showNoQuotesReferral) {
    return /* @__PURE__ */ jsx148(NoQuotesReferral, { quotes, ...otherProps });
  }
  const showPartialQuotesReferral = eligibleForPartialQuotesReferral && customerName !== void 0 && coverOptionsUrl !== void 0;
  const showUnquotable = variant === "unsupported-trade-referral";
  const hideNoQuoteCard = showPartialQuotesReferral;
  const isGridLayout = layout === "grid";
  const classes = classNames49("mobius-quote-cards__grid", {
    "--is-horizontal": isGridLayout && !isDesktop || !isGridLayout && variantWithoutQdpDrawer,
    "--is-grid": isGridLayout && isDesktop
  });
  if (isToggling) {
    return /* @__PURE__ */ jsx148(QuotesSkeleton, { ...props });
  }
  if (showUnquotable) {
    return /* @__PURE__ */ jsx148(
      Unquotable,
      {
        contactPhoneNumber: otherProps.contactPhoneNumber,
        referenceNumber: otherProps.referenceNumber
      }
    );
  }
  return /* @__PURE__ */ jsxs109(
    Section,
    {
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      children: [
        /* @__PURE__ */ jsx148("div", { role: "list", className: classes, "data-testid": "quote-cards-list", children: quotes && quotes.length > 0 ? quotesList?.map((quote) => /* @__PURE__ */ jsx148(
          QuoteCard,
          {
            quote,
            variant,
            hideNoQuoteCard
          },
          quote.id
        )) : /* @__PURE__ */ jsx148(NoQuotesCard, {}) }),
        showPartialQuotesReferral && /* @__PURE__ */ jsx148(
          PartialQuotesReferral,
          {
            quotes: unquotedQuotes,
            customerName,
            coverOptionsUrl
          }
        )
      ]
    }
  );
};

// src/components/QuoteCards/ExperimentGridView/QuoteCards.tsx
import { useAtom as useAtom18 } from "jotai";
import classNames52 from "classnames/dedupe";
import { useBreakpoint as useBreakpoint10 } from "@simplybusiness/mobius";

// src/components/QuoteCards/ExperimentGridView/PartialQuotesReferral/PartialQuotesReferral.tsx
import { Link as Link21, Text as Text58 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext30 } from "@simplybusiness/services";
import { jsx as jsx149, jsxs as jsxs110 } from "react/jsx-runtime";
function PartialQuotesReferral2({
  quotes,
  customerName,
  coverOptionsUrl,
  view
}) {
  const insurersPanel = (quotes || []).map((quote) => ({
    insurerName: quote.insurerNameParametrized,
    insurerLogo: quote.insurerLogo
  }));
  const { snowplow } = useSnowplowContext30();
  const handleCoverOptionsClick = () => snowplow?.trigger("referralReasonsVariantBCoverOptionsLinkClicked");
  return /* @__PURE__ */ jsx149(
    "div",
    {
      "data-testid": `partial-quotes-referral-${view}`,
      className: `partial-quotes-referral__container partial-quotes-referral__container--${view} partial-quotes-referral`,
      children: /* @__PURE__ */ jsxs110("div", { className: "partial-quotes-referral__main", children: [
        /* @__PURE__ */ jsx149("div", { className: "partial-quotes-referral__info", children: /* @__PURE__ */ jsxs110(Text58, { children: [
          "Hi ",
          customerName,
          ", we've searched through our panel of trusted providers but we havent been able to find many results that match your cover detail selections. You can expand your search by editing your choices on the",
          " ",
          /* @__PURE__ */ jsx149(Link21, { href: coverOptionsUrl, onClick: handleCoverOptionsClick, children: "Cover Options" }),
          " ",
          "page or through the filters above."
        ] }) }),
        /* @__PURE__ */ jsx149("div", { className: "partial-quotes-referral__insurer-panel", children: insurersPanel.map((insurer, index) => /* @__PURE__ */ jsx149(
          Logo,
          {
            logoPath: insurer.insurerLogo,
            alt: insurer.insurerName,
            className: "partial-quotes-referral-logo"
          },
          index
        )) })
      ] })
    }
  );
}

// src/components/QuoteCards/ExperimentGridView/QuoteCard/QuoteCard.tsx
import classNames51 from "classnames/dedupe";

// src/components/QuoteCards/ExperimentGridView/QuoteCard/Coverage/CoverageUK/Coverage.tsx
import {
  Accordion as Accordion7,
  Box as Box12,
  Modal as Modal4,
  Text as Text59,
  useBreakpoint as useBreakpoint9
} from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext31 } from "@simplybusiness/services";
import classNames50 from "classnames/dedupe";
import { useCallback as useCallback10, useState as useState16 } from "react";
import { useAtom as useAtom16 } from "jotai/index";
import { Fragment as Fragment28, jsx as jsx150, jsxs as jsxs111 } from "react/jsx-runtime";
var Coverage4 = ({ covers, className }) => {
  const [open, setOpen] = useState16(false);
  const [modalData, setModalData] = useState16({
    displayName: "",
    excesses: []
  });
  const { down } = useBreakpoint9(customBreakpoints);
  const isMobileDevice = down("md");
  const { snowplow } = useSnowplowContext31();
  const classes = classNames50("mobius-quote-card__coverage", className);
  const handleOpen = useCallback10(
    ({ displayName, excesses }) => {
      setModalData({ displayName, excesses });
      setOpen(true);
    },
    []
  );
  const handleAccordionChange = useCallback10(
    (open2) => {
      snowplow?.trigger("coverageInfoClicked", {
        deviceType: isMobileDevice ? "mobile" : "desktop",
        open: open2
      });
    },
    [isMobileDevice, snowplow]
  );
  const [layout] = useAtom16(qcpLayoutToggleAtom);
  const isGridLayout = layout === "grid";
  return /* @__PURE__ */ jsx150(Fragment28, { children: /* @__PURE__ */ jsxs111(Box12, { className: classes, "data-testid": "quote-coverage-uk", children: [
    isMobileDevice || isGridLayout ? /* @__PURE__ */ jsx150(
      Accordion7,
      {
        showText: "Show coverage info",
        hideText: "Hide coverage info",
        onChange: handleAccordionChange,
        startOpen: true,
        children: /* @__PURE__ */ jsx150(CoverageItems, { covers, onOpen: handleOpen })
      }
    ) : /* @__PURE__ */ jsxs111(Fragment28, { children: [
      /* @__PURE__ */ jsx150(Text59, { className: "mobius-quote-card__coverage-title", variant: "h3", children: "Coverage Information" }),
      /* @__PURE__ */ jsx150(CoverageItems, { covers, onOpen: handleOpen })
    ] }),
    /* @__PURE__ */ jsxs111(
      Modal4,
      {
        className: "mobius-quote-card__coverage-item-excess-modal",
        isOpen: open,
        onClose: () => setOpen(false),
        children: [
          /* @__PURE__ */ jsxs111(Modal4.Header, { children: [
            modalData.displayName,
            " excess"
          ] }),
          /* @__PURE__ */ jsx150(Modal4.Content, { children: modalData.excesses.map((cover) => /* @__PURE__ */ jsx150(
            CoverLimit,
            {
              ...cover,
              product: modalData.displayName
            },
            cover.title
          )) })
        ]
      }
    )
  ] }) });
};

// src/components/QuoteCards/ExperimentGridView/QuoteCard/Coverage/index.tsx
import { jsx as jsx151 } from "react/jsx-runtime";
var Coverage5 = (props) => {
  return /* @__PURE__ */ jsx151(Coverage4, { ...props });
};

// src/components/QuoteCards/ExperimentGridView/QuoteCard/PricingUK/Pricing.tsx
import { calendarClock as calendarClock4 } from "@simplybusiness/icons";
import { Flex as Flex39, Icon as Icon34, Text as Text60 } from "@simplybusiness/mobius";
import { useAtom as useAtom17 } from "jotai";
import { Fragment as Fragment29, jsx as jsx152, jsxs as jsxs112 } from "react/jsx-runtime";
var Pricing4 = ({
  quote,
  showInstallmentsInformation
}) => {
  const {
    installmentsAvailable,
    downpaymentAmount,
    installmentsAmount,
    installmentsCount,
    installmentsTotal,
    premium
  } = quote;
  const [paymentPeriod] = useAtom17(paymentToggleAtom);
  const isMonthly = paymentPeriod === "monthly";
  const hasInstallments = installmentsAvailable && installmentsAmount;
  const showInstalments = isMonthly && hasInstallments && showInstallmentsInformation;
  const instalmentsText = downpaymentAmount ? `Then ${installmentsCount} monthly payments of` : `${installmentsCount} monthly payments of`;
  return /* @__PURE__ */ jsxs112("div", { className: "mobius-quote-card__pricing --is-uk", children: [
    /* @__PURE__ */ jsxs112(
      Flex39,
      {
        alignItems: "flex-start",
        gap: "xxs",
        justifyContent: "space-between",
        className: "mobius-quote-card__pricing-flex",
        children: [
          /* @__PURE__ */ jsx152(
            Premium2,
            {
              isMonthly,
              hasInstallments,
              installmentsAmount,
              premium
            }
          ),
          /* @__PURE__ */ jsx152(QuoteCardBadges, { className: "--is-uk --is-desktop", children: /* @__PURE__ */ jsx152(
            QuoteCardBadge,
            {
              icon: /* @__PURE__ */ jsx152(Icon34, { icon: calendarClock4, color: "var(--color-accent)" }),
              "data-testid": "quote-card-badge-12-month-policy",
              children: "12 month policy"
            }
          ) })
        ]
      }
    ),
    showInstalments && /* @__PURE__ */ jsxs112("div", { className: "mobius-quote-card__instalments-grid", children: [
      downpaymentAmount && /* @__PURE__ */ jsxs112(Fragment29, { children: [
        /* @__PURE__ */ jsx152(Text60, { children: "First payment" }),
        /* @__PURE__ */ jsx152(Text60, { className: "mobius-quote-card__instalment_amount", children: /* @__PURE__ */ jsx152("strong", { children: downpaymentAmount }) })
      ] }),
      /* @__PURE__ */ jsx152(Text60, { children: instalmentsText }),
      /* @__PURE__ */ jsx152(Text60, { className: "mobius-quote-card__instalment_amount", children: /* @__PURE__ */ jsx152("strong", { children: installmentsAmount }) }),
      /* @__PURE__ */ jsx152(Text60, { children: "Total over 12 months" }),
      /* @__PURE__ */ jsx152(Text60, { className: "mobius-quote-card__instalment_amount", children: /* @__PURE__ */ jsx152("strong", { children: installmentsTotal }) })
    ] }),
    /* @__PURE__ */ jsx152(QuoteCardBadges, { className: "--is-mobile", children: /* @__PURE__ */ jsx152(
      QuoteCardBadge,
      {
        icon: /* @__PURE__ */ jsx152(Icon34, { icon: calendarClock4, color: "var(--color-accent)" }),
        "data-testid": "quote-card-badge-12-month-policy",
        children: "12 month policy"
      }
    ) })
  ] });
};

// src/components/QuoteCards/ExperimentGridView/QuoteCard/QuoteCard.tsx
import { Fragment as Fragment30, jsx as jsx153, jsxs as jsxs113 } from "react/jsx-runtime";
var QuoteCard2 = ({
  quote,
  variant,
  hideNoQuoteCard
}) => {
  const { status } = quote;
  const insurer = quote.covers[0]?.coverInsurer;
  const insurerParametrized = insurer?.toLowerCase().replaceAll(" ", "-");
  const chopinTestId = `buy-${insurerParametrized}-block`;
  const { isUK } = useLocale();
  const filteredCovers = filterCovers(quote);
  const classes = classNames51("mobius-quote-card");
  if (status === "referred") {
    if (hideNoQuoteCard === true) {
      return /* @__PURE__ */ jsx153(Fragment30, {});
    }
    return /* @__PURE__ */ jsx153(NoQuoteCard, { insurer, insurerLogo: quote.insurerLogo });
  }
  return /* @__PURE__ */ jsxs113(
    "div",
    {
      role: "listitem",
      className: classes,
      id: chopinTestId,
      "data-testid": "quote-cards-list-item",
      children: [
        isUK ? /* @__PURE__ */ jsx153(
          HeaderUK,
          {
            logo: quote.insurerLogo,
            underWriterText: quote.underwriter
          }
        ) : /* @__PURE__ */ jsx153(
          Header3,
          {
            logo: quote.insurerLogo,
            insurerFinancialStrengthRatings: quote.ratings
          }
        ),
        isUK ? /* @__PURE__ */ jsx153(Pricing4, { quote, displayBadges: true, showInstallmentsInformation: true }) : /* @__PURE__ */ jsx153(Pricing2, { quote, displayBadges: true, showInstallmentsInformation: true }),
        /* @__PURE__ */ jsx153(
          Coverage5,
          {
            covers: filteredCovers,
            additionalCoverage: quote.additionalCoverage,
            displayVariant: "qcp",
            withModal: true,
            variant,
            upsells: quote.upsells
          }
        ),
        /* @__PURE__ */ jsx153(QuoteActions2, { quote, variant })
      ]
    }
  );
};

// src/components/QuoteCards/ExperimentGridView/QuoteCards.tsx
import { useState as useState17, useEffect as useEffect11 } from "react";
import { Fragment as Fragment31, jsx as jsx154, jsxs as jsxs114 } from "react/jsx-runtime";
var useHydrated = () => {
  const [hydrated, setHydrated] = useState17(false);
  useEffect11(() => {
    setHydrated(true);
  }, []);
  return hydrated;
};
var QuoteCards2 = (props) => {
  const { quotes, ...otherProps } = props;
  const isToggling = useMutationStatus("toggleCovers");
  const { componentName, variant, customerName, coverOptionsUrl } = otherProps;
  const unquotedQuotes = [];
  const quotedQuotes = [];
  (quotes || []).forEach((quote) => {
    if (quote.status === "quoted") {
      quotedQuotes.push(quote);
    } else {
      unquotedQuotes.push(quote);
    }
  });
  const eligibleForReferralReasons = variant === "referral-reasons";
  const withoutQdpDrawer = variant === "without-qdp-drawer";
  const variantWithoutQdpDrawer = withoutQdpDrawer || eligibleForReferralReasons;
  const quotedQuotesCount = quotedQuotes.length;
  const showReferral = withoutQdpDrawer && quotedQuotesCount === 0;
  const showPartialQuotesReferral = eligibleForReferralReasons && customerName !== void 0 && coverOptionsUrl !== void 0;
  const showUnquotable = variant === "unsupported-trade-referral";
  const hideNoQuoteCard = showPartialQuotesReferral;
  const { up } = useBreakpoint10(customBreakpoints);
  const isDesktop = up("lg");
  const hydrated = useHydrated();
  const [layout] = useAtom18(qcpLayoutToggleAtom);
  if (!hydrated) {
    return /* @__PURE__ */ jsx154(QuotesSkeleton, { ...props });
  }
  const isGridLayout = layout === "grid";
  const classes = classNames52(
    "mobius-quote-cards__grid",
    "--is-grid-view-treatment",
    {
      "--is-horizontal": isGridLayout && !isDesktop || !isGridLayout && variantWithoutQdpDrawer,
      "--is-grid": isGridLayout && isDesktop
    }
  );
  if (isToggling) {
    return /* @__PURE__ */ jsx154(QuotesSkeleton, { ...props });
  }
  if (showUnquotable) {
    return /* @__PURE__ */ jsx154(
      Unquotable,
      {
        contactPhoneNumber: otherProps.contactPhoneNumber,
        referenceNumber: otherProps.referenceNumber
      }
    );
  }
  if (showReferral) {
    return /* @__PURE__ */ jsx154(NoQuotesReferral, { quotes, ...otherProps });
  }
  const isQuotesCountMultipleOfThree = !!quotes && quotes.length % 3 === 0;
  let partialQuotesSignpostDisplay = null;
  if (showPartialQuotesReferral) {
    partialQuotesSignpostDisplay = isQuotesCountMultipleOfThree ? "banner" : "grid";
  }
  const referredQuotes = [];
  const nonReferredQuotes = [];
  (quotes || []).forEach((q) => {
    if (q.status === "referred") {
      referredQuotes.push(q);
    } else {
      nonReferredQuotes.push(q);
    }
  });
  const sortedQuotes = nonReferredQuotes.sort(sortByPrice);
  const showNoQuotesCard = sortedQuotes.length === 0;
  const renderQuoteCards = (quotesToRender) => quotesToRender.map((quote) => /* @__PURE__ */ jsx154(
    QuoteCard2,
    {
      quote,
      variant,
      hideNoQuoteCard
    },
    quote.id
  ));
  return /* @__PURE__ */ jsxs114(
    Section,
    {
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      children: [
        /* @__PURE__ */ jsx154("div", { role: "list", className: classes, "data-testid": "quote-cards-list", children: showNoQuotesCard ? /* @__PURE__ */ jsx154(NoQuotesCard, {}) : /* @__PURE__ */ jsxs114(Fragment31, { children: [
          renderQuoteCards(sortedQuotes),
          !isGridLayout && referredQuotes.length > 0 && renderQuoteCards(referredQuotes),
          partialQuotesSignpostDisplay === "grid" && /* @__PURE__ */ jsx154(
            PartialQuotesReferral2,
            {
              quotes: unquotedQuotes,
              customerName: customerName || "",
              coverOptionsUrl: coverOptionsUrl || "",
              view: isGridLayout ? "grid" : "banner"
            }
          )
        ] }) }),
        isGridLayout && !showPartialQuotesReferral && referredQuotes.length > 0 && /* @__PURE__ */ jsx154("div", { className: classes, children: renderQuoteCards(referredQuotes) }),
        partialQuotesSignpostDisplay === "banner" && /* @__PURE__ */ jsx154(
          PartialQuotesReferral2,
          {
            quotes: unquotedQuotes,
            customerName: customerName || "",
            coverOptionsUrl: coverOptionsUrl || "",
            view: "banner"
          }
        )
      ]
    }
  );
};

// src/components/QuoteCards/index.tsx
import { jsx as jsx155 } from "react/jsx-runtime";
var QuoteCards3 = (props) => {
  const isGridView = ["treatment_grid", "treatment_list"].includes(
    useExperiment("uk2505Gridvslistview") || ""
  );
  if (isGridView) {
    return /* @__PURE__ */ jsx155(QuoteCards2, { ...props });
  }
  return /* @__PURE__ */ jsx155(QuoteCards, { ...props });
};

// src/components/QuoteHelp/QuoteHelp.tsx
import { telephone as telephone4, message } from "@simplybusiness/icons";
import {
  Flex as Flex40,
  Icon as Icon35,
  Link as Link22,
  Text as Text61
} from "@simplybusiness/mobius";
import { forwardRef as forwardRef23 } from "react";
import { jsx as jsx156, jsxs as jsxs115 } from "react/jsx-runtime";
var QuoteHelp = forwardRef23((props, ref) => {
  const { contactPhoneNumber, referenceNumber, chatWithAgent, ...otherProps } = props;
  return /* @__PURE__ */ jsxs115(ChatBox, { ref, ...otherProps, children: [
    /* @__PURE__ */ jsx156(Text61, { variant: "body", children: "Have a question about your quote? Give us a call \u2014 we\u2019re here to help." }),
    (contactPhoneNumber || chatWithAgent) && /* @__PURE__ */ jsxs115(Flex40, { className: "mobius-quote-help__contact-container", children: [
      contactPhoneNumber && /* @__PURE__ */ jsxs115(
        Link22,
        {
          href: `tel:${contactPhoneNumber}`,
          className: "mobius-quote-help__contact-phone-number",
          children: [
            /* @__PURE__ */ jsx156(Icon35, { fixedWidth: true, icon: telephone4 }),
            " ",
            contactPhoneNumber
          ]
        }
      ),
      chatWithAgent && /* @__PURE__ */ jsx156(ChatBox.ChatLink, { icon: message })
    ] }),
    referenceNumber && /* @__PURE__ */ jsxs115(Text61, { variant: "body", children: [
      "Quote reference ID:",
      " ",
      /* @__PURE__ */ jsx156("strong", { className: "mobius-quote-help__reference-number", children: referenceNumber })
    ] })
  ] });
});
QuoteHelp.displayName = "QuoteHelp";

// src/components/Referral/Referral.tsx
import { LinkButton as LinkButton6 } from "@simplybusiness/mobius";
import classNames54 from "classnames/dedupe";
import { forwardRef as forwardRef25 } from "react";

// src/components/Referral/ReferralText.tsx
import { useSnowplowContext as useSnowplowContext32 } from "@simplybusiness/services";
import { Link as Link23, Text as Text62 } from "@simplybusiness/mobius";
import { Fragment as Fragment32, jsx as jsx157, jsxs as jsxs116 } from "react/jsx-runtime";
var ReferralText = (props) => {
  const { firstName, referenceNumber, phoneNumbers, sbDirect, children } = props;
  const { snowplow } = useSnowplowContext32();
  const handleMobileLinkClick = () => snowplow?.trigger("mobileLinkClick");
  return /* @__PURE__ */ jsx157("div", { className: "mobius-referral__text", children: sbDirect ? /* @__PURE__ */ jsxs116(Fragment32, { children: [
    /* @__PURE__ */ jsxs116(Text62, { variant: "h2", children: [
      "Thanks, ",
      firstName
    ] }),
    /* @__PURE__ */ jsx157(Text62, { variant: "body", children: "Based on the information you shared about your business, we are searching for quotes offline." }),
    /* @__PURE__ */ jsx157(Text62, { variant: "body", children: "One of our licensed agents is ready to work with you to help find coverage for your small business." }),
    /* @__PURE__ */ jsxs116(Text62, { variant: "body", children: [
      "You can speak with them at",
      " ",
      /* @__PURE__ */ jsx157(
        Link23,
        {
          id: "thank-you-mobile-link-sb",
          href: `tel:${phoneNumbers.contactUs}`,
          onClick: handleMobileLinkClick,
          children: phoneNumbers.contactUs
        }
      )
    ] }),
    children
  ] }) : /* @__PURE__ */ jsxs116(Fragment32, { children: [
    /* @__PURE__ */ jsx157(Text62, { variant: "h2", children: "Thank You!" }),
    /* @__PURE__ */ jsx157(Text62, { variant: "body", children: "We appreciate you taking the time to answer our questions. We're using this info right now to see if we can provide you with a quote." }),
    /* @__PURE__ */ jsxs116(Text62, { variant: "body", children: [
      "If we do find a quote, one of our licensed agents will email you or call you from ",
      phoneNumbers.contactYou,
      ", so be on the lookout!"
    ] }),
    /* @__PURE__ */ jsx157(Text62, { variant: "h3", children: "Don't want to wait?" }),
    /* @__PURE__ */ jsxs116(Text62, { variant: "body", children: [
      "We get it - you're busy! If you want to reach an agent ASAP about your insurance quote, give us a call at",
      " ",
      /* @__PURE__ */ jsx157(
        Link23,
        {
          id: "thank-you-mobile-link-non-sb",
          href: `tel:${phoneNumbers.contactUs}`,
          onClick: handleMobileLinkClick,
          children: phoneNumbers.contactUs
        }
      ),
      " ",
      "at a time that works best for you."
    ] }),
    /* @__PURE__ */ jsxs116(Text62, { variant: "body", children: [
      "Don't forget to have your reference number handy - it's",
      " ",
      referenceNumber,
      "."
    ] }),
    /* @__PURE__ */ jsx157(Text62, { variant: "body", children: "Thanks again for choosing Simply Business!" })
  ] }) });
};

// src/components/Referral/TrustSection/TrustSection.tsx
import { circleTick } from "@simplybusiness/icons";
import {
  Flex as Flex41,
  Icon as Icon36,
  List as List2,
  ListItem as ListItem2,
  Segment as Segment3,
  Text as Text63,
  Trust as Trust2
} from "@simplybusiness/mobius";
import classNames53 from "classnames/dedupe";
import { forwardRef as forwardRef24 } from "react";
import { jsx as jsx158, jsxs as jsxs117 } from "react/jsx-runtime";
var TrustSection = forwardRef24((props, ref) => {
  const { elementType: Element = "div", ...otherProps } = props;
  const classes = classNames53(
    "mobius",
    "mobius-trust-section",
    otherProps.className
  );
  return /* @__PURE__ */ jsxs117(Element, { ref, ...otherProps, className: classes, children: [
    /* @__PURE__ */ jsx158(Segment3, { className: "mobius-trust-section__header", children: /* @__PURE__ */ jsx158(Text63, { elementType: "h2", children: "How our licensed agents can help" }) }),
    /* @__PURE__ */ jsx158(Segment3, { className: "mobius-trust-section__body", children: /* @__PURE__ */ jsxs117(
      Flex41,
      {
        flexDirection: "column",
        alignItems: "center",
        className: "mobius-trust-section__body-content",
        children: [
          /* @__PURE__ */ jsxs117(
            List2,
            {
              icon: /* @__PURE__ */ jsx158(Icon36, { icon: circleTick, color: "var(--color-valid)" }),
              className: "mobius-trust-section__list",
              children: [
                /* @__PURE__ */ jsx158(ListItem2, { children: /* @__PURE__ */ jsx158(Text63, { children: "Speak to a small business insurance expert" }) }),
                /* @__PURE__ */ jsx158(ListItem2, { children: /* @__PURE__ */ jsx158(Text63, { children: "Ask questions and get answers right away" }) }),
                /* @__PURE__ */ jsx158(ListItem2, { children: /* @__PURE__ */ jsx158(Text63, { children: "Get coverage for your unique business" }) })
              ]
            }
          ),
          /* @__PURE__ */ jsx158(Trust2, { locale: "en-US", theme: "light", variant: "mini" }),
          /* @__PURE__ */ jsx158(Text63, { children: /* @__PURE__ */ jsx158("strong", { children: "150,000 customers served" }) })
        ]
      }
    ) })
  ] });
});
TrustSection.displayName = "TrustSection";

// src/components/Referral/Referral.tsx
import { jsx as jsx159, jsxs as jsxs118 } from "react/jsx-runtime";
var Referral = forwardRef25((props, ref) => {
  const {
    className,
    firstName,
    showTrustSection,
    referenceNumber,
    phoneNumbers,
    sbDirect,
    checkoutUrl,
    backUrl,
    children,
    componentName,
    ...otherProps
  } = props;
  const classes = classNames54("mobius", "mobius-referral", className);
  const { variant } = otherProps;
  const showCheckoutButtons = variant === "with-coverage-summary" && checkoutUrl;
  const textProps = {
    firstName,
    referenceNumber,
    phoneNumbers,
    sbDirect
  };
  return /* @__PURE__ */ jsxs118(
    "div",
    {
      ref,
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      className: classes,
      "data-testid": "referral",
      children: [
        /* @__PURE__ */ jsx159(ReferralText, { ...textProps, children: showCheckoutButtons && /* @__PURE__ */ jsxs118("div", { className: "mobius-checkout-buttons", children: [
          /* @__PURE__ */ jsx159(
            LinkButton6,
            {
              href: backUrl ?? "#",
              variant: "secondary",
              "data-testid": "back-button",
              children: "Back"
            }
          ),
          /* @__PURE__ */ jsx159(
            LinkButton6,
            {
              href: checkoutUrl,
              variant: "primary",
              "data-testid": "checkout-button",
              children: "Checkout"
            }
          )
        ] }) }),
        showTrustSection && /* @__PURE__ */ jsx159(TrustSection, {}),
        children
      ]
    }
  );
});
Referral.displayName = "Referral";

// src/components/shared/DialogueModal/DialogueModal.tsx
import { useEffect as useEffect13, useMemo as useMemo5, useState as useState18 } from "react";
import { Modal as Modal5, Drawer as Drawer3, Button as Button21 } from "@simplybusiness/mobius";

// src/components/shared/PersistentSummary/helpers/PersistentPaymentSummaryHelper.tsx
import { useEffect as useEffect12 } from "react";

// src/components/shared/PersistentSummary/UtilsHelper.tsx
var currencyBasedLocale = { USD: "en-US", GBP: "en-GB" };
function currencyFormatter(currency) {
  return new Intl.NumberFormat(
    currencyBasedLocale[currency.toUpperCase()],
    {
      style: "currency",
      currency
    }
  );
}
function fetchRequest(url, payload) {
  const journeyTokenElement = document.querySelector("[name='journey_token']");
  const authenticityTokenElement = document.querySelector(
    "[name='authenticity_token']"
  );
  if (!journeyTokenElement || !authenticityTokenElement) {
    return Promise.reject(new Error("Tokens not found"));
  }
  const journeyToken = journeyTokenElement.value;
  const authenticityToken = authenticityTokenElement.value;
  return fetch(`${url}&journey_token=${journeyToken}`, {
    method: "POST",
    body: payload,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": authenticityToken
    }
  }).then((result) => {
    return result.json();
  }).then((json) => {
    return Promise.resolve(json);
  }).catch((error) => {
    return Promise.reject(new Error(error));
  });
}

// src/components/shared/PersistentSummary/helpers/PersistentPaymentSummaryHelper.tsx
var notUndefined = (anyValue) => typeof anyValue !== "undefined";
var currencyBasedLocale2 = {
  USD: "en-US",
  GBP: "en-GB"
};
var paymentOptions = { ANNUAL: "annual", MONTHLY: "monthly" };
var productInfoTexts = (productsInfo, key) => {
  return productsInfo.map((productInfo) => productInfo[key]).filter(notUndefined).filter((value) => typeof value === "string");
};
var upfrontPaymentAmount = (productInfo) => {
  if (productInfo.selectedPaymentOption === paymentOptions.ANNUAL) {
    return productInfo.availablePaymentOptions.annual.amount;
  }
  return productInfo.availablePaymentOptions.monthly.downpaymentAmount;
};
var monthlyProductsInfo = (productsInfo) => {
  return productsInfo.reduce((accumulator, productInfo) => {
    if (productInfo.selectedPaymentOption === paymentOptions.MONTHLY) {
      return accumulator.concat(productInfo);
    }
    return accumulator;
  }, []);
};
var upfrontPayments = (productsInfo, currency) => {
  return productsInfo.map((productInfo) => ({
    labels: productInfo.coverNames,
    value: currencyFormatter(currency).format(
      upfrontPaymentAmount(productInfo)
    )
  }));
};
var upfrontPaymentsTotal = (productsInfo, currency) => {
  const initialValue = 0;
  const total = productsInfo.reduce((accumulator, productInfo) => {
    return accumulator + upfrontPaymentAmount(productInfo);
  }, initialValue);
  return currencyFormatter(currency).format(total);
};
var monthlyPayments = (productsInfo, currency, hasMonthlyFees = false) => {
  const monthlyProductsData = monthlyProductsInfo(productsInfo);
  if (!monthlyProductsData.length) return [];
  const flattenInstallmentsSchedule = monthlyProductsData.flatMap(
    (productInfo) => {
      return productInfo.availablePaymentOptions.monthly.installmentsSchedule;
    }
  );
  const installmentsSchedule = Object.values(
    flattenInstallmentsSchedule.reduce(
      (acc, { month, year, amount }) => {
        const formattedMonth = `${year}-${month}`;
        acc[formattedMonth] = {
          month: formattedMonth,
          amount: (acc[formattedMonth] ? acc[formattedMonth].amount : 0) + amount
        };
        return acc;
      },
      {}
    )
  ).sort((a, b) => new Date(a.month).getTime() - new Date(b.month).getTime());
  const groupedAmounts = installmentsSchedule.reduce(
    (acc, schedule) => {
      if (acc.last && acc.last !== schedule.amount) {
        acc.result.push([]);
      }
      acc.result[acc.result.length - 1].push(schedule.amount);
      return { ...acc, last: schedule.amount };
    },
    { result: [[]], last: null }
  ).result;
  return groupedAmounts.map((group, index) => {
    const prefix = index === 0 ? "" : "Then ";
    const labels = hasMonthlyFees ? productsInfo[0].coverNames : [`${prefix}${group.length} monthly payments of`];
    return {
      labels,
      value: currencyFormatter(currency).format(group[0])
    };
  });
};
var firstMonthlyPaymentDate = (productsInfo, currency) => {
  const monthlyPaymentDates = monthlyProductsInfo(productsInfo).map(
    (productInfo) => {
      return new Date(
        productInfo.availablePaymentOptions.monthly.firstInstallmentDate
      );
    }
  );
  return new Date(
    Math.min(...monthlyPaymentDates.map((date) => date.getTime()))
  ).toLocaleDateString(currencyBasedLocale2[currency.toUpperCase()], {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  });
};
var monthlyPaymentSummary = (productsInfo, currency) => {
  const installmentCount = productsInfo.reduce((acc, productInfo) => {
    const monthlyInstallments = productInfo.availablePaymentOptions?.monthly?.installmentsSchedule ?? [];
    return acc + monthlyInstallments.length;
  }, 0);
  return {
    label: `${installmentCount} monthly payments of`,
    value: currencyFormatter(currency).format(
      Number(
        productsInfo[0].availablePaymentOptions?.monthly?.installmentAmount ?? 0
      )
    )
  };
};
var selectProductsMarkedForPurchase = (products) => products.filter((product) => product.markedForPurchase);
var useTriggerEventTracker = (eventName, ...args) => {
  useEffect12(() => {
    if (eventName && window) {
      window.EventTracker?.trigger(eventName, ...args);
    }
  }, [eventName, args]);
};

// src/components/shared/DialogueModal/ctaAction.tsx
var ctaAction = (fieldName, setEventDetails) => {
  const checkboxes = document.querySelectorAll(
    ".s-step-recommendations input[type=checkbox]"
  );
  checkboxes.forEach((box) => {
    if (box.name === fieldName) {
      box.click();
      if (box.checked === true) {
        setEventDetails({
          eventName: "coverage_selection_recommendations_coverage_added",
          args: [fieldName]
        });
      } else {
        setEventDetails({
          eventName: "coverage_selection_recommendations_coverage_removed",
          args: [fieldName]
        });
      }
    }
  });
};

// src/components/shared/DialogueModal/DialogueModal.tsx
import { Fragment as Fragment33, jsx as jsx160, jsxs as jsxs119 } from "react/jsx-runtime";
var productNameMap = {
  "General liability": "General Liability",
  "Professional liability": "Professional Liability / Errors & Omissions",
  Cyber: "Cyber",
  "Inland marine": "Business Equipment and Small Tools",
  "Business Owners Policy": "Business Owners Policy"
};
var DialogueModal = ({
  name,
  fieldName,
  productInfo,
  text: text3 = "Learn more",
  isDrawer = false
}) => {
  const [open, setOpen] = useState18(false);
  const [buttonLabel, setButtonLabel] = useState18("Add this coverage");
  const [buttonStyle, setButtonStyle] = useState18(false);
  const [eventDetails, setEventDetails] = useState18({ eventName: null, args: [] });
  const memoizedProductInfo = useMemo5(
    () => ({ __html: productInfo }),
    [productInfo]
  );
  useTriggerEventTracker(eventDetails.eventName, ...eventDetails.args);
  const handleCtaClick = () => {
    ctaAction(fieldName, setEventDetails);
    setButtonLabel(
      buttonLabel === "Add this coverage" ? "Remove this coverage" : "Add this coverage"
    );
    setButtonStyle(!buttonStyle);
    setOpen(false);
  };
  const handleDialogueClick = () => {
    setOpen(true);
    if (fieldName) {
      setEventDetails({
        eventName: "coverage_selection_learn_more_modal_opened",
        args: [fieldName.replace(/_coverage$/, "")]
      });
    }
  };
  useEffect13(() => {
    const checkboxes = document.querySelectorAll(
      ".s-step-recommendations input[type=checkbox]"
    );
    const toggleLogic = (box) => {
      if (box && box.checked === false) {
        setButtonLabel("Add this coverage");
        setButtonStyle(false);
      } else {
        setButtonLabel("Remove this coverage");
        setButtonStyle(true);
      }
    };
    checkboxes.forEach((box) => {
      box.addEventListener("change", () => {
        toggleLogic(box);
      });
      if (box.name === fieldName) {
        toggleLogic(box);
      }
    });
  }, [buttonLabel, fieldName]);
  return /* @__PURE__ */ jsxs119(Fragment33, { children: [
    /* @__PURE__ */ jsx160(
      Button21,
      {
        className: "mobius-dialogue-modal__styled-button",
        size: "sm",
        onClick: () => {
          handleDialogueClick();
        },
        children: text3
      }
    ),
    !isDrawer && /* @__PURE__ */ jsxs119(Modal5, { isOpen: open, onClose: () => setOpen(false), animation: "slideUp", children: [
      /* @__PURE__ */ jsx160(Modal5.Header, { children: productNameMap[name] || name }),
      /* @__PURE__ */ jsx160(Modal5.Content, { children: /* @__PURE__ */ jsx160("div", { className: "mobius-dialogue-modal__description mobius-dialogue-modal__description_non_drawer", children: /* @__PURE__ */ jsx160("div", { dangerouslySetInnerHTML: memoizedProductInfo }) }) })
    ] }),
    isDrawer && /* @__PURE__ */ jsxs119(
      Drawer3,
      {
        isOpen: open,
        onClose: () => setOpen(false),
        direction: "right",
        closeLabel: "Close",
        children: [
          /* @__PURE__ */ jsx160(Drawer3.Header, { children: /* @__PURE__ */ jsx160("div", { className: "mobius-dialogue-modal__header", children: productNameMap[name] || name }) }),
          /* @__PURE__ */ jsx160(Drawer3.Content, { children: /* @__PURE__ */ jsxs119("div", { className: "mobius-dialogue-modal__description mobius-dialogue-modal__description_drawer", children: [
            /* @__PURE__ */ jsx160("div", { className: "mobius-dialogue-modal__styled-drawer-content", children: /* @__PURE__ */ jsx160("div", { dangerouslySetInnerHTML: memoizedProductInfo }) }),
            /* @__PURE__ */ jsx160("div", { className: "mobius-dialogue-modal__styled-cta-wrapper", children: /* @__PURE__ */ jsx160(
              Button21,
              {
                className: `mobius-dialogue-modal__styled-cta ${buttonStyle ? "--is-ghost" : ""}`,
                onClick: () => {
                  handleCtaClick();
                },
                children: buttonLabel
              }
            ) })
          ] }) })
        ]
      }
    )
  ] });
};

// src/components/shared/PersistentSummary/PersistentCartPaymentOptions/PersistentCartPaymentOptions.tsx
import { useState as useState23, useEffect as useEffect14, useMemo as useMemo6 } from "react";
import { SegmentGroup as SegmentGroup3 } from "@simplybusiness/mobius";

// src/components/shared/PersistentSummary/PaymentSummary/index.tsx
import { useContext as useContext2 } from "react";
import { SegmentGroup as SegmentGroup2, Segment as Segment5, Text as Text65, Flex as Flex42 } from "@simplybusiness/mobius";

// src/components/shared/PersistentSummary/CombinedPaymentContext.tsx
import { createContext } from "react";
var CombinedPaymentContext = createContext(false);

// src/components/shared/PersistentSummary/PaymentSummary/PaymentItemsSection.tsx
import { Divider, Segment as Segment4, Text as Text64 } from "@simplybusiness/mobius";
import React, { useContext } from "react";
import { Fragment as Fragment34, jsx as jsx161, jsxs as jsxs120 } from "react/jsx-runtime";
var PaymentItemsSection = ({
  headerText,
  headerItem,
  items,
  summaryItem,
  isExternalCarrier = false
}) => {
  const isCombinedPaymentPage = useContext(CombinedPaymentContext);
  return /* @__PURE__ */ jsxs120(Segment4, { "data-testid": "payment-items-section", children: [
    /* @__PURE__ */ jsx161("div", { className: "mobius-payment-summary__section-header-text", children: headerText }),
    /* @__PURE__ */ jsxs120("div", { className: "mobius-payment-summary__section-header", children: [
      headerItem && !isExternalCarrier && /* @__PURE__ */ jsxs120(Fragment34, { children: [
        /* @__PURE__ */ jsx161(Text64, { variant: "small", spacing: "tight", children: /* @__PURE__ */ jsx161("strong", { className: "mobius-payment-summary__header-label", children: headerItem.label }) }),
        /* @__PURE__ */ jsx161(
          Text64,
          {
            variant: "small",
            spacing: "tight",
            className: "mobius-payment-summary__justified-text",
            children: /* @__PURE__ */ jsx161("strong", { className: "mobius-payment-summary__header-label", children: headerItem.value })
          }
        )
      ] }),
      items.map((item, index) => /* @__PURE__ */ jsxs120(React.Fragment, { children: [
        /* @__PURE__ */ jsx161("div", { className: "mobius-payment-summary__item-grid", children: item.labels.map((label) => /* @__PURE__ */ jsx161(Text64, { variant: "small", spacing: "tight", children: label }, label)) }),
        /* @__PURE__ */ jsx161(
          Text64,
          {
            variant: "small",
            spacing: "tight",
            className: "mobius-payment-summary__justified-text",
            children: item.value
          }
        )
      ] }, ["item", index].join("-")))
    ] }),
    summaryItem && /* @__PURE__ */ jsxs120(Fragment34, { children: [
      /* @__PURE__ */ jsx161(
        Divider,
        {
          className: isCombinedPaymentPage ? "combined-styles" : void 0
        }
      ),
      /* @__PURE__ */ jsxs120("div", { className: "mobius-payment-summary__summary-item", children: [
        /* @__PURE__ */ jsx161(
          Text64,
          {
            variant: "small",
            spacing: "tight",
            className: isCombinedPaymentPage ? "mobius-payment-summary__combined-payment-page-text" : "mobius-payment-summary__default-payment-page-text",
            children: summaryItem.label
          }
        ),
        /* @__PURE__ */ jsx161(
          Text64,
          {
            variant: "small",
            spacing: "tight",
            className: isCombinedPaymentPage ? "mobius-payment-summary__combined-payment-page-text mobius-payment-summary__text-align-right" : "mobius-payment-summary__default-payment-page-text mobius-payment-summary__text-align-right",
            children: summaryItem.value
          }
        )
      ] })
    ] })
  ] });
};

// src/components/shared/PersistentSummary/PaymentSummary/index.tsx
import { jsx as jsx162, jsxs as jsxs121 } from "react/jsx-runtime";
var PaymentSummary2 = ({
  primaryTrade,
  businessName,
  upfrontPayments: upfrontPayments2,
  upfrontPaymentsTotal: upfrontPaymentsTotal2,
  monthlyPayments: monthlyPayments2,
  monthlyPaymentSummary: monthlyPaymentSummary2,
  firstMonthlyPaymentDate: firstMonthlyPaymentDate2,
  totalPaymentAmount,
  nonRefundableTexts,
  surchargeTexts,
  multiProductText,
  cardFeeDisclosureText,
  isExternalCarrier,
  hasMonthlyFees
}) => {
  const isCombinedPaymentPage = useContext2(CombinedPaymentContext);
  const areMonthlyPaymentsAvailable = monthlyPayments2.length > 0;
  const upfrontPaymentsSummaryItem = () => {
    if (areMonthlyPaymentsAvailable) {
      return {
        label: "To pay today",
        value: upfrontPaymentsTotal2
      };
    }
    return null;
  };
  const monthlyPaymentsHeaderItem = {
    label: "First monthly payment taken",
    value: firstMonthlyPaymentDate2
  };
  return /* @__PURE__ */ jsxs121("div", { children: [
    /* @__PURE__ */ jsxs121(
      SegmentGroup2,
      {
        "data-testid": "payment-summary",
        className: isCombinedPaymentPage ? "combined-styles" : void 0,
        children: [
          !isCombinedPaymentPage ? /* @__PURE__ */ jsx162(Segment5, { "data-testid": "business-information-section", children: /* @__PURE__ */ jsxs121("div", { className: "mobius-payment-summary__item-grid", children: [
            /* @__PURE__ */ jsx162(Text65, { variant: "h4", children: `${primaryTrade} insurance` }),
            /* @__PURE__ */ jsx162(Text65, { variant: "small", spacing: "tight", children: /* @__PURE__ */ jsx162("strong", { children: businessName }) })
          ] }) }) : null,
          /* @__PURE__ */ jsx162(
            PaymentItemsSection,
            {
              "data-testid": "today-payment-section",
              headerText: "Today's payment",
              items: upfrontPayments2,
              summaryItem: upfrontPaymentsSummaryItem()
            }
          ),
          areMonthlyPaymentsAvailable && /* @__PURE__ */ jsx162(
            PaymentItemsSection,
            {
              "data-testid": "monthly-payment-section",
              headerText: "Monthly payments",
              headerItem: monthlyPaymentsHeaderItem,
              items: monthlyPayments2,
              summaryItem: hasMonthlyFees ? monthlyPaymentSummary2 : void 0,
              isExternalCarrier
            }
          ),
          /* @__PURE__ */ jsx162(Segment5, { colour: "subtle", children: !isCombinedPaymentPage ? /* @__PURE__ */ jsxs121(
            Flex42,
            {
              className: "mobius-payment-summary__styled-flex",
              "data-testid": "total-payment-amount",
              children: [
                /* @__PURE__ */ jsx162(Text65, { children: "Total (inc. tax + fees)" }),
                /* @__PURE__ */ jsx162(Text65, { children: totalPaymentAmount })
              ]
            }
          ) : /* @__PURE__ */ jsxs121(
            Flex42,
            {
              className: "mobius-payment-summary__styled-flex",
              "data-testid": "total-payment-amount",
              children: [
                /* @__PURE__ */ jsxs121(Text65, { children: [
                  /* @__PURE__ */ jsx162("strong", { children: "Total" }),
                  " (inc. tax + fees)"
                ] }),
                /* @__PURE__ */ jsx162(Text65, { children: /* @__PURE__ */ jsx162("strong", { children: totalPaymentAmount }) })
              ]
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ jsx162(Text65, { variant: "legal", children: multiProductText }),
    nonRefundableTexts.map((text3, index) => /* @__PURE__ */ jsx162(Text65, { variant: "legal", children: text3 }, ["non-refundable-text", index].join("-"))),
    surchargeTexts.map((text3, index) => /* @__PURE__ */ jsx162(Text65, { variant: "legal", children: text3 }, ["surcharge-text", index].join("-"))),
    /* @__PURE__ */ jsx162(Text65, { variant: "legal", children: cardFeeDisclosureText })
  ] });
};

// src/components/shared/PersistentSummary/PaymentOptions/index.tsx
import {
  Alert as Alert2,
  Button as Button23,
  RadioGroup as RadioGroup2,
  Segment as Segment6,
  Text as Text67
} from "@simplybusiness/mobius";
import { useContext as useContext4, useState as useState20 } from "react";

// src/components/shared/PersistentSummary/DialogueModal.tsx
import { Button as Button22, Modal as Modal6 } from "@simplybusiness/mobius";
import { useState as useState19 } from "react";
import { Fragment as Fragment35, jsx as jsx163, jsxs as jsxs122 } from "react/jsx-runtime";
var DialogueModal2 = ({
  redirectFunction,
  headerText,
  description,
  actionButtonText,
  cancelButtonText,
  button
}) => {
  const [openModal, setOpenModal] = useState19(false);
  const [loading2, setIsLoading] = useState19(false);
  const [eventName, setEventName] = useState19(null);
  useTriggerEventTracker(eventName);
  const handleOpenModal = (ev) => {
    ev.preventDefault();
    setOpenModal(true);
  };
  const handleCancelButtonClick = (ev) => {
    ev.preventDefault();
    setOpenModal(false);
    setEventName("cancel_return_to_checkout_button_clicked");
  };
  const handleActionButtonClick = () => {
    setIsLoading(true);
    setEventName("go_back_to_quote_selection_clicked");
    redirectFunction();
  };
  return /* @__PURE__ */ jsxs122(Fragment35, { children: [
    /* @__PURE__ */ jsx163(Button22, { size: "sm", ...button?.props || {}, onClick: handleOpenModal }),
    /* @__PURE__ */ jsxs122(Modal6, { isOpen: openModal, onClose: () => setOpenModal(loading2), children: [
      /* @__PURE__ */ jsx163(Modal6.Header, { children: headerText }),
      /* @__PURE__ */ jsxs122(Modal6.Content, { children: [
        description,
        /* @__PURE__ */ jsxs122("div", { className: "mobius-payment-summary__button-div", children: [
          /* @__PURE__ */ jsx163(
            Button22,
            {
              variant: "secondary",
              size: "sm",
              isLoading: loading2,
              isDisabled: loading2,
              onPress: handleActionButtonClick,
              children: actionButtonText
            }
          ),
          /* @__PURE__ */ jsx163(
            Button22,
            {
              variant: "ghost",
              size: "sm",
              isDisabled: loading2,
              onClick: handleCancelButtonClick,
              children: cancelButtonText
            }
          )
        ] })
      ] })
    ] })
  ] });
};

// src/components/shared/PersistentSummary/PaymentOptions/PaymentOption.tsx
import { useContext as useContext3 } from "react";
import { Divider as Divider2, Flex as Flex43, Radio as Radio2, Text as Text66 } from "@simplybusiness/mobius";
import { Fragment as Fragment36, jsx as jsx164, jsxs as jsxs123 } from "react/jsx-runtime";
var PaymentOption = ({
  label,
  value,
  toPayToday,
  installment,
  currency,
  hasMonthlyFees,
  ...otherProps
}) => {
  const isCombinedPaymentPage = useContext3(CombinedPaymentContext);
  const formatter = currencyFormatter(currency);
  if (toPayToday == null) return null;
  return /* @__PURE__ */ jsx164(
    Radio2,
    {
      className: "sb-brand",
      "data-testid": value,
      value,
      label,
      ...otherProps,
      children: /* @__PURE__ */ jsxs123(
        Flex43,
        {
          className: `${isCombinedPaymentPage ? "combined-styles" : void 0} mobius-payment-summary__styled-wrapper`,
          children: [
            /* @__PURE__ */ jsxs123(Flex43, { className: "mobius-payment-summary__styled-flex", children: [
              /* @__PURE__ */ jsx164(Text66, { variant: "small", className: "today-payment", children: "To pay today" }),
              /* @__PURE__ */ jsx164(Text66, { variant: "small", className: "today-payment", children: formatter.format(toPayToday) })
            ] }),
            installment && Object.keys(installment).length > 0 && /* @__PURE__ */ jsxs123(Fragment36, { children: [
              /* @__PURE__ */ jsxs123(Flex43, { className: "mobius-payment-summary__styled-flex", children: [
                /* @__PURE__ */ jsxs123(Text66, { variant: "small", className: "monthly-payment", children: [
                  installment.count,
                  " monthly payments of"
                ] }),
                /* @__PURE__ */ jsx164(Text66, { variant: "small", className: "monthly-payment", children: formatter.format(installment.amount) })
              ] }),
              /* @__PURE__ */ jsx164(Divider2, { className: "mobius-payment-summary__styled-divider" }),
              /* @__PURE__ */ jsxs123(Flex43, { className: "mobius-payment-summary__styled-flex", children: [
                /* @__PURE__ */ jsx164(Text66, { variant: "small", children: "Total" }),
                /* @__PURE__ */ jsx164(Text66, { variant: "small", className: "total-payment", children: hasMonthlyFees ? formatter.format(
                  installment.count * installment.amount + toPayToday
                ) : formatter.format(installment.total) })
              ] })
            ] })
          ]
        }
      )
    }
  );
};

// src/components/shared/PersistentSummary/PaymentOptions/index.tsx
import { jsx as jsx165, jsxs as jsxs124 } from "react/jsx-runtime";
var ERRORS2 = {
  CART_ITEM_NOT_FOUND: "We encountered an issue updating your payment option. Please try selecting the same option again in a few moments.",
  SERVER_ERROR: "We encountered an unexpected issue. Please try again in a few moments or try refreshing the page."
};
var paymentOptions2 = { ANNUAL: "annual", MONTHLY: "monthly" };
var PaymentOptions = ({
  annual,
  monthly,
  selectedOption = "",
  currency,
  fireEvent,
  cartItemReference,
  markedForPurchase,
  onUpdateItem,
  promptInformation,
  enablePaymentOptionsServerUpdate,
  hasMonthlyFees,
  onPaymentOptionsClientUpdate
}) => {
  let installmentData = {
    downpayment: 0,
    count: 0,
    amount: 0,
    total: 0
  };
  const [completeQuote, setIsCompleteQuote] = useState20(false);
  const [removeProduct, setIsRemovedProduct] = useState20(false);
  const [updatingPaymentOption, setUpdatingPaymentOption] = useState20(false);
  const [isError, setIsError] = useState20(false);
  const [errorMessage, setErrorMessage] = useState20("");
  const isCombinedPaymentPage = useContext4(CombinedPaymentContext);
  if (monthly && Object.keys(monthly).length > 0 && monthly.installmentsSchedule.length > 0) {
    installmentData = {
      downpayment: monthly.downpaymentAmount,
      count: monthly.installmentsSchedule.length,
      amount: monthly.installmentsSchedule[0].amount,
      total: annual.amount
    };
  }
  const promptButton = (className, loading2, buttonText, onClickFn = () => {
  }) => /* @__PURE__ */ jsx165(
    Button23,
    {
      variant: "secondary",
      size: "sm",
      className,
      isLoading: loading2,
      isDisabled: loading2,
      onClick: () => onClickFn(),
      children: buttonText
    }
  );
  const removeFromCart = async (itemReference) => {
    const url = `?step_action=update_cart_item`;
    const payload = JSON.stringify({
      item_id: itemReference,
      action: "remove"
    });
    const response = await fetchRequest(url, payload);
    onUpdateItem(response, itemReference);
    if (response) setIsRemovedProduct(false);
  };
  const removeFromCartAndRedirect = async (itemReference, redirectUrl) => {
    const url = `?step_action=update_cart_item`;
    const payload = JSON.stringify({
      item_id: itemReference,
      action: "remove"
    });
    const response = await fetchRequest(url, payload);
    if (response) window.location.href = redirectUrl;
  };
  const handleServerPaymentOptionsChange = async (paymentOption) => {
    let response;
    try {
      setIsError(false);
      setUpdatingPaymentOption(true);
      fireEvent(cartItemReference, paymentOption);
      const url = `?step_action=update_cart_item`;
      const payload = JSON.stringify({
        action: "update_payment_option",
        item_id: cartItemReference,
        payment_option: paymentOption
      });
      response = await fetchRequest(url, payload);
      if (!response.success) {
        const message2 = response.message || "Error updating payment option";
        throw new Error(message2);
      }
      onUpdateItem(response, cartItemReference);
    } catch {
      if (response && response.code === 404 && response.productsInformation && response.totalPaymentAmount) {
        setErrorMessage(ERRORS2.CART_ITEM_NOT_FOUND);
        onUpdateItem(response, cartItemReference);
      } else {
        setErrorMessage(ERRORS2.SERVER_ERROR);
      }
      setIsError(true);
    } finally {
      setUpdatingPaymentOption(false);
    }
  };
  const handlePaymentOptionsChange = async (paymentOption) => {
    if (enablePaymentOptionsServerUpdate) {
      await handleServerPaymentOptionsChange(paymentOption);
    } else {
      if (onPaymentOptionsClientUpdate) {
        onPaymentOptionsClientUpdate(cartItemReference, paymentOption);
      }
    }
  };
  return !promptInformation.promptCustomer ? /* @__PURE__ */ jsxs124(
    Segment6,
    {
      className: `subtle ${!markedForPurchase && "exclude-for-purchase"} ${isCombinedPaymentPage && "combined-styles"}`,
      children: [
        /* @__PURE__ */ jsx165(Text67, { elementType: "p", "data-testid": "payment-options-title", children: "Payment Options" }),
        isCombinedPaymentPage ? /* @__PURE__ */ jsxs124(
          RadioGroup2,
          {
            className: "sb-brand",
            name: `payment_options[${cartItemReference}]`,
            "data-testid": "radio-group",
            defaultValue: selectedOption,
            "aria-label": "Payment options",
            onChange: (e) => {
              handlePaymentOptionsChange(e.target.value).catch((error) => {
                console.error("Error handling payment options change:", error);
              });
            },
            isDisabled: updatingPaymentOption,
            isInvalid: isError,
            errorMessage: isError ? errorMessage : void 0,
            children: [
              /* @__PURE__ */ jsx165(
                PaymentOption,
                {
                  label: "Pay monthly",
                  value: paymentOptions2.MONTHLY,
                  toPayToday: installmentData.downpayment,
                  currency,
                  installment: installmentData
                }
              ),
              /* @__PURE__ */ jsx165(
                PaymentOption,
                {
                  label: "Pay annually",
                  value: paymentOptions2.ANNUAL,
                  toPayToday: annual.amount,
                  currency
                }
              )
            ]
          }
        ) : /* @__PURE__ */ jsxs124(
          RadioGroup2,
          {
            className: "sb-brand",
            name: `payment_options[${cartItemReference}]`,
            "data-testid": "radio-group",
            defaultValue: selectedOption,
            "aria-label": "Payment options",
            onChange: (e) => {
              handlePaymentOptionsChange(e.target.value).catch((error) => {
                console.error("Error handling payment options change:", error);
              });
            },
            isDisabled: updatingPaymentOption,
            isInvalid: isError,
            errorMessage: isError ? errorMessage : void 0,
            children: [
              /* @__PURE__ */ jsx165(
                PaymentOption,
                {
                  label: "Pay annually",
                  value: paymentOptions2.ANNUAL,
                  toPayToday: annual.amount,
                  currency
                }
              ),
              /* @__PURE__ */ jsx165(
                PaymentOption,
                {
                  label: "Pay monthly",
                  value: paymentOptions2.MONTHLY,
                  toPayToday: installmentData.downpayment,
                  currency,
                  installment: installmentData,
                  hasMonthlyFees
                }
              )
            ]
          }
        )
      ]
    }
  ) : /* @__PURE__ */ jsx165(Segment6, { className: "non-eligible-item subtle", children: /* @__PURE__ */ jsxs124("div", { className: "mobius-payment-summary__styled-div", children: [
    /* @__PURE__ */ jsx165(Alert2, { header: "Action required", variant: "error", children: promptInformation.message }),
    promptInformation.type === "completeQuote" ? promptButton(
      "incomplete-quote-actions",
      completeQuote,
      promptInformation.buttonText,
      () => {
        setIsCompleteQuote(true);
        void removeFromCartAndRedirect(
          cartItemReference,
          promptInformation.actionUrl
        );
      }
    ) : /* @__PURE__ */ jsx165(
      DialogueModal2,
      {
        cancelButtonText: "Cancel",
        headerText: "Resync your quote",
        actionButtonText: "Resync your quote",
        description: "In resyncing your coverage you will be taken back to your original quote selection.",
        redirectFunction: () => {
          setIsCompleteQuote(true);
          void removeFromCartAndRedirect(
            cartItemReference,
            promptInformation.actionUrl
          );
        },
        button: promptButton(
          "incomplete-quote-actions",
          completeQuote,
          promptInformation.buttonText
        )
      }
    ),
    /* @__PURE__ */ jsx165(
      Button23,
      {
        variant: "ghost",
        size: "sm",
        className: "incomplete-quote-actions",
        isLoading: removeProduct,
        isDisabled: removeProduct,
        onPress: () => {
          setIsRemovedProduct(true);
          void removeFromCart(cartItemReference);
        },
        children: "Remove this coverage"
      }
    )
  ] }) });
};

// src/components/shared/PersistentSummary/JourneyContinuationNotice/index.tsx
import { Segment as Segment7, Text as Text68 } from "@simplybusiness/mobius";
import { jsxs as jsxs125 } from "react/jsx-runtime";
var JourneyContinuationNotice = ({
  continuationProduct
}) => {
  return /* @__PURE__ */ jsxs125(Segment7, { children: [
    /* @__PURE__ */ jsxs125(Text68, { elementType: "h4", spacing: "loose", children: [
      "We did not forget about ",
      continuationProduct
    ] }),
    /* @__PURE__ */ jsxs125(Text68, { elementType: "span", children: [
      "We will get your ",
      continuationProduct,
      " quote right after you checkout."
    ] })
  ] });
};

// src/components/shared/PersistentSummary/PersistentCartPaymentOptions/PersistentCartPaymentOptions.tsx
import { useBreakpoint as useBreakpoint13 } from "@simplybusiness/mobius";

// src/components/shared/PersistentSummary/SummaryWrapper.tsx
import { useState as useState22, useContext as useContext6 } from "react";

// src/components/shared/PersistentSummary/ProductSummary/index.tsx
import { bin, circleTick as circleTick2 } from "@simplybusiness/icons";
import {
  Button as Button24,
  Divider as Divider3,
  Flex as Flex44,
  Icon as Icon37,
  Text as Text69,
  useBreakpoint as useBreakpoint11
} from "@simplybusiness/mobius";
import { Fragment as Fragment37, useContext as useContext5, useState as useState21 } from "react";
import { Fragment as Fragment38, jsx as jsx166, jsxs as jsxs126 } from "react/jsx-runtime";
function RenderItem(label, value, isPrimary) {
  return /* @__PURE__ */ jsxs126("div", { className: "mobius-payment-summary__styled-grid", children: [
    /* @__PURE__ */ jsx166(
      Text69,
      {
        elementType: "span",
        className: isPrimary ? "mobius-payment-summary__styled-grid-primary-text" : "mobius-payment-summary__styled-grid-secondary-text",
        children: label
      }
    ),
    /* @__PURE__ */ jsx166(
      Text69,
      {
        elementType: "span",
        className: "align-right " + (isPrimary ? "mobius-payment-summary__styled-grid-primary-text" : "mobius-payment-summary__styled-grid-secondary-text"),
        children: value
      }
    )
  ] });
}
function SummaryFragment(product, mobileView, policyStartDate, totalGrossPremium, hasSharedLimits, applicationDashboard, hasPrimaryCover = false) {
  const productCovers = Object.keys(product);
  const covers = ["Contractors' Equipment & Small Tools"];
  const breakpointSize = useBreakpoint11([
    { size: "sm", value: 321 },
    { size: "md", value: 322 },
    { size: "lg", value: 641 }
  ]).breakpoint.size;
  const isMobile = breakpointSize == "md" || mobileView;
  const minMobileCovers = isMobile && productCovers.length > 1;
  const minDesktopCovers = !isMobile && productCovers.length > 0;
  const isCombinedPaymentPage = useContext5(CombinedPaymentContext);
  function showCover(cover) {
    const show = product[cover].displayPremium !== "";
    return show;
  }
  function showPolicyStartDate(idx) {
    const show = !applicationDashboard && policyStartDate;
    if (hasPrimaryCover) {
      return show && idx === 0 && hasSharedLimits;
    }
    return show;
  }
  function showPrimaryCoverDivider(idx) {
    return hasPrimaryCover && idx === 0 && hasSharedLimits;
  }
  function showSecondaryCoverDivider(idx) {
    return hasPrimaryCover && idx !== 0 && hasSharedLimits;
  }
  function showNonPrimaryCoverDivider(cover) {
    return !hasPrimaryCover && product[cover].displayPremium !== "" && policyStartDate;
  }
  return /* @__PURE__ */ jsxs126(
    "div",
    {
      className: `mobius-payment-summary__summary-fragment-wrapper ${isCombinedPaymentPage ? "combined-styles" : void 0}`,
      children: [
        productCovers.map((cover, idx) => /* @__PURE__ */ jsxs126(Fragment37, { children: [
          showCover(cover) && /* @__PURE__ */ jsxs126(Fragment38, { children: [
            /* @__PURE__ */ jsx166(Flex44, { className: "mobius-payment-summary__cover", children: totalGrossPremium && (!hasSharedLimits || idx === 0 && hasSharedLimits) ? RenderItem(cover, totalGrossPremium, true) : RenderItem(cover, "", true) }),
            showPolicyStartDate(idx) && /* @__PURE__ */ jsxs126(Fragment38, { children: [
              /* @__PURE__ */ jsx166(
                Flex44,
                {
                  className: !isMobile ? "mobius-payment-summary__flex-margin-bottom" : "",
                  children: RenderItem(
                    `Policy starting ${policyStartDate}`,
                    "",
                    false
                  )
                }
              ),
              showPrimaryCoverDivider(idx) && /* @__PURE__ */ jsx166(Divider3, {})
            ] })
          ] }),
          showNonPrimaryCoverDivider(cover) && /* @__PURE__ */ jsx166(Divider3, {}),
          product[cover].displayLimits && product[cover].displayLimits.map(
            (limit) => {
              return limit.label ? /* @__PURE__ */ jsx166(
                Flex44,
                {
                  className: "mobius-payment-summary__flex-margin-bottom",
                  children: RenderItem(limit.label, limit.value, false)
                },
                limit.label
              ) : null;
            }
          ),
          product[cover].displayExcessTitle && product[cover].displayExcessAmount && /* @__PURE__ */ jsx166(Flex44, { className: "mobius-payment-summary__flex-margin-bottom", children: RenderItem(
            product[cover].displayExcessTitle,
            formatAmount(product[cover].displayExcessAmount),
            false
          ) }),
          product[cover].displaySpecificExcesses && /* @__PURE__ */ jsxs126(Fragment38, { children: [
            Object.keys(product[cover].displaySpecificExcesses).map(
              (excess) => /* @__PURE__ */ jsx166(
                Flex44,
                {
                  className: "mobius-payment-summary__flex-margin-bottom",
                  children: /* @__PURE__ */ jsx166(Fragment38, { children: RenderItem(
                    excess,
                    formatAmount(
                      product[cover].displaySpecificExcesses[excess]
                    ),
                    false
                  ) })
                },
                excess
              )
            ),
            showSecondaryCoverDivider(idx) && /* @__PURE__ */ jsx166(Divider3, {})
          ] })
        ] }, cover)),
        (minMobileCovers || minDesktopCovers) && /* @__PURE__ */ jsx166(
          Flex44,
          {
            className: `mobius-payment-summary__minimum-covers ${applicationDashboard && !productCovers.some((r) => covers.indexOf(r) >= 0) && !isMobile ? "mobius-payment-summary__minimum-covers-desktop" : ""}`
          }
        )
      ]
    }
  );
}
function ProductSummary({
  productName,
  product,
  additionalCover,
  totalGrossPremium,
  mobileView,
  policyStartDate,
  hasSharedLimits,
  applicationDashboard = false,
  updateApplicationDashboard,
  isOnlyProduct,
  hasPrimaryCover
}) {
  const [loading2, setIsLoading] = useState21(false);
  const additionalCoversKeys = Object.keys(additionalCover);
  const oneOrMoreProducts = Object.keys(product).length > 0;
  const [eventDetails, setEventDetails] = useState21({ eventName: null, args: [] });
  useTriggerEventTracker(eventDetails.eventName, ...eventDetails.args);
  const removeProduct = async () => {
    const url = `?step_action=remove_product`;
    const payload = JSON.stringify({ product_name: productName });
    const response = await fetchRequest(url, payload);
    if (response) {
      updateApplicationDashboard(response);
      setIsLoading(false);
    }
  };
  const handleRemoveButtonClick = (ev) => {
    ev.preventDefault();
    setIsLoading(true);
    setEventDetails({
      eventName: "dashboard_remove_product",
      args: [productName ? productName : ""]
    });
    void removeProduct();
  };
  const removeButton = () => {
    return isOnlyProduct ? "" : /* @__PURE__ */ jsx166(
      Button24,
      {
        size: "sm",
        variant: "ghost",
        isLoading: loading2,
        isDisabled: loading2,
        onClick: (ev) => {
          handleRemoveButtonClick(ev);
        },
        children: /* @__PURE__ */ jsxs126("div", { children: [
          /* @__PURE__ */ jsx166(Icon37, { icon: bin }),
          "\xA0",
          "Remove"
        ] })
      }
    );
  };
  function checkPrimaryCover(hasPrimaryCover2, product2) {
    if (hasPrimaryCover2) {
      return {
        "Business Owners Policy": {
          displayPremium: "0",
          displaySpecificExcesses: {},
          covered: true,
          optional: false,
          displayLimits: [{ label: "", value: "" }],
          displayExcessTitle: "",
          displayExcessAmount: ""
        },
        ...product2
      };
    }
    return product2;
  }
  return /* @__PURE__ */ jsxs126(Fragment38, { children: [
    oneOrMoreProducts && SummaryFragment(
      checkPrimaryCover(hasPrimaryCover ? hasPrimaryCover : false, product),
      mobileView,
      policyStartDate,
      totalGrossPremium,
      hasSharedLimits,
      applicationDashboard,
      hasPrimaryCover
    ),
    additionalCoversKeys.length > 0 && additionalCoversKeys.map((newCover) => {
      const newCoverRecord = {
        [newCover]: additionalCover[newCover]
      };
      return /* @__PURE__ */ jsxs126(Fragment37, { children: [
        oneOrMoreProducts && /* @__PURE__ */ jsx166(
          Text69,
          {
            className: "mobius-payment-summary__additional-covers",
            elementType: "p",
            children: " "
          }
        ),
        SummaryFragment(
          newCoverRecord,
          mobileView,
          oneOrMoreProducts ? "" : policyStartDate,
          oneOrMoreProducts ? "" : totalGrossPremium,
          hasSharedLimits,
          applicationDashboard,
          hasPrimaryCover
        )
      ] }, newCover);
    }),
    applicationDashboard && /* @__PURE__ */ jsxs126("div", { className: "mobius-payment-summary__button-div", children: [
      /* @__PURE__ */ jsxs126(
        Flex44,
        {
          justifyContent: "space-between",
          className: "mobius-payment-summary__flex-margin-top",
          children: [
            /* @__PURE__ */ jsx166(Icon37, { icon: circleTick2, color: "var(--color-primary)" }),
            /* @__PURE__ */ jsx166("span", { className: "mobius-payment-summary__big-button-span", children: "Quote completed" })
          ]
        }
      ),
      removeButton()
    ] })
  ] });
}

// src/components/shared/PersistentSummary/SummaryWrapper.tsx
import { plus, pencil, bin as bin2 } from "@simplybusiness/icons";
import { Image as Image3, Segment as Segment8, Button as Button25, Flex as Flex45, Icon as Icon38 } from "@simplybusiness/mobius";
import { useBreakpoint as useBreakpoint12 } from "@simplybusiness/mobius";
import { Fragment as Fragment39, jsx as jsx167, jsxs as jsxs127 } from "react/jsx-runtime";
function SummaryWrapper({
  productName,
  productSummary,
  totalGrossPremium,
  hasSharedLimits,
  insurerLogo,
  policyStartDate,
  expandCover,
  mobileView,
  editURL,
  markedForPurchase,
  onUpdateItem,
  cartItemReference,
  promptInformation = { promptCustomer: false },
  eligibleForRemoval,
  editModalDescription,
  applicationDashboard = false,
  updateApplicationDashboard,
  isOnlyProduct,
  hasPrimaryCover
}) {
  let additionalCover = {};
  const [editQuote, setIsEditQuote] = useState22(false);
  const [removeItem, setIsRemovedItem] = useState22(false);
  const [addItem, setIsAddedItem] = useState22(false);
  const isCombinedPaymentPage = useContext6(CombinedPaymentContext);
  const [eventName, setEventName] = useState22(null);
  useTriggerEventTracker(eventName);
  const productSummaryKeys = Object.keys(productSummary);
  const product = productSummaryKeys.reduce((products, key) => {
    if (!productSummary[key].optional) {
      products[key] = productSummary[key];
    } else {
      additionalCover[key] = productSummary[key];
    }
    return products;
  }, {});
  const breakpointSize = useBreakpoint12([
    { size: "sm", value: 567 },
    { size: "md", value: 568 },
    { size: "lg", value: 812 }
  ]).breakpoint.size;
  const isMobileLandScape = breakpointSize == "md";
  const setButtonStyle = () => {
    return {
      alignSelf: "center",
      padding: isMobileLandScape && "6px",
      fontSize: isMobileLandScape && "var(--font-size-2)"
    };
  };
  const editButton = /* @__PURE__ */ jsx167(
    Button25,
    {
      className: "mobius-payment-summary__button",
      variant: "primary",
      size: "sm",
      isDisabled: editQuote,
      onPress: () => {
        try {
          setEventName("go_back_to_quote_selection_clicked");
        } catch (e) {
          console.error("Error in TriggerEventTracker", e);
        }
      },
      children: isCombinedPaymentPage ? /* @__PURE__ */ jsx167(Fragment39, { children: "Edit" }) : /* @__PURE__ */ jsxs127("div", { children: [
        /* @__PURE__ */ jsx167(Icon38, { icon: pencil }),
        "\xA0",
        "Edit"
      ] })
    }
  );
  const toggleItem = async (cartItemReference2) => {
    const url = `?step_action=update_cart_item`;
    const payload = JSON.stringify({
      item_id: cartItemReference2,
      action: "update"
    });
    const response = await fetchRequest(url, payload);
    onUpdateItem(response, cartItemReference2);
    if (response) {
      setIsAddedItem(false);
      setIsRemovedItem(false);
    }
  };
  return /* @__PURE__ */ jsx167(Fragment39, { children: /* @__PURE__ */ jsxs127(Segment8, { children: [
    /* @__PURE__ */ jsxs127(Flex45, { className: "mobius-payment-summary__summary-wrapper-segment", children: [
      /* @__PURE__ */ jsx167(Image3, { className: "mobius-payment-summary__styled-image", src: insurerLogo, alt: "insurerLogo" }),
      !eligibleForRemoval && !promptInformation.promptCustomer && editURL && /* @__PURE__ */ jsx167(
        DialogueModal2,
        {
          cancelButtonText: "Cancel, return to checkout",
          headerText: "Editing your coverage",
          actionButtonText: "Go back to your quote selection",
          redirectFunction: () => window.location.href = editURL,
          description: editModalDescription || ``,
          button: editButton
        }
      ),
      eligibleForRemoval && !promptInformation.promptCustomer ? markedForPurchase ? /* @__PURE__ */ jsx167(
        Button25,
        {
          className: "mobius-payment-summary__button",
          variant: "primary",
          size: "sm",
          isLoading: removeItem,
          isDisabled: removeItem,
          onPress: () => {
            setIsRemovedItem(true);
            toggleItem(cartItemReference);
          },
          children: /* @__PURE__ */ jsxs127("div", { children: [
            /* @__PURE__ */ jsx167(Icon38, { icon: bin2 }),
            "\xA0",
            "Remove"
          ] })
        }
      ) : /* @__PURE__ */ jsx167(
        Button25,
        {
          className: "mobius-payment-summary__button",
          variant: "primary",
          size: "sm",
          isLoading: addItem,
          isDisabled: addItem,
          onPress: () => {
            setIsAddedItem(true);
            toggleItem(cartItemReference);
          },
          children: /* @__PURE__ */ jsxs127("div", { children: [
            /* @__PURE__ */ jsx167(Icon38, { icon: plus }),
            "\xA0",
            "Add"
          ] })
        }
      ) : ""
    ] }),
    /* @__PURE__ */ jsx167(
      "div",
      {
        className: `mobius-payment-summary__summary-wrapper-div persistent_product_summary ${!markedForPurchase && "exclude-for-purchase"}`,
        children: /* @__PURE__ */ jsx167(
          ProductSummary,
          {
            productName,
            product,
            additionalCover,
            totalGrossPremium,
            hasSharedLimits,
            mobileView,
            policyStartDate,
            applicationDashboard,
            updateApplicationDashboard,
            isOnlyProduct,
            hasPrimaryCover
          }
        )
      }
    )
  ] }) });
}

// src/components/shared/PersistentSummary/PersistentCartPaymentOptions/CallToAction.tsx
import { Button as Button26, Flex as Flex46, Image as Image4, Text as Text70, Icon as Icon39 } from "@simplybusiness/mobius";
import { lock as lock2 } from "@simplybusiness/icons";
import { jsx as jsx168, jsxs as jsxs128 } from "react/jsx-runtime";
var CallToAction = ({
  enableCheckoutFormSubmission,
  isFormSubmitting,
  fireCheckoutButtonClickedEvent,
  onCallToActionClick,
  buttonText,
  poweredByStripeLogo
}) => {
  const extraClassName = enableCheckoutFormSubmission ? "" : "combined-payment-page-sticky";
  return /* @__PURE__ */ jsx168(
    "div",
    {
      className: `mobius-payment-summary__form-actions-box ${extraClassName}`,
      children: /* @__PURE__ */ jsx168(Flex46, { className: "mobius-payment-cta-container", children: enableCheckoutFormSubmission ? /* @__PURE__ */ jsx168(
        Button26,
        {
          className: "mobius-payment-summary__checkout-button",
          type: "submit",
          size: "md",
          isLoading: isFormSubmitting,
          isDisabled: isFormSubmitting,
          "data-testid": "submit-btn",
          onClick: fireCheckoutButtonClickedEvent,
          children: "Checkout"
        }
      ) : /* @__PURE__ */ jsxs128(Flex46, { flexDirection: "column", children: [
        /* @__PURE__ */ jsx168(
          Button26,
          {
            className: "mobius-payment-summary__checkout-button combined-payment-page-sticky",
            size: "md",
            "data-testid": "open-payment-drawer-btn",
            onClick: () => onCallToActionClick(true),
            children: buttonText
          }
        ),
        /* @__PURE__ */ jsxs128(
          Flex46,
          {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            children: [
              /* @__PURE__ */ jsx168(
                Icon39,
                {
                  icon: lock2,
                  className: "mobius-call-to-action_secure-checkout-icon"
                }
              ),
              /* @__PURE__ */ jsxs128(Text70, { className: "mobius-call-to-action_secure-checkout-text", children: [
                "Secure Checkout",
                " "
              ] }),
              /* @__PURE__ */ jsx168(
                Image4,
                {
                  className: "powered-by-stripe-logo",
                  src: poweredByStripeLogo,
                  alt: "Powered by Stripe"
                }
              )
            ]
          }
        )
      ] }) })
    }
  );
};

// src/components/shared/PersistentSummary/PersistentCartPaymentOptions/PersistentCartPaymentOptions.tsx
import { Fragment as Fragment40, jsx as jsx169, jsxs as jsxs129 } from "react/jsx-runtime";
var PersistentCartPaymentOptions = ({
  businessInformation,
  productsInformation,
  paymentBreakdown,
  currency,
  totalPaymentAmount,
  requestPath,
  csrfToken,
  journeyToken,
  continuationProduct = "",
  multiProductText,
  onPurchaseCartDigestUpdate = (_newValue) => {
  },
  onPaymentOptionsUpdate = (_productInformation) => {
  },
  onCallToActionClick = (_newValue) => {
  },
  onPayTodayAmountUpdate = (_payTodayAmount) => {
  },
  showPaymentSummaryOnly = false,
  enableCheckoutFormSubmission = true,
  enablePaymentOptionsServerUpdate = false,
  combinedPaymentPage = false,
  isExternalCarrier = false,
  hasMonthlyFees = false,
  cardFeeDisclosureText = "",
  poweredByStripeLogo = ""
}) => {
  const [productsInfo, setProductsInfo] = useState23(productsInformation);
  const [dynamicPaymentBreakdown, setDynamicPaymentBreakdown] = useState23(paymentBreakdown);
  const [totalPayment, setTotalPayment] = useState23(totalPaymentAmount);
  const [isFormSubmitting, setIsFormSubmitting] = useState23(false);
  const productsMarkedForPurchase = selectProductsMarkedForPurchase(productsInfo);
  const breakpointSize = useBreakpoint13([
    { size: "sm", value: 639 },
    { size: "lg", value: 640 }
  ]).breakpoint.size;
  const [eventDetails, setEventDetails] = useState23({ eventName: null, args: [] });
  useTriggerEventTracker(eventDetails.eventName, ...eventDetails.args);
  const firePaymentOptionChangeEvent = (cartItemReference, newPaymentPeriod) => {
    const currentProduct = productsInfo.find(
      (product) => product.cartItemReference === cartItemReference
    );
    try {
      setEventDetails({
        eventName: "payment_option_changed",
        args: [
          newPaymentPeriod,
          ...currentProduct ? currentProduct.coverNames : [""]
        ]
      });
    } catch (e) {
      console.error("Error in TriggerEventTracker", e);
    }
  };
  const fireCheckoutButtonClickedEvent = () => {
    productsInfo.forEach((product) => {
      setEventDetails({
        eventName: "checkout_button_clicked",
        args: [
          product.selectedPaymentOption,
          ...product ? product.coverNames : [""]
        ]
      });
    });
  };
  const handleUpdateItem = (response) => {
    setProductsInfo(response.productsInformation);
    setTotalPayment(response.totalPaymentAmount);
    setDynamicPaymentBreakdown(response.paymentBreakdown);
    onPaymentOptionsUpdate(response.productsInformation);
    onPurchaseCartDigestUpdate(response.purchase_cart_digest);
  };
  const handlePaymentOptionsClientSideUpdate = (cartItemReference, newPaymentPeriod) => {
    firePaymentOptionChangeEvent(cartItemReference, newPaymentPeriod);
    setProductsInfo(
      (prevState) => prevState.map(
        (productInfo) => productInfo.cartItemReference === cartItemReference ? { ...productInfo, selectedPaymentOption: newPaymentPeriod } : productInfo
      )
    );
  };
  const upfrontPaymentsTotalValue = useMemo6(() => {
    return upfrontPaymentsTotal(productsMarkedForPurchase, currency);
  }, [productsMarkedForPurchase, currency]);
  const buttonText = `Pay ${upfrontPaymentsTotalValue || ""}`;
  useEffect14(() => {
    onPayTodayAmountUpdate(buttonText);
  }, [buttonText, onPayTodayAmountUpdate]);
  const upfrontPaymentBreakdown = () => {
    if (!enablePaymentOptionsServerUpdate) {
      return upfrontPayments(productsMarkedForPurchase, currency);
    }
    return dynamicPaymentBreakdown.downpayment;
  };
  const monthlyPaymentBreakdown = () => {
    if (!enablePaymentOptionsServerUpdate) {
      return monthlyPayments(
        productsMarkedForPurchase,
        currency,
        hasMonthlyFees
      );
    }
    return dynamicPaymentBreakdown.installments;
  };
  const buildFormAttributes = () => {
    if (!enableCheckoutFormSubmission) return {};
    return {
      action: requestPath,
      method: "POST",
      onSubmit: () => setIsFormSubmitting(true)
    };
  };
  return /* @__PURE__ */ jsx169(CombinedPaymentContext.Provider, { value: combinedPaymentPage, children: /* @__PURE__ */ jsxs129(
    "form",
    {
      "data-testid": "checkout-form",
      id: "checkout-form",
      ...buildFormAttributes(),
      children: [
        /* @__PURE__ */ jsx169(
          "input",
          {
            className: "hidden",
            name: "authenticity_token",
            type: "hidden",
            "data-testid": "authenticity-token",
            value: csrfToken
          }
        ),
        /* @__PURE__ */ jsx169(
          "input",
          {
            className: "hidden",
            name: "journey_token",
            type: "hidden",
            value: journeyToken,
            "data-testid": "journey-token"
          }
        ),
        /* @__PURE__ */ jsxs129(
          "div",
          {
            className: `mobius-payment-summary__outer-grid ${combinedPaymentPage ? "combined-payment-page" : void 0} ${showPaymentSummaryOnly ? "show-payment-summary-only" : void 0}`,
            children: [
              !showPaymentSummaryOnly && /* @__PURE__ */ jsxs129(Fragment40, { children: [
                /* @__PURE__ */ jsx169(
                  "div",
                  {
                    className: `mobius-payment-summary__product-payment-options ${combinedPaymentPage ? "combined-styles" : void 0}`,
                    children: productsInfo.map((productInfo) => /* @__PURE__ */ jsxs129(
                      SegmentGroup3,
                      {
                        className: !productInfo.promptInformation?.promptCustomer ? "product-group" : "product-group non-purchasable-product",
                        "data-testid": productInfo.cartItemReference,
                        horizontal: breakpointSize == "lg",
                        children: [
                          /* @__PURE__ */ jsx169(
                            SummaryWrapper,
                            {
                              productName: "",
                              updateApplicationDashboard: (response) => {
                                console.log("updateApplicationDashboard");
                                console.log(response);
                              },
                              productSummary: productInfo.productSummary.coverInformation,
                              policyStartDate: productInfo.productSummary.policyStartDate,
                              insurerLogo: productInfo.productSummary.insurerLogo,
                              hasPrimaryCover: productInfo.productSummary.hasPrimaryCover,
                              hasSharedLimits: productInfo.productSummary.hasSharedLimits,
                              mobileView: true,
                              expandCover: false,
                              editURL: productInfo.editUrl,
                              markedForPurchase: productInfo.markedForPurchase,
                              onUpdateItem: handleUpdateItem,
                              cartItemReference: productInfo.cartItemReference,
                              promptInformation: productInfo.promptInformation,
                              eligibleForRemoval: productInfo.eligibleForRemoval,
                              editModalDescription: productInfo.editModalDescription
                            }
                          ),
                          /* @__PURE__ */ jsx169(
                            PaymentOptions,
                            {
                              annual: productInfo.availablePaymentOptions.annual,
                              monthly: productInfo.availablePaymentOptions.monthly,
                              currency,
                              selectedOption: productInfo.selectedPaymentOption,
                              cartItemReference: productInfo.cartItemReference,
                              fireEvent: firePaymentOptionChangeEvent,
                              markedForPurchase: productInfo.markedForPurchase,
                              promptInformation: productInfo.promptInformation,
                              onUpdateItem: handleUpdateItem,
                              enablePaymentOptionsServerUpdate,
                              hasMonthlyFees,
                              onPaymentOptionsClientUpdate: handlePaymentOptionsClientSideUpdate
                            }
                          )
                        ]
                      },
                      productInfo.cartItemReference
                    ))
                  }
                ),
                continuationProduct.length > 0 && /* @__PURE__ */ jsx169(
                  JourneyContinuationNotice,
                  {
                    continuationProduct
                  }
                ),
                /* @__PURE__ */ jsx169(
                  CallToAction,
                  {
                    enableCheckoutFormSubmission,
                    isFormSubmitting,
                    fireCheckoutButtonClickedEvent,
                    onCallToActionClick,
                    buttonText,
                    poweredByStripeLogo
                  }
                )
              ] }),
              /* @__PURE__ */ jsx169("div", { className: "mobius-payment-summary__payment-summary-box", children: /* @__PURE__ */ jsx169("div", { className: "payment-summary", children: /* @__PURE__ */ jsx169(
                PaymentSummary2,
                {
                  primaryTrade: businessInformation.primaryTrade,
                  businessName: businessInformation.businessName,
                  upfrontPayments: upfrontPaymentBreakdown(),
                  upfrontPaymentsTotal: upfrontPaymentsTotalValue,
                  monthlyPayments: monthlyPaymentBreakdown(),
                  monthlyPaymentSummary: monthlyPaymentSummary(
                    productsMarkedForPurchase,
                    currency
                  ),
                  firstMonthlyPaymentDate: firstMonthlyPaymentDate(
                    productsMarkedForPurchase,
                    currency
                  ),
                  totalPaymentAmount: currencyFormatter(currency).format(
                    totalPayment
                  ),
                  nonRefundableTexts: productInfoTexts(
                    productsMarkedForPurchase,
                    "nonRefundableText"
                  ),
                  surchargeTexts: productInfoTexts(
                    productsMarkedForPurchase,
                    "surchargeText"
                  ),
                  multiProductText: multiProductText ? multiProductText : "",
                  cardFeeDisclosureText,
                  isExternalCarrier,
                  hasMonthlyFees
                }
              ) }) })
            ]
          }
        )
      ]
    }
  ) });
};

// src/components/shared/PersistentSummary/PriceSummary/index.tsx
import { Box as Box13, Flex as Flex47, Text as Text71 } from "@simplybusiness/mobius";
import { jsx as jsx170, jsxs as jsxs130 } from "react/jsx-runtime";
function PriceSummary({ priceModel }) {
  const { downpaymentAmount, annualPaymentAmount, installmentCounts } = priceModel;
  return /* @__PURE__ */ jsxs130(Box13, { className: "mobius-payment-summary__price-summary-box", children: [
    downpaymentAmount && /* @__PURE__ */ jsxs130("div", { className: "mobius-payment-summary__styled-grid mobius-payment-summary__price-summary-group mobius-payment-summary__border-bottom", children: [
      /* @__PURE__ */ jsx170(Text71, { elementType: "span", children: /* @__PURE__ */ jsx170("strong", { children: "To pay today" }) }),
      /* @__PURE__ */ jsx170(Text71, { elementType: "span", className: "align-right", children: /* @__PURE__ */ jsx170("strong", { children: downpaymentAmount }) })
    ] }),
    installmentCounts && installmentCounts.map((installmentCount, index) => /* @__PURE__ */ jsxs130(
      "div",
      {
        className: "mobius-payment-summary__styled-grid mobius-payment-summary__price-summary-group mobius-payment-summary__border-bottom",
        children: [
          /* @__PURE__ */ jsx170(Text71, { elementType: "span", children: installmentCount.labels[0] }),
          /* @__PURE__ */ jsx170(Text71, { elementType: "span", className: "align-right", children: installmentCount.value })
        ]
      },
      index
    )),
    /* @__PURE__ */ jsx170(Flex47, { children: /* @__PURE__ */ jsxs130("div", { className: "mobius-payment-summary__styled-grid mobius-payment-summary__price-summary-group", children: [
      /* @__PURE__ */ jsxs130(Text71, { elementType: "span", children: [
        "Total",
        "\xA0",
        /* @__PURE__ */ jsx170(Text71, { elementType: "span", children: "(inc.tax + fees)" })
      ] }),
      /* @__PURE__ */ jsx170(
        Text71,
        {
          elementType: "span",
          className: "align-right mobius-payment-summary__price-summary-text",
          children: annualPaymentAmount
        }
      )
    ] }) })
  ] });
}

// src/components/shared/PersistentSummary/PersistentCartPriceSummary/PersistentCartPriceSummary.tsx
import { jsx as jsx171 } from "react/jsx-runtime";
function PersistentCartPriceSummary({
  cartPriceModel
}) {
  const { productsInformation, currency, totalPaymentAmount } = cartPriceModel;
  const priceModel = {
    downpaymentAmount: upfrontPaymentsTotal(productsInformation, currency),
    installmentCounts: monthlyPayments(productsInformation, currency),
    annualPaymentAmount: currencyFormatter(currency).format(totalPaymentAmount)
  };
  return /* @__PURE__ */ jsx171("div", { className: "mobius-payment-summary__persistent-price-summary", children: /* @__PURE__ */ jsx171(PriceSummary, { priceModel }) });
}

// src/components/shared/PersistentSummary/PersistentPriceSummary/PersistentPriceSummary.tsx
import { jsx as jsx172 } from "react/jsx-runtime";
var transformPriceModel = (priceModel) => {
  return priceModel.installmentCount ? {
    downpaymentAmount: priceModel.downpaymentAmount,
    installmentCounts: [
      {
        labels: [`${priceModel.installmentCount} Monthly payments of`],
        value: priceModel.installmentAmount
      }
    ],
    annualPaymentAmount: priceModel.totalPaymentAmount
  } : {
    downpaymentAmount: priceModel.totalPaymentAmount,
    installmentCounts: [],
    annualPaymentAmount: priceModel.totalPaymentAmount
  };
};
function PersistentPriceSummary({
  priceModel
}) {
  const transformedPriceModel = transformPriceModel(priceModel);
  return /* @__PURE__ */ jsx172("div", { className: "persistent_price_summary", children: /* @__PURE__ */ jsx172(PriceSummary, { priceModel: transformedPriceModel }) });
}

// src/components/shared/PersistentSummary/PersistentSummaryHeader/PersistentSummaryHeader.tsx
import { Text as Text72, Box as Box14, Flex as Flex48 } from "@simplybusiness/mobius";
import { jsx as jsx173, jsxs as jsxs131 } from "react/jsx-runtime";
var PersistentSummaryHeader = ({
  text: text3 = "Your quoted coverages"
}) => {
  return /* @__PURE__ */ jsxs131(Box14, { children: [
    /* @__PURE__ */ jsx173(Flex48, { className: "coverage-widget-up-arrow" }),
    /* @__PURE__ */ jsx173(Flex48, { children: /* @__PURE__ */ jsx173(
      Text72,
      {
        className: "coverage-title mobius-payment-summary__styled-coverage-text mobius-payment-summary__styled-box",
        elementType: "span",
        children: text3
      }
    ) })
  ] });
};

// src/components/shared/PersistentSummary/PersistentProductSummary/PersistentProductSummary.tsx
import { useEffect as useEffect15, useState as useState24 } from "react";
import { jsx as jsx174 } from "react/jsx-runtime";
var PersistentProductSummary = ({
  productSummary,
  expandCover,
  mobileView,
  applicationDashboard = false,
  updateApplicationDashboard,
  isOnlyProduct
}) => {
  const [isUpsell, setIsUpsell] = useState24(false);
  useEffect15(() => {
    setIsUpsell(document.getElementsByClassName("upsell-question").length > 0);
  }, []);
  if (!Array.isArray(productSummary)) {
    return null;
  }
  return /* @__PURE__ */ jsx174("div", { className: "persistent_product_summary mobius-payment-summary__persistent-product-summary-div", children: productSummary.map((product, idx) => /* @__PURE__ */ jsx174(
    SummaryWrapper,
    {
      productName: product.productName,
      productSummary: product.coverInformation,
      policyStartDate: product.policyStartDate,
      totalGrossPremium: product.totalGrossPremium,
      hasSharedLimits: product.hasSharedLimits,
      hasPrimaryCover: product.hasPrimaryCover,
      insurerLogo: product.insurerLogo,
      expandCover: isUpsell && expandCover,
      mobileView,
      applicationDashboard,
      updateApplicationDashboard,
      isOnlyProduct,
      onUpdateItem: () => {
      }
    },
    `${idx}_${product.insurerLogo}`
  )) });
};

// src/components/shared/QuoteDetailsForm/QuoteDetailsForm.tsx
import { useEffect as useEffect16, useState as useState25 } from "react";

// src/components/shared/QuoteDetailsForm/BuyButton.tsx
import { Fragment as Fragment41, jsx as jsx175, jsxs as jsxs132 } from "react/jsx-runtime";
var underscoreToHyphen = (value) => value.replace(/_/g, "-");
var objectMap = (object, mapFn) => Object.fromEntries(Object.entries(object).map(mapFn));
var dataPropsFromDataObject = (data) => objectMap(data, (entry) => [`data-${underscoreToHyphen(entry[0])}`, entry[1]]);
var BuyButton = ({
  buyButtonData = { track: "test" },
  buttonLabel = "Buy"
}) => {
  const dataAttributes = dataPropsFromDataObject(buyButtonData);
  return /* @__PURE__ */ jsxs132(Fragment41, { children: [
    /* @__PURE__ */ jsx175(
      "button",
      {
        type: "submit",
        className: "btn-primary mobius-quote-details-form__buy_button buy-button js-buy-button portable-hide qa-buy-quote-option",
        ...dataAttributes,
        children: /* @__PURE__ */ jsx175("span", { children: buttonLabel })
      }
    ),
    /* @__PURE__ */ jsx175(
      "button",
      {
        type: "submit",
        className: "btn-primary mobius-quote-details-form__buy_button buy-button js-buy-button portable-show us-buy-button",
        ...dataAttributes,
        children: /* @__PURE__ */ jsx175("span", { children: buttonLabel })
      }
    ),
    /* @__PURE__ */ jsx175(
      "button",
      {
        type: "submit",
        className: "btn-primary mobius-quote-details-form__buy_button buy-button portable-show uk-details-button",
        ...dataAttributes,
        children: /* @__PURE__ */ jsx175("span", { children: buttonLabel })
      }
    )
  ] });
};

// src/components/shared/QuoteDetailsForm/QuoteDetailsForm.tsx
import { jsx as jsx176, jsxs as jsxs133 } from "react/jsx-runtime";
var QuoteDetailsForm = ({
  buyButtonData,
  formAuthenticityToken,
  insurer,
  quoteId,
  journeyToken,
  buttonLabel
}) => {
  const [action, setAction] = useState25("");
  useEffect16(() => {
    setAction(document.location.toString());
  }, []);
  return /* @__PURE__ */ jsxs133("form", { action, method: "post", children: [
    /* @__PURE__ */ jsx176(
      "input",
      {
        type: "hidden",
        name: "journey_token",
        "data-testid": "journey_token",
        value: journeyToken
      }
    ),
    /* @__PURE__ */ jsx176(
      "input",
      {
        type: "hidden",
        name: "authenticity_token",
        "data-testid": "authenticity_token",
        value: formAuthenticityToken
      }
    ),
    /* @__PURE__ */ jsx176(
      "input",
      {
        type: "hidden",
        name: "insurer",
        "data-testid": "insurer",
        value: insurer
      }
    ),
    /* @__PURE__ */ jsx176(
      "input",
      {
        type: "hidden",
        name: "quote_id",
        "data-testid": "quote_id",
        value: quoteId
      }
    ),
    /* @__PURE__ */ jsx176(
      "input",
      {
        type: "hidden",
        name: "buy_button_clicked",
        "data-testid": "buy_button_clicked",
        value: "yes"
      }
    ),
    /* @__PURE__ */ jsx176(BuyButton, { buyButtonData, buttonLabel })
  ] });
};

// src/components/shared/TransferConsentPageUK/TransferConsentPageUK.tsx
import { useState as useState27 } from "react";

// src/components/shared/TransferConsentPageUK/TransferConsentFormUK/TransferConsentFormUK.tsx
import { useState as useState26 } from "react";
import { Text as Text73, LoadingIndicator, Button as Button27, Flex as Flex49 } from "@simplybusiness/mobius";

// src/components/shared/TransferConsentPageUK/values.tsx
var transferState = "TRANSFER";
var errorState = "ERROR";
var successState = "SUCCESS";
var declinedState = "DECLINED";

// src/components/shared/TransferConsentPageUK/TransferConsentFormUK/TransferConsentFormUK.tsx
import { jsx as jsx177, jsxs as jsxs134 } from "react/jsx-runtime";
var text = {
  transfer: {
    header: "No quotes showing?",
    body: [
      `We can't currently offer you a quote but our partner, 
      Gallagher, might be able to help you.`,
      `Gallagher has a team of specialists that can offer
      you insurance advice and guidance, as well as your own dedicated account handler.`,
      `As one of the world's largest insurance brokers, Gallagher supports
      thousands of businesses with tailored insurance advice to arrange either standard or
      specialist business insurance.`,
      `If you're happy for us to hand over your details to Gallagher, 
      they might be able to provide you with a quote.`
    ]
  }
};
var TransferConsentFormUK = ({
  transferUrl = "https://default.url",
  csrfToken = "defaultToken",
  transferState: transferState2 = () => console.log("default state")
}) => {
  const [loading2, setLoadingState] = useState26(false);
  const handleSubmit = async (option) => {
    setLoadingState(true);
    const response = await fetch(transferUrl, {
      method: "POST",
      body: JSON.stringify({ consent: option === "yes" }),
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }).then((res) => res.json());
    const result = response.success ? successState : errorState;
    const stateParams = {
      state: option === "yes" ? result : declinedState,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      response
    };
    transferState2(stateParams);
  };
  return /* @__PURE__ */ jsxs134("div", { children: [
    /* @__PURE__ */ jsx177(Text73, { variant: "h2", children: text.transfer.header }),
    text.transfer.body.map((message2) => /* @__PURE__ */ jsx177(Text73, { children: message2 }, message2)),
    loading2 ? /* @__PURE__ */ jsx177("div", { className: "mobius-transfer-consent__styled-div", children: /* @__PURE__ */ jsx177(LoadingIndicator, { size: "lg", "data-testid": "loading-indicator" }) }) : /* @__PURE__ */ jsxs134(
      Flex49,
      {
        className: "mobius-transfer-consent__styled-button-container",
        gap: "xs",
        children: [
          /* @__PURE__ */ jsx177(
            Button27,
            {
              size: "sm",
              variant: "secondary",
              onClick: () => {
                handleSubmit("yes").catch(console.error);
              },
              children: "Yes"
            }
          ),
          /* @__PURE__ */ jsx177(
            Button27,
            {
              size: "sm",
              variant: "secondary",
              onClick: () => {
                handleSubmit("no").catch(console.error);
              },
              children: "No"
            }
          )
        ]
      }
    )
  ] });
};

// src/components/shared/TransferConsentPageUK/TransferResultMessageUK/TransferResultMessageUK.tsx
import { Text as Text74 } from "@simplybusiness/mobius";

// src/components/shared/TransferConsentPageUK/PhoneNumber.tsx
import { Link as Link24 } from "@simplybusiness/mobius";
import { jsx as jsx178 } from "react/jsx-runtime";
function PhoneNumber(number) {
  return /* @__PURE__ */ jsx178(Link24, { href: `tel:${number}`, children: number });
}

// src/components/shared/TransferConsentPageUK/TransferReference.tsx
import { jsx as jsx179 } from "react/jsx-runtime";
function TransferReference(transferStatus) {
  return /* @__PURE__ */ jsx179("span", { className: "mobius-transfer-reference__span", children: transferStatus.response.reference });
}

// src/components/shared/TransferConsentPageUK/Header.tsx
function header(transferStatus, text3) {
  switch (transferStatus.state) {
    case successState:
      return "Transfer successful";
    case errorState:
      return "Transfer unsuccessful";
    default:
      return text3.consentNotGiven.header;
  }
}

// src/components/shared/TransferConsentPageUK/TransferResultMessageUK/TransferResultMessageUK.tsx
import { Fragment as Fragment42, jsx as jsx180, jsxs as jsxs135 } from "react/jsx-runtime";
var text2 = {
  consentNotGiven: {
    header: "Transfer not completed",
    body: `Your details have not been passed to Gallagher, if you need any 
      further help call us on `,
    phone_number: "0330 912 0297"
  }
};
var TransferResultMessageUK = ({
  transferStatus
}) => {
  function Message() {
    const transferReferenceCopy = `Here is your unique customer reference number for Gallagher: `;
    switch (transferStatus.state) {
      case successState:
        return /* @__PURE__ */ jsxs135(Fragment42, { children: [
          /* @__PURE__ */ jsxs135(Text74, { children: [
            `Great, Gallagher will be in touch as soon as possible
            within their working hours. You can also contact them on `,
            PhoneNumber("01443 807415"),
            ` between 9am-5pm, Monday to Friday.`
          ] }),
          /* @__PURE__ */ jsxs135(Text74, { children: [
            transferReferenceCopy,
            TransferReference(transferStatus)
          ] })
        ] });
      case errorState:
        return /* @__PURE__ */ jsxs135(Fragment42, { children: [
          /* @__PURE__ */ jsxs135(Text74, { children: [
            `Unfortunately, we've been unable to pass your details over 
          at this time but we'll try our best to pass on your information to Gallagher. 
          If you'd like to speak with them, you can call on `,
            PhoneNumber("01443 807415"),
            ` between 9am-5pm, Monday to Friday.`
          ] }),
          /* @__PURE__ */ jsxs135(Text74, { children: [
            transferReferenceCopy,
            TransferReference(transferStatus)
          ] })
        ] });
      default:
        return /* @__PURE__ */ jsxs135(Text74, { children: [
          text2.consentNotGiven.body,
          PhoneNumber(text2.consentNotGiven.phone_number)
        ] });
    }
  }
  return /* @__PURE__ */ jsxs135("div", { children: [
    /* @__PURE__ */ jsx180(Text74, { variant: "h2", children: header(transferStatus, text2) }),
    /* @__PURE__ */ jsx180(Message, {})
  ] });
};

// src/components/shared/TransferConsentPageUK/TransferConsentPageUK.tsx
import { jsx as jsx181 } from "react/jsx-runtime";
var TransferConsentPageUK = ({
  transferUrl,
  csrfToken
}) => {
  const [transferState2, setTransferState] = useState27({
    state: transferState,
    response: null
  });
  return /* @__PURE__ */ jsx181("div", { children: transferState2.state === transferState ? /* @__PURE__ */ jsx181(
    TransferConsentFormUK,
    {
      transferUrl,
      csrfToken,
      transferState: setTransferState
    }
  ) : /* @__PURE__ */ jsx181(TransferResultMessageUK, { transferStatus: transferState2 }) });
};

// src/pages/AgentReferralPage/AgentReferralPage.tsx
import { Box as Box15, Container as Container14, Trust as Trust3 } from "@simplybusiness/mobius";

// src/contexts/TrustpilotProvider.tsx
import { useEffect as useEffect17 } from "react";
import { jsx as jsx182 } from "react/jsx-runtime";
var TrustpilotProvider = ({ children }) => {
  useEffect17(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.className = "optanon-category-C0002";
    script.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return /* @__PURE__ */ jsx182("div", { children });
};

// src/contexts/ZendeskProvider.tsx
import { useEffect as useEffect18 } from "react";
var getZendeskKeys = (pageData) => pageData.scripts?.find(({ metadata }) => metadata.name === "zendesk-chat")?.props;
var ZendeskProvider = ({ chatKey, customerId }) => {
  useEffect18(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "ze-snippet";
    script.className = "optanon-category-C0003";
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${chatKey}`;
    script.async = true;
    script.addEventListener("load", function() {
      if (window?.zE) {
        window.zE("messenger:on", "open", function() {
          window.zE("messenger:set", "conversationFields", [
            { id: customerId, value: window?.location.href }
          ]);
        });
      }
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [chatKey, customerId]);
  return null;
};

// src/pages/Page/Page.tsx
import { useEffect as useEffect19, useState as useState28 } from "react";
import { jsx as jsx183, jsxs as jsxs136 } from "react/jsx-runtime";
var Page = (props) => {
  const {
    configuration,
    layout: {
      /* metadata, */
      components
      /* variations */
    },
    children,
    experiments
  } = props;
  useExperiments(experiments);
  useLocale(configuration.locale);
  const [pageReady, setPageReady] = useState28(false);
  const {
    authenticityToken,
    journeyToken,
    site,
    journeyId,
    vertical,
    affclie
  } = configuration;
  const [, setTokens] = useTokens();
  const [, setEnvironment] = useEnvironment();
  useEffect19(() => {
    setTokens({ authenticityToken, journeyToken });
    setEnvironment({ site, journeyId, vertical, affclie });
    setPageReady(true);
  }, [
    authenticityToken,
    journeyToken,
    setTokens,
    setEnvironment,
    site,
    journeyId,
    vertical,
    affclie
  ]);
  const headerComponentProps = getPropsByName({
    name: "header",
    components
  });
  const progressComponentProps = getPropsByName({
    name: "progress-steps",
    components
  });
  const preFooterComponentProps = getPropsByName({
    name: "pre-footer",
    components
  });
  const footerComponentProps = getPropsByName({
    name: "footer",
    components
  });
  return /* @__PURE__ */ jsxs136(
    "div",
    {
      className: "mobius-page__container",
      "data-page-loaded": pageReady,
      "data-testid": "base-page",
      children: [
        /* @__PURE__ */ jsx183(Header2, { ...headerComponentProps }),
        progressComponentProps && /* @__PURE__ */ jsx183(ProgressSteps, { ...progressComponentProps }),
        children,
        preFooterComponentProps && /* @__PURE__ */ jsx183(PreFooter, { ...preFooterComponentProps }),
        /* @__PURE__ */ jsx183(Footer4, { ...footerComponentProps })
      ]
    }
  );
};

// src/pages/Page/PageProviders.tsx
import { InterventionsProvider } from "@simplybusiness/mobius-interventions";
import { getSnowplowConfig, SnowplowProvider } from "@simplybusiness/services";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Provider } from "jotai";

// src/constants/interventions.ts
var INACTIVITY_TIME = 5e3;

// src/pages/Page/PageProviders.tsx
import { jsx as jsx184, jsxs as jsxs137 } from "react/jsx-runtime";
function PageProviders(props) {
  const { configuration } = props;
  const { site } = configuration;
  const snowplowProps = getSnowplowConfig(props);
  const duid = snowplowProps?.duid;
  const zendeskProps = getZendeskKeys(props);
  const queryClient = new QueryClient();
  const disablePolling = configuration.disableIdmPolling === "true";
  return /* @__PURE__ */ jsx184(Provider, { children: /* @__PURE__ */ jsxs137(QueryClientProvider, { client: queryClient, children: [
    zendeskProps && /* @__PURE__ */ jsx184(ZendeskProvider, { ...zendeskProps, experiments: props.experiments }),
    /* @__PURE__ */ jsx184(SnowplowProvider, { scripts: snowplowProps, children: /* @__PURE__ */ jsx184(
      InterventionsProvider,
      {
        site,
        duid,
        inactivityTime: INACTIVITY_TIME,
        disablePolling,
        children: /* @__PURE__ */ jsx184(ErrorBoundary, { children: /* @__PURE__ */ jsx184(TrustpilotProvider, { children: props.children }) })
      }
    ) }),
    /* @__PURE__ */ jsx184(ReactQueryDevtools, { initialIsOpen: false })
  ] }) });
}

// src/pages/AgentReferralPage/AgentReferralPage.tsx
import { jsx as jsx185, jsxs as jsxs138 } from "react/jsx-runtime";
var AgentReferralPageInner = (props) => {
  const {
    layout: { components }
  } = props;
  const agentReferral = getPropsByName({
    name: "agent-referral-content",
    components
  });
  const agentResources = getPropsByName({
    name: "agent-resources",
    components
  });
  return /* @__PURE__ */ jsxs138(Container14, { size: "sm", children: [
    /* @__PURE__ */ jsxs138("div", { className: "mobius-agent-referral-container", children: [
      !!agentReferral && /* @__PURE__ */ jsx185(
        AgentReferral,
        {
          ...agentReferral
        }
      ),
      !!agentResources && /* @__PURE__ */ jsx185(
        AgentResources,
        {
          ...agentResources
        }
      )
    ] }),
    /* @__PURE__ */ jsx185(Box15, { paddingTop: "xxl", children: /* @__PURE__ */ jsx185(TrustpilotProvider, { children: /* @__PURE__ */ jsx185(Trust3, { locale: "en-US", theme: "light", variant: "horizontal" }) }) })
  ] });
};
var AgentReferralPage = (props) => {
  return /* @__PURE__ */ jsx185(PageProviders, { ...props, children: /* @__PURE__ */ jsx185(Page, { ...props, children: /* @__PURE__ */ jsx185("main", { className: "mobius mobius-page__main", children: /* @__PURE__ */ jsx185(AgentReferralPageInner, { ...props }) }) }) });
};

// src/pages/QuestionnairePage/QuestionnairePage.tsx
import { useMemo as useMemo7 } from "react";
import { Container as Container15 } from "@simplybusiness/mobius";
import { jsx as jsx186 } from "react/jsx-runtime";
var QuestionnairePageInner = (props) => {
  const {
    layout: { components }
  } = props;
  const questionnaire = getPropsByName({
    name: "questionnaire",
    components
  });
  const submitAction = useMemo7(
    () => questionnaire.actions?.find(
      (action) => action.actionType === "submit"
    ),
    [questionnaire.actions]
  );
  useSetQuestionnaireFormUrl(submitAction?.url);
  return /* @__PURE__ */ jsx186(Container15, { size: "sm", children: !!questionnaire && /* @__PURE__ */ jsx186(Questionnaire, { ...questionnaire }) });
};
var QuestionnairePage = (props) => {
  return /* @__PURE__ */ jsx186(PageProviders, { ...props, children: /* @__PURE__ */ jsx186(Page, { ...props, children: /* @__PURE__ */ jsx186("main", { className: "mobius mobius-page__main", children: /* @__PURE__ */ jsx186(QuestionnairePageInner, { ...props }) }) }) });
};

// src/pages/QuoteComparisonPage/QuoteComparisonPage.tsx
import { Alert as Alert3, Box as Box16, Container as Container16 } from "@simplybusiness/mobius";
import { InterventionWrapper as InterventionWrapper2 } from "@simplybusiness/mobius-interventions";
import "react-loading-skeleton/dist/skeleton.css";

// src/components/QCPRedirect/QCPRedirect.tsx
import { Button as Button28, Icon as Icon40, Link as Link26 } from "@simplybusiness/mobius";
import { leftArrow as leftArrow3, rightArrow as rightArrow5 } from "@simplybusiness/icons";
import { useSnowplowContext as useSnowplowContext33 } from "@simplybusiness/services";

// src/components/QCPRedirect/QCPRedirectSkeleton.tsx
import Skeleton2, { SkeletonTheme as SkeletonTheme3 } from "react-loading-skeleton";
import { Link as Link25 } from "@simplybusiness/mobius";
import { Fragment as Fragment43, jsx as jsx187 } from "react/jsx-runtime";
var StyledSkeleton2 = (props) => /* @__PURE__ */ jsx187(
  Skeleton2,
  {
    borderRadius: "var(--radius-2)",
    ...props,
    containerClassName: "mobius-skeleton"
  }
);
var QCPRedirectSkeleton = () => {
  return /* @__PURE__ */ jsx187(Fragment43, { children: /* @__PURE__ */ jsx187("div", { className: "mobius-qcp-redirect", children: /* @__PURE__ */ jsx187(
    SkeletonTheme3,
    {
      baseColor: "var(--color-background-light)",
      highlightColor: "var(--color-background)",
      children: /* @__PURE__ */ jsx187(Link25, { children: /* @__PURE__ */ jsx187(StyledSkeleton2, { width: "40%", height: "2rem" }) })
    }
  ) }) });
};

// src/components/QCPRedirect/QCPRedirect.tsx
import { jsx as jsx188, jsxs as jsxs139 } from "react/jsx-runtime";
var QCPRedirect = ({
  variant,
  coverageName,
  targetUrl
}) => {
  const { snowplow } = useSnowplowContext33();
  const qcpRedirectClass = "mobius-qcp-redirect";
  const isToggling = useMutationStatus("toggleCovers");
  const handleLinkClick = (elementContent) => {
    if (targetUrl && elementContent) {
      snowplow?.trigger("linkClicked", {
        targetUrl,
        elementContent
      });
    }
  };
  if (isToggling) {
    return /* @__PURE__ */ jsx188(QCPRedirectSkeleton, {});
  }
  if (variant === "checkout") {
    return /* @__PURE__ */ jsx188("div", { className: qcpRedirectClass, children: /* @__PURE__ */ jsx188(Link26, { href: targetUrl, children: /* @__PURE__ */ jsxs139(
      Button28,
      {
        variant: "secondary",
        onPress: () => handleLinkClick(`Skip ${coverageName}`),
        children: [
          "Skip ",
          coverageName,
          /* @__PURE__ */ jsx188(Icon40, { icon: rightArrow5, fixedWidth: true })
        ]
      }
    ) }) });
  }
  return /* @__PURE__ */ jsx188("div", { className: qcpRedirectClass, children: /* @__PURE__ */ jsx188(Link26, { href: targetUrl, children: /* @__PURE__ */ jsxs139(
    Button28,
    {
      variant: "secondary",
      onPress: () => handleLinkClick(`Back to ${coverageName} quotes`),
      children: [
        /* @__PURE__ */ jsx188(Icon40, { icon: leftArrow3, fixedWidth: true }),
        "Back to ",
        coverageName,
        " quotes"
      ]
    }
  ) }) });
};

// src/components/SkipToNextCoverage/SkipToNextCoverage.tsx
import { Link as Link28, Text as Text76 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext34 } from "@simplybusiness/services";

// src/components/SkipToNextCoverage/SkipToNextCoverageSkeleton.tsx
import Skeleton3, { SkeletonTheme as SkeletonTheme4 } from "react-loading-skeleton";
import { Text as Text75, Link as Link27 } from "@simplybusiness/mobius";
import { Fragment as Fragment44, jsx as jsx189, jsxs as jsxs140 } from "react/jsx-runtime";
var StyledSkeleton3 = (props) => /* @__PURE__ */ jsx189(
  Skeleton3,
  {
    borderRadius: "var(--radius-2)",
    ...props,
    containerClassName: "mobius-skeleton"
  }
);
var SkipToNextCoverageSkeleton = () => {
  return /* @__PURE__ */ jsx189(Fragment44, { children: /* @__PURE__ */ jsxs140(
    SkeletonTheme4,
    {
      baseColor: "var(--color-background-light)",
      highlightColor: "var(--color-background)",
      children: [
        /* @__PURE__ */ jsx189(Text75, { children: /* @__PURE__ */ jsx189(StyledSkeleton3, { width: "100%", height: "2rem" }) }),
        /* @__PURE__ */ jsxs140("div", { className: "mobius-skip-to-next-coverage mobius-skip_to_next_coverage__skeleton", children: [
          /* @__PURE__ */ jsx189(Text75, { children: /* @__PURE__ */ jsx189(StyledSkeleton3, { width: "40%", height: "2rem" }) }),
          /* @__PURE__ */ jsx189(Link27, { children: /* @__PURE__ */ jsx189(StyledSkeleton3, { width: "60%", height: "2rem" }) })
        ] })
      ]
    }
  ) });
};

// src/components/SkipToNextCoverage/SkipToNextCoverage.tsx
import { Fragment as Fragment45, jsx as jsx190, jsxs as jsxs141 } from "react/jsx-runtime";
var SkipToNextCoverage = ({
  currentCoverageName,
  nextCoverageName,
  nextCoverageQuoteCount,
  nextCoverageMinPrice,
  nextCoverageUrl
}) => {
  const { snowplow } = useSnowplowContext34();
  const skipToNextCoverageClass = "mobius-skip-to-next-coverage";
  const isToggling = useMutationStatus("toggleCovers");
  const quoteText = (quoteCount) => {
    return quoteCount === 1 ? "quote" : "quotes";
  };
  const handleLinkClick = (elementContent2) => {
    if (nextCoverageUrl && elementContent2) {
      snowplow?.trigger("linkClicked", {
        targetUrl: nextCoverageUrl,
        elementContent: elementContent2
      });
    }
  };
  const elementContent = `Skip to ${nextCoverageName} without choosing ${currentCoverageName}`;
  if (isToggling) {
    return /* @__PURE__ */ jsx190(SkipToNextCoverageSkeleton, {});
  }
  return /* @__PURE__ */ jsxs141(Fragment45, { children: [
    /* @__PURE__ */ jsxs141(Text76, { elementType: "h3", children: [
      "Next, ",
      nextCoverageName
    ] }),
    /* @__PURE__ */ jsxs141("div", { className: skipToNextCoverageClass, children: [
      /* @__PURE__ */ jsxs141(Text76, { variant: "body", children: [
        "We found",
        " ",
        /* @__PURE__ */ jsxs141("strong", { children: [
          nextCoverageQuoteCount,
          " ",
          quoteText(nextCoverageQuoteCount),
          " "
        ] }),
        "from ",
        nextCoverageMinPrice,
        "."
      ] }),
      /* @__PURE__ */ jsx190(
        Link28,
        {
          href: nextCoverageUrl,
          onClick: () => handleLinkClick(elementContent),
          children: elementContent
        }
      )
    ] })
  ] });
};

// src/pages/QuoteComparisonPage/Interventions/VoucherIntervention.tsx
import {
  VoucherIntervention as Intervention
} from "@simplybusiness/mobius-interventions";

// src/hooks/useApplyVoucher/useApplyVoucher.ts
import { getAirbrake as getAirbrake7 } from "@simplybusiness/services";
import { useMutation as useMutation7 } from "@tanstack/react-query";
var airbrake6 = getAirbrake7({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY
});
var useApplyVoucher = () => {
  const [tokens] = useTokens();
  const mutation = useMutation7({
    mutationFn: (voucherCode) => apiRequest(`?step_action=apply_voucher&voucher_code=${voucherCode}`, {
      ...tokens
    }),
    onError: (error2) => {
      console.error(`Error applying voucher: ${error2.message}`);
      void airbrake6.notify(error2);
    },
    mutationKey: ["applyVoucher"]
  });
  const { isPending, isError, error, isSuccess, mutate } = mutation;
  return {
    applyVoucher: mutate,
    isSuccess,
    isPending,
    isError,
    error
  };
};

// src/pages/QuoteComparisonPage/Interventions/VoucherIntervention.tsx
import { Fragment as Fragment46, jsx as jsx191 } from "react/jsx-runtime";
var VOUCHER_CODE = "CPNXA";
var VoucherIntervention = (props) => {
  const { data } = props;
  const { component_names } = data || {};
  const { applyVoucher, isPending } = useApplyVoucher();
  const onClick = () => {
    applyVoucher(VOUCHER_CODE);
  };
  if (component_names?.includes("voucher-intervention")) {
    return /* @__PURE__ */ jsx191(
      Intervention,
      {
        ...props,
        code: VOUCHER_CODE,
        onClick,
        isPending
      }
    );
  } else {
    return /* @__PURE__ */ jsx191(Fragment46, {});
  }
};

// src/pages/QuoteComparisonPage/Interventions/MvtStickyFooterIntervention.tsx
import {
  ReassuranceIntervention,
  StarRatingIntervention,
  TradeSocialProofingIntervention
} from "@simplybusiness/mobius-interventions";
import { Fragment as Fragment47, jsx as jsx192 } from "react/jsx-runtime";
var MvtStickyFooterIntervention = (props) => {
  const { data } = props;
  const { component_names } = data || {};
  if (component_names?.includes("reassurance")) {
    return /* @__PURE__ */ jsx192(ReassuranceIntervention, { ...props });
  } else if (component_names?.includes("trade-social-proofing")) {
    return /* @__PURE__ */ jsx192(TradeSocialProofingIntervention, { ...props });
  } else if (component_names?.includes("star-rating")) {
    return /* @__PURE__ */ jsx192(StarRatingIntervention, { ...props });
  } else {
    return /* @__PURE__ */ jsx192(Fragment47, {});
  }
};

// src/pages/QuoteComparisonPage/Interventions/UsInactivityIntervention.tsx
import {
  InterventionWrapper,
  QCPInactivityIntervention
} from "@simplybusiness/mobius-interventions";
import { jsx as jsx193 } from "react/jsx-runtime";
var UsInactivityIntervention = ({
  trade,
  vertical,
  interventionName,
  ...rest
}) => /* @__PURE__ */ jsx193(InterventionWrapper, { name: interventionName, children: /* @__PURE__ */ jsx193(QCPInactivityIntervention, { trade, vertical, ...rest }) });

// src/pages/QuoteComparisonPage/QuoteComparisonPage.tsx
import { Fragment as Fragment48, jsx as jsx194, jsxs as jsxs142 } from "react/jsx-runtime";
var QCPInner = (props) => {
  const {
    layout: { components: initialComponents }
  } = props;
  useSetQcpState(initialComponents);
  const [components] = useQuoteComparisonPageState();
  const headline = getPropsByName({ name: "headline", components });
  const coverToggles = getPropsByName({ name: "cover-toggles", components });
  const agentActions = getPropsByName({ name: "agent-actions", components });
  const quoteCards = getPropsByName({ name: "quote-cards", components });
  const quoteHelp = getPropsByName({ name: "quote-help", components });
  const alert = getPropsByName({ name: "alert", components });
  const skipToNextCoverage = getPropsByName({
    name: "skip-to-next-coverage",
    components
  });
  const qcpRedirect = getPropsByName({ name: "qcp-redirect", components });
  const usInactivityIntervention = getPropsByName({
    name: "usa-qcp-inactivity-intervention-modal",
    components
  });
  const agentInformation = getPropsByName({
    name: "agent-information",
    components
  });
  return /* @__PURE__ */ jsx194(Fragment48, { children: /* @__PURE__ */ jsxs142(Container16, { size: "sm", children: [
    !!usInactivityIntervention && /* @__PURE__ */ jsx194(
      UsInactivityIntervention,
      {
        ...usInactivityIntervention
      }
    ),
    !!headline && /* @__PURE__ */ jsx194(Headline2, { ...headline }),
    !!alert && /* @__PURE__ */ jsx194(Box16, { paddingBottom: "lg", children: /* @__PURE__ */ jsx194(
      Alert3,
      {
        variant: alert.type,
        header: alert.header,
        children: alert.textContent
      }
    ) }),
    !!coverToggles && /* @__PURE__ */ jsx194(
      CoverTogglesContainer3,
      {
        ...coverToggles
      }
    ),
    !!agentActions && /* @__PURE__ */ jsx194(
      AgentActions,
      {
        ...agentActions
      }
    ),
    !!quoteCards && /* @__PURE__ */ jsx194(
      QuoteCards3,
      {
        ...quoteCards
      }
    ),
    !!skipToNextCoverage && /* @__PURE__ */ jsx194(
      SkipToNextCoverage,
      {
        ...skipToNextCoverage
      }
    ),
    !!qcpRedirect && /* @__PURE__ */ jsx194(QCPRedirect, { ...qcpRedirect }),
    !!quoteHelp && /* @__PURE__ */ jsx194(QuoteHelp, { ...quoteHelp }),
    !!agentInformation && /* @__PURE__ */ jsx194(Box16, { paddingTop: "md", children: /* @__PURE__ */ jsx194(
      AgentInformation,
      {
        ...agentInformation
      }
    ) })
  ] }) });
};
var QuoteComparisonPage = (props) => {
  return /* @__PURE__ */ jsx194(PageProviders, { ...props, children: /* @__PURE__ */ jsxs142(Page, { ...props, children: [
    /* @__PURE__ */ jsx194("main", { className: "mobius mobius-page__main", children: /* @__PURE__ */ jsx194(QCPInner, { ...props }) }),
    /* @__PURE__ */ jsx194(InterventionWrapper2, { name: "mvt-sticky-footer-intervention", children: /* @__PURE__ */ jsx194(MvtStickyFooterIntervention, {}) }),
    /* @__PURE__ */ jsx194(InterventionWrapper2, { name: "voucher-intervention", children: /* @__PURE__ */ jsx194(VoucherIntervention, {}) })
  ] }) });
};

// src/pages/ReferralPage/ReferralPage.tsx
import { Container as Container17 } from "@simplybusiness/mobius";
import classNames55 from "classnames/dedupe";
import { jsx as jsx195, jsxs as jsxs143 } from "react/jsx-runtime";
var ReferralPageInner = (props) => {
  const {
    layout: { components }
  } = props;
  const mainProps = getPropsByName({ name: "thank-you-content", components });
  const nextCoverage = getPropsByName({ name: "next-coverage", components });
  const quoteHelp = getPropsByName({ name: "quote-help", components });
  const coverageSummary = getPropsByName({
    name: "coverage-summary",
    components
  });
  const classes = classNames55({
    "mobius-cross-sell": !!coverageSummary
  });
  return /* @__PURE__ */ jsxs143(Container17, { size: "sm", children: [
    /* @__PURE__ */ jsxs143(
      Referral,
      {
        ...mainProps,
        className: classes,
        children: [
          !!coverageSummary && /* @__PURE__ */ jsx195(
            CoverageSummary,
            {
              ...coverageSummary
            }
          ),
          !!nextCoverage && /* @__PURE__ */ jsx195(
            NextCoverage,
            {
              ...nextCoverage
            }
          )
        ]
      }
    ),
    !!quoteHelp && /* @__PURE__ */ jsx195(QuoteHelp, { ...quoteHelp })
  ] });
};
var ReferralPage = (props) => {
  return /* @__PURE__ */ jsx195(PageProviders, { ...props, children: /* @__PURE__ */ jsx195(Page, { ...props, children: /* @__PURE__ */ jsx195("main", { className: "mobius mobius-page__main", children: /* @__PURE__ */ jsx195(ReferralPageInner, { ...props }) }) }) });
};

// src/pages/PersonalisedCoverPage/PersonalisedCoverPage.tsx
import "react-loading-skeleton/dist/skeleton.css";

// src/components/PersonalisedCover/PersonalisedCover.tsx
import {
  Container as Container18,
  Text as Text80,
  Alert as Alert4,
  Icon as Icon45,
  LinkButton as LinkButton7
} from "@simplybusiness/mobius";
import { forwardRef as forwardRef26, useCallback as useCallback15, useState as useState32 } from "react";

// src/components/PersonalisedCover/CoverOptions/CoverOptions.tsx
import { Stack } from "@simplybusiness/mobius";

// src/components/PersonalisedCover/CoverOptions/CoverOption/CoverOption.tsx
import classNames58 from "classnames/dedupe";

// src/components/PersonalisedCover/CoverOptions/CoverOption/CoverLimit.tsx
import { Button as Button29, Icon as Icon41 } from "@simplybusiness/mobius";
import { pen } from "@simplybusiness/icons";

// src/components/PersonalisedCover/CoverOptions/CoverOption/SelectCoverLimit.tsx
import { Select as Select3 } from "@simplybusiness/mobius";
import { jsx as jsx196 } from "react/jsx-runtime";
var SelectCoverLimit = ({
  coverLimits,
  selectedLimit,
  onChange,
  label,
  inputProps
}) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };
  const { defaultValue, value, ...restInputProps } = inputProps;
  return /* @__PURE__ */ jsx196(
    Select3,
    {
      label,
      ...restInputProps,
      value: selectedLimit,
      onChange: handleChange,
      children: coverLimits.map(({ value: value2, label: label2 }) => /* @__PURE__ */ jsx196("option", { value: value2, children: label2.toString() }, value2))
    }
  );
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/CoverLimit.tsx
import { useSnowplowContext as useSnowplowContext35 } from "@simplybusiness/services";
import { jsx as jsx197, jsxs as jsxs144 } from "react/jsx-runtime";
var CoverLimit2 = ({
  isEditingCoverLimit,
  coverLimits = [],
  selectedLimit,
  onLimitChange,
  setIsEditingCoverLimit,
  isDisabled,
  primaryText,
  inputProps
}) => {
  const { snowplow } = useSnowplowContext35();
  const safeCoverLimits = coverLimits || [];
  let limitLabel = safeCoverLimits.find(
    (option) => option.value === selectedLimit
  )?.label;
  if (!limitLabel && safeCoverLimits.length > 0) {
    limitLabel = safeCoverLimits[0]?.label;
  }
  const handleEditLimitClicked = () => {
    setIsEditingCoverLimit(true);
    snowplow?.trigger("limitLinkClicked", {
      label: primaryText
    });
  };
  if (isEditingCoverLimit) {
    return /* @__PURE__ */ jsx197(
      SelectCoverLimit,
      {
        coverLimits: safeCoverLimits,
        selectedLimit,
        onChange: onLimitChange,
        label: "Please select the cover limit you need",
        inputProps
      }
    );
  }
  return /* @__PURE__ */ jsxs144(
    Button29,
    {
      variant: "link",
      size: "sm",
      className: "mobius-cover-option__limit-button",
      isDisabled,
      onClick: handleEditLimitClicked,
      children: [
        limitLabel ? `${limitLabel} limit` : "Select limit",
        /* @__PURE__ */ jsx197(Icon41, { icon: pen })
      ]
    }
  );
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/MoreInfo.tsx
import { Accordion as Accordion8, Text as Text78 } from "@simplybusiness/mobius";

// src/components/PersonalisedCover/CoverOptions/ChildQuestion/ChildQuestion.tsx
import classNames56 from "classnames/dedupe";
import { Text as Text77 } from "@simplybusiness/mobius";

// src/components/PersonalisedCover/CoverOptions/ChildQuestion/QuestionInput.tsx
import {
  useCallback as useCallback12,
  useEffect as useEffect21,
  useState as useState29
} from "react";
import {
  Option as Option3,
  Radio as Radio3,
  RadioGroup as RadioGroup3,
  Select as Select4,
  DateField as DateField2
} from "@simplybusiness/mobius";

// src/components/PersonalisedCover/CoverOptions/validation/question/validate.ts
var validateQuestion3 = (question, answers) => {
  return validateQuestion(question, answers);
};

// src/hooks/usePersonalisedCover/usePersonalisedCover.ts
import { atom as atom2, useAtom as useAtom19 } from "jotai";
import { useCallback as useCallback11, useEffect as useEffect20 } from "react";
var personalisedCoverInitialState = {
  coreCovers: [],
  additionalCovers: [],
  answers: {},
  errors: {},
  validations: {}
};
var personalisedCoverAtom = atom2(personalisedCoverInitialState);
var usePersonalisedCover = (coreCovers, additionalCovers) => {
  const [state, setState] = useAtom19(personalisedCoverAtom);
  const setInitialState = useCallback11(
    (coreCovers2, additionalCovers2) => {
      setState((prevState) => {
        const allCovers = [...coreCovers2, ...additionalCovers2];
        const newAnswers = { ...prevState.answers };
        const newValidations = { ...prevState.validations };
        const newErrors = { ...prevState.errors };
        const processAnswer = (cover2) => {
          if (cover2.answer && cover2.fieldName) {
            if (cover2.type === "date") {
              newAnswers[cover2.fieldName] = {
                value: toISODate(cover2.answer),
                type: cover2.type
              };
            } else {
              newAnswers[cover2.fieldName] = { value: cover2.answer };
            }
          }
          if (cover2.fieldName) {
            newValidations[cover2.fieldName] = cover2.required && !cover2.valid;
            newErrors[cover2.fieldName] = cover2.required && !cover2.valid ? cover2.errorMessage : "";
          }
        };
        allCovers.forEach((cover2) => {
          processAnswer(cover2);
          cover2.childQuestions?.forEach(processAnswer);
        });
        return {
          ...prevState,
          coreCovers: coreCovers2,
          additionalCovers: additionalCovers2,
          answers: newAnswers,
          validations: newValidations,
          errors: newErrors
        };
      });
    },
    [setState]
  );
  useEffect20(() => {
    if (coreCovers && additionalCovers) {
      setInitialState(coreCovers, additionalCovers);
    }
  }, [coreCovers, additionalCovers, setInitialState]);
  const updateAnswer = useCallback11(
    (name, value) => {
      setState((prevState) => {
        return {
          ...prevState,
          answers: {
            ...prevState.answers,
            [name]: value
          }
        };
      });
    },
    [setState]
  );
  const setError = useCallback11(
    (name, value) => {
      setState((prevState) => {
        return {
          ...prevState,
          errors: {
            ...prevState.errors,
            [name]: value
          }
        };
      });
    },
    [setState]
  );
  const setIsValid = useCallback11(
    (name, value) => {
      setState((prevState) => {
        return {
          ...prevState,
          validations: {
            ...prevState.validations,
            [name]: value
          }
        };
      });
    },
    [setState]
  );
  const isValid = useCallback11(
    (name) => {
      return state.validations[name];
    },
    [state]
  );
  const errorMessage = useCallback11(
    (name) => {
      return state.errors[name];
    },
    [state.errors]
  );
  const resetErrors = useCallback11(() => {
    setState((prevState) => {
      return {
        ...prevState,
        errors: {}
      };
    });
  }, [setState]);
  const resetValidations = useCallback11(() => {
    setState((prevState) => {
      return {
        ...prevState,
        validations: {}
      };
    });
  }, [setState]);
  const removeError = useCallback11(
    (fieldName) => {
      setState((prevState) => {
        const newValidations = { ...prevState.validations };
        delete newValidations[fieldName];
        const newErrors = { ...prevState.errors };
        delete newErrors[fieldName];
        return {
          ...prevState,
          validations: newValidations,
          errors: newErrors
        };
      });
    },
    [setState]
  );
  const cover = useCallback11(
    (fieldName) => {
      return state.coreCovers?.find((cover2) => cover2.fieldName === fieldName) || state.additionalCovers?.find((cover2) => cover2.fieldName === fieldName) || {
        id: "",
        name: "",
        fieldName: "",
        primaryText: "",
        supportingText: "",
        type: "",
        coverLimits: {},
        valid: false,
        answer: "",
        errorMessage: "",
        required: false,
        visible: false
      };
    },
    [state]
  );
  return {
    answers: state.answers,
    coreCovers: state.coreCovers,
    additionalCovers: state.additionalCovers,
    updateAnswer,
    setInitialState,
    setError,
    errorMessage,
    setIsValid,
    isValid,
    resetErrors,
    resetValidations,
    cover,
    formErrors: state.validations,
    errors: state.errors,
    removeError
  };
};

// src/hooks/useSendCoverAnswers/useSendCoverAnswers.ts
import { getAirbrake as getAirbrake8 } from "@simplybusiness/services";
import { useMutation as useMutation8 } from "@tanstack/react-query";
var airbrake7 = getAirbrake8({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY
});
var useSendCoverAnswers = () => {
  const [tokens, setTokens] = useTokens();
  const { setInitialState } = usePersonalisedCover();
  const { locale } = useLocale();
  const isSendingAnswers = useMutationStatus("sendCoverAnswers");
  const mutation = useMutation8({
    mutationFn: (answers) => {
      const transformedAnswers = Object.entries(answers).map(
        ([question, answer]) => {
          if (answer.type === "date") {
            return {
              name: question,
              answer: formatDateByLocale(answer.value, locale)
            };
          } else {
            return {
              name: question,
              answer: answer.value
            };
          }
        }
      );
      return apiRequest("?step_action=covers", {
        ...tokens,
        questions: transformedAnswers
      });
    },
    onSuccess: ({ data }) => {
      const { coreCovers, additionalCovers } = getPropsByName({
        name: "personalised-cover",
        components: data.layout.components
      });
      setInitialState(coreCovers, additionalCovers);
      setTokens(data.configuration);
      return Promise.resolve({ coreCovers, additionalCovers });
    },
    onError: (error2) => {
      if (error2.name !== "AbortError" && error2.name !== "TimeoutError") {
        console.error(`Error updating PCP: ${error2.message}`);
        airbrake7.notify(error2);
      }
      return Promise.reject(error2);
    },
    mutationKey: ["sendCoverAnswers"]
  });
  const { isError, error, isSuccess, mutateAsync } = mutation;
  return {
    sendAnswers: mutateAsync,
    isSuccess,
    isPending: isSendingAnswers,
    isError,
    error
  };
};

// src/components/PersonalisedCover/CoverOptions/ChildQuestion/QuestionInput.tsx
import { useSnowplowContext as useSnowplowContext36 } from "@simplybusiness/services";
import { Fragment as Fragment49, jsx as jsx198, jsxs as jsxs145 } from "react/jsx-runtime";
var QuestionInput = ({
  type,
  fieldName,
  primaryText,
  coverLimits,
  checkIfInvalid
}) => {
  const {
    answers,
    updateAnswer,
    setError,
    errorMessage,
    isValid,
    setIsValid,
    cover
  } = usePersonalisedCover();
  const { snowplow } = useSnowplowContext36();
  const question = cover(fieldName);
  const coverErrorMessage = errorMessage(fieldName);
  const { sendAnswers, isPending } = useSendCoverAnswers();
  const [_, setIsDirty] = useState29(false);
  const inValid = isValid(fieldName);
  const handleChange = useCallback12(
    (payload, type2) => {
      if (!("value" in payload.target)) return;
      const answer = { value: payload.target.value, type: type2 };
      const validation = validateQuestion3(question, {
        fieldName: answer.value
      });
      setIsDirty(true);
      if (!validation.valid) {
        checkIfInvalid(fieldName);
        setIsValid(fieldName, false);
        setError(fieldName, validation.message || "");
        return;
      }
      setIsValid(fieldName, true);
      updateAnswer(fieldName, answer);
      sendAnswers({ ...answers, [fieldName]: answer }).catch(console.error);
      snowplow?.trigger("coverQuestionAnswered", {
        question: primaryText,
        answer: answer.value
      });
    },
    [
      answers,
      checkIfInvalid,
      fieldName,
      primaryText,
      question,
      sendAnswers,
      setError,
      setIsValid,
      snowplow,
      updateAnswer
    ]
  );
  const handleDateBlur = (event) => {
    if (!("value" in event.target)) return;
    if (event.target.value === answers[fieldName]?.value) return;
    handleChange(event, "date");
  };
  useEffect21(() => {
    if (inValid) {
      checkIfInvalid(fieldName);
      setError(fieldName, coverErrorMessage);
      snowplow?.trigger("validationShown", {
        cover: question.name,
        question: fieldName
      });
    }
  }, [
    coverErrorMessage,
    fieldName,
    setError,
    inValid,
    checkIfInvalid,
    snowplow,
    question.name
  ]);
  const enhancedQuestionProps = {
    name: fieldName,
    value: answers[fieldName]?.value.toString() || "",
    isInvalid: inValid,
    errorMessage: coverErrorMessage,
    isDisabled: isPending,
    isRequired: true
  };
  switch (type) {
    case "select":
      if (coverLimits.options) {
        return /* @__PURE__ */ jsx198(
          Select4,
          {
            id: fieldName,
            "aria-label": primaryText,
            ...enhancedQuestionProps,
            onChange: handleChange,
            children: /* @__PURE__ */ jsxs145(Fragment49, { children: [
              /* @__PURE__ */ jsx198(Option3, { value: "", isDisabled: true, children: "Please select" }, ""),
              coverLimits.options.map(({ value, label }) => /* @__PURE__ */ jsx198(Option3, { value, children: label }, value))
            ] })
          }
        );
      }
      break;
    case "radio_buttons":
      if (coverLimits.options) {
        return /* @__PURE__ */ jsx198(
          RadioGroup3,
          {
            id: fieldName,
            "aria-label": primaryText,
            orientation: "horizontal",
            ...enhancedQuestionProps,
            onChange: handleChange,
            isDisabled: isPending,
            children: coverLimits.options.map(({ value, label }) => /* @__PURE__ */ jsx198(Radio3, { value, children: label }, value))
          }
        );
      }
      break;
    case "date":
      return /* @__PURE__ */ jsx198(
        DateField2,
        {
          id: fieldName,
          "aria-label": primaryText,
          ...enhancedQuestionProps,
          onBlur: handleDateBlur,
          isDisabled: isPending
        }
      );
    default:
      break;
  }
  return null;
};

// src/components/PersonalisedCover/CoverOptions/ChildQuestion/ChildQuestion.tsx
import { jsx as jsx199, jsxs as jsxs146 } from "react/jsx-runtime";
var ChildQuestion = ({
  question,
  checkIfInvalid
}) => {
  const { primaryText, supportingText, fieldName, type, coverLimits } = question;
  const classes = classNames56("mobius", "mobius-child-question");
  return /* @__PURE__ */ jsxs146("div", { className: classes, children: [
    /* @__PURE__ */ jsx199(Text77, { className: "mobius-child-question__primary-text", variant: "h4", children: primaryText }),
    supportingText && /* @__PURE__ */ jsx199("span", { dangerouslySetInnerHTML: { __html: supportingText } }),
    /* @__PURE__ */ jsx199(
      QuestionInput,
      {
        type,
        fieldName,
        primaryText,
        coverLimits,
        checkIfInvalid
      }
    )
  ] });
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/MoreInfo.tsx
import { Fragment as Fragment50, jsx as jsx200, jsxs as jsxs147 } from "react/jsx-runtime";
var MoreInfo = ({
  fieldName,
  open,
  onOpen,
  selectedLimit,
  onLimitChange,
  inputProps,
  checkIfInvalid,
  additionalQuestionLabel
}) => {
  const { cover } = usePersonalisedCover();
  const field = cover(fieldName);
  const { supportingText, type, childQuestions } = field;
  const coverLimits = field.coverLimits?.options;
  const hasCoverLimits = coverLimits && type === "select";
  if (additionalQuestionLabel === "More info") {
    return null;
  }
  return /* @__PURE__ */ jsxs147(
    Accordion8,
    {
      showText: additionalQuestionLabel ?? "More info",
      hideText: additionalQuestionLabel ?? "More info",
      startOpen: open,
      onChange: onOpen,
      children: [
        supportingText && /* @__PURE__ */ jsx200("span", { dangerouslySetInnerHTML: { __html: supportingText } }),
        hasCoverLimits && /* @__PURE__ */ jsx200(
          SelectCoverLimit,
          {
            coverLimits,
            selectedLimit,
            onChange: onLimitChange,
            inputProps,
            label: "Would you like to change your cover limit?"
          }
        ),
        childQuestions && childQuestions.length > 0 && /* @__PURE__ */ jsxs147(Fragment50, { children: [
          /* @__PURE__ */ jsx200(Text78, { children: "Please answer these required questions:" }),
          childQuestions.map((question) => /* @__PURE__ */ jsx200(
            ChildQuestion,
            {
              question,
              checkIfInvalid
            },
            question.primaryText
          ))
        ] })
      ]
    }
  );
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/CoverOptionHeader.tsx
import { Flex as Flex50, Switch, Text as Text79 } from "@simplybusiness/mobius";
import { jsx as jsx201, jsxs as jsxs148 } from "react/jsx-runtime";
var CoverOptionHeader = ({
  primaryText,
  preselected,
  isEnabled,
  isPending,
  onSwitchChange
}) => {
  return /* @__PURE__ */ jsxs148(
    Flex50,
    {
      className: "mobius-cover-option__header",
      justifyContent: "space-between",
      alignItems: "center",
      children: [
        /* @__PURE__ */ jsx201(Text79, { className: "mobius-cover-option__primary-text", elementType: "h3", children: primaryText }),
        !preselected && /* @__PURE__ */ jsx201(
          Switch,
          {
            checked: isEnabled,
            onChange: onSwitchChange,
            isDisabled: isPending
          }
        )
      ]
    }
  );
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/hooks/useCoverOption.ts
import { useState as useState30, useCallback as useCallback13, useEffect as useEffect22 } from "react";
import { useSnowplowContext as useSnowplowContext37 } from "@simplybusiness/services";

// src/components/PersonalisedCover/CoverOptions/utils.ts
var isTruthyAnswer = (cover, answer) => {
  if (!answer) return false;
  if (cover.type === "select") {
    return answer !== "0";
  }
  if (cover.type === "radio_buttons") {
    return answer !== "no" && answer !== "0";
  }
  return false;
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/utils/coverOptionUtils.ts
var answerValue = (params) => {
  const { type, state, limit, limits } = params;
  switch (type) {
    case "select":
      return state ? limit : "0";
    case "radio_buttons":
      if (limits && limits.length === 2 && limits.some((l) => l.value === "0")) {
        return state ? limit : "0";
      }
      return state ? "yes" : "no";
    default:
      return "";
  }
};
var createAnswer = (fieldName, type, isEnabled, limit, limits) => {
  return {
    name: fieldName,
    value: answerValue({
      state: isEnabled,
      type,
      limit,
      limits
    })
  };
};
var validateCoverAnswer = (field, value) => {
  const validation = validateQuestion3(field, {
    fieldName: value
  });
  return {
    isValid: validation.valid,
    errorMessage: validation.message || ""
  };
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/hooks/useCoverOption.ts
var useCoverOption = ({
  fieldName,
  preselected = false,
  open,
  handleOpen,
  isCoreCover,
  firePresentedCoverEvent = true
}) => {
  const {
    updateAnswer,
    answers,
    setError,
    errorMessage,
    isValid,
    setIsValid,
    removeError,
    cover
  } = usePersonalisedCover();
  const field = cover(fieldName);
  const { snowplow } = useSnowplowContext37();
  const { sendAnswers, isPending } = useSendCoverAnswers();
  const { primaryText, type, chatbotPrompts } = field;
  const coverLimits = field.coverLimits?.options;
  const hasCoverLimits = coverLimits && type === "select";
  const [isEditingCoverLimit, setIsEditingCoverLimit] = useState30(false);
  const initialLimit = coverLimits?.[0]?.value ?? "";
  const [limit, setLimit] = useState30(
    isTruthyAnswer(field, answers[fieldName]?.value) ? answers[fieldName]?.value : initialLimit
  );
  const coverErrorMessage = errorMessage(fieldName);
  const [isInvalid, setIsInvalid] = useState30(false);
  const [pageLoadOpenAccordion, setPageLoadOpenAccordion] = useState30(false);
  const isEnabledFromAnswers = preselected || isTruthyAnswer(field, answers[fieldName]?.value);
  const [isEnabled, setIsEnabled] = useState30(isEnabledFromAnswers);
  useEffect22(() => {
    setIsEnabled(isEnabledFromAnswers);
  }, [isEnabledFromAnswers]);
  useEffect22(() => {
    if (open) {
      setIsEditingCoverLimit(false);
    }
  }, [open]);
  const checkChildQuestionValidity = () => {
    return field.childQuestions?.every((childQuestion) => childQuestion.valid);
  };
  const checkIfValid = useCallback13(
    (fieldName2) => {
      if (isValid(fieldName2)) {
        setIsInvalid(true);
        setIsValid(fieldName2, false);
        snowplow?.trigger("validationShown", {
          cover: field.name,
          question: fieldName2
        });
      }
      if (!isEnabled) {
        removeError(fieldName2);
        handleOpen();
      }
    },
    [
      isValid,
      isEnabled,
      setIsValid,
      snowplow,
      field.name,
      removeError,
      handleOpen
    ]
  );
  const setAnswer = useCallback13(
    (newState) => {
      const answer = createAnswer(
        fieldName,
        type,
        newState,
        limit,
        coverLimits
      );
      const { isValid: isAnswerValid, errorMessage: errorMessage2 } = validateCoverAnswer(
        field,
        answer.value
      );
      if (answer && isAnswerValid) {
        updateAnswer(fieldName, answer);
        sendAnswers({ ...answers, [fieldName]: answer }).catch(console.error);
        snowplow?.trigger("coverQuestionAnswered", {
          question: primaryText,
          answer: answer.value
        });
      } else if (!isCoreCover) {
        setIsValid(fieldName, false);
        setIsInvalid(true);
        setError(fieldName, String(errorMessage2));
        snowplow?.trigger("validationShown", {
          cover: field.name,
          question: fieldName
        });
      }
    },
    [
      fieldName,
      type,
      limit,
      coverLimits,
      field,
      isCoreCover,
      updateAnswer,
      sendAnswers,
      answers,
      snowplow,
      primaryText,
      setIsValid,
      setError
    ]
  );
  const handleSwitchChange = () => {
    const newState = !isEnabled;
    setIsEnabled(newState);
    setAnswer(newState);
    if (!newState && !isCoreCover) {
      setIsInvalid(false);
      removeError(fieldName);
    }
    handleOpen();
  };
  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setIsEditingCoverLimit(false);
    snowplow?.trigger("limitChanged", {
      label: primaryText,
      limit: newLimit
    });
    const { isValid: isAnswerValid, errorMessage: errorMessage2 } = validateCoverAnswer(
      field,
      newLimit
    );
    if (isEnabled && isAnswerValid) {
      setIsValid(fieldName, true);
      updateAnswer(fieldName, { value: newLimit });
      sendAnswers({ ...answers, [fieldName]: { value: newLimit } }).catch(
        console.error
      );
    } else {
      setIsValid(fieldName, false);
      setError(fieldName, String(errorMessage2));
    }
  };
  const handleAccordionOpen = useCallback13(() => {
    snowplow?.trigger("additionalQuestionsClicked", {
      property: primaryText
    });
    setIsEditingCoverLimit(false);
    handleOpen();
  }, [handleOpen, primaryText, snowplow]);
  useEffect22(() => {
    if (!open && isEnabled && !pageLoadOpenAccordion && !preselected) {
      setPageLoadOpenAccordion(true);
      handleOpen();
    }
    if (preselected && !answers[fieldName]) {
      setAnswer(true);
      setIsEnabled(true);
    }
  }, [
    preselected,
    answers,
    fieldName,
    setAnswer,
    open,
    isEnabled,
    pageLoadOpenAccordion,
    handleOpen
  ]);
  useEffect22(() => {
    if (firePresentedCoverEvent) {
      snowplow?.trigger("coverPresented", {
        property: primaryText
      });
    }
  }, [firePresentedCoverEvent, primaryText, snowplow]);
  return {
    field,
    primaryText,
    type,
    coverLimits,
    hasCoverLimits,
    isEditingCoverLimit,
    setIsEditingCoverLimit,
    limit,
    coverErrorMessage,
    isInvalid,
    isEnabled,
    isPending,
    checkIfValid,
    handleSwitchChange,
    handleLimitChange,
    handleAccordionOpen,
    checkChildQuestionValidity,
    chatbotPrompts
  };
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/ChatbotPrompts/ChatbotPrompts.tsx
import {
  useEffect as useEffect23,
  useRef as useRef7,
  useState as useState31,
  useCallback as useCallback14
} from "react";
import { Icon as Icon43, useBreakpoint as useBreakpoint14 } from "@simplybusiness/mobius";
import { sparkles } from "@simplybusiness/icons";

// src/components/PersonalisedCover/CoverOptions/CoverOption/ChatbotPrompts/ChatbotPrompt.tsx
import { Button as Button30 } from "@simplybusiness/mobius";
import { useSnowplowContext as useSnowplowContext38 } from "@simplybusiness/services";
import { jsx as jsx202 } from "react/jsx-runtime";
var ChatbotPrompt = ({ label, coverName }) => {
  const { snowplow } = useSnowplowContext38();
  const handleClick = () => {
    snowplow?.trigger("chatbotPromptClicked", {
      label: coverName,
      property: label
    });
  };
  return /* @__PURE__ */ jsx202(
    Button30,
    {
      className: "mobius-chatbot-prompt",
      size: "sm",
      variant: "ghost",
      onClick: handleClick,
      "data-cover-name": coverName,
      children: label
    }
  );
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/ChatbotPrompts/ScrollButton/ScrollButton.tsx
import { Button as Button31, Icon as Icon42 } from "@simplybusiness/mobius";
import classNames57 from "classnames/dedupe";
import { chevronLeft as chevronLeft2 } from "@simplybusiness/icons";
import { jsx as jsx203 } from "react/jsx-runtime";
var ScrollButton = ({
  onClick,
  direction,
  isHidden = false
}) => {
  const scrollButtonClasses = classNames57(
    "mobius-chatbot-prompts__scroll-button",
    {
      "mobius-chatbot-prompts__scroll-button--left": direction === "left",
      "mobius-chatbot-prompts__scroll-button--right": direction === "right",
      "mobius-chatbot-prompts__scroll-button--hidden": isHidden
    }
  );
  return /* @__PURE__ */ jsx203(
    Button31,
    {
      className: scrollButtonClasses,
      onClick: () => onClick(direction),
      isDisabled: isHidden,
      variant: "basic",
      "aria-label": `Scroll prompts ${direction}`,
      children: /* @__PURE__ */ jsx203(Icon42, { icon: chevronLeft2, size: "sm" })
    }
  );
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/ChatbotPrompts/ChatbotPrompts.tsx
import { jsx as jsx204, jsxs as jsxs149 } from "react/jsx-runtime";
var ChatbotPrompts = ({
  chatbotPrompts,
  coverName
}) => {
  const [scrollStatus, setScrollStatus] = useState31(null);
  const scrollRef = useRef7(null);
  const { down } = useBreakpoint14();
  const isMobile = down("md");
  useEffect23(() => {
    const element = scrollRef.current;
    if (element && element.scrollWidth > element.clientWidth) {
      setScrollStatus("left");
    }
  }, []);
  const handleScroll = useCallback14(
    (event) => {
      const target = event.target;
      const maxScroll = target.scrollWidth - target.clientWidth;
      const isAtEnd = Math.abs(target.scrollLeft - maxScroll) < 3;
      if (target.scrollLeft === 0) {
        setScrollStatus("left");
      } else if (isAtEnd) {
        setScrollStatus("right");
      } else if (scrollStatus !== "middle") {
        setScrollStatus("middle");
      }
    },
    [scrollStatus]
  );
  const handleScrollClick = useCallback14(
    (scrollDirection) => {
      if (scrollRef && scrollRef.current) {
        const scrollParent = scrollRef.current;
        if (isMobile) {
          const scrollAmount = scrollParent.clientWidth / 2;
          scrollParent.scrollBy({
            left: scrollDirection === "right" ? scrollAmount : -scrollAmount,
            behavior: "smooth"
          });
        } else {
          const prompts = Array.from(scrollParent.children);
          let scrollToElement;
          if (scrollDirection === "right") {
            prompts.forEach((prompt) => {
              if (prompt.offsetLeft < scrollParent.scrollLeft + scrollParent.clientWidth) {
                scrollToElement = prompt;
              }
            });
          } else {
            prompts.reverse().forEach((prompt) => {
              if (prompt.offsetLeft + prompt.offsetWidth > scrollParent.scrollLeft) {
                scrollToElement = prompt;
              }
            });
          }
          if (scrollToElement) {
            scrollParent.scrollTo({
              left: scrollToElement.offsetLeft - scrollParent.offsetLeft,
              behavior: "smooth"
            });
          }
        }
      }
    },
    [isMobile]
  );
  return /* @__PURE__ */ jsxs149("div", { className: "mobius-chatbot-prompts", "aria-label": "Chatbot prompts", children: [
    /* @__PURE__ */ jsx204(
      Icon43,
      {
        className: scrollStatus && scrollStatus !== "left" ? "--is-hidden" : "",
        icon: sparkles,
        size: "md",
        "data-testid": "sparkles-icon"
      }
    ),
    scrollStatus && /* @__PURE__ */ jsx204(
      ScrollButton,
      {
        onClick: handleScrollClick,
        isHidden: scrollStatus === "left",
        direction: "left"
      }
    ),
    /* @__PURE__ */ jsx204(
      "div",
      {
        ref: scrollRef,
        onScroll: handleScroll,
        className: "mobius-chatbot-prompts__scroll",
        role: "list",
        children: chatbotPrompts.map((prompt) => /* @__PURE__ */ jsx204(ChatbotPrompt, { label: prompt, coverName }, prompt))
      }
    ),
    scrollStatus && /* @__PURE__ */ jsx204(
      ScrollButton,
      {
        onClick: handleScrollClick,
        isHidden: scrollStatus === "right",
        direction: "right"
      }
    )
  ] });
};

// src/components/PersonalisedCover/CoverOptions/CoverOption/CoverOption.tsx
import { jsx as jsx205, jsxs as jsxs150 } from "react/jsx-runtime";
var CoverOption = ({
  preselected = false,
  open,
  handleOpen,
  isCoreCover,
  firePresentedCoverEvent = true,
  fieldName,
  additionalQuestionLabel
}) => {
  const option = useCoverOption({
    fieldName,
    preselected,
    open,
    handleOpen,
    isCoreCover,
    firePresentedCoverEvent
  });
  const isChatbotExperiment = useExperiment("uk2505BrieBot") === "treatment";
  const showChatbotPrompts = isChatbotExperiment && option.chatbotPrompts && option.chatbotPrompts?.length > 0;
  const coverOptionValid = () => {
    return option.checkChildQuestionValidity() || !option.isInvalid;
  };
  const classes = classNames58("mobius", "mobius-cover-option", {
    "mobius-cover-option--is-checked": option.isEnabled,
    "mobius-cover-option--is-error": !coverOptionValid()
  });
  const basicQuestionProps = {
    name: fieldName,
    errorMessage: option.coverErrorMessage,
    isDisabled: option.isPending
  };
  const moreInfoAdditionalQuestionLabel = isChatbotExperiment ? additionalQuestionLabel : null;
  return /* @__PURE__ */ jsxs150("div", { className: classes, children: [
    /* @__PURE__ */ jsxs150("div", { className: "mobius-cover-option__inner", children: [
      /* @__PURE__ */ jsx205(
        CoverOptionHeader,
        {
          primaryText: option.primaryText,
          preselected,
          isEnabled: option.isEnabled,
          isPending: option.isPending,
          onSwitchChange: option.handleSwitchChange
        }
      ),
      option.hasCoverLimits && /* @__PURE__ */ jsx205(
        CoverLimit2,
        {
          coverLimits: option.coverLimits,
          selectedLimit: option.limit.toString(),
          isEditingCoverLimit: option.isEditingCoverLimit,
          onLimitChange: option.handleLimitChange,
          setIsEditingCoverLimit: option.setIsEditingCoverLimit,
          isDisabled: open || option.isPending,
          primaryText: option.primaryText,
          inputProps: basicQuestionProps
        }
      ),
      /* @__PURE__ */ jsx205(
        MoreInfo,
        {
          fieldName,
          open,
          onOpen: option.handleAccordionOpen,
          selectedLimit: option.limit.toString(),
          onLimitChange: option.handleLimitChange,
          inputProps: basicQuestionProps,
          checkIfInvalid: option.checkIfValid,
          additionalQuestionLabel: moreInfoAdditionalQuestionLabel
        }
      )
    ] }),
    showChatbotPrompts && /* @__PURE__ */ jsx205(
      ChatbotPrompts,
      {
        chatbotPrompts: option.chatbotPrompts,
        coverName: option.primaryText
      }
    )
  ] });
};

// src/components/PersonalisedCover/CoverOptions/CoverOptions.tsx
import { jsx as jsx206 } from "react/jsx-runtime";
var CoverOptions = ({
  covers,
  isCoreCover,
  groupId,
  openAccordionId,
  handleAccordionChange
}) => {
  return /* @__PURE__ */ jsx206(Stack, { gap: "sm", children: covers.map((cover, index) => {
    return /* @__PURE__ */ jsx206(
      CoverOption,
      {
        index,
        fieldName: cover.fieldName,
        openAccordionId,
        isCoreCover,
        additionalQuestionLabel: cover.additionalQuestionLabel,
        firePresentedCoverEvent: isCoreCover && covers.length == 1,
        preselected: isCoreCover && covers.length == 1,
        open: openAccordionId === `${groupId}-${index}`,
        handleOpen: () => handleAccordionChange(`${groupId}-${index}`)
      },
      cover.primaryText
    );
  }) });
};

// src/components/PersonalisedCover/PersonalisedCoverActions/SubmitAction.tsx
import { Button as Button32, Icon as Icon44 } from "@simplybusiness/mobius";
import { rightArrow as rightArrow6 } from "@simplybusiness/icons";
import { useSnowplowContext as useSnowplowContext39 } from "@simplybusiness/services";
import { useRef as useRef8 } from "react";
import { jsx as jsx207, jsxs as jsxs151 } from "react/jsx-runtime";
var transformedAnswer = (answer, locale) => {
  if (answer.type === "date") {
    return formatDateByLocale(answer.value, locale);
  }
  return answer.value;
};
var SubmitAction = ({
  action,
  validationCoreCoverAlert,
  isDisabled
}) => {
  const { snowplow } = useSnowplowContext39();
  const { locale } = useLocale();
  const {
    answers,
    coreCovers,
    additionalCovers,
    setError,
    setIsValid,
    resetValidations,
    resetErrors
  } = usePersonalisedCover();
  const { authenticityToken, journeyToken } = useTokensValues();
  const skipCallbackRef = useRef8(false);
  const handlePackagesSelected = () => {
    snowplow?.trigger("selectPackageClicked", {});
  };
  const questionCover = (fieldName) => {
    return coreCovers.find((cover) => cover.fieldName === fieldName) || additionalCovers.find((cover) => cover.fieldName === fieldName) || {
      fieldName: "",
      primaryText: "",
      supportingText: "",
      type: "",
      coverLimits: {},
      valid: false,
      answer: "",
      errorMessage: "",
      required: false,
      visible: false
    };
  };
  const onSubmit = (event) => {
    if (skipCallbackRef.current) {
      return;
    }
    event.preventDefault();
    resetValidations();
    resetErrors();
    let validForm = true;
    if (validationCoreCoverAlert) {
      validationCoreCoverAlert(false);
    }
    const validCoreCovers = coreCovers.some((cover) => {
      const answer = answers[cover.fieldName];
      return answer && isTruthyAnswer(cover, answer.value);
    });
    if (!validCoreCovers && validationCoreCoverAlert) {
      validationCoreCoverAlert(true);
      validForm = false;
    }
    Object.entries(answers).map(([key, answer]) => {
      const question = questionCover(key);
      const validation = validateQuestion3(question, {
        [question.fieldName]: transformedAnswer(answer, locale)
      });
      if (!validation.valid) {
        setIsValid(key, false);
        setError(key, validation.message || "");
        validForm = false;
      }
      if (question.required && !answer.value) {
        setIsValid(key, true);
        setError(key, question.errorMessage);
        validForm = false;
      }
      question.childQuestions?.forEach((childQuestion) => {
        const childAnswer = answers[childQuestion.fieldName];
        if (childQuestion.required && (!childAnswer || !childAnswer.value)) {
          setIsValid(childQuestion.fieldName, true);
          setError(childQuestion.fieldName, childQuestion.errorMessage);
          validForm = false;
        }
      });
    });
    if (validForm) {
      skipCallbackRef.current = true;
      event.target.submit();
    }
  };
  if (!action) {
    return null;
  }
  return /* @__PURE__ */ jsxs151(
    "form",
    {
      action: action.url,
      method: "POST",
      className: "mobius-personalised-cover__form",
      onSubmit: (event) => onSubmit(event),
      children: [
        Object.entries(answers).map(([key, answer]) => /* @__PURE__ */ jsx207(
          "input",
          {
            type: "hidden",
            name: key,
            value: transformedAnswer(answer, locale)
          },
          key
        )),
        /* @__PURE__ */ jsx207(
          "input",
          {
            type: "hidden",
            name: "authenticity_token",
            value: authenticityToken
          }
        ),
        /* @__PURE__ */ jsx207("input", { type: "hidden", name: "journey_token", value: journeyToken }),
        /* @__PURE__ */ jsxs151(
          Button32,
          {
            className: "mobius-personalised-cover__submit-action",
            type: "submit",
            variant: "primary",
            name: "package_selection_clicked",
            value: "yes",
            size: "md",
            onClick: handlePackagesSelected,
            isDisabled,
            children: [
              "Get selection ",
              /* @__PURE__ */ jsx207(Icon44, { icon: rightArrow6 })
            ]
          }
        )
      ]
    }
  );
};

// src/components/PersonalisedCover/PersonalisedCoverActions/SeeMoreCoversAction.tsx
import { useSnowplowContext as useSnowplowContext40 } from "@simplybusiness/services";
import { Button as Button33 } from "@simplybusiness/mobius";
import { jsx as jsx208 } from "react/jsx-runtime";
var SeeMoreCoversAction = ({
  action,
  isDisabled
}) => {
  const { snowplow } = useSnowplowContext40();
  const handleSeeMoreCovers = () => {
    snowplow?.trigger("seeMoreClicked", {});
  };
  return /* @__PURE__ */ jsx208(
    Button33,
    {
      elementType: "a",
      variant: "secondary",
      name: "see_more_covers_clicked",
      size: "md",
      onClick: handleSeeMoreCovers,
      href: action.url,
      isDisabled,
      children: "See more covers"
    }
  );
};

// src/components/PersonalisedCover/PersonalisedCoverActions/PersonalisedCoverActions.tsx
import { jsx as jsx209, jsxs as jsxs152 } from "react/jsx-runtime";
var PersonalisedCoverActions = ({
  actions,
  validationCoreCoverAlert
}) => {
  const { isPending } = useSendCoverAnswers();
  if (!actions) {
    return null;
  }
  const submitAction = actions.find(
    (action) => action.actionType === "submit"
  );
  const seeMoreCoversAction = actions.find(
    (action) => action.name === "See more covers"
  );
  return /* @__PURE__ */ jsxs152("div", { className: "mobius-personalised-cover__actions", children: [
    seeMoreCoversAction && /* @__PURE__ */ jsx209(
      SeeMoreCoversAction,
      {
        action: seeMoreCoversAction,
        isDisabled: isPending
      }
    ),
    submitAction && /* @__PURE__ */ jsx209(
      SubmitAction,
      {
        action: submitAction,
        validationCoreCoverAlert,
        isDisabled: isPending
      }
    )
  ] });
};

// src/components/PersonalisedCover/PersonalisedCover.tsx
import { chevronLeft as chevronLeft3 } from "@simplybusiness/icons";
import { jsx as jsx210, jsxs as jsxs153 } from "react/jsx-runtime";
var PersonalisedCover = forwardRef26(
  (props, ref) => {
    const {
      title,
      coreCovers: coreCoversInitial,
      coreCoversDescription,
      additionalCovers: additionalCoversInitial,
      additionalCoversDescription,
      actions
    } = props;
    const { coreCovers, additionalCovers } = usePersonalisedCover(
      coreCoversInitial,
      additionalCoversInitial
    );
    const [openAccordionId, setOpenAccordionId] = useState32(null);
    const [showCoreValidationMessage, setShowCoreValidationMessage] = useState32(false);
    const handleAccordionChange = useCallback15(
      (coverId) => {
        setOpenAccordionId(openAccordionId === coverId ? null : coverId);
      },
      [openAccordionId]
    );
    const backAction = actions?.find(
      (action) => action.name === "Back"
    );
    return /* @__PURE__ */ jsxs153(Container18, { className: "mobius-personalised-cover__container", ref, children: [
      backAction && /* @__PURE__ */ jsxs153(
        LinkButton7,
        {
          className: "mobius-personalised-cover__back",
          variant: "link",
          size: "sm",
          href: backAction.url,
          children: [
            /* @__PURE__ */ jsx210(Icon45, { icon: chevronLeft3 }),
            "Back"
          ]
        }
      ),
      /* @__PURE__ */ jsx210(Text80, { variant: "h2", children: title }),
      showCoreValidationMessage ? /* @__PURE__ */ jsx210(Alert4, { variant: "error", children: coreCoversDescription }) : /* @__PURE__ */ jsx210(Text80, { variant: "body", children: coreCoversDescription }),
      /* @__PURE__ */ jsx210(
        CoverOptions,
        {
          covers: coreCovers || coreCoversInitial,
          isCoreCover: true,
          openAccordionId,
          handleAccordionChange,
          groupId: "core-covers"
        }
      ),
      /* @__PURE__ */ jsx210(Text80, { variant: "body", children: additionalCoversDescription }),
      /* @__PURE__ */ jsx210(
        CoverOptions,
        {
          covers: additionalCovers || additionalCoversInitial,
          openAccordionId,
          handleAccordionChange,
          groupId: "additional-covers"
        }
      ),
      /* @__PURE__ */ jsx210(
        PersonalisedCoverActions,
        {
          actions,
          validationCoreCoverAlert: setShowCoreValidationMessage
        }
      )
    ] });
  }
);
PersonalisedCover.displayName = "PersonalisedCover";

// src/pages/PersonalisedCoverPage/PersonalisedCoverPage.tsx
import { Fragment as Fragment51, jsx as jsx211 } from "react/jsx-runtime";
var PersonalisedCoverPageInner = (props) => {
  const {
    layout: { components }
  } = props;
  const personalisedCoverProps = getPropsByName({
    name: "personalised-cover",
    components
  });
  return /* @__PURE__ */ jsx211(Fragment51, { children: personalisedCoverProps && /* @__PURE__ */ jsx211(PersonalisedCover, { ...personalisedCoverProps }) });
};
var PersonalisedCoverPage = (props) => {
  return /* @__PURE__ */ jsx211(PageProviders, { ...props, children: /* @__PURE__ */ jsx211(Page, { ...props, children: /* @__PURE__ */ jsx211("main", { className: "mobius mobius-page__main", children: /* @__PURE__ */ jsx211(PersonalisedCoverPageInner, { ...props }) }) }) });
};

// src/components/shared/PreQCP/PreQCPSignposting.tsx
import { jsx as jsx212, jsxs as jsxs154 } from "react/jsx-runtime";
var PreQCPSignposting = ({
  quotedProduct,
  journeyCurrentPagePath,
  journeyToken,
  authenticityToken,
  secondaryProduct
}) => {
  return /* @__PURE__ */ jsxs154("div", { className: "mobius-pre-qcp__pre-qcp-card-container", children: [
    /* @__PURE__ */ jsx212("div", { className: "mobius-pre-qcp__additional-rfq-body", children: /* @__PURE__ */ jsxs154("div", { className: "mobius-pre-qcp__pre-qcp-primary", children: [
      /* @__PURE__ */ jsx212("h2", { className: "mobius-pre-qcp__quoted-product-name", children: quotedProduct.name }),
      quotedProduct.min_price && /* @__PURE__ */ jsxs154("div", { className: "mobius-pre-qcp__quoted-subtext", children: [
        "From ",
        /* @__PURE__ */ jsx212("span", { children: quotedProduct.min_price }),
        " / month"
      ] }),
      /* @__PURE__ */ jsx212("div", { className: "mobius-pre-qcp__button-container", children: /* @__PURE__ */ jsxs154("form", { action: journeyCurrentPagePath, method: "post", children: [
        /* @__PURE__ */ jsx212(
          "input",
          {
            type: "hidden",
            name: "authenticity_token",
            value: authenticityToken,
            autoComplete: "off"
          }
        ),
        /* @__PURE__ */ jsx212(
          "input",
          {
            type: "hidden",
            name: "journey_token",
            id: "journey_token",
            value: journeyToken,
            autoComplete: "off"
          }
        ),
        /* @__PURE__ */ jsx212(
          "button",
          {
            id: "btn-submit",
            type: "submit",
            className: "mobius --variant-primary --size-sm mobius-button btn-primary explanation-btn",
            children: quotedProduct.hyperlink_text
          }
        )
      ] }) })
    ] }) }),
    /* @__PURE__ */ jsxs154("div", { className: "mobius-pre-qcp__additional-rfq-body", children: [
      /* @__PURE__ */ jsx212("h2", { className: "mobius-pre-qcp__quoted-product-name", children: secondaryProduct.name }),
      secondaryProduct.min_price && /* @__PURE__ */ jsxs154("div", { className: "mobius-pre-qcp__quoted-subtext", children: [
        "From ",
        /* @__PURE__ */ jsx212("span", { children: secondaryProduct.min_price }),
        " / month"
      ] }),
      /* @__PURE__ */ jsx212("div", { className: "mobius-pre-qcp__pre-qcp-continuation-subtext", children: secondaryProduct.text })
    ] })
  ] });
};
export {
  Actions3 as Actions,
  AgentActions,
  AgentInformation,
  AgentReferral,
  AgentReferralPage,
  AgentResources,
  CoverToggle,
  CoverTogglesContainer3 as CoverTogglesContainer,
  CoverageSummary,
  DialogueModal,
  ErrorBoundary,
  Footer4 as Footer,
  Header2 as Header,
  Headline2 as Headline,
  InfoCard,
  InsuranceBenefits,
  LOGO_LINK,
  NextCoverage,
  OPENING_HOURS_LABEL,
  OPENING_HOURS_UK,
  OPENING_HOURS_US,
  Page,
  PageProviders,
  PersistentCartPaymentOptions,
  PersistentCartPriceSummary,
  PersistentPriceSummary,
  PersistentProductSummary,
  PersistentSummaryHeader,
  PersonalisedCoverPage,
  PreFooter,
  PreQCPSignposting,
  ProductSummary,
  ProgressSteps,
  ProgressStepsItem,
  Questionnaire,
  QuestionnairePage,
  QuoteCard,
  QuoteCards3 as QuoteCards,
  QuoteComparisonPage,
  QuoteDetailsForm,
  QuoteHelp,
  Referral,
  ReferralPage,
  TransferConsentPageUK,
  TrustSection,
  QuoteComparisonPage as UKQCPPage,
  QuoteComparisonPage as USQCPPage
};
